/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 36);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(44);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(59)();
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return keyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return injectGlobal; });
/* unused harmony export isStyledComponent */
/* unused harmony export consolidateStreamedStyles */
/* unused harmony export ThemeProvider */
/* unused harmony export withTheme */
/* unused harmony export ServerStyleSheet */
/* unused harmony export StyleSheetManager */
/* unused harmony export __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_plain_object__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_plain_object___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_plain_object__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_stylis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis_rule_sheet__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_stylis_rule_sheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_is__);








/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate$2(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

var hyphenate_1 = hyphenate$2;

var hyphenate = hyphenate_1;

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

var hyphenateStyleName_1 = hyphenateStyleName;

// 
var objToCss = function objToCss(obj, prevKey) {
  var css = Object.keys(obj).filter(function (key) {
    var chunk = obj[key];
    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
  }).map(function (key) {
    if (__WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(obj[key])) return objToCss(obj[key], key);
    return hyphenateStyleName_1(key) + ': ' + obj[key] + ';';
  }).join(' ');
  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};

var flatten = function flatten(chunks, executionContext) {
  return chunks.reduce(function (ruleSet, chunk) {
    /* Remove falsey values */
    if (chunk === undefined || chunk === null || chunk === false || chunk === '') {
      return ruleSet;
    }
    /* Flatten ruleSet */
    if (Array.isArray(chunk)) {
      return [].concat(ruleSet, flatten(chunk, executionContext));
    }

    /* Handle other components */
    if (chunk.hasOwnProperty('styledComponentId')) {
      // $FlowFixMe not sure how to make this pass
      return [].concat(ruleSet, ['.' + chunk.styledComponentId]);
    }

    /* Either execute or defer the function */
    if (typeof chunk === 'function') {
      return executionContext ? ruleSet.concat.apply(ruleSet, flatten([chunk(executionContext)], executionContext)) : ruleSet.concat(chunk);
    }

    /* Handle objects */
    return ruleSet.concat(
    // $FlowFixMe have to add %checks somehow to isPlainObject
    __WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(chunk) ? objToCss(chunk) : chunk.toString());
  }, []);
};

// 
// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new __WEBPACK_IMPORTED_MODULE_1_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new __WEBPACK_IMPORTED_MODULE_1_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];
// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = __WEBPACK_IMPORTED_MODULE_2_stylis_rule_sheet___default()(function (rule) {
  parsingRules.push(rule);
});

stylis.use([parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var stringifyRules = function stringifyRules(rules, selector, prefix) {
  var flatCSS = rules.join('').replace(/^\s*\/\/.*$/gm, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  return stylis(prefix || !selector ? '' : selector, cssStr);
};

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

// 

function isStyledComponent(target) /* : %checks */{
  return typeof target === 'function' && typeof target.styledComponentId === 'string';
}

// 

/* This function is DEPRECATED and will be removed on the next major version release.
 * It was needed to rehydrate all style blocks prepended to chunks before React
 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
 * the use of streamed style tags and will perform the rehydration earlier when needed
 * this function will not be needed anymore */
function consolidateStreamedStyles() {
  if (false) {
    // eslint-disable-next-line no-console
    console.warn('styled-components automatically does streaming SSR rehydration now.\n' + 'Calling consolidateStreamedStyles manually is no longer necessary and a noop now.\n' + '- Please remove the consolidateStreamedStyles call from your client.');
  }
}

// 
/* eslint-disable no-bitwise */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
var charsLength = 52;

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};

/* input a number, usually a hash and convert it to base-52 */
var generateAlphabeticName = function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  /* get a char and divide by alphabet-length */
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
};

// 

var interleave = (function (strings, interpolations) {
  return interpolations.reduce(function (array, interp, i) {
    return array.concat(interp, strings[i + 1]);
  }, [strings[0]]);
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
var css = (function (styles) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  if (!Array.isArray(styles) && (typeof styles === 'undefined' ? 'undefined' : _typeof(styles)) === 'object') {
    return flatten(interleave([], [styles].concat(interpolations)));
  }
  return flatten(interleave(styles, interpolations));
});

var stream = {}

// 


var SC_ATTR = typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":""}).SC_ATTR || 'data-styled-components';
var SC_STREAM_ATTR = 'data-styled-streamed';
var CONTEXT_KEY = '__styled-components-stylesheet__';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = typeof false === 'boolean' && false || "production" !== 'production';

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
  return  true ? __webpack_require__.nc : null;
});

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb();
    }
  };
});

// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */

/* adds a new ID:name pairing to a names dictionary */
var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};

/* resets an ID entirely by overwriting it in the dictionary */
var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};

/* factory for a names dictionary checking the existance of an ID:name pairing */
var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};

/* stringifies names for the html/element output */
var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};

/* clones the nested names dictionary */
var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends({}, names[id]);
  }
  return clone;
};

// 
/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */

/* retrieve a sheet for a given style tag */
var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
  var size = document.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = document.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  /* we should always be able to find a tag */
  throw new Error();
};

/* insert a rule safely and return whether it was actually injected */
var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  /* abort early if cssRule string is falsy */
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
  } catch (err) {
    /* any error indicates an invalid rule */
    return false;
  }

  return true;
};

/* deletes `size` rules starting from `removalIndex` */
var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i > lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 
/* eslint-disable flowtype/object-type-delimiter */
/* eslint-disable react/prop-types */

/* this error is used for makeStyleTag */
var parentNodeUnmountedErr =  false ? '\nTrying to insert a new style tag, but the given Node is unmounted!\n- Are you using a custom target that isn\'t mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n'.trim() : '';

/* this error is used for tags */
var throwCloneTagErr = function throwCloneTagErr() {
  throw new Error( false ? '\nThe clone method cannot be used on the client!\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n'.trim() : '');
};

/* this marker separates component styles and is important for rehydration */
var makeTextMarker = function makeTextMarker(id) {
  return '\n/* sc-component-id: ' + id + ' */\n';
};

/* add up all numbers in array up until and including the index */
var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};

/* create a new style tag after lastEl */
var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var el = document.createElement('style');
  el.setAttribute(SC_ATTR, '');

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  /* Work around insertRule quirk in EdgeHTML */
  el.appendChild(document.createTextNode(''));

  if (target && !tagEl) {
    /* Append to target when no previous element was passed */
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new Error(parentNodeUnmountedErr);
    }

    /* Insert new style tag after the previous one */
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};

/* takes a css factory function and outputs an html styled tag factory */
var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};

/* takes a css factory function and outputs an element factory */
var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};

/* speedy tags utilise insertRule */
var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    var marker = markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);
    return marker;
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; /* add up no of injected rules */
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker);
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    styleTag: el,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    css: css,
    toHTML: wrapAsHtmlTag(css, names),
    toElement: wrapAsElement(css, names),
    clone: throwCloneTagErr
  };
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;
  var makeTextNode = function makeTextNode(id) {
    return document.createTextNode(makeTextMarker(id));
  };

  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    var marker = markers[id] = makeTextNode(id);
    el.appendChild(marker);
    names[id] = Object.create(null);
    return marker;
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    /* create new empty text node and replace the current one */
    var newMarker = makeTextNode(id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }
    return str;
  };

  return {
    styleTag: el,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    css: css,
    toHTML: wrapAsHtmlTag(css, names),
    toElement: wrapAsElement(css, names),
    clone: throwCloneTagErr
  };
};

var makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTagInternal(namesClone, markersClone);
  };

  var tag = {
    styleTag: null,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    css: css,
    toHTML: wrapAsHtmlTag(css, names),
    toElement: wrapAsElement(css, names),
    clone: clone
  };

  return tag;
};

var makeServerTag = function makeServerTag() {
  return makeServerTagInternal();
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);
    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

/* wraps a given tag so that rehydration is performed once when necessary */
var makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, names, immediateRehydration) {
  /* rehydration function that adds all rules to the new tag */
  var rehydrate = once(function () {
    /* add all extracted components to the new tag */
    for (var i = 0; i < extracted.length; i += 1) {
      var _extracted$i = extracted[i],
          componentId = _extracted$i.componentId,
          cssFromDOM = _extracted$i.cssFromDOM;

      var cssRules = splitByRules(cssFromDOM);
      tag.insertRules(componentId, cssRules);
    }

    /* remove old HTMLStyleElements, since they have been rehydrated */
    for (var _i = 0; _i < els.length; _i += 1) {
      var el = els[_i];
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  });

  if (immediateRehydration) rehydrate();

  return _extends({}, tag, {
    /* add rehydration hook to insertion methods */
    insertMarker: function insertMarker(id) {
      rehydrate();
      return tag.insertMarker(id);
    },
    insertRules: function insertRules(id, cssRules, name) {
      rehydrate();
      return tag.insertRules(id, cssRules, name);
    }
  });
};

// 

/* determine the maximum number of components before tags are sharded */
var MAX_SIZE = void 0;
if (IS_BROWSER) {
  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  /* for servers we do not need to shard at all */
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {
  /* a map from ids to tags */
  /* deferred rules for a given id */
  /* this is used for not reinjecting rules via hasNameForId() */
  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */
  /* a list of tags belonging to this StyleSheet */
  /* a tag for import rules */
  /* current capacity until a new tag must be created */
  /* children (aka clones) of this StyleSheet inheriting all and future injections */

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    this.id = sheetRunningId += 1;
    this.sealed = false;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  /* rehydrate all SSR'd style tags */


  StyleSheet.prototype.rehydrate = function rehydrate() {
    if (!IS_BROWSER || this.forceServer) {
      return this;
    }

    var els = [];
    var names = [];
    var extracted = [];
    var isStreamed = false;

    /* retrieve all of our SSR style elements from the DOM */
    var nodes = document.querySelectorAll('style[' + SC_ATTR + ']');
    var nodesSize = nodes.length;

    /* abort rehydration if no previous style tags were found */
    if (nodesSize === 0) {
      return this;
    }

    for (var i = 0; i < nodesSize; i += 1) {
      // $FlowFixMe: We can trust that all elements in this query are style elements
      var el = nodes[i];

      /* check if style tag is a streamed tag */
      isStreamed = !!el.getAttribute(SC_STREAM_ATTR) || isStreamed;

      /* retrieve all component names */
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(/\s+/);
      var elNamesSize = elNames.length;
      for (var j = 0; j < elNamesSize; j += 1) {
        var name = elNames[j];
        /* add rehydrated name to sheet to avoid readding styles */
        this.rehydratedNames[name] = true;
        names.push(name);
      }

      /* extract all components and their CSS */
      extracted = extracted.concat(extractComps(el.textContent));
      /* store original HTMLStyleElement */
      els.push(el);
    }

    /* abort rehydration if nothing was extracted */
    var extractedSize = extracted.length;
    if (extractedSize === 0) {
      return this;
    }

    /* create a tag to be used for rehydration */
    var tag = this.makeTag(null);
    var rehydrationTag = makeRehydrationTag(tag, els, extracted, names, isStreamed);

    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(rehydrationTag);

    /* retrieve all component ids */
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = rehydrationTag;
    }

    return this;
  };

  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
    * StyleSheetManager's context */


  /* reset the internal "master" instance */
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */


  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);
    /* add to clone array */
    this.clones.push(sheet);

    /* clone all tags */
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      /* reconstruct tagMap */
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    /* clone other maps */
    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
    sheet.deferred = _extends({}, this.deferred);

    return sheet;
  };

  /* force StyleSheet to create a new tag on the next injection */


  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;
    this.sealed = true;
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  /* get a tag for a given componentId, assign the componentId to one, or shard */
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    /* simply return a tag, when the componentId was already assigned one */
    var prev = this.tagMap[id];
    if (prev !== undefined && !this.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
    this.capacity -= 1;
    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      this.sealed = false;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  /* mainly for injectGlobal to check for its id */


  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  /* caching layer checking id+name to already have a corresponding tag and injected rules */


  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    /* exception for rehydrated names which are checked separately */
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  /* registers a componentId and registers it on its tag */


  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    /* don't inject when the id is already registered */
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  /* injects rules for a given id with a name that will need to be cached */


  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    /* add deferred rules for component */
    var injectRules = cssRules;
    var deferredRules = this.deferred[id];
    if (deferredRules !== undefined) {
      injectRules = deferredRules.concat(injectRules);
      delete this.deferred[id];
    }

    var tag = this.getTagForId(id);
    tag.insertRules(id, injectRules, name);
  };

  /* removes all rules for a given id, which doesn't remove its marker but resets it */


  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    /* remove all rules from the tag */
    tag.removeRules(id);
    /* ignore possible rehydrated names */
    this.ignoreRehydratedNames[id] = true;
    /* delete possible deferred rules */
    delete this.deferred[id];
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;


    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return Object(__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"])(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    /* NOTE: This is just for backwards-compatibility with jest-styled-components */

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

var _StyleSheetManager$ch;

// 
/* this error is used for makeStyleTag */
var targetPropErr =  false ? '\nThe StyleSheetManager expects a valid target or sheet prop!\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n'.trim() : '';

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager() {
    classCallCheck(this, StyleSheetManager);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  StyleSheetManager.prototype.getChildContext = function getChildContext() {
    var _ref;

    return _ref = {}, _ref[CONTEXT_KEY] = this.sheetInstance, _ref;
  };

  StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
    if (this.props.sheet) {
      this.sheetInstance = this.props.sheet;
    } else if (this.props.target) {
      this.sheetInstance = new StyleSheet(this.props.target);
    } else {
      throw new Error(targetPropErr);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    /* eslint-disable react/prop-types */
    // Flow v0.43.1 will report an error accessing the `children` property,
    // but v0.47.0 will not. It is necessary to use a type cast instead of
    // a "fixme" comment to satisfy both Flow versions.
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.only(this.props.children);
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]).isRequired, _StyleSheetManager$ch);

 false ? StyleSheetManager.propTypes = {
  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),
  target: PropTypes.shape({
    appendChild: PropTypes.func.isRequired
  })
} : void 0;

// 
/* eslint-disable no-underscore-dangle */
/* this error is used for makeStyleTag */
var sheetClosedErr =  false ? '\nCan\'t collect styles once you\'ve consumed a ServerStyleSheet\'s styles!\nServerStyleSheet is a one off instance for each server-side render cycle.\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n'.trim() : '';

var streamBrowserErr =  false ? 'Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.' : '';

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    /* The master sheet might be reset, so keep a reference here */
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.closed = false;
  }

  ServerStyleSheet.prototype.complete = function complete() {
    if (!this.closed) {
      /* Remove closed StyleSheets from the master sheet */
      var index = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index, 1);
      this.closed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.closed) {
      throw new Error(sheetClosedErr);
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.complete();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.complete();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    {
      throw new Error(streamBrowserErr);
    }

    /* the tag index keeps track of which tags have already been emitted */
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';
    var ourStream = new stream.Readable();
    // $FlowFixMe
    ourStream._read = function () {};

    readableStream.on('data', function (chunk) {
      var tags = instance.tags;

      var html = '';

      /* retrieve html for each new style tag */
      for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
        var tag = tags[instanceTagIndex];
        html += tag.toHTML(streamAttr);
      }

      /* force our StyleSheets to emit entirely new tags */
      instance.sealAllTags();
      /* prepend style html to chunk */
      ourStream.push(html + chunk);
    });

    readableStream.on('end', function () {
      _this.complete();
      ourStream.push(null);
    });

    readableStream.on('error', function (err) {
      _this.complete();
      ourStream.emit('error', err);
    });

    return ourStream;
  };

  return ServerStyleSheet;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 

var determineTheme = (function (props, fallbackTheme, defaultProps) {
  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types */
  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
  /* eslint-enable */

  return theme;
});

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 

/* eslint-disable no-undef */
function getComponentName(target) {
  return target.displayName || target.name || 'Component';
}

// 

function isTag(target) /* : %checks */{
  return typeof target === 'string';
}

// 
function generateDisplayName(target) {
  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
}

// 
/* eslint-disable max-len */
/**
 * Trying to avoid the unknown-prop errors on styled components by filtering by
 * React's attribute whitelist.
 *
 * To regenerate this regex:
 *
 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
 * 2. Run `regexgen` with the list of space-separated words below as input
 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
 *    and no false positives from partials
 **/
/*
children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan
*/
/* eslint-enable max-len */

var ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur|Invalid)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|(?:attribute|glyph)Nam|playsInlin|(?:formE|e)ncTyp|(?:writing|input|edge)Mod|(?:xlinkTy|itemSco|keyTy|slo)p|(?:amplitu|mo)d|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|lip(?:Path)?|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|autoFocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|formActio|zoomAndPa|onFocusI|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur|Invalid)|rient)|p(?:reserveA(?:spectRatio|lpha)|ointsAt[X-Z]|anose1)|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:gradientT|patternT|t)ransform|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:strokeMiterlimi|(?:specularConsta|repeatCou|fontVaria)n|(?:(?:specularE|e)xpon|renderingInt|asc)en|d(?:iffuseConsta|esce)n|(?:fontSizeAdju|lengthAdju|manife)s|baselineShif|vectorEffec|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|a(?:utoCorrec|bou)|markerStar|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|m(?:arkerMi|etho)|preloa|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:allowFullScre|hidd)en|strokeDasharray|systemLanguage|(?:strokeLineca|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|(?:pointerEve|keyPoi)nts|unicodeRange|(?:(?:allowReord|placehold|frameBord|paintOrd|post|ord)e|repeatDu|d(?:efe|u))r|mathematical|(?:vI|i)deographic|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|vAlphabetic|mediaGroup|spellCheck|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|(?:xmlnsXl|valueL)ink|a(?:rabicForm|l(?:phabetic|t)|sync)|pathLength|(?:text|m(?:in|ax))Length|innerHTML|xlinkShow|(?:xlinkHr|glyphR)ef|r(?:e(?:quired|sult|f))?|o(?:verflow|pen)|(?:tabInde|(?:sand|b)bo|viewBo)x|(?:(?:href|xml|src)La|kerni)ng|f(?:o(?:ntSize|rm)|il(?:ter|l))|autoPlay|unicode|p(?:attern|oints)|t(?:arget[XY]|o)|i(?:temRef|n2|s)|divisor|d(?:efault|ata|ir)?|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|(?:width|size)s|(?:stri|la)ng|prefix|itemID|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|s)|t(?:arget|ype)|typeof|width|value|x(?:mlns)?|label|m(?:edia|a(?:sk|x)|in)|size|href|k(?:ey)?|end|low|x[12]|i[dn]|y[12]|g[12]|by|f[xy]|[yz])$/;

/* From DOMProperty */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(x|data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));

var validAttr = (function (name) {
  return ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase());
});

// 
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */

var createBroadcast = function createBroadcast(initialState) {
  var listeners = {};
  var id = 0;
  var state = initialState;

  function publish(nextState) {
    state = nextState;

    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in listeners) {
      var listener = listeners[key];
      if (listener === undefined) {
        // eslint-disable-next-line no-continue
        continue;
      }

      listener(state);
    }
  }

  function subscribe(listener) {
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    listener(state);
    return currentId;
  }

  function unsubscribe(unsubID) {
    listeners[unsubID] = undefined;
  }

  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
};

var _ThemeProvider$childC;
var _ThemeProvider$contex;

// 
/* globals React$Element */
// NOTE: DO NOT CHANGE, changing this is a semver major change!
var CHANNEL = '__styled-components__';
var CHANNEL_NEXT = CHANNEL + 'next__';

var CONTEXT_CHANNEL_SHAPE = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
  getTheme: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  subscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  unsubscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
});

var warnChannelDeprecated = void 0;
if (false) {
  warnChannelDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.error('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
  });
}

var isFunction = function isFunction(test) {
  return typeof test === 'function';
};

/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider() {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.unsubscribeToOuterId = -1;

    _this.getTheme = _this.getTheme.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
    // with the outer theme
    var outerContext = this.context[CHANNEL_NEXT];
    if (outerContext !== undefined) {
      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
        _this2.outerTheme = theme;

        if (_this2.broadcast !== undefined) {
          _this2.publish(_this2.props.theme);
        }
      });
    }

    this.broadcast = createBroadcast(this.getTheme());
  };

  ThemeProvider.prototype.getChildContext = function getChildContext() {
    var _this3 = this,
        _babelHelpers$extends;

    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL_NEXT] = {
      getTheme: this.getTheme,
      subscribe: this.broadcast.subscribe,
      unsubscribe: this.broadcast.unsubscribe
    }, _babelHelpers$extends[CHANNEL] = function (subscriber) {
      if (false) {
        warnChannelDeprecated();
      }

      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
      return function () {
        return _this3.broadcast.unsubscribe(unsubscribeId);
      };
    }, _babelHelpers$extends));
  };

  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.theme !== nextProps.theme) {
      this.publish(nextProps.theme);
    }
  };

  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeToOuterId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    }
  };

  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation


  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
    var theme = passedTheme || this.props.theme;
    if (isFunction(theme)) {
      var mergedTheme = theme(this.outerTheme);
      if (false) {
        throw new Error(process.env.NODE_ENV !== 'production' ? '[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!' : '');
      }
      return mergedTheme;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(theme)) {
      throw new Error( false ? '[ThemeProvider] Please make your theme prop a plain object' : '');
    }
    return _extends({}, this.outerTheme, theme);
  };

  ThemeProvider.prototype.publish = function publish(theme) {
    this.broadcast.publish(this.getTheme(theme));
  };

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.only(this.props.children);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

ThemeProvider.childContextTypes = (_ThemeProvider$childC = {}, _ThemeProvider$childC[CHANNEL] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, _ThemeProvider$childC[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$childC);
ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);

// 

// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var STATIC_EXECUTION_CONTEXT = {};

var _StyledComponent = (function (ComponentStyle, constructWithOptions) {
  var identifiers = {};

  /* We depend on components having unique IDs */
  var generateId = function generateId(_displayName, parentComponentId) {
    var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

    var componentId = void 0;

    /**
     * only fall back to hashing the component injection order if
     * a proper displayName isn't provided by the babel plugin
     */
    if (!_displayName) {
      var nr = (identifiers[displayName] || 0) + 1;
      identifiers[displayName] = nr;

      componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);
    } else {
      componentId = displayName + '-' + ComponentStyle.generateName(displayName);
    }

    return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
  };

  var BaseStyledComponent = function (_Component) {
    inherits(BaseStyledComponent, _Component);

    function BaseStyledComponent() {
      var _temp, _this, _ret;

      classCallCheck(this, BaseStyledComponent);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
        theme: null,
        generatedClassName: ''
      }, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
      var attrs = this.constructor.attrs;

      var context = _extends({}, props, { theme: theme });
      if (attrs === undefined) {
        return context;
      }

      this.attrs = Object.keys(attrs).reduce(function (acc, key) {
        var attr = attrs[key];
        // eslint-disable-next-line no-param-reassign
        acc[key] = typeof attr === 'function' ? attr(context) : attr;
        return acc;
      }, {});

      return _extends({}, context, this.attrs);
    };

    BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
      var _constructor = this.constructor,
          attrs = _constructor.attrs,
          componentStyle = _constructor.componentStyle,
          warnTooManyClasses = _constructor.warnTooManyClasses;

      var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.master;

      // staticaly styled-components don't need to build an execution context object,
      // and shouldn't be increasing the number of class names
      if (componentStyle.isStatic && attrs === undefined) {
        return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
      } else {
        var executionContext = this.buildExecutionContext(theme, props);
        var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);

        if (false) {
          warnTooManyClasses(className);
        }

        return className;
      }
    };

    BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var componentStyle = this.constructor.componentStyle;

      var styledContext = this.context[CHANNEL_NEXT];

      // If this is a staticaly-styled component, we don't need to the theme
      // to generate or build styles.
      if (componentStyle.isStatic) {
        var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
        this.setState({ generatedClassName: generatedClassName });
        // If there is a theme in the context, subscribe to the event emitter. This
        // is necessary due to pure components blocking context updates, this circumvents
        // that by updating when an event is emitted
      } else if (styledContext !== undefined) {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          // This will be called once immediately
          var theme = determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);
          var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);

          _this2.setState({ theme: theme, generatedClassName: generatedClassName });
        });
      } else {
        // eslint-disable-next-line react/prop-types
        var theme = this.props.theme || {};
        var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
        this.setState({ theme: theme, generatedClassName: _generatedClassName });
      }
    };

    BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      // If this is a statically-styled component, we don't need to listen to
      // props changes to update styles
      var componentStyle = this.constructor.componentStyle;

      if (componentStyle.isStatic) {
        return;
      }

      this.setState(function (oldState) {
        var theme = determineTheme(nextProps, oldState.theme, _this3.constructor.defaultProps);
        var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);

        return { theme: theme, generatedClassName: generatedClassName };
      });
    };

    BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      this.unsubscribeFromContext();
    };

    BaseStyledComponent.prototype.render = function render() {
      var _this4 = this;

      // eslint-disable-next-line react/prop-types
      var innerRef = this.props.innerRef;
      var generatedClassName = this.state.generatedClassName;
      var _constructor2 = this.constructor,
          styledComponentId = _constructor2.styledComponentId,
          target = _constructor2.target;


      var isTargetTag = isTag(target);

      var className = [
      // eslint-disable-next-line react/prop-types
      this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');

      var baseProps = _extends({}, this.attrs, {
        className: className
      });

      if (isStyledComponent(target)) {
        baseProps.innerRef = innerRef;
      } else {
        baseProps.ref = innerRef;
      }

      var propsForElement = Object.keys(this.props).reduce(function (acc, propName) {
        // Don't pass through non HTML tags through to HTML elements
        // always omit innerRef
        if (propName !== 'innerRef' && propName !== 'className' && (!isTargetTag || validAttr(propName))) {
          // eslint-disable-next-line no-param-reassign
          acc[propName] = _this4.props[propName];
        }

        return acc;
      }, baseProps);

      return Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(target, propsForElement);
    };

    return BaseStyledComponent;
  }(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

  var createStyledComponent = function createStyledComponent(target, options, rules) {
    var _StyledComponent$cont;

    var _options$isClass = options.isClass,
        isClass = _options$isClass === undefined ? !isTag(target) : _options$isClass,
        _options$displayName = options.displayName,
        displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
        _options$componentId = options.componentId,
        componentId = _options$componentId === undefined ? generateId(options.displayName, options.parentComponentId) : _options$componentId,
        _options$ParentCompon = options.ParentComponent,
        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
        extendingRules = options.rules,
        attrs = options.attrs;


    var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : componentId;

    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);

    var StyledComponent = function (_ParentComponent) {
      inherits(StyledComponent, _ParentComponent);

      function StyledComponent() {
        classCallCheck(this, StyledComponent);
        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
      }

      StyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId,
            optionsToCopy = objectWithoutProperties(options, ['componentId']);


        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

        var newOptions = _extends({}, optionsToCopy, {
          componentId: newComponentId,
          ParentComponent: StyledComponent
        });

        return createStyledComponent(tag, newOptions, rules);
      };

      createClass(StyledComponent, null, [{
        key: 'extend',
        get: function get$$1() {
          var rulesFromOptions = options.rules,
              parentComponentId = options.componentId,
              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);


          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);

          var newOptions = _extends({}, optionsToCopy, {
            rules: newRules,
            parentComponentId: parentComponentId,
            ParentComponent: StyledComponent
          });

          return constructWithOptions(createStyledComponent, target, newOptions);
        }
      }]);
      return StyledComponent;
    }(ParentComponent);

    StyledComponent.contextTypes = (_StyledComponent$cont = {}, _StyledComponent$cont[CHANNEL] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, _StyledComponent$cont[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _StyledComponent$cont[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]), _StyledComponent$cont);


    if (false) {
      StyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
    }

    if (isClass) __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(StyledComponent, target);

    // we do this after hoisting to ensure we're overwriting existing
    // rules when wrapping another styled component class
    StyledComponent.displayName = displayName;
    StyledComponent.styledComponentId = styledComponentId;
    StyledComponent.attrs = attrs;
    StyledComponent.componentStyle = componentStyle;
    StyledComponent.target = target;

    return StyledComponent;
  };

  return createStyledComponent;
});

// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(str) {
  var l = str.length | 0,
      h = l | 0,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;

    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);

    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;

    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;

  return h >>> 0;
}

// 
var areStylesCacheable = IS_BROWSER;

var isStaticRules = function isStaticRules(rules, attrs) {
  for (var i = 0; i < rules.length; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule)) {
      return false;
    } else if (typeof rule === 'function' && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs !== undefined) {
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in attrs) {
      var value = attrs[key];
      if (typeof value === 'function') {
        return false;
      }
    }
  }

  return true;
};

var isHMREnabled = typeof module !== 'undefined' && module.hot && "production" !== 'production';

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */
var _ComponentStyle = (function (nameGenerator, flatten, stringifyRules) {
  /* combines hashStr (murmurhash) and nameGenerator for convenience */
  var generateRuleHash = function generateRuleHash(str) {
    return nameGenerator(murmurhash(str));
  };

  var ComponentStyle = function () {
    function ComponentStyle(rules, attrs, componentId) {
      classCallCheck(this, ComponentStyle);

      this.rules = rules;
      this.isStatic = !isHMREnabled && isStaticRules(rules, attrs);
      this.componentId = componentId;

      if (!StyleSheet.master.hasId(componentId)) {
        var placeholder =  false ? ['.' + componentId + ' {}'] : [];

        StyleSheet.master.deferredInject(componentId, placeholder);
      }
    }

    /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */


    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
      var isStatic = this.isStatic,
          componentId = this.componentId,
          lastClassName = this.lastClassName;

      if (areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) {
        return lastClassName;
      }

      var flatCSS = flatten(this.rules, executionContext);
      var name = generateRuleHash(this.componentId + flatCSS.join(''));

      if (!styleSheet.hasNameForId(componentId, name)) {
        var css = stringifyRules(flatCSS, '.' + name);
        styleSheet.inject(this.componentId, css, name);
      }

      this.lastClassName = name;
      return name;
    };

    ComponentStyle.generateName = function generateName(str) {
      return generateRuleHash(str);
    };

    return ComponentStyle;
  }();

  return ComponentStyle;
});

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 
var _styled = (function (styledComponent, constructWithOptions) {
  var styled = function styled(tag) {
    return constructWithOptions(styledComponent, tag);
  };

  // Shorthands for all valid HTML Elements
  domElements.forEach(function (domElement) {
    styled[domElement] = styled(domElement);
  });

  return styled;
});

// 
var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

var _keyframes = (function (nameGenerator, stringifyRules, css) {
  return function () {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var name = nameGenerator(murmurhash(replaceWhitespace(JSON.stringify(rules))));
    var id = 'sc-keyframes-' + name;

    if (!styleSheet.hasNameForId(id, name)) {
      styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
    }

    return name;
  };
});

// 
var _injectGlobal = (function (stringifyRules, css) {
  var injectGlobal = function injectGlobal() {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var hash = murmurhash(JSON.stringify(rules));
    var id = 'sc-global-' + hash;

    if (!styleSheet.hasId(id)) {
      styleSheet.inject(id, stringifyRules(rules));
    }
  };

  return injectGlobal;
});

// 
var _constructWithOptions = (function (css) {
  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (!Object(__WEBPACK_IMPORTED_MODULE_6_react_is__["isValidElementType"])(tag)) {
      throw new Error( false ? 'Cannot create styled-component for component: ' + String(tag) : '');
    }

    /* This is callable directly as a template function */
    // $FlowFixMe: Not typed to avoid destructuring arguments
    var templateFunction = function templateFunction() {
      return componentConstructor(tag, options, css.apply(undefined, arguments));
    };

    /* If config methods are called, wrap up a new template function and merge options */
    templateFunction.withConfig = function (config) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
    };
    templateFunction.attrs = function (attrs) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
        attrs: _extends({}, options.attrs || {}, attrs)
      }));
    };

    return templateFunction;
  };

  return constructWithOptions;
});

// 
/* globals ReactClass */

var wrapWithTheme = function wrapWithTheme(Component$$1) {
  var _WithTheme$contextTyp;

  var componentName = Component$$1.displayName || Component$$1.name || 'Component';
  var isStatelessFunctionalComponent = typeof Component$$1 === 'function' && !(Component$$1.prototype && 'isReactComponent' in Component$$1.prototype);

  // NOTE: We can't pass a ref to a stateless functional component
  var shouldSetInnerRef = isStyledComponent(Component$$1) || isStatelessFunctionalComponent;

  var WithTheme = function (_React$Component) {
    inherits(WithTheme, _React$Component);

    function WithTheme() {
      var _temp, _this, _ret;

      classCallCheck(this, WithTheme);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {}, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping


    WithTheme.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var defaultProps = this.constructor.defaultProps;

      var styledContext = this.context[CHANNEL_NEXT];
      var themeProp = determineTheme(this.props, undefined, defaultProps);
      if (styledContext === undefined && themeProp === undefined && "production" !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
      } else if (styledContext === undefined && themeProp !== undefined) {
        this.setState({ theme: themeProp });
      } else {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          var theme = determineTheme(_this2.props, nextTheme, defaultProps);
          _this2.setState({ theme: theme });
        });
      }
    };

    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var defaultProps = this.constructor.defaultProps;

      this.setState(function (oldState) {
        var theme = determineTheme(nextProps, oldState.theme, defaultProps);

        return { theme: theme };
      });
    };

    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    WithTheme.prototype.render = function render() {
      var props = _extends({
        theme: this.state.theme
      }, this.props);

      if (!shouldSetInnerRef) {
        props.ref = props.innerRef;
        delete props.innerRef;
      }

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component$$1, props);
    };

    return WithTheme;
  }(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

  WithTheme.displayName = 'WithTheme(' + componentName + ')';
  WithTheme.styledComponentId = 'withTheme';
  WithTheme.contextTypes = (_WithTheme$contextTyp = {}, _WithTheme$contextTyp[CHANNEL] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, _WithTheme$contextTyp[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _WithTheme$contextTyp);


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(WithTheme, Component$$1);
};

// 

/* eslint-disable */
var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
  StyleSheet: StyleSheet
};

// 

/* Import singletons */
/* Import singleton constructors */
/* Import components */
/* Import Higher Order Components */
/* Warning if you've imported this file on React Native */
if (false) {
  // eslint-disable-next-line no-console
  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
}

/* Warning if there are several instances of styled-components */
if (false) {
  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;

  if (window['__styled-components-init__'] === 1) {
    // eslint-disable-next-line no-console
    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
  }

  window['__styled-components-init__'] += 1;
}

/* Instantiate singletons */
var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
var constructWithOptions = _constructWithOptions(css);
var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);

/* Instantiate exported singletons */
var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
var injectGlobal = _injectGlobal(stringifyRules, css);
var styled = _styled(StyledComponent, constructWithOptions);


/* harmony default export */ __webpack_exports__["b"] = (styled);
//# sourceMappingURL=styled-components.browser.es.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(53), __webpack_require__(54)(module)))

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translate__ = __webpack_require__(88);
/* unused harmony reexport translate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__I18n__ = __webpack_require__(32);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__I18n__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Interpolate__ = __webpack_require__(91);
/* unused harmony reexport Interpolate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Trans__ = __webpack_require__(92);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__Trans__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__I18nextProvider__ = __webpack_require__(98);
/* unused harmony reexport I18nextProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loadNamespaces__ = __webpack_require__(99);
/* unused harmony reexport loadNamespaces */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__context__ = __webpack_require__(22);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__context__["c"]; });
/* unused harmony reexport setDefaults */
/* unused harmony reexport getDefaults */
/* unused harmony reexport setI18n */
/* unused harmony reexport getI18n */








/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Intro; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Title; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SubTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Paragraph; });
/* unused harmony export BaseInput */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Input; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return Triangle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Link; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n  margin: 2em auto;\n  padding: 0 2em;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  ',';\n'],['\n  margin: 2em auto;\n  padding: 0 2em;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n']),_templateObject3=_taggedTemplateLiteral(['\n  color: ',';\n  text-shadow: ',';\n  text-transform: uppercase;\n  text-align: center;\n  font-size: 30px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  ',';\n'],['\n  color: ',';\n  text-shadow: ',';\n  text-transform: uppercase;\n  text-align: center;\n  font-size: 30px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  ',';\n']),_templateObject4=_taggedTemplateLiteral(['\n      &:after {\n        content: \'\';\n        margin-top: 0.2em;\n        width: 4.5em;\n        height: 0;\n        border-bottom: 2px solid ',';\n      }\n    '],['\n      &:after {\n        content: \'\';\n        margin-top: 0.2em;\n        width: 4.5em;\n        height: 0;\n        border-bottom: 2px solid ',';\n      }\n    ']),_templateObject5=_taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  ',';\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  ',';\n']),_templateObject6=_taggedTemplateLiteral(['\n      &:after {\n        content: \'\';\n        margin-top: 0.2em;\n        width: 2.3em;\n        height: 0;\n        border-bottom: 2px solid ',';\n      }\n    '],['\n      &:after {\n        content: \'\';\n        margin-top: 0.2em;\n        width: 2.3em;\n        height: 0;\n        border-bottom: 2px solid ',';\n      }\n    ']),_templateObject7=_taggedTemplateLiteral(['\n  color: ',';\n  text-shadow: ',';\n  text-align: center;\n  max-width: 56.25em;\n  font-size: 20px;\n'],['\n  color: ',';\n  text-shadow: ',';\n  text-align: center;\n  max-width: 56.25em;\n  font-size: 20px;\n']),_templateObject8=_taggedTemplateLiteral(['\n  font-family: Avenir;\n  outline: none;\n\n  &:focus {\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);\n  }\n'],['\n  font-family: Avenir;\n  outline: none;\n\n  &:focus {\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);\n  }\n']),_templateObject9=_taggedTemplateLiteral(['\n  padding: 0.6em;\n  border: solid 1px #999999;\n  border-radius: 15px;\n  box-sizing: border-box;\n\n  &::placeholder {\n    font-style: italic;\n  }\n'],['\n  padding: 0.6em;\n  border: solid 1px #999999;\n  border-radius: 15px;\n  box-sizing: border-box;\n\n  &::placeholder {\n    font-style: italic;\n  }\n']),_templateObject10=_taggedTemplateLiteral(['\n  cursor: pointer;\n  color: #fff;\n  font-weight: bold;\n  border: none;\n  border-radius: 18px;\n  text-transform: uppercase;\n  background: transparent;\n  border: ',';\n  padding: 0.5em 1.5em;\n  font-size: 13px;\n  text-shadow: 7px 7px 5px rgba(0,0,0, 0.03);\n  box-shadow: 7px 7px 5px rgba(0,0,0, 0.03);\n'],['\n  cursor: pointer;\n  color: #fff;\n  font-weight: bold;\n  border: none;\n  border-radius: 18px;\n  text-transform: uppercase;\n  background: transparent;\n  border: ',';\n  padding: 0.5em 1.5em;\n  font-size: 13px;\n  text-shadow: 7px 7px 5px rgba(0,0,0, 0.03);\n  box-shadow: 7px 7px 5px rgba(0,0,0, 0.03);\n']),_templateObject11=_taggedTemplateLiteral(['\n  width: 0;\n  height: 0;\n  ',';\n\n  ',';\n\n  ',';\n\n  ',';\n'],['\n  width: 0;\n  height: 0;\n  ',';\n\n  ',';\n\n  ',';\n\n  ',';\n']),_templateObject12=_taggedTemplateLiteral(['\n      border-top: 3em solid ',';\n      border-right: 100vw solid transparent;\n    '],['\n      border-top: 3em solid ',';\n      border-right: 100vw solid transparent;\n    ']),_templateObject13=_taggedTemplateLiteral(['\n      border-bottom: 3em solid ',';\n      border-left: 100vw solid transparent;\n    '],['\n      border-bottom: 3em solid ',';\n      border-left: 100vw solid transparent;\n    ']),_templateObject14=_taggedTemplateLiteral(['\n      border-bottom: 3em solid ',';\n      border-right: 100vw solid transparent;\n    '],['\n      border-bottom: 3em solid ',';\n      border-right: 100vw solid transparent;\n    ']),_templateObject15=_taggedTemplateLiteral(['\n      border-top: 3em solid ',';\n      border-left: 100vw solid transparent;\n    '],['\n      border-top: 3em solid ',';\n      border-left: 100vw solid transparent;\n    ']),_templateObject16=_taggedTemplateLiteral(['\n  text-decoration: none;\n  color: #fff;\n'],['\n  text-decoration: none;\n  color: #fff;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].section(_templateObject,function(props){return props.small&&'max-width: 37.5em;';});var Intro=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject2);var Title=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].h2(_templateObject3,function(props){return props.color?props.color:'#000';},function(props){return props.dropshadow?'7px 7px 5px rgba(0,0,0, 0.03)':'none';},function(props){return!props.noUnderline&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* css */])(_templateObject4,props.color?props.color:'#000');});var SubTitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].h3(_templateObject5,function(props){return!props.noUnderline&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* css */])(_templateObject6,props.color?props.color:'#000');});var Paragraph=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].p(_templateObject7,function(props){return props.color?props.color:'#000';},function(props){return props.dropshadow?'7px 7px 5px rgba(0,0,0, 0.03)':'none';});var BaseInput=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].input(_templateObject8);var Input=BaseInput.extend(_templateObject9);var Button=BaseInput.withComponent('button').extend(_templateObject10,function(props){return props.border?'solid 2px #fff':'none';});var Triangle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject11,function(props){return props.leftBottom&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* css */])(_templateObject12,props.color);},function(props){return props.rightTop&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* css */])(_templateObject13,props.color);},function(props){return props.leftTop&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* css */])(_templateObject14,props.color);},function(props){return props.rightBottom&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* css */])(_templateObject15,props.color);});var Link=__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].a(_templateObject16);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule warning
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(65);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(68);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__createHashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(69);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(11);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(9);
/* unused harmony reexport parsePath */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__PathUtils__["b"]; });










/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var consoleLogger = {
  type: 'logger',

  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    var _console;

    /* eslint no-console: 0 */
    if (console && console[type]) (_console = console)[type].apply(_console, _toConsumableArray(args));
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Logger);

    this.init(concreteLogger, options);
  }

  Logger.prototype.init = function init(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    this.prefix = options.prefix || 'i18next:';
    this.logger = concreteLogger || consoleLogger;
    this.options = options;
    this.debug = options.debug;
  };

  Logger.prototype.setDebug = function setDebug(bool) {
    this.debug = bool;
  };

  Logger.prototype.log = function log() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return this.forward(args, 'log', '', true);
  };

  Logger.prototype.warn = function warn() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return this.forward(args, 'warn', '', true);
  };

  Logger.prototype.error = function error() {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return this.forward(args, 'error', '');
  };

  Logger.prototype.deprecate = function deprecate() {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
  };

  Logger.prototype.forward = function forward(args, lvl, prefix, debugOnly) {
    if (debugOnly && !this.debug) return null;
    if (typeof args[0] === 'string') args[0] = '' + prefix + this.prefix + ' ' + args[0];
    return this.logger[lvl](args);
  };

  Logger.prototype.create = function create(moduleName) {
    return new Logger(this.logger, _extends({ prefix: this.prefix + ':' + moduleName + ':' }, this.options));
  };

  return Logger;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Logger());

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(9);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["a" /* default */])(a.state, b.state);
};

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventEmitter = function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.observers = {};
  }

  EventEmitter.prototype.on = function on(events, listener) {
    var _this = this;

    events.split(' ').forEach(function (event) {
      _this.observers[event] = _this.observers[event] || [];
      _this.observers[event].push(listener);
    });
  };

  EventEmitter.prototype.off = function off(event, listener) {
    var _this2 = this;

    if (!this.observers[event]) {
      return;
    }

    this.observers[event].forEach(function () {
      if (!listener) {
        delete _this2.observers[event];
      } else {
        var index = _this2.observers[event].indexOf(listener);
        if (index > -1) {
          _this2.observers[event].splice(index, 1);
        }
      }
    });
  };

  EventEmitter.prototype.emit = function emit(event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (this.observers[event]) {
      var cloned = [].concat(this.observers[event]);
      cloned.forEach(function (observer) {
        observer.apply(undefined, args);
      });
    }

    if (this.observers['*']) {
      var _cloned = [].concat(this.observers['*']);
      _cloned.forEach(function (observer) {
        observer.apply(observer, [event].concat(args));
      });
    }
  };

  return EventEmitter;
}();

/* harmony default export */ __webpack_exports__["a"] = (EventEmitter);

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = makeString;
/* harmony export (immutable) */ __webpack_exports__["a"] = copy;
/* harmony export (immutable) */ __webpack_exports__["h"] = setPath;
/* harmony export (immutable) */ __webpack_exports__["f"] = pushPath;
/* harmony export (immutable) */ __webpack_exports__["d"] = getPath;
/* harmony export (immutable) */ __webpack_exports__["b"] = deepExtend;
/* harmony export (immutable) */ __webpack_exports__["g"] = regexEscape;
/* harmony export (immutable) */ __webpack_exports__["c"] = escape;
function makeString(object) {
  if (object == null) return '';
  /* eslint prefer-template: 0 */
  return '' + object;
}

function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};

    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    object = object[key];
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}

function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}

function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}

function deepExtend(target, source, overwrite) {
  /* eslint no-restricted-syntax: 0 */
  for (var prop in source) {
    if (prop in target) {
      // If we reached a leaf string in target or source then replace with source or skip depending on the 'overwrite' switch
      if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
        if (overwrite) target[prop] = source[prop];
      } else {
        deepExtend(target[prop], source[prop], overwrite);
      }
    } else {
      target[prop] = source[prop];
    }
  }
  return target;
}

function regexEscape(str) {
  /* eslint no-useless-escape: 0 */
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}

/* eslint-disable */
var _entityMap = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': '&quot;',
  "'": '&#39;',
  "/": '&#x2F;'
};
/* eslint-enable */

function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(64);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(70);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(27);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(71);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(73);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(75);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(77);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(28);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(19);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(79);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(81);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(83);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(84);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(85);
/* unused harmony reexport withRouter */





























/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(20);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = setDefaults;
/* harmony export (immutable) */ __webpack_exports__["a"] = getDefaults;
/* harmony export (immutable) */ __webpack_exports__["e"] = setI18n;
/* harmony export (immutable) */ __webpack_exports__["b"] = getI18n;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reactI18nextModule; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var defaultOptions = {
  wait: false,
  withRef: false,
  bindI18n: 'languageChanged loaded',
  bindStore: 'added removed',
  translateFuncName: 't',
  nsMode: 'default',
  usePureComponent: false
};

var i18n = void 0;

function setDefaults(options) {
  defaultOptions = _extends({}, defaultOptions, options);
}

function getDefaults() {
  return defaultOptions;
}

function setI18n(instance) {
  i18n = instance;
}

function getI18n() {
  return i18n;
}

var reactI18nextModule = {
  type: '3rdParty',

  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(39);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.hoistNonReactStatics = factory());
}(this, (function () {
    'use strict';
    
    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    
    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
            
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }
            
            var keys = getOwnPropertyNames(sourceComponent);
            
            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }
            
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try { // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
            
            return targetComponent;
        }
        
        return targetComponent;
    };
})));


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(29);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(21);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(74)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context__ = __webpack_require__(22);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var removedIsInitialSSR = false;

var I18n = function (_Component) {
  _inherits(I18n, _Component);

  function I18n(props, context) {
    _classCallCheck(this, I18n);

    var _this = _possibleConstructorReturn(this, (I18n.__proto__ || Object.getPrototypeOf(I18n)).call(this, props, context));

    _this.i18n = props.i18n || context.i18n || Object(__WEBPACK_IMPORTED_MODULE_2__context__["b" /* getI18n */])();
    _this.namespaces = props.ns || _this.i18n.options && _this.i18n.options.defaultNS;
    if (typeof _this.namespaces === 'string') _this.namespaces = [_this.namespaces];

    var i18nOptions = _this.i18n && _this.i18n.options && _this.i18n.options.react || {};
    _this.options = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2__context__["a" /* getDefaults */])(), i18nOptions, props);

    // nextjs SSR: getting data from next.js or other ssr stack
    if (props.initialI18nStore) {
      _this.i18n.services.resourceStore.data = props.initialI18nStore;
      _this.options.wait = false; // we got all passed down already
    }
    if (props.initialLanguage) {
      _this.i18n.changeLanguage(props.initialLanguage);
    }

    // provider SSR: data was set in provider and ssr flag was set
    if (_this.i18n.options && _this.i18n.options.isInitialSSR) {
      _this.options.wait = false;
    }

    var language = _this.i18n.languages && _this.i18n.languages[0];
    var ready = !!language && _this.namespaces.every(function (ns) {
      return _this.i18n.hasResourceBundle(language, ns);
    });

    _this.state = {
      i18nLoadedAt: null,
      ready: ready
    };

    _this.t = _this.getI18nTranslate();

    _this.onI18nChanged = _this.onI18nChanged.bind(_this);
    _this.getI18nTranslate = _this.getI18nTranslate.bind(_this);
    return _this;
  }

  _createClass(I18n, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        t: this.t,
        i18n: this.i18n
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var bind = function bind() {
        if (_this2.options.bindI18n && _this2.i18n) _this2.i18n.on(_this2.options.bindI18n, _this2.onI18nChanged);
        if (_this2.options.bindStore && _this2.i18n.store) _this2.i18n.store.on(_this2.options.bindStore, _this2.onI18nChanged);
      };

      this.mounted = true;
      this.i18n.loadNamespaces(this.namespaces, function () {
        var ready = function ready() {
          if (_this2.mounted && !_this2.state.ready) _this2.setState({ ready: true });
          if (_this2.options.wait && _this2.mounted) bind();
        };

        if (_this2.i18n.isInitialized) {
          ready();
        } else {
          var initialized = function initialized() {
            // due to emitter removing issue in i18next we need to delay remove
            setTimeout(function () {
              _this2.i18n.off('initialized', initialized);
            }, 1000);
            ready();
          };

          _this2.i18n.on('initialized', initialized);
        }
      });

      if (!this.options.wait) bind();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this3 = this;

      this.mounted = false;
      if (this.onI18nChanged) {
        if (this.options.bindI18n) {
          var p = this.options.bindI18n.split(' ');
          p.forEach(function (f) {
            return _this3.i18n.off(f, _this3.onI18nChanged);
          });
        }
        if (this.options.bindStore) {
          var _p = this.options.bindStore.split(' ');
          _p.forEach(function (f) {
            return _this3.i18n.store && _this3.i18n.store.off(f, _this3.onI18nChanged);
          });
        }
      }
    }
  }, {
    key: 'onI18nChanged',
    value: function onI18nChanged() {
      if (!this.mounted) return;

      this.t = this.getI18nTranslate();
      this.setState({ i18nLoadedAt: new Date() }); // rerender
    }
  }, {
    key: 'getI18nTranslate',
    value: function getI18nTranslate() {
      return this.i18n.getFixedT(null, this.options.nsMode === 'fallback' ? this.namespaces : this.namespaces[0]);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var children = this.props.children;
      var ready = this.state.ready;


      if (!ready && this.options.wait) return null;

      // remove ssr flag set by provider - first render was done from now on wait if set to wait
      if (this.i18n.options && this.i18n.options.isInitialSSR && !removedIsInitialSSR) {
        removedIsInitialSSR = true;
        setTimeout(function () {
          delete _this4.i18n.options.isInitialSSR;
        }, 100);
      }

      return children(this.t, {
        i18n: this.i18n,
        t: this.t,
        ready: ready
      });
    }
  }]);

  return I18n;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (I18n);


I18n.contextTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

I18n.childContextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ella_color_svg__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ella_color_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ella_color_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ella_mono_black_svg__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ella_mono_black_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ella_mono_black_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ella_mono_white_svg__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ella_mono_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ella_mono_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__facebook_svg__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__facebook_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__facebook_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__twitter_svg__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__twitter_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__twitter_svg__);
/* harmony default export */ __webpack_exports__["a"] = ({ellaColor:__WEBPACK_IMPORTED_MODULE_0__ella_color_svg___default.a,ellaMonoBlack:__WEBPACK_IMPORTED_MODULE_1__ella_mono_black_svg___default.a,ellaMonoWhite:__WEBPACK_IMPORTED_MODULE_2__ella_mono_white_svg___default.a,facebook:__WEBPACK_IMPORTED_MODULE_3__facebook_svg___default.a,twitter:__WEBPACK_IMPORTED_MODULE_4__twitter_svg___default.a});

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/close.4aed07ac.svg";

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({

  processors: {},

  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });

    return value;
  }
});

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(37);
module.exports = __webpack_require__(43);


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(38).enable();
  window.Promise = __webpack_require__(41);
}

// fetch() polyfill for making API calls.
__webpack_require__(42);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(14);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(23);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(40)))

/***/ }),
/* 40 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(23);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fonts__ = __webpack_require__(178);
var _templateObject=_taggedTemplateLiteral(['\n  @font-face {\n    font-family: \'Avenir\';\n    src: url(\'','\') format(\'woff2\'),\n      url(\'','\') format(\'woff\'),\n      url(\'','\') format(\'truetype\');\n  }\n\n  @font-face {\n    font-family: \'Avenir\';\n    src: url(\'','\') format(\'woff2\');\n    font-weight: bold;\n}\n\n  body {\n    margin: 0;\n    padding: 0;\n    font-family: Avenir;\n    text-rendering: optimizeLegibility;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale; \n  }\n'],['\n  @font-face {\n    font-family: \'Avenir\';\n    src: url(\'','\') format(\'woff2\'),\n      url(\'','\') format(\'woff\'),\n      url(\'','\') format(\'truetype\');\n  }\n\n  @font-face {\n    font-family: \'Avenir\';\n    src: url(\'','\') format(\'woff2\');\n    font-weight: bold;\n}\n\n  body {\n    margin: 0;\n    padding: 0;\n    font-family: Avenir;\n    text-rendering: optimizeLegibility;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale; \n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable no-unused-expressions *//* eslint-disable react/jsx-filename-extension *//* global document */Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* injectGlobal */])(_templateObject,__WEBPACK_IMPORTED_MODULE_6__fonts__["c" /* AvenirRegularWOFF2 */],__WEBPACK_IMPORTED_MODULE_6__fonts__["b" /* AvenirRegularWOFF */],__WEBPACK_IMPORTED_MODULE_6__fonts__["d" /* AvenirTTF */],__WEBPACK_IMPORTED_MODULE_6__fonts__["a" /* AvenirHeavyWOFF2 */]);__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */],null),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(14),n=__webpack_require__(15),p=__webpack_require__(24),q=__webpack_require__(16),r="function"===typeof Symbol&&Symbol.for,t=r?Symbol.for("react.element"):60103,u=r?Symbol.for("react.portal"):60106,v=r?Symbol.for("react.fragment"):60107,w=r?Symbol.for("react.strict_mode"):60108,x=r?Symbol.for("react.profiler"):60114,y=r?Symbol.for("react.provider"):60109,z=r?Symbol.for("react.context"):60110,A=r?Symbol.for("react.async_mode"):60111,B=
r?Symbol.for("react.forward_ref"):60112;r&&Symbol.for("react.timeout");var C="function"===typeof Symbol&&Symbol.iterator;function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}
var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function F(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function G(){}
G.prototype=F.prototype;function H(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}var I=H.prototype=new G;I.constructor=H;k(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:J.current}}
function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,e,c){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+T(d,h);g+=S(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+T(d,h++),g+=S(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function U(a,b){a.func.call(a.context,b,a.count++)}
function V(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,q.thatReturnsArgument):null!=a&&(N(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(O,"$&/")+"/");b=Q(b,g,c,d);null==a||S(a,"",V,b);R(b)}
var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=Q(null,null,b,e);null==a||S(a,"",U,b);R(b)},count:function(a){return null==a?0:S(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];W(a,b,null,q.thatReturnsArgument);return b},only:function(a){N(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:F,PureComponent:H,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:z,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_currentValue2:a,_changedBits:0,_changedBits2:0,Provider:null,Consumer:null};a.Provider={$$typeof:y,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:B,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:A,unstable_Profiler:x,createElement:M,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==
b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.4.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:J,
assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default?Z.default:Z;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(46);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(15),ca=__webpack_require__(0),m=__webpack_require__(47),p=__webpack_require__(14),v=__webpack_require__(16),da=__webpack_require__(48),ea=__webpack_require__(49),fa=__webpack_require__(50),ha=__webpack_require__(24);
function A(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ca?void 0:A("227");
function ia(a,b,c,d,e,f,g,h,k){this._hasCaughtError=!1;this._caughtError=null;var n=Array.prototype.slice.call(arguments,3);try{b.apply(c,n)}catch(r){this._caughtError=r,this._hasCaughtError=!0}}
var B={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){ia.apply(B,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){B.invokeGuardedCallback.apply(this,arguments);if(B.hasCaughtError()){var n=B.clearCaughtError();B._hasRethrowError||(B._hasRethrowError=!0,B._rethrowError=n)}},rethrowCaughtError:function(){return ka.apply(B,arguments)},hasCaughtError:function(){return B._hasCaughtError},clearCaughtError:function(){if(B._hasCaughtError){var a=
B._caughtError;B._caughtError=null;B._hasCaughtError=!1;return a}A("198")}};function ka(){if(B._hasRethrowError){var a=B._rethrowError;B._rethrowError=null;B._hasRethrowError=!1;throw a;}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:A("96",a);if(!oa[c]){b.extractEvents?void 0:A("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?A("99",h):void 0;pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&qa(k[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:A("98",d,a)}}}}
function qa(a,b,c){ra[a]?A("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={};function ta(a){la?A("101"):void 0;la=Array.prototype.slice.call(a);na()}function ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?A("102",c):void 0,ma[c]=d,b=!0)}b&&na()}
var va={plugins:oa,eventNameDispatchConfigs:pa,registrationNameModules:ra,registrationNameDependencies:sa,possibleRegistrationNames:null,injectEventPluginOrder:ta,injectEventPluginsByName:ua},wa=null,xa=null,ya=null;function za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=ya(d);B.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Aa(a,b){null==b?A("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ba(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ca=null;
function Da(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)za(a,b,c[e],d[e]);else c&&za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ea(a){return Da(a,!0)}function Fa(a){return Da(a,!1)}var Ga={injectEventPluginOrder:ta,injectEventPluginsByName:ua};
function Ha(a,b){var c=a.stateNode;if(!c)return null;var d=wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?A("231",b,typeof c):void 0;
return c}function Ia(a,b){null!==a&&(Ca=Aa(Ca,a));a=Ca;Ca=null;a&&(b?Ba(a,Ea):Ba(a,Fa),Ca?A("95"):void 0,B.rethrowCaughtError())}function Ja(a,b,c,d){for(var e=null,f=0;f<oa.length;f++){var g=oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=Aa(e,g))}Ia(e,!1)}var Ka={injection:Ga,getListener:Ha,runEventsInBatch:Ia,runExtractedEventsInBatch:Ja},La=Math.random().toString(36).slice(2),C="__reactInternalInstance$"+La,Ma="__reactEventHandlers$"+La;
function Na(a){if(a[C])return a[C];for(;!a[C];)if(a.parentNode)a=a.parentNode;else return null;a=a[C];return 5===a.tag||6===a.tag?a:null}function Oa(a){if(5===a.tag||6===a.tag)return a.stateNode;A("33")}function Pa(a){return a[Ma]||null}var Qa={precacheFiberNode:function(a,b){b[C]=a},getClosestInstanceFromNode:Na,getInstanceFromNode:function(a){a=a[C];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Oa,getFiberCurrentPropsFromNode:Pa,updateFiberProps:function(a,b){a[Ma]=b}};
function F(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ra(a,b,c){for(var d=[];a;)d.push(a),a=F(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function Sa(a,b,c){if(b=Ha(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a)}function Ta(a){a&&a.dispatchConfig.phasedRegistrationNames&&Ra(a._targetInst,Sa,a)}
function Ua(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?F(b):null;Ra(b,Sa,a)}}function Va(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ha(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a))}function Xa(a){a&&a.dispatchConfig.registrationName&&Va(a._targetInst,null,a)}function Ya(a){Ba(a,Ta)}
function Za(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=F(h))g++;h=0;for(var k=f;k;k=F(k))h++;for(;0<g-h;)e=F(e),g--;for(;0<h-g;)f=F(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=F(e);f=F(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=F(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=F(d)}for(d=0;d<e.length;d++)Va(e[d],"bubbled",a);for(a=c.length;0<a--;)Va(c[a],"captured",b)}
var $a={accumulateTwoPhaseDispatches:Ya,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ba(a,Ua)},accumulateEnterLeaveDispatches:Za,accumulateDirectDispatches:function(a){Ba(a,Xa)}};function ab(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var bb={animationend:ab("Animation","AnimationEnd"),animationiteration:ab("Animation","AnimationIteration"),animationstart:ab("Animation","AnimationStart"),transitionend:ab("Transition","TransitionEnd")},cb={},db={};m.canUseDOM&&(db=document.createElement("div").style,"AnimationEvent"in window||(delete bb.animationend.animation,delete bb.animationiteration.animation,delete bb.animationstart.animation),"TransitionEvent"in window||delete bb.transitionend.transition);
function eb(a){if(cb[a])return cb[a];if(!bb[a])return a;var b=bb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in db)return cb[a]=b[c];return a}var fb=eb("animationend"),gb=eb("animationiteration"),hb=eb("animationstart"),ib=eb("transitionend"),jb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),kb=null;
function lb(){!kb&&m.canUseDOM&&(kb="textContent"in document.documentElement?"textContent":"innerText");return kb}var G={_root:null,_startText:null,_fallbackText:null};function mb(){if(G._fallbackText)return G._fallbackText;var a,b=G._startText,c=b.length,d,e=nb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);G._fallbackText=e.slice(a,1<d?1-d:void 0);return G._fallbackText}function nb(){return"value"in G._root?G._root.value:G._root[lb()]}
var ob="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),pb={type:null,target:null,currentTarget:v.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function H(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?v.thatReturnsTrue:v.thatReturnsFalse;this.isPropagationStopped=v.thatReturnsFalse;return this}
p(H.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=v.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=v.thatReturnsTrue)},persist:function(){this.isPersistent=v.thatReturnsTrue},isPersistent:v.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<ob.length;a++)this[ob[a]]=null}});H.Interface=pb;H.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;p(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=p({},d.Interface,a);c.extend=d.extend;qb(c);return c};qb(H);
function rb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function sb(a){a instanceof this?void 0:A("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function qb(a){a.eventPool=[];a.getPooled=rb;a.release=sb}var tb=H.extend({data:null}),ub=H.extend({data:null}),vb=[9,13,27,32],wb=m.canUseDOM&&"CompositionEvent"in window,xb=null;m.canUseDOM&&"documentMode"in document&&(xb=document.documentMode);
var yb=m.canUseDOM&&"TextEvent"in window&&!xb,zb=m.canUseDOM&&(!wb||xb&&8<xb&&11>=xb),Ab=String.fromCharCode(32),Bb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Cb=!1;
function Db(a,b){switch(a){case "keyup":return-1!==vb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Eb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Fb=!1;function Gb(a,b){switch(a){case "compositionend":return Eb(b);case "keypress":if(32!==b.which)return null;Cb=!0;return Ab;case "textInput":return a=b.data,a===Ab&&Cb?null:a;default:return null}}
function Hb(a,b){if(Fb)return"compositionend"===a||!wb&&Db(a,b)?(a=mb(),G._root=null,G._startText=null,G._fallbackText=null,Fb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return zb?null:b.data;default:return null}}
var Ib={eventTypes:Bb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(wb)b:{switch(a){case "compositionstart":e=Bb.compositionStart;break b;case "compositionend":e=Bb.compositionEnd;break b;case "compositionupdate":e=Bb.compositionUpdate;break b}e=void 0}else Fb?Db(a,c)&&(e=Bb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=Bb.compositionStart);e?(zb&&(Fb||e!==Bb.compositionStart?e===Bb.compositionEnd&&Fb&&(f=mb()):(G._root=d,G._startText=nb(),Fb=!0)),e=tb.getPooled(e,b,c,d),f?e.data=
f:(f=Eb(c),null!==f&&(e.data=f)),Ya(e),f=e):f=null;(a=yb?Gb(a,c):Hb(a,c))?(b=ub.getPooled(Bb.beforeInput,b,c,d),b.data=a,Ya(b)):b=null;return null===f?b:null===b?f:[f,b]}},Jb=null,Kb={injectFiberControlledHostComponent:function(a){Jb=a}},Lb=null,Mb=null;function Nb(a){if(a=xa(a)){Jb&&"function"===typeof Jb.restoreControlledState?void 0:A("194");var b=wa(a.stateNode);Jb.restoreControlledState(a.stateNode,a.type,b)}}function Ob(a){Lb?Mb?Mb.push(a):Mb=[a]:Lb=a}
function Pb(){return null!==Lb||null!==Mb}function Qb(){if(Lb){var a=Lb,b=Mb;Mb=Lb=null;Nb(a);if(b)for(a=0;a<b.length;a++)Nb(b[a])}}var Rb={injection:Kb,enqueueStateRestore:Ob,needsStateRestore:Pb,restoreStateIfNeeded:Qb};function Sb(a,b){return a(b)}function Tb(a,b,c){return a(b,c)}function Ub(){}var Vb=!1;function Wb(a,b){if(Vb)return a(b);Vb=!0;try{return Sb(a,b)}finally{Vb=!1,Pb()&&(Ub(),Qb())}}
var Xb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Yb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Xb[a.type]:"textarea"===b?!0:!1}function Zb(a){a=a.target||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function $b(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function ac(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function bc(a){var b=ac(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function cc(a){a._valueTracker||(a._valueTracker=bc(a))}function dc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=ac(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var ec=ca.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,I="function"===typeof Symbol&&Symbol.for,fc=I?Symbol.for("react.element"):60103,gc=I?Symbol.for("react.portal"):60106,hc=I?Symbol.for("react.fragment"):60107,ic=I?Symbol.for("react.strict_mode"):60108,jc=I?Symbol.for("react.profiler"):60114,mc=I?Symbol.for("react.provider"):60109,nc=I?Symbol.for("react.context"):60110,oc=I?Symbol.for("react.async_mode"):60111,pc=I?Symbol.for("react.forward_ref"):60112,qc=I?Symbol.for("react.timeout"):
60113,rc="function"===typeof Symbol&&Symbol.iterator;function sc(a){if(null===a||"undefined"===typeof a)return null;a=rc&&a[rc]||a["@@iterator"];return"function"===typeof a?a:null}
function tc(a){var b=a.type;if("function"===typeof b)return b.displayName||b.name;if("string"===typeof b)return b;switch(b){case oc:return"AsyncMode";case nc:return"Context.Consumer";case hc:return"ReactFragment";case gc:return"ReactPortal";case jc:return"Profiler("+a.pendingProps.id+")";case mc:return"Context.Provider";case ic:return"StrictMode";case qc:return"Timeout"}if("object"===typeof b&&null!==b)switch(b.$$typeof){case pc:return a=b.render.displayName||b.render.name||"",""!==a?"ForwardRef("+
a+")":"ForwardRef"}return null}function vc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=tc(a);var f=null;c&&(f=tc(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a.return}while(a);return b}
var wc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,xc={},yc={};function zc(a){if(yc.hasOwnProperty(a))return!0;if(xc.hasOwnProperty(a))return!1;if(wc.test(a))return yc[a]=!0;xc[a]=!0;return!1}
function Ac(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}function Bc(a,b,c,d){if(null===b||"undefined"===typeof b||Ac(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}
function J(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var K={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){K[a]=new J(a,0,!1,a,null)});
[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];K[b]=new J(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){K[a]=new J(a,2,!1,a.toLowerCase(),null)});["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){K[a]=new J(a,2,!1,a,null)});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){K[a]=new J(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){K[a]=new J(a,3,!0,a.toLowerCase(),null)});["capture","download"].forEach(function(a){K[a]=new J(a,4,!1,a.toLowerCase(),null)});
["cols","rows","size","span"].forEach(function(a){K[a]=new J(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){K[a]=new J(a,5,!1,a.toLowerCase(),null)});var Cc=/[\-:]([a-z])/g;function Dc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Cc,
Dc);K[b]=new J(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Cc,Dc);K[b]=new J(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Cc,Dc);K[b]=new J(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});K.tabIndex=new J("tabIndex",1,!1,"tabindex",null);
function Ec(a,b,c,d){var e=K.hasOwnProperty(b)?K[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Bc(b,c,e,d)&&(c=null),d||null===e?zc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Fc(a,b){var c=b.checked;return p({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Gc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Hc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Ic(a,b){b=b.checked;null!=b&&Ec(a,"checked",b,!1)}
function Jc(a,b){Ic(a,b);var c=Hc(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?Kc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Kc(a,b.type,Hc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Lc(a,b){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue"))""===a.value&&(a.value=""+a._wrapperState.initialValue),a.defaultValue=""+a._wrapperState.initialValue;b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Kc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Hc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var Mc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Nc(a,b,c){a=H.getPooled(Mc.change,a,b,c);a.type="change";Ob(c);Ya(a);return a}var Oc=null,Pc=null;function Qc(a){Ia(a,!1)}function Rc(a){var b=Oa(a);if(dc(b))return a}
function Sc(a,b){if("change"===a)return b}var Tc=!1;m.canUseDOM&&(Tc=$b("input")&&(!document.documentMode||9<document.documentMode));function Uc(){Oc&&(Oc.detachEvent("onpropertychange",Vc),Pc=Oc=null)}function Vc(a){"value"===a.propertyName&&Rc(Pc)&&(a=Nc(Pc,a,Zb(a)),Wb(Qc,a))}function Wc(a,b,c){"focus"===a?(Uc(),Oc=b,Pc=c,Oc.attachEvent("onpropertychange",Vc)):"blur"===a&&Uc()}function Xc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Rc(Pc)}
function Yc(a,b){if("click"===a)return Rc(b)}function Zc(a,b){if("input"===a||"change"===a)return Rc(b)}
var $c={eventTypes:Mc,_isInputEventSupported:Tc,extractEvents:function(a,b,c,d){var e=b?Oa(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Sc:Yb(e)?Tc?f=Zc:(f=Xc,g=Wc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Yc);if(f&&(f=f(a,b)))return Nc(f,c,d);g&&g(a,e,b);"blur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&Kc(e,"number",e.value)}},ad=H.extend({view:null,
detail:null}),bd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function cd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=bd[a])?!!b[a]:!1}function dd(){return cd}
var ed=ad.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:dd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),fd=ed.extend({pointerId:null,width:null,height:null,pressure:null,tiltX:null,tiltY:null,pointerType:null,isPrimary:null}),gd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},
mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},hd={eventTypes:gd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||
e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Na(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,n=void 0;if("mouseout"===a||"mouseover"===a)g=ed,h=gd.mouseLeave,k=gd.mouseEnter,n="mouse";else if("pointerout"===a||"pointerover"===a)g=fd,h=gd.pointerLeave,k=gd.pointerEnter,n="pointer";a=null==f?e:Oa(f);e=null==b?e:Oa(b);h=g.getPooled(h,f,c,d);h.type=n+"leave";h.target=a;h.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=n+"enter";c.target=e;c.relatedTarget=a;Za(h,
c,f,b);return[h,c]}};function id(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function jd(a){2!==id(a)?A("188"):void 0}
function kd(a){var b=a.alternate;if(!b)return b=id(a),3===b?A("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return jd(e),a;if(g===d)return jd(e),b;g=g.sibling}A("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:A("189")}}c.alternate!==d?A("190"):void 0}3!==c.tag?A("188"):void 0;return c.stateNode.current===c?a:b}function ld(a){a=kd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function md(a){a=kd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}var nd=H.extend({animationName:null,elapsedTime:null,pseudoElement:null}),od=H.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),pd=ad.extend({relatedTarget:null});
function qd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var rd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},sd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},td=ad.extend({key:function(a){if(a.key){var b=rd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=qd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?sd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:dd,charCode:function(a){return"keypress"===
a.type?qd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?qd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),ud=ed.extend({dataTransfer:null}),vd=ad.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:dd}),wd=H.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),xd=ed.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),yd=[["abort","abort"],[fb,"animationEnd"],[gb,"animationIteration"],[hb,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[ib,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],zd={},Ad={};function Bd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};zd[a]=b;Ad[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],["pointerdown","pointerDown"],
["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Bd(a,!0)});yd.forEach(function(a){Bd(a,!1)});
var Cd={eventTypes:zd,isInteractiveTopLevelEventType:function(a){a=Ad[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Ad[a];if(!e)return null;switch(a){case "keypress":if(0===qd(c))return null;case "keydown":case "keyup":a=td;break;case "blur":case "focus":a=pd;break;case "click":if(2===c.button)return null;case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=ed;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
ud;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=vd;break;case fb:case gb:case hb:a=nd;break;case ib:a=wd;break;case "scroll":a=ad;break;case "wheel":a=xd;break;case "copy":case "cut":case "paste":a=od;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=fd;break;default:a=H}b=a.getPooled(e,b,c,d);Ya(b);return b}},Dd=Cd.isInteractiveTopLevelEventType,
Ed=[];function Fd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c.return;)c=c.return;c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Na(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Ja(a.topLevelType,b,a.nativeEvent,Zb(a.nativeEvent))}var Gd=!0;function Id(a){Gd=!!a}function L(a,b){if(!b)return null;var c=(Dd(a)?Jd:Kd).bind(null,a);b.addEventListener(a,c,!1)}
function Ld(a,b){if(!b)return null;var c=(Dd(a)?Jd:Kd).bind(null,a);b.addEventListener(a,c,!0)}function Jd(a,b){Tb(Kd,a,b)}function Kd(a,b){if(Gd){var c=Zb(b);c=Na(c);null===c||"number"!==typeof c.tag||2===id(c)||(c=null);if(Ed.length){var d=Ed.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Wb(Fd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Ed.length&&Ed.push(a)}}}
var Md={get _enabled(){return Gd},setEnabled:Id,isEnabled:function(){return Gd},trapBubbledEvent:L,trapCapturedEvent:Ld,dispatchEvent:Kd},Nd={},Od=0,Pd="_reactListenersID"+(""+Math.random()).slice(2);function Qd(a){Object.prototype.hasOwnProperty.call(a,Pd)||(a[Pd]=Od++,Nd[a[Pd]]={});return Nd[a[Pd]]}function Rd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Sd(a,b){var c=Rd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Rd(c)}}function Td(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var Ud=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Vd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Wd=null,Xd=null,Yd=null,Zd=!1;
function $d(a,b){if(Zd||null==Wd||Wd!==da())return null;var c=Wd;"selectionStart"in c&&Td(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Yd&&ea(Yd,c)?null:(Yd=c,a=H.getPooled(Vd.select,Xd,a,b),a.type="select",a.target=Wd,Ya(a),a)}
var ae={eventTypes:Vd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Qd(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Oa(b):window;switch(a){case "focus":if(Yb(e)||"true"===e.contentEditable)Wd=e,Xd=b,Yd=null;break;case "blur":Yd=Xd=Wd=null;break;case "mousedown":Zd=!0;break;case "contextmenu":case "mouseup":return Zd=!1,$d(c,d);case "selectionchange":if(Ud)break;
case "keydown":case "keyup":return $d(c,d)}return null}};Ga.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));wa=Qa.getFiberCurrentPropsFromNode;xa=Qa.getInstanceFromNode;ya=Qa.getNodeFromInstance;Ga.injectEventPluginsByName({SimpleEventPlugin:Cd,EnterLeaveEventPlugin:hd,ChangeEventPlugin:$c,SelectEventPlugin:ae,BeforeInputEventPlugin:Ib});var be=void 0;
be="object"===typeof performance&&"function"===typeof performance.now?function(){return performance.now()}:function(){return Date.now()};var ce=void 0,de=void 0;
if(m.canUseDOM){var ee=[],fe=0,ge={},he=-1,ie=!1,je=!1,ke=0,le=33,me=33,ne={didTimeout:!1,timeRemaining:function(){var a=ke-be();return 0<a?a:0}},oe=function(a,b){if(ge[b])try{a(ne)}finally{delete ge[b]}},pe="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===pe&&(ie=!1,0!==ee.length)){if(0!==ee.length&&(a=be(),!(-1===he||he>a))){he=-1;ne.didTimeout=!0;for(var b=0,c=ee.length;b<c;b++){var d=ee[b],e=d.timeoutTime;-1!==
e&&e<=a?oe(d.scheduledCallback,d.callbackId):-1!==e&&(-1===he||e<he)&&(he=e)}}for(a=be();0<ke-a&&0<ee.length;)a=ee.shift(),ne.didTimeout=!1,oe(a.scheduledCallback,a.callbackId),a=be();0<ee.length&&!je&&(je=!0,requestAnimationFrame(qe))}},!1);var qe=function(a){je=!1;var b=a-ke+me;b<me&&le<me?(8>b&&(b=8),me=b<le?le:b):le=b;ke=a+me;ie||(ie=!0,window.postMessage(pe,"*"))};ce=function(a,b){var c=-1;null!=b&&"number"===typeof b.timeout&&(c=be()+b.timeout);if(-1===he||-1!==c&&c<he)he=c;fe++;b=fe;ee.push({scheduledCallback:a,
callbackId:b,timeoutTime:c});ge[b]=!0;je||(je=!0,requestAnimationFrame(qe));return b};de=function(a){delete ge[a]}}else{var re=0,se={};ce=function(a){var b=re++,c=setTimeout(function(){a({timeRemaining:function(){return Infinity},didTimeout:!1})});se[b]=c;return b};de=function(a){var b=se[a];delete se[a];clearTimeout(b)}}function te(a){var b="";ca.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}
function ue(a,b){a=p({children:void 0},b);if(b=te(b.children))a.children=b;return a}function ve(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function we(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function xe(a,b){null!=b.dangerouslySetInnerHTML?A("91"):void 0;return p({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function ye(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?A("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:A("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function ze(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Ae(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Be={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Ce(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function De(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Ce(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Ee=void 0,Fe=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Be.svg||"innerHTML"in a)a.innerHTML=b;else{Ee=Ee||document.createElement("div");Ee.innerHTML="<svg>"+b+"</svg>";for(b=Ee.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Ge(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var He={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ie=["Webkit","ms","Moz","O"];Object.keys(He).forEach(function(a){Ie.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);He[b]=He[a]})});
function Je(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||He.hasOwnProperty(e)&&He[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Ke=p({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Le(a,b,c){b&&(Ke[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?A("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?A("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:A("61")),null!=b.style&&"object"!==typeof b.style?A("62",c()):void 0)}
function Me(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Ne=v.thatReturns("");
function Oe(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Qd(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Ld("scroll",a);break;case "focus":case "blur":Ld("focus",a);Ld("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":$b(e,!0)&&Ld(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===jb.indexOf(e)&&L(e,a)}c[e]=!0}}}
function Pe(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Be.html&&(d=Ce(a));d===Be.html?"script"===a?(a=c.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function Qe(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function Re(a,b,c,d){var e=Me(b,c);switch(b){case "iframe":case "object":L("load",a);var f=c;break;case "video":case "audio":for(f=0;f<jb.length;f++)L(jb[f],a);f=c;break;case "source":L("error",a);f=c;break;case "img":case "image":case "link":L("error",a);L("load",a);f=c;break;case "form":L("reset",a);L("submit",a);f=c;break;case "details":L("toggle",a);f=c;break;case "input":Gc(a,c);f=Fc(a,c);L("invalid",a);Oe(d,"onChange");break;case "option":f=ue(a,c);break;case "select":we(a,c);f=p({},c,{value:void 0});
L("invalid",a);Oe(d,"onChange");break;case "textarea":ye(a,c);f=xe(a,c);L("invalid",a);Oe(d,"onChange");break;default:f=c}Le(b,f,Ne);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?Je(a,k,Ne):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&Fe(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&Ge(a,k):"number"===typeof k&&Ge(a,""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ra.hasOwnProperty(h)?null!=k&&Oe(d,
h):null!=k&&Ec(a,h,k,e))}switch(b){case "input":cc(a);Lc(a,c);break;case "textarea":cc(a);Ae(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?ve(a,!!c.multiple,b,!1):null!=c.defaultValue&&ve(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=v)}}
function Se(a,b,c,d,e){var f=null;switch(b){case "input":c=Fc(a,c);d=Fc(a,d);f=[];break;case "option":c=ue(a,c);d=ue(a,d);f=[];break;case "select":c=p({},c,{value:void 0});d=p({},d,{value:void 0});f=[];break;case "textarea":c=xe(a,c);d=xe(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=v)}Le(b,d,Ne);b=a=void 0;var g=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var h=c[a];for(b in h)h.hasOwnProperty(b)&&(g||
(g={}),g[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ra.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];h=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==h&&(null!=k||null!=h))if("style"===a)if(h){for(b in h)!h.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(g||(g={}),g[b]="");for(b in k)k.hasOwnProperty(b)&&h[b]!==k[b]&&(g||(g={}),g[b]=k[b])}else g||(f||(f=[]),f.push(a,g)),
g=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(a,""+k)):"children"===a?h===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ra.hasOwnProperty(a)?(null!=k&&Oe(e,a),f||h===k||(f=[])):(f=f||[]).push(a,k))}g&&(f=f||[]).push("style",g);return f}
function Te(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Ic(a,e);Me(c,d);d=Me(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?Je(a,h,Ne):"dangerouslySetInnerHTML"===g?Fe(a,h):"children"===g?Ge(a,h):Ec(a,g,h,d)}switch(c){case "input":Jc(a,e);break;case "textarea":ze(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ve(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
ve(a,!!e.multiple,e.defaultValue,!0):ve(a,!!e.multiple,e.multiple?[]:"",!1))}}
function Ue(a,b,c,d,e){switch(b){case "iframe":case "object":L("load",a);break;case "video":case "audio":for(d=0;d<jb.length;d++)L(jb[d],a);break;case "source":L("error",a);break;case "img":case "image":case "link":L("error",a);L("load",a);break;case "form":L("reset",a);L("submit",a);break;case "details":L("toggle",a);break;case "input":Gc(a,c);L("invalid",a);Oe(e,"onChange");break;case "select":we(a,c);L("invalid",a);Oe(e,"onChange");break;case "textarea":ye(a,c),L("invalid",a),Oe(e,"onChange")}Le(b,
c,Ne);d=null;for(var f in c)if(c.hasOwnProperty(f)){var g=c[f];"children"===f?"string"===typeof g?a.textContent!==g&&(d=["children",g]):"number"===typeof g&&a.textContent!==""+g&&(d=["children",""+g]):ra.hasOwnProperty(f)&&null!=g&&Oe(e,f)}switch(b){case "input":cc(a);Lc(a,c);break;case "textarea":cc(a);Ae(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&(a.onclick=v)}return d}function Ve(a,b){return a.nodeValue!==b}
var We={createElement:Pe,createTextNode:Qe,setInitialProperties:Re,diffProperties:Se,updateProperties:Te,diffHydratedProperties:Ue,diffHydratedText:Ve,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Jc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;
c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Pa(d);e?void 0:A("90");dc(d);Jc(d,e)}}}break;case "textarea":ze(a,c);break;case "select":b=c.value,null!=b&&ve(a,!!c.multiple,b,!1)}}},Xe=null,Ye=null;function Ze(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function $e(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html}var af=be,bf=ce,cf=de;function df(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function ef(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var ff=[],gf=-1;function hf(a){return{current:a}}
function M(a){0>gf||(a.current=ff[gf],ff[gf]=null,gf--)}function N(a,b){gf++;ff[gf]=a.current;a.current=b}var jf=hf(ha),O=hf(!1),kf=ha;function lf(a){return mf(a)?kf:jf.current}
function nf(a,b){var c=a.type.contextTypes;if(!c)return ha;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function mf(a){return 2===a.tag&&null!=a.type.childContextTypes}function of(a){mf(a)&&(M(O,a),M(jf,a))}function pf(a){M(O,a);M(jf,a)}
function qf(a,b,c){jf.current!==ha?A("168"):void 0;N(jf,b,a);N(O,c,a)}function rf(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:A("108",tc(a)||"Unknown",e);return p({},b,c)}function sf(a){if(!mf(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ha;kf=jf.current;N(jf,b,a);N(O,O.current,a);return!0}
function tf(a,b){var c=a.stateNode;c?void 0:A("169");if(b){var d=rf(a,kf);c.__reactInternalMemoizedMergedChildContext=d;M(O,a);M(jf,a);N(jf,d,a)}else M(O,a);N(O,b,a)}
function uf(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function vf(a,b,c){var d=a.alternate;null===d?(d=new uf(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function wf(a,b,c){var d=a.type,e=a.key;a=a.props;if("function"===typeof d)var f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case hc:return xf(a.children,b,c,e);case oc:f=11;b|=3;break;case ic:f=11;b|=2;break;case jc:return d=new uf(15,a,e,b|4),d.type=jc,d.expirationTime=c,d;case qc:f=16;b|=2;break;default:a:{switch("object"===typeof d&&null!==d?d.$$typeof:null){case mc:f=13;break a;case nc:f=12;break a;case pc:f=14;break a;default:A("130",null==d?
d:typeof d,"")}f=void 0}}b=new uf(f,a,e,b);b.type=d;b.expirationTime=c;return b}function xf(a,b,c,d){a=new uf(10,a,d,b);a.expirationTime=c;return a}function yf(a,b,c){a=new uf(6,a,null,b);a.expirationTime=c;return a}function zf(a,b,c){b=new uf(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function Af(a,b,c){b=new uf(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a}var Bf=null,Cf=null;function Df(a){return function(b){try{return a(b)}catch(c){}}}
function Ef(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Bf=Df(function(a){return b.onCommitFiberRoot(c,a)});Cf=Df(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Ff(a){"function"===typeof Bf&&Bf(a)}function Gf(a){"function"===typeof Cf&&Cf(a)}var Hf=!1;
function If(a){return{expirationTime:0,baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Jf(a){return{expirationTime:a.expirationTime,baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Kf(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Lf(a,b,c){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b);if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c}
function Mf(a,b,c){var d=a.alternate;if(null===d){var e=a.updateQueue;var f=null;null===e&&(e=a.updateQueue=If(a.memoizedState))}else e=a.updateQueue,f=d.updateQueue,null===e?null===f?(e=a.updateQueue=If(a.memoizedState),f=d.updateQueue=If(d.memoizedState)):e=a.updateQueue=Jf(f):null===f&&(f=d.updateQueue=Jf(e));null===f||e===f?Lf(e,b,c):null===e.lastUpdate||null===f.lastUpdate?(Lf(e,b,c),Lf(f,b,c)):(Lf(e,b,c),f.lastUpdate=b)}
function Nf(a,b,c){var d=a.updateQueue;d=null===d?a.updateQueue=If(a.memoizedState):Of(a,d);null===d.lastCapturedUpdate?d.firstCapturedUpdate=d.lastCapturedUpdate=b:(d.lastCapturedUpdate.next=b,d.lastCapturedUpdate=b);if(0===d.expirationTime||d.expirationTime>c)d.expirationTime=c}function Of(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Jf(b));return b}
function Pf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-1025|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return p({},d,e);case 2:Hf=!0}return d}
function Qf(a,b,c,d,e){Hf=!1;if(!(0===b.expirationTime||b.expirationTime>e)){b=Of(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,n=f;null!==k;){var r=k.expirationTime;if(r>e){if(null===g&&(g=k,f=n),0===h||h>r)h=r}else n=Pf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k));k=k.next}r=null;for(k=b.firstCapturedUpdate;null!==k;){var w=k.expirationTime;if(w>e){if(null===r&&(r=k,null===
g&&(f=n)),0===h||h>w)h=w}else n=Pf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k));k=k.next}null===g&&(b.lastUpdate=null);null===r?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===r&&(f=n);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=r;b.expirationTime=h;a.memoizedState=n}}
function Rf(a,b){"function"!==typeof a?A("191",a):void 0;a.call(b)}
function Sf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);a=b.firstEffect;for(b.firstEffect=b.lastEffect=null;null!==a;){var d=a.callback;null!==d&&(a.callback=null,Rf(d,c));a=a.nextEffect}a=b.firstCapturedEffect;for(b.firstCapturedEffect=b.lastCapturedEffect=null;null!==a;)b=a.callback,null!==b&&(a.callback=null,Rf(b,c)),a=a.nextEffect}
function Tf(a,b){return{value:a,source:b,stack:vc(b)}}var Uf=hf(null),Vf=hf(null),Wf=hf(0);function Xf(a){var b=a.type._context;N(Wf,b._changedBits,a);N(Vf,b._currentValue,a);N(Uf,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode}function Yf(a){var b=Wf.current,c=Vf.current;M(Uf,a);M(Vf,a);M(Wf,a);a=a.type._context;a._currentValue=c;a._changedBits=b}var Zf={},$f=hf(Zf),ag=hf(Zf),bg=hf(Zf);function cg(a){a===Zf?A("174"):void 0;return a}
function dg(a,b){N(bg,b,a);N(ag,a,a);N($f,Zf,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:De(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=De(b,c)}M($f,a);N($f,b,a)}function eg(a){M($f,a);M(ag,a);M(bg,a)}function fg(a){ag.current===a&&(M($f,a),M(ag,a))}function hg(a,b,c){var d=a.memoizedState;b=b(c,d);d=null===b||void 0===b?d:p({},d,b);a.memoizedState=d;a=a.updateQueue;null!==a&&0===a.expirationTime&&(a.baseState=d)}
var lg={isMounted:function(a){return(a=a._reactInternalFiber)?2===id(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=ig();d=jg(d,a);var e=Kf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Mf(a,e,d);kg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=ig();d=jg(d,a);var e=Kf(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Mf(a,e,d);kg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=ig();c=jg(c,a);var d=Kf(c);d.tag=2;void 0!==
b&&null!==b&&(d.callback=b);Mf(a,d,c);kg(a,c)}};function mg(a,b,c,d,e,f){var g=a.stateNode;a=a.type;return"function"===typeof g.shouldComponentUpdate?g.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ea(b,c)||!ea(d,e):!0}
function ng(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&lg.enqueueReplaceState(b,b.state,null)}
function og(a,b){var c=a.type,d=a.stateNode,e=a.pendingProps,f=lf(a);d.props=e;d.state=a.memoizedState;d.refs=ha;d.context=nf(a,f);f=a.updateQueue;null!==f&&(Qf(a,f,e,d,b),d.state=a.memoizedState);f=a.type.getDerivedStateFromProps;"function"===typeof f&&(hg(a,f,e),d.state=a.memoizedState);"function"===typeof c.getDerivedStateFromProps||"function"===typeof d.getSnapshotBeforeUpdate||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||(c=d.state,"function"===typeof d.componentWillMount&&
d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount(),c!==d.state&&lg.enqueueReplaceState(d,d.state,null),f=a.updateQueue,null!==f&&(Qf(a,f,e,d,b),d.state=a.memoizedState));"function"===typeof d.componentDidMount&&(a.effectTag|=4)}var pg=Array.isArray;
function qg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?A("110"):void 0,d=c.stateNode);d?void 0:A("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ha?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?A("148"):void 0;c._owner?void 0:A("254",a)}return a}
function rg(a,b){"textarea"!==a.type&&A("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function sg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=vf(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=yf(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=qg(a,b,c),d.return=a,d;d=wf(c,a.mode,d);d.ref=qg(a,b,c);d.return=a;return d}function n(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
zf(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function r(a,b,c,d,f){if(null===b||10!==b.tag)return b=xf(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function w(a,b,c){if("string"===typeof b||"number"===typeof b)return b=yf(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case fc:return c=wf(b,a.mode,c),c.ref=qg(a,null,b),c.return=a,c;case gc:return b=zf(b,a.mode,c),b.return=a,b}if(pg(b)||sc(b))return b=xf(b,a.mode,c,null),b.return=
a,b;rg(a,b)}return null}function P(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case fc:return c.key===e?c.type===hc?r(a,b,c.props.children,d,e):k(a,b,c,d):null;case gc:return c.key===e?n(a,b,c,d):null}if(pg(c)||sc(c))return null!==e?null:r(a,b,c,d,null);rg(a,c)}return null}function kc(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);
if("object"===typeof d&&null!==d){switch(d.$$typeof){case fc:return a=a.get(null===d.key?c:d.key)||null,d.type===hc?r(b,a,d.props.children,e,d.key):k(b,a,d,e);case gc:return a=a.get(null===d.key?c:d.key)||null,n(b,a,d,e)}if(pg(d)||sc(d))return a=a.get(c)||null,r(b,a,d,e,null);rg(b,d)}return null}function Hd(e,g,h,k){for(var u=null,x=null,t=g,q=g=0,n=null;null!==t&&q<h.length;q++){t.index>q?(n=t,t=null):n=t.sibling;var l=P(e,t,h[q],k);if(null===l){null===t&&(t=n);break}a&&t&&null===l.alternate&&b(e,
t);g=f(l,g,q);null===x?u=l:x.sibling=l;x=l;t=n}if(q===h.length)return c(e,t),u;if(null===t){for(;q<h.length;q++)if(t=w(e,h[q],k))g=f(t,g,q),null===x?u=t:x.sibling=t,x=t;return u}for(t=d(e,t);q<h.length;q++)if(n=kc(t,e,q,h[q],k))a&&null!==n.alternate&&t.delete(null===n.key?q:n.key),g=f(n,g,q),null===x?u=n:x.sibling=n,x=n;a&&t.forEach(function(a){return b(e,a)});return u}function E(e,g,h,k){var t=sc(h);"function"!==typeof t?A("150"):void 0;h=t.call(h);null==h?A("151"):void 0;for(var u=t=null,n=g,x=
g=0,y=null,l=h.next();null!==n&&!l.done;x++,l=h.next()){n.index>x?(y=n,n=null):y=n.sibling;var r=P(e,n,l.value,k);if(null===r){n||(n=y);break}a&&n&&null===r.alternate&&b(e,n);g=f(r,g,x);null===u?t=r:u.sibling=r;u=r;n=y}if(l.done)return c(e,n),t;if(null===n){for(;!l.done;x++,l=h.next())l=w(e,l.value,k),null!==l&&(g=f(l,g,x),null===u?t=l:u.sibling=l,u=l);return t}for(n=d(e,n);!l.done;x++,l=h.next())l=kc(n,e,x,l.value,k),null!==l&&(a&&null!==l.alternate&&n.delete(null===l.key?x:l.key),g=f(l,g,x),null===
u?t=l:u.sibling=l,u=l);a&&n.forEach(function(a){return b(e,a)});return t}return function(a,d,f,h){"object"===typeof f&&null!==f&&f.type===hc&&null===f.key&&(f=f.props.children);var k="object"===typeof f&&null!==f;if(k)switch(f.$$typeof){case fc:a:{var n=f.key;for(k=d;null!==k;){if(k.key===n)if(10===k.tag?f.type===hc:k.type===f.type){c(a,k.sibling);d=e(k,f.type===hc?f.props.children:f.props,h);d.ref=qg(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=k.sibling}f.type===hc?(d=xf(f.props.children,
a.mode,h,f.key),d.return=a,a=d):(h=wf(f,a.mode,h),h.ref=qg(a,d,f),h.return=a,a=h)}return g(a);case gc:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=zf(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=
a,a=d):(c(a,d),d=yf(f,a.mode,h),d.return=a,a=d),g(a);if(pg(f))return Hd(a,d,f,h);if(sc(f))return E(a,d,f,h);k&&rg(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:h=a.type,A("152",h.displayName||h.name||"Component")}return c(a,d)}}var tg=sg(!0),ug=sg(!1),vg=null,wg=null,xg=!1;function yg(a,b){var c=new uf(5,null,null,0);c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function zg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}function Ag(a){if(xg){var b=wg;if(b){var c=b;if(!zg(a,b)){b=df(c);if(!b||!zg(a,b)){a.effectTag|=2;xg=!1;vg=a;return}yg(vg,c)}vg=a;wg=ef(b)}else a.effectTag|=2,xg=!1,vg=a}}
function Bg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;vg=a}function Cg(a){if(a!==vg)return!1;if(!xg)return Bg(a),xg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!$e(b,a.memoizedProps))for(b=wg;b;)yg(a,b),b=df(b);Bg(a);wg=vg?df(a.stateNode):null;return!0}function Dg(){wg=vg=null;xg=!1}function Q(a,b,c){Eg(a,b,c,b.expirationTime)}function Eg(a,b,c,d){b.child=null===a?ug(b,null,c,d):tg(b,a.child,c,d)}
function Fg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Gg(a,b,c,d,e){Fg(a,b);var f=0!==(b.effectTag&64);if(!c&&!f)return d&&tf(b,!1),R(a,b);c=b.stateNode;ec.current=b;var g=f?null:c.render();b.effectTag|=1;f&&(Eg(a,b,null,e),b.child=null);Eg(a,b,g,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&tf(b,!0);return b.child}
function Hg(a){var b=a.stateNode;b.pendingContext?qf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&qf(a,b.context,!1);dg(a,b.containerInfo)}
function Ig(a,b,c,d){var e=a.child;null!==e&&(e.return=a);for(;null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var g=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==g&&(0===g.expirationTime||g.expirationTime>d)&&(g.expirationTime=d);else if(null!==g&&(0===g.expirationTime||g.expirationTime>d))g.expirationTime=d;else break;f=f.return}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=
e.child}if(null!==f)f.return=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){e.return=f.return;f=e;break}f=f.return}e=f}}
function Jg(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps,g=!0;if(O.current)g=!1;else if(f===e)return b.stateNode=0,Xf(b),R(a,b);var h=e.value;b.memoizedProps=e;if(null===f)h=1073741823;else if(f.value===e.value){if(f.children===e.children&&g)return b.stateNode=0,Xf(b),R(a,b);h=0}else{var k=f.value;if(k===h&&(0!==k||1/k===1/h)||k!==k&&h!==h){if(f.children===e.children&&g)return b.stateNode=0,Xf(b),R(a,b);h=0}else if(h="function"===typeof d._calculateChangedBits?d._calculateChangedBits(k,
h):1073741823,h|=0,0===h){if(f.children===e.children&&g)return b.stateNode=0,Xf(b),R(a,b)}else Ig(b,d,h,c)}b.stateNode=h;Xf(b);Q(a,b,e.children);return b.child}function R(a,b){null!==a&&b.child!==a.child?A("153"):void 0;if(null!==b.child){a=b.child;var c=vf(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=vf(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Kg(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:Hg(b);break;case 2:sf(b);break;case 4:dg(b,b.stateNode.containerInfo);break;case 13:Xf(b)}return null}switch(b.tag){case 0:null!==a?A("155"):void 0;var d=b.type,e=b.pendingProps,f=lf(b);f=nf(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,f=f.getDerivedStateFromProps,"function"===
typeof f&&hg(b,f,e),e=sf(b),d.updater=lg,b.stateNode=d,d._reactInternalFiber=b,og(b,c),a=Gg(a,b,!0,e,c)):(b.tag=1,Q(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,O.current||b.memoizedProps!==c?(d=lf(b),d=nf(b,d),e=e(c,d),b.effectTag|=1,Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 2:e=sf(b);if(null===a)if(null===b.stateNode){var g=b.pendingProps,h=b.type;d=lf(b);var k=2===b.tag&&null!=b.type.contextTypes;f=k?nf(b,d):ha;g=new h(g,f);b.memoizedState=null!==
g.state&&void 0!==g.state?g.state:null;g.updater=lg;b.stateNode=g;g._reactInternalFiber=b;k&&(k=b.stateNode,k.__reactInternalMemoizedUnmaskedChildContext=d,k.__reactInternalMemoizedMaskedChildContext=f);og(b,c);d=!0}else{h=b.type;d=b.stateNode;k=b.memoizedProps;f=b.pendingProps;d.props=k;var n=d.context;g=lf(b);g=nf(b,g);var r=h.getDerivedStateFromProps;(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(k!==f||n!==g)&&ng(b,d,f,g);Hf=!1;var w=b.memoizedState;n=d.state=w;var P=b.updateQueue;null!==P&&(Qf(b,P,f,d,c),n=b.memoizedState);k!==f||w!==n||O.current||Hf?("function"===typeof r&&(hg(b,r,f),n=b.memoizedState),(k=Hf||mg(b,k,f,w,n,g))?(h||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||("function"===typeof d.componentWillMount&&d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount()),"function"===typeof d.componentDidMount&&
(b.effectTag|=4)):("function"===typeof d.componentDidMount&&(b.effectTag|=4),b.memoizedProps=f,b.memoizedState=n),d.props=f,d.state=n,d.context=g,d=k):("function"===typeof d.componentDidMount&&(b.effectTag|=4),d=!1)}else h=b.type,d=b.stateNode,f=b.memoizedProps,k=b.pendingProps,d.props=f,n=d.context,g=lf(b),g=nf(b,g),r=h.getDerivedStateFromProps,(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(f!==k||n!==g)&&ng(b,d,k,g),Hf=!1,n=b.memoizedState,w=d.state=n,P=b.updateQueue,null!==P&&(Qf(b,P,k,d,c),w=b.memoizedState),f!==k||n!==w||O.current||Hf?("function"===typeof r&&(hg(b,r,k),w=b.memoizedState),(r=Hf||mg(b,f,k,n,w,g))?(h||"function"!==typeof d.UNSAFE_componentWillUpdate&&"function"!==typeof d.componentWillUpdate||("function"===typeof d.componentWillUpdate&&d.componentWillUpdate(k,w,g),"function"===typeof d.UNSAFE_componentWillUpdate&&d.UNSAFE_componentWillUpdate(k,w,g)),"function"===typeof d.componentDidUpdate&&
(b.effectTag|=4),"function"===typeof d.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),b.memoizedProps=k,b.memoizedState=w),d.props=k,d.state=w,d.context=g,d=r):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||
f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),d=!1);return Gg(a,b,d,e,c);case 3:Hg(b);e=b.updateQueue;if(null!==e)if(d=b.memoizedState,d=null!==d?d.element:null,Qf(b,e,b.pendingProps,null,c),e=b.memoizedState.element,e===d)Dg(),a=R(a,b);else{d=b.stateNode;if(d=(null===a||null===a.child)&&d.hydrate)wg=ef(b.stateNode.containerInfo),vg=b,d=xg=!0;d?(b.effectTag|=2,b.child=ug(b,null,e,c)):(Dg(),Q(a,b,e));a=b.child}else Dg(),a=R(a,b);return a;case 5:a:{cg(bg.current);e=cg($f.current);d=De(e,
b.type);e!==d&&(N(ag,b,b),N($f,d,b));null===a&&Ag(b);e=b.type;k=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!O.current&&k===d){if(k=b.mode&1&&!!d.hidden)b.expirationTime=1073741823;if(!k||1073741823!==c){a=R(a,b);break a}}k=d.children;$e(e,d)?k=null:f&&$e(e,f)&&(b.effectTag|=16);Fg(a,b);1073741823!==c&&b.mode&1&&d.hidden?(b.expirationTime=1073741823,b.memoizedProps=d,a=null):(Q(a,b,k),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Ag(b),b.memoizedProps=b.pendingProps,
null;case 16:return null;case 4:return dg(b,b.stateNode.containerInfo),e=b.pendingProps,O.current||b.memoizedProps!==e?(null===a?b.child=tg(b,null,e,c):Q(a,b,e),b.memoizedProps=e,a=b.child):a=R(a,b),a;case 14:return e=b.type.render,c=b.pendingProps,d=b.ref,O.current||b.memoizedProps!==c||d!==(null!==a?a.ref:null)?(e=e(c,d),Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 10:return c=b.pendingProps,O.current||b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 11:return c=
b.pendingProps.children,O.current||null!==c&&b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 15:return c=b.pendingProps,b.memoizedProps===c?a=R(a,b):(Q(a,b,c.children),b.memoizedProps=c,a=b.child),a;case 13:return Jg(a,b,c);case 12:a:if(d=b.type,f=b.pendingProps,k=b.memoizedProps,e=d._currentValue,g=d._changedBits,O.current||0!==g||k!==f){b.memoizedProps=f;h=f.unstable_observedBits;if(void 0===h||null===h)h=1073741823;b.stateNode=h;if(0!==(g&h))Ig(b,d,g,c);else if(k===f){a=
R(a,b);break a}c=f.children;c=c(e);b.effectTag|=1;Q(a,b,c);a=b.child}else a=R(a,b);return a;default:A("156")}}function Lg(a){a.effectTag|=4}var Pg=void 0,Qg=void 0,Rg=void 0;Pg=function(){};Qg=function(a,b,c){(b.updateQueue=c)&&Lg(b)};Rg=function(a,b,c,d){c!==d&&Lg(b)};
function Sg(a,b){var c=b.pendingProps;switch(b.tag){case 1:return null;case 2:return of(b),null;case 3:eg(b);pf(b);var d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)Cg(b),b.effectTag&=-3;Pg(b);return null;case 5:fg(b);d=cg(bg.current);var e=b.type;if(null!==a&&null!=b.stateNode){var f=a.memoizedProps,g=b.stateNode,h=cg($f.current);g=Se(g,e,f,c,d);Qg(a,b,g,e,f,c,d,h);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!c)return null===b.stateNode?
A("166"):void 0,null;a=cg($f.current);if(Cg(b))c=b.stateNode,e=b.type,f=b.memoizedProps,c[C]=b,c[Ma]=f,d=Ue(c,e,f,a,d),b.updateQueue=d,null!==d&&Lg(b);else{a=Pe(e,c,d,a);a[C]=b;a[Ma]=c;a:for(f=b.child;null!==f;){if(5===f.tag||6===f.tag)a.appendChild(f.stateNode);else if(4!==f.tag&&null!==f.child){f.child.return=f;f=f.child;continue}if(f===b)break;for(;null===f.sibling;){if(null===f.return||f.return===b)break a;f=f.return}f.sibling.return=f.return;f=f.sibling}Re(a,e,c,d);Ze(e,c)&&Lg(b);b.stateNode=
a}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)Rg(a,b,a.memoizedProps,c);else{if("string"!==typeof c)return null===b.stateNode?A("166"):void 0,null;d=cg(bg.current);cg($f.current);Cg(b)?(d=b.stateNode,c=b.memoizedProps,d[C]=b,Ve(d,c)&&Lg(b)):(d=Qe(c,d),d[C]=b,b.stateNode=d)}return null;case 14:return null;case 16:return null;case 10:return null;case 11:return null;case 15:return null;case 4:return eg(b),Pg(b),null;case 13:return Yf(b),null;case 12:return null;case 0:A("167");
default:A("156")}}function Tg(a,b){var c=b.source;null===b.stack&&null!==c&&vc(c);null!==c&&tc(c);b=b.value;null!==a&&2===a.tag&&tc(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}function Ug(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Vg(a,c)}else b.current=null}
function Wg(a){"function"===typeof Gf&&Gf(a);switch(a.tag){case 2:Ug(a);var b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Vg(a,c)}break;case 5:Ug(a);break;case 4:Xg(a)}}function Yg(a){return 5===a.tag||3===a.tag||4===a.tag}
function Zg(a){a:{for(var b=a.return;null!==b;){if(Yg(b)){var c=b;break a}b=b.return}A("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:A("161")}c.effectTag&16&&(Ge(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Yg(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(f=b,g=e.stateNode,8===f.nodeType?f.parentNode.insertBefore(g,f):f.appendChild(g)):b.appendChild(e.stateNode);else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===
e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Xg(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?A("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(Wg(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?d=b.stateNode.containerInfo:Wg(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function $g(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&(c[Ma]=d,Te(c,f,e,a,d))}break;case 6:null===b.stateNode?A("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 15:break;case 16:break;default:A("163")}}function ah(a,b,c){c=Kf(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){bh(d);Tg(a,b)};return c}
function ch(a,b,c){c=Kf(c);c.tag=3;var d=a.stateNode;null!==d&&"function"===typeof d.componentDidCatch&&(c.callback=function(){null===dh?dh=new Set([this]):dh.add(this);var c=b.value,d=b.stack;Tg(a,b);this.componentDidCatch(c,{componentStack:null!==d?d:""})});return c}
function eh(a,b,c,d,e,f){c.effectTag|=512;c.firstEffect=c.lastEffect=null;d=Tf(d,c);a=b;do{switch(a.tag){case 3:a.effectTag|=1024;d=ah(a,d,f);Nf(a,d,f);return;case 2:if(b=d,c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&(null===dh||!dh.has(c))){a.effectTag|=1024;d=ch(a,b,f);Nf(a,d,f);return}}a=a.return}while(null!==a)}
function fh(a){switch(a.tag){case 2:of(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return eg(a),pf(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return fg(a),null;case 16:return b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 4:return eg(a),null;case 13:return Yf(a),null;default:return null}}var gh=af(),hh=2,ih=gh,jh=0,kh=0,lh=!1,S=null,mh=null,T=0,nh=-1,oh=!1,U=null,ph=!1,qh=!1,dh=null;
function rh(){if(null!==S)for(var a=S.return;null!==a;){var b=a;switch(b.tag){case 2:of(b);break;case 3:eg(b);pf(b);break;case 5:fg(b);break;case 4:eg(b);break;case 13:Yf(b)}a=a.return}mh=null;T=0;nh=-1;oh=!1;S=null;qh=!1}
function sh(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&512)){b=Sg(b,a,T);var e=a;if(1073741823===T||1073741823!==e.expirationTime){var f=0;switch(e.tag){case 3:case 2:var g=e.updateQueue;null!==g&&(f=g.expirationTime)}for(g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&
(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{qh=!0;break}}else{a=fh(a,oh,T);if(null!==a)return a.effectTag&=511,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}
function th(a){var b=Kg(a.alternate,a,T);null===b&&(b=sh(a));ec.current=null;return b}
function uh(a,b,c){lh?A("243"):void 0;lh=!0;if(b!==T||a!==mh||null===S)rh(),mh=a,T=b,nh=-1,S=vf(mh.current,null,T),a.pendingCommitExpirationTime=0;var d=!1;oh=!c||T<=hh;do{try{if(c)for(;null!==S&&!vh();)S=th(S);else for(;null!==S;)S=th(S)}catch(f){if(null===S)d=!0,bh(f);else{null===S?A("271"):void 0;c=S;var e=c.return;if(null===e){d=!0;bh(f);break}eh(a,e,c,f,oh,T,ih);S=sh(c)}}break}while(1);lh=!1;if(d)return null;if(null===S){if(qh)return a.pendingCommitExpirationTime=b,a.current.alternate;oh?A("262"):
void 0;0<=nh&&setTimeout(function(){var b=a.current.expirationTime;0!==b&&(0===a.remainingExpirationTime||a.remainingExpirationTime<b)&&wh(a,b)},nh);xh(a.current.expirationTime)}return null}
function Vg(a,b){var c;a:{lh&&!ph?A("263"):void 0;for(c=a.return;null!==c;){switch(c.tag){case 2:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromCatch||"function"===typeof d.componentDidCatch&&(null===dh||!dh.has(d))){a=Tf(b,a);a=ch(c,a,1);Mf(c,a,1);kg(c,1);c=void 0;break a}break;case 3:a=Tf(b,a);a=ah(c,a,1);Mf(c,a,1);kg(c,1);c=void 0;break a}c=c.return}3===a.tag&&(c=Tf(b,a),c=ah(a,c,1),Mf(a,c,1),kg(a,1));c=void 0}return c}
function yh(){var a=2+25*(((ig()-2+500)/25|0)+1);a<=jh&&(a=jh+1);return jh=a}function jg(a,b){a=0!==kh?kh:lh?ph?1:T:b.mode&1?zh?2+10*(((a-2+15)/10|0)+1):2+25*(((a-2+500)/25|0)+1):1;zh&&(0===Ah||a>Ah)&&(Ah=a);return a}
function kg(a,b){for(;null!==a;){if(0===a.expirationTime||a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a.return)if(3===a.tag){var c=a.stateNode;!lh&&0!==T&&b<T&&rh();var d=c.current.expirationTime;lh&&!ph&&mh===c||wh(c,d);Bh>Ch&&A("185")}else break;a=a.return}}function ig(){ih=af()-gh;return hh=(ih/10|0)+2}
function Dh(a){var b=kh;kh=2+25*(((ig()-2+500)/25|0)+1);try{return a()}finally{kh=b}}function Eh(a,b,c,d,e){var f=kh;kh=1;try{return a(b,c,d,e)}finally{kh=f}}var Fh=null,V=null,Gh=0,Hh=-1,W=!1,X=null,Y=0,Ah=0,Ih=!1,Jh=!1,Kh=null,Lh=null,Z=!1,Mh=!1,zh=!1,Nh=null,Ch=1E3,Bh=0,Oh=1;function Ph(a){if(0!==Gh){if(a>Gh)return;cf(Hh)}var b=af()-gh;Gh=a;Hh=bf(Qh,{timeout:10*(a-2)-b})}
function wh(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===V?(Fh=V=a,a.nextScheduledRoot=a):(V=V.nextScheduledRoot=a,V.nextScheduledRoot=Fh);else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}W||(Z?Mh&&(X=a,Y=1,Rh(a,1,!1)):1===b?Sh():Ph(b))}
function Th(){var a=0,b=null;if(null!==V)for(var c=V,d=Fh;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===V?A("244"):void 0;if(d===d.nextScheduledRoot){Fh=V=d.nextScheduledRoot=null;break}else if(d===Fh)Fh=e=d.nextScheduledRoot,V.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===V){V=c;V.nextScheduledRoot=Fh;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===V)break;
c=d;d=d.nextScheduledRoot}}c=X;null!==c&&c===b&&1===a?Bh++:Bh=0;X=b;Y=a}function Qh(a){Uh(0,!0,a)}function Sh(){Uh(1,!1,null)}function Uh(a,b,c){Lh=c;Th();if(b)for(;null!==X&&0!==Y&&(0===a||a>=Y)&&(!Ih||ig()>=Y);)ig(),Rh(X,Y,!Ih),Th();else for(;null!==X&&0!==Y&&(0===a||a>=Y);)Rh(X,Y,!1),Th();null!==Lh&&(Gh=0,Hh=-1);0!==Y&&Ph(Y);Lh=null;Ih=!1;Vh()}function Wh(a,b){W?A("253"):void 0;X=a;Y=b;Rh(a,b,!1);Sh();Vh()}
function Vh(){Bh=0;if(null!==Nh){var a=Nh;Nh=null;for(var b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){Jh||(Jh=!0,Kh=d)}}}if(Jh)throw a=Kh,Kh=null,Jh=!1,a;}function Rh(a,b,c){W?A("245"):void 0;W=!0;c?(c=a.finishedWork,null!==c?Xh(a,c,b):(a.finishedWork=null,c=uh(a,b,!0),null!==c&&(vh()?a.finishedWork=c:Xh(a,c,b)))):(c=a.finishedWork,null!==c?Xh(a,c,b):(a.finishedWork=null,c=uh(a,b,!1),null!==c&&Xh(a,c,b)));W=!1}
function Xh(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Nh?Nh=[d]:Nh.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=0;return}a.finishedWork=null;ph=lh=!0;c=b.stateNode;c.current===b?A("177"):void 0;d=c.pendingCommitExpirationTime;0===d?A("261"):void 0;c.pendingCommitExpirationTime=0;ig();ec.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var e=b.firstEffect}else e=b;else e=b.firstEffect;Xe=Gd;var f=da();if(Td(f)){if("selectionStart"in
f)var g={start:f.selectionStart,end:f.selectionEnd};else a:{var h=window.getSelection&&window.getSelection();if(h&&0!==h.rangeCount){g=h.anchorNode;var k=h.anchorOffset,n=h.focusNode;h=h.focusOffset;try{g.nodeType,n.nodeType}catch(Wa){g=null;break a}var r=0,w=-1,P=-1,kc=0,Hd=0,E=f,t=null;b:for(;;){for(var x;;){E!==g||0!==k&&3!==E.nodeType||(w=r+k);E!==n||0!==h&&3!==E.nodeType||(P=r+h);3===E.nodeType&&(r+=E.nodeValue.length);if(null===(x=E.firstChild))break;t=E;E=x}for(;;){if(E===f)break b;t===g&&
++kc===k&&(w=r);t===n&&++Hd===h&&(P=r);if(null!==(x=E.nextSibling))break;E=t;t=E.parentNode}E=x}g=-1===w||-1===P?null:{start:w,end:P}}else g=null}g=g||{start:0,end:0}}else g=null;Ye={focusedElem:f,selectionRange:g};Id(!1);for(U=e;null!==U;){f=!1;g=void 0;try{for(;null!==U;){if(U.effectTag&256){var u=U.alternate;k=U;switch(k.tag){case 2:if(k.effectTag&256&&null!==u){var y=u.memoizedProps,D=u.memoizedState,ja=k.stateNode;ja.props=k.memoizedProps;ja.state=k.memoizedState;var hi=ja.getSnapshotBeforeUpdate(y,
D);ja.__reactInternalSnapshotBeforeUpdate=hi}break;case 3:case 5:case 6:case 4:break;default:A("163")}}U=U.nextEffect}}catch(Wa){f=!0,g=Wa}f&&(null===U?A("178"):void 0,Vg(U,g),null!==U&&(U=U.nextEffect))}for(U=e;null!==U;){u=!1;y=void 0;try{for(;null!==U;){var q=U.effectTag;q&16&&Ge(U.stateNode,"");if(q&128){var z=U.alternate;if(null!==z){var l=z.ref;null!==l&&("function"===typeof l?l(null):l.current=null)}}switch(q&14){case 2:Zg(U);U.effectTag&=-3;break;case 6:Zg(U);U.effectTag&=-3;$g(U.alternate,
U);break;case 4:$g(U.alternate,U);break;case 8:D=U,Xg(D),D.return=null,D.child=null,D.alternate&&(D.alternate.child=null,D.alternate.return=null)}U=U.nextEffect}}catch(Wa){u=!0,y=Wa}u&&(null===U?A("178"):void 0,Vg(U,y),null!==U&&(U=U.nextEffect))}l=Ye;z=da();q=l.focusedElem;u=l.selectionRange;if(z!==q&&fa(document.documentElement,q)){Td(q)&&(z=u.start,l=u.end,void 0===l&&(l=z),"selectionStart"in q?(q.selectionStart=z,q.selectionEnd=Math.min(l,q.value.length)):window.getSelection&&(z=window.getSelection(),
y=q[lb()].length,l=Math.min(u.start,y),u=void 0===u.end?l:Math.min(u.end,y),!z.extend&&l>u&&(y=u,u=l,l=y),y=Sd(q,l),D=Sd(q,u),y&&D&&(1!==z.rangeCount||z.anchorNode!==y.node||z.anchorOffset!==y.offset||z.focusNode!==D.node||z.focusOffset!==D.offset)&&(ja=document.createRange(),ja.setStart(y.node,y.offset),z.removeAllRanges(),l>u?(z.addRange(ja),z.extend(D.node,D.offset)):(ja.setEnd(D.node,D.offset),z.addRange(ja)))));z=[];for(l=q;l=l.parentNode;)1===l.nodeType&&z.push({element:l,left:l.scrollLeft,
top:l.scrollTop});q.focus();for(q=0;q<z.length;q++)l=z[q],l.element.scrollLeft=l.left,l.element.scrollTop=l.top}Ye=null;Id(Xe);Xe=null;c.current=b;for(U=e;null!==U;){e=!1;q=void 0;try{for(z=d;null!==U;){var gg=U.effectTag;if(gg&36){var lc=U.alternate;l=U;u=z;switch(l.tag){case 2:var ba=l.stateNode;if(l.effectTag&4)if(null===lc)ba.props=l.memoizedProps,ba.state=l.memoizedState,ba.componentDidMount();else{var ri=lc.memoizedProps,si=lc.memoizedState;ba.props=l.memoizedProps;ba.state=l.memoizedState;
ba.componentDidUpdate(ri,si,ba.__reactInternalSnapshotBeforeUpdate)}var Mg=l.updateQueue;null!==Mg&&(ba.props=l.memoizedProps,ba.state=l.memoizedState,Sf(l,Mg,ba,u));break;case 3:var Ng=l.updateQueue;if(null!==Ng){y=null;if(null!==l.child)switch(l.child.tag){case 5:y=l.child.stateNode;break;case 2:y=l.child.stateNode}Sf(l,Ng,y,u)}break;case 5:var ti=l.stateNode;null===lc&&l.effectTag&4&&Ze(l.type,l.memoizedProps)&&ti.focus();break;case 6:break;case 4:break;case 15:break;case 16:break;default:A("163")}}if(gg&
128){l=void 0;var uc=U.ref;if(null!==uc){var Og=U.stateNode;switch(U.tag){case 5:l=Og;break;default:l=Og}"function"===typeof uc?uc(l):uc.current=l}}var ui=U.nextEffect;U.nextEffect=null;U=ui}}catch(Wa){e=!0,q=Wa}e&&(null===U?A("178"):void 0,Vg(U,q),null!==U&&(U=U.nextEffect))}lh=ph=!1;"function"===typeof Ff&&Ff(b.stateNode);b=c.current.expirationTime;0===b&&(dh=null);a.remainingExpirationTime=b}function vh(){return null===Lh||Lh.timeRemaining()>Oh?!1:Ih=!0}
function bh(a){null===X?A("246"):void 0;X.remainingExpirationTime=0;Jh||(Jh=!0,Kh=a)}function xh(a){null===X?A("246"):void 0;X.remainingExpirationTime=a}function Yh(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||W||Sh()}}function Zh(a,b){if(Z&&!Mh){Mh=!0;try{return a(b)}finally{Mh=!1}}return a(b)}function $h(a,b){W?A("187"):void 0;var c=Z;Z=!0;try{return Eh(a,b)}finally{Z=c,Sh()}}function ai(a){var b=Z;Z=!0;try{Eh(a)}finally{(Z=b)||W||Uh(1,!1,null)}}
function bi(a,b,c,d,e){var f=b.current;if(c){c=c._reactInternalFiber;var g;b:{2===id(c)&&2===c.tag?void 0:A("170");for(g=c;3!==g.tag;){if(mf(g)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}(g=g.return)?void 0:A("171")}g=g.stateNode.context}c=mf(c)?rf(c,g):g}else c=ha;null===b.context?b.context=c:b.pendingContext=c;b=e;e=Kf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);Mf(f,e,d);kg(f,d);return d}
function ci(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?A("188"):A("268",Object.keys(a)));a=ld(b);return null===a?null:a.stateNode}function di(a,b,c,d){var e=b.current,f=ig();e=jg(f,e);return bi(a,b,c,e,d)}function ei(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}
function fi(a){var b=a.findFiberByHostInstance;return Ef(p({},a,{findHostInstanceByFiber:function(a){a=ld(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}
var gi={updateContainerAtExpirationTime:bi,createContainer:function(a,b,c){return Af(a,b,c)},updateContainer:di,flushRoot:Wh,requestWork:wh,computeUniqueAsyncExpiration:yh,batchedUpdates:Yh,unbatchedUpdates:Zh,deferredUpdates:Dh,syncUpdates:Eh,interactiveUpdates:function(a,b,c){if(zh)return a(b,c);Z||W||0===Ah||(Uh(Ah,!1,null),Ah=0);var d=zh,e=Z;Z=zh=!0;try{return a(b,c)}finally{zh=d,(Z=e)||W||Sh()}},flushInteractiveUpdates:function(){W||0===Ah||(Uh(Ah,!1,null),Ah=0)},flushControlled:ai,flushSync:$h,
getPublicRootInstance:ei,findHostInstance:ci,findHostInstanceWithNoPortals:function(a){a=md(a);return null===a?null:a.stateNode},injectIntoDevTools:fi};function ii(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:gc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}Kb.injectFiberControlledHostComponent(We);
function ji(a){this._expirationTime=yh();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}ji.prototype.render=function(a){this._defer?void 0:A("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new ki;bi(a,b,null,c,d._onCommit);return d};ji.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
ji.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:A("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?A("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Wh(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};ji.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function ki(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}ki.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
ki.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?A("191",c):void 0;c()}}};function li(a,b,c){this._internalRoot=Af(a,b,c)}li.prototype.render=function(a,b){var c=this._internalRoot,d=new ki;b=void 0===b?null:b;null!==b&&d.then(b);di(a,c,null,d._onCommit);return d};
li.prototype.unmount=function(a){var b=this._internalRoot,c=new ki;a=void 0===a?null:a;null!==a&&c.then(a);di(null,b,null,c._onCommit);return c};li.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new ki;c=void 0===c?null:c;null!==c&&e.then(c);di(b,d,a,e._onCommit);return e};
li.prototype.createBatch=function(){var a=new ji(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function mi(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Sb=gi.batchedUpdates;Tb=gi.interactiveUpdates;Ub=gi.flushInteractiveUpdates;
function ni(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new li(a,!1,b)}
function oi(a,b,c,d,e){mi(c)?void 0:A("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=ei(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=ni(c,d);if("function"===typeof e){var h=e;e=function(){var a=ei(f._internalRoot);h.call(a)}}Zh(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return ei(f._internalRoot)}
function pi(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;mi(b)?void 0:A("200");return ii(a,b,null,c)}
var qi={createPortal:pi,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:ci(a)},hydrate:function(a,b,c){return oi(null,a,b,!0,c)},render:function(a,b,c){return oi(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?A("38"):void 0;return oi(a,b,c,!1,d)},unmountComponentAtNode:function(a){mi(a)?void 0:A("40");return a._reactRootContainer?(Zh(function(){oi(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return pi.apply(void 0,
arguments)},unstable_batchedUpdates:Yh,unstable_deferredUpdates:Dh,flushSync:$h,unstable_flushControlled:ai,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ka,EventPluginRegistry:va,EventPropagators:$a,ReactControlledComponent:Rb,ReactDOMComponentTree:Qa,ReactDOMEventListener:Md},unstable_createRoot:function(a,b){return new li(a,!0,null!=b&&!0===b.hydrate)}};fi({findFiberByHostInstance:Na,bundleType:0,version:"16.4.0",rendererPackageName:"react-dom"});
var vi={default:qi},wi=vi&&qi||vi;module.exports=wi.default?wi.default:wi;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(51);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(52);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 53 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



var isObject = __webpack_require__(56);

function isObjectObject(o) {
  return isObject(o) === true
    && Object.prototype.toString.call(o) === '[object Object]';
}

module.exports = function isPlainObject(o) {
  var ctor,prot;

  if (isObjectObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (typeof ctor !== 'function') return false;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



module.exports = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */
(function (factory) {/* eslint-disable */
	 true ? (module['exports'] = factory(null)) :
		typeof define === 'function' && define['amd'] ? define(factory(null)) :
			(window['stylis'] = factory(null))
}(/** @param {*=} options */function factory (options) {/* eslint-disable */

	'use strict'

	/**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */

	var nullptn = /^\0+/g /* matches leading null characters */
	var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
	var colonptn = /: */g /* splits animation rules */
	var cursorptn = /zoo|gra/ /* assert cursor varient */
	var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
	var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
	var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
	var elementptn = / *[\0] */g /* selector elements */
	var selectorptn = /,\r+?/g /* splits selectors */
	var andptn = /([\t\r\n ])*\f?&/g /* match & */
	var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
	var invalidptn = /\W+/g /* removes invalid characters from keyframes */
	var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
	var plcholdrptn = /::(place)/g /* match ::placeholder varient */
	var readonlyptn = /:(read-only)/g /* match :read-only varient */
	var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
	var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
	var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
	var whiteptn = /\s{2,}/g /* matches repeating whitespace */
	var pseudoptn = /([^\(])(:+) */g /* pseudo element */
	var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
	var gradientptn = /([\w-]+t\()/g /* match *gradient property */
	var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
	var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */
	var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
	var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
	var trimptn = /[ \t]+$/ /* match tail whitspace */
	var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available

	/* vendors */
	var webkit = '-webkit-'
	var moz = '-moz-'
	var ms = '-ms-'

	/* character codes */
	var SEMICOLON = 59 /* ; */
	var CLOSEBRACES = 125 /* } */
	var OPENBRACES = 123 /* { */
	var OPENPARENTHESES = 40 /* ( */
	var CLOSEPARENTHESES = 41 /* ) */
	var OPENBRACKET = 91 /* [ */
	var CLOSEBRACKET = 93 /* ] */
	var NEWLINE = 10 /* \n */
	var CARRIAGE = 13 /* \r */
	var TAB = 9 /* \t */
	var AT = 64 /* @ */
	var SPACE = 32 /*   */
	var AND = 38 /* & */
	var DASH = 45 /* - */
	var UNDERSCORE = 95 /* _ */
	var STAR = 42 /* * */
	var COMMA = 44 /* , */
	var COLON = 58 /* : */
	var SINGLEQUOTE = 39 /* ' */
	var DOUBLEQUOTE = 34 /* " */
	var FOWARDSLASH = 47 /* / */
	var GREATERTHAN = 62 /* > */
	var PLUS = 43 /* + */
	var TILDE = 126 /* ~ */
	var NULL = 0 /* \0 */
	var FORMFEED = 12 /* \f */
	var VERTICALTAB = 11 /* \v */

	/* special identifiers */
	var KEYFRAME = 107 /* k */
	var MEDIA = 109 /* m */
	var SUPPORTS = 115 /* s */
	var PLACEHOLDER = 112 /* p */
	var READONLY = 111 /* o */
	var IMPORT = 169 /* <at>i */
	var CHARSET = 163 /* <at>c */
	var DOCUMENT = 100 /* <at>d */
	var PAGE = 112 /* <at>p */

	var column = 1 /* current column */
	var line = 1 /* current line numebr */
	var pattern = 0 /* :pattern */

	var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
	var prefix = 1 /* vendor prefix */
	var escape = 1 /* escape :global() pattern */
	var compress = 0 /* compress output */
	var semicolon = 0 /* no/semicolon option */
	var preserve = 0 /* preserve empty selectors */

	/* empty reference */
	var array = []

	/* plugins */
	var plugins = []
	var plugged = 0
	var should = null

	/* plugin context */
	var POSTS = -2
	var PREPS = -1
	var UNKWN = 0
	var PROPS = 1
	var BLCKS = 2
	var ATRUL = 3

	/* plugin newline context */
	var unkwn = 0

	/* keyframe animation */
	var keyed = 1
	var key = ''

	/* selector namespace */
	var nscopealt = ''
	var nscope = ''

	/**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */
	function compile (parent, current, body, id, depth) {
		var bracket = 0 /* brackets [] */
		var comment = 0 /* comments /* // or /* */
		var parentheses = 0 /* functions () */
		var quote = 0 /* quotes '', "" */

		var first = 0 /* first character code */
		var second = 0 /* second character code */
		var code = 0 /* current character code */
		var tail = 0 /* previous character code */
		var trail = 0 /* character before previous code */
		var peak = 0 /* previous non-whitespace code */

		var counter = 0 /* count sequence termination */
		var context = 0 /* track current context */
		var atrule = 0 /* track @at-rule context */
		var pseudo = 0 /* track pseudo token index */
		var caret = 0 /* current character index */
		var format = 0 /* control character formating context */
		var insert = 0 /* auto semicolon insertion */
		var invert = 0 /* inverted selector pattern */
		var length = 0 /* generic length address */
		var eof = body.length /* end of file(length) */
		var eol = eof - 1 /* end of file(characters) */

		var char = '' /* current character */
		var chars = '' /* current buffer of characters */
		var child = '' /* next buffer of characters */
		var out = '' /* compiled body */
		var children = '' /* compiled children */
		var flat = '' /* compiled leafs */
		var selector /* generic selector address */
		var result /* generic address */

		// ...build body
		while (caret < eof) {
			code = body.charCodeAt(caret)

			// eof varient
			if (caret === eol) {
				// last character + noop context, add synthetic padding for noop context to terminate
				if (comment + quote + parentheses + bracket !== 0) {
					if (comment !== 0) {
						code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
					}

					quote = parentheses = bracket = 0
					eof++
					eol++
				}
			}

			if (comment + quote + parentheses + bracket === 0) {
				// eof varient
				if (caret === eol) {
					if (format > 0) {
						chars = chars.replace(formatptn, '')
					}

					if (chars.trim().length > 0) {
						switch (code) {
							case SPACE:
							case TAB:
							case SEMICOLON:
							case CARRIAGE:
							case NEWLINE: {
								break
							}
							default: {
								chars += body.charAt(caret)
							}
						}

						code = SEMICOLON
					}
				}

				// auto semicolon insertion
				if (insert === 1) {
					switch (code) {
						// false flags
						case OPENBRACES:
						case CLOSEBRACES:
						case SEMICOLON:
						case DOUBLEQUOTE:
						case SINGLEQUOTE:
						case OPENPARENTHESES:
						case CLOSEPARENTHESES:
						case COMMA: {
							insert = 0
						}
						// ignore
						case TAB:
						case CARRIAGE:
						case NEWLINE:
						case SPACE: {
							break
						}
						// valid
						default: {
							insert = 0
							length = caret
							first = code
							caret--
							code = SEMICOLON

							while (length < eof) {
								switch (body.charCodeAt(length++)) {
									case NEWLINE:
									case CARRIAGE:
									case SEMICOLON: {
										++caret
										code = first
										length = eof
										break
									}
									case COLON: {
										if (format > 0) {
											++caret
											code = first
										}
									}
									case OPENBRACES: {
										length = eof
									}
								}
							}
						}
					}
				}

				// token varient
				switch (code) {
					case OPENBRACES: {
						chars = chars.trim()
						first = chars.charCodeAt(0)
						counter = 1
						length = ++caret

						while (caret < eof) {
							code = body.charCodeAt(caret)

							switch (code) {
								case OPENBRACES: {
									counter++
									break
								}
								case CLOSEBRACES: {
									counter--
									break
								}
							}

							if (counter === 0) {
								break
							}

							caret++
						}

						child = body.substring(length, caret)

						if (first === NULL) {
							first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
						}

						switch (first) {
							// @at-rule
							case AT: {
								if (format > 0) {
									chars = chars.replace(formatptn, '')
								}

								second = chars.charCodeAt(1)

								switch (second) {
									case DOCUMENT:
									case MEDIA:
									case SUPPORTS:
									case DASH: {
										selector = current
										break
									}
									default: {
										selector = array
									}
								}

								child = compile(current, selector, child, second, depth+1)
								length = child.length

								// preserve empty @at-rule
								if (preserve > 0 && length === 0) {
									length = chars.length
								}

								// execute plugins, @at-rule context
								if (plugged > 0) {
									selector = select(array, chars, invert)
									result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id)
									chars = selector.join('')

									if (result !== void 0) {
										if ((length = (child = result.trim()).length) === 0) {
											second = 0
											child = ''
										}
									}
								}

								if (length > 0) {
									switch (second) {
										case SUPPORTS: {
											chars = chars.replace(supportsptn, supports)
										}
										case DOCUMENT:
										case MEDIA:
										case DASH: {
											child = chars + '{' + child + '}'
											break
										}
										case KEYFRAME: {
											chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
											child = chars + '{' + child + '}'

											if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
												child = '@' + webkit + child + '@' + child
											} else {
												child = '@' + child
											}
											break
										}
										default: {
											child = chars + child

											if (id === PAGE) {
												child = (out += child, '')
											}
										}
									}
								} else {
									child = ''
								}

								break
							}
							// selector
							default: {
								child = compile(current, select(current, chars, invert), child, id, depth+1)
							}
						}

						children += child

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						atrule = 0
						chars = ''
						child = ''
						code = body.charCodeAt(++caret)
						break
					}
					case CLOSEBRACES:
					case SEMICOLON: {
						chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()

						if ((length = chars.length) > 1) {
							// monkey-patch missing colon
							if (pseudo === 0) {
								first = chars.charCodeAt(0)

								// first character is a letter or dash, buffer has a space character
								if ((first === DASH || first > 96 && first < 123)) {
									length = (chars = chars.replace(' ', ':')).length
								}
							}

							// execute plugins, property context
							if (plugged > 0) {
								if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
									if ((length = (chars = result.trim()).length) === 0) {
										chars = '\0\0'
									}
								}
							}

							first = chars.charCodeAt(0)
							second = chars.charCodeAt(1)

							switch (first + second) {
								case NULL: {
									break
								}
								case IMPORT:
								case CHARSET: {
									flat += chars + body.charAt(caret)
									break
								}
								default: {
									if (chars.charCodeAt(length-1) === COLON)
										break

									out += property(chars, first, second, chars.charCodeAt(2))
								}
							}
						}

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						chars = ''
						code = body.charCodeAt(++caret)
						break
					}
				}
			}

			// parse characters
			switch (code) {
				case CARRIAGE:
				case NEWLINE: {
					// auto insert semicolon
					if (comment + quote + parentheses + bracket + semicolon === 0) {
						// valid non-whitespace characters that
						// may precede a newline
						switch (peak) {
							case CLOSEPARENTHESES:
							case SINGLEQUOTE:
							case DOUBLEQUOTE:
							case AT:
							case TILDE:
							case GREATERTHAN:
							case STAR:
							case PLUS:
							case FOWARDSLASH:
							case DASH:
							case COLON:
							case COMMA:
							case SEMICOLON:
							case OPENBRACES:
							case CLOSEBRACES: {
								break
							}
							default: {
								// current buffer has a colon
								if (pseudo > 0) {
									insert = 1
								}
							}
						}
					}

					// terminate line comment
					if (comment === FOWARDSLASH) {
						comment = 0
					} else if (cascade + context === 0) {
						format = 1
						chars += '\0'
					}

					// execute plugins, newline context
					if (plugged * unkwn > 0) {
						proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id)
					}

					// next line, reset column position
					column = 1
					line++
					break
				}
				case SEMICOLON:
				case CLOSEBRACES: {
					if (comment + quote + parentheses + bracket === 0) {
						column++
						break
					}
				}
				default: {
					// increment column position
					column++

					// current character
					char = body.charAt(caret)

					// remove comments, escape functions, strings, attributes and prepare selectors
					switch (code) {
						case TAB:
						case SPACE: {
							if (quote + bracket + comment === 0) {
								switch (tail) {
									case COMMA:
									case COLON:
									case TAB:
									case SPACE: {
										char = ''
										break
									}
									default: {
										if (code !== SPACE) {
											char = ' '
										}
									}
								}
							}
							break
						}
						// escape breaking control characters
						case NULL: {
							char = '\\0'
							break
						}
						case FORMFEED: {
							char = '\\f'
							break
						}
						case VERTICALTAB: {
							char = '\\v'
							break
						}
						// &
						case AND: {
							// inverted selector pattern i.e html &
							if (quote + comment + bracket === 0 && cascade > 0) {
								invert = 1
								format = 1
								char = '\f' + char
							}
							break
						}
						// ::p<l>aceholder, l
						// :read-on<l>y, l
						case 108: {
							if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
								switch (caret - pseudo) {
									// ::placeholder
									case 2: {
										if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
											pattern = tail
										}
									}
									// :read-only
									case 8: {
										if (trail === READONLY) {
											pattern = trail
										}
									}
								}
							}
							break
						}
						// :<pattern>
						case COLON: {
							if (quote + comment + bracket === 0) {
								pseudo = caret
							}
							break
						}
						// selectors
						case COMMA: {
							if (comment + parentheses + quote + bracket === 0) {
								format = 1
								char += '\r'
							}
							break
						}
						// quotes
						case DOUBLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						case SINGLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						// attributes
						case OPENBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket++
							}
							break
						}
						case CLOSEBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket--
							}
							break
						}
						// functions
						case CLOSEPARENTHESES: {
							if (quote + comment + bracket === 0) {
								parentheses--
							}
							break
						}
						case OPENPARENTHESES: {
							if (quote + comment + bracket === 0) {
								if (context === 0) {
									switch (tail*2 + trail*3) {
										// :matches
										case 533: {
											break
										}
										// :global, :not, :nth-child etc...
										default: {
											counter = 0
											context = 1
										}
									}
								}

								parentheses++
							}
							break
						}
						case AT: {
							if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
								atrule = 1
							}
							break
						}
						// block/line comments
						case STAR:
						case FOWARDSLASH: {
							if (quote + bracket + parentheses > 0) {
								break
							}

							switch (comment) {
								// initialize line/block comment context
								case 0: {
									switch (code*2 + body.charCodeAt(caret+1)*3) {
										// //
										case 235: {
											comment = FOWARDSLASH
											break
										}
										// /*
										case 220: {
											length = caret
											comment = STAR
											break
										}
									}
									break
								}
								// end block comment context
								case STAR: {
									if (code === FOWARDSLASH && tail === STAR) {
										// /*<!> ... */, !
										if (body.charCodeAt(length+2) === 33) {
											out += body.substring(length, caret+1)
										}
										char = ''
										comment = 0
									}
								}
							}
						}
					}

					// ignore comment blocks
					if (comment === 0) {
						// aggressive isolation mode, divide each individual selector
						// including selectors in :not function but excluding selectors in :global function
						if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
							switch (code) {
								case COMMA:
								case TILDE:
								case GREATERTHAN:
								case PLUS:
								case CLOSEPARENTHESES:
								case OPENPARENTHESES: {
									if (context === 0) {
										// outside of an isolated context i.e nth-child(<...>)
										switch (tail) {
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												char = char + '\0'
												break
											}
											default: {
												char = '\0' + char + (code === COMMA ? '' : '\0')
											}
										}
										format = 1
									} else {
										// within an isolated context, sleep untill it's terminated
										switch (code) {
											case OPENPARENTHESES: {
												context = ++counter
												break
											}
											case CLOSEPARENTHESES: {
												if ((context = --counter) === 0) {
													format = 1
													char += '\0'
												}
												break
											}
										}
									}
									break
								}
								case TAB:
								case SPACE: {
									switch (tail) {
										case NULL:
										case OPENBRACES:
										case CLOSEBRACES:
										case SEMICOLON:
										case COMMA:
										case FORMFEED:
										case TAB:
										case SPACE:
										case NEWLINE:
										case CARRIAGE: {
											break
										}
										default: {
											// ignore in isolated contexts
											if (context === 0) {
												format = 1
												char += '\0'
											}
										}
									}
								}
							}
						}

						// concat buffer of characters
						chars += char

						// previous non-whitespace character code
						if (code !== SPACE && code !== TAB) {
							peak = code
						}
					}
				}
			}

			// tail character codes
			trail = tail
			tail = code

			// visit every character
			caret++
		}

		length = out.length

		// preserve empty selector
 		if (preserve > 0) {
 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
					length = current.join(',').length + 2
 				}
 			}
		}

		if (length > 0) {
			// cascade isolation mode?
			selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current

			// execute plugins, block context
			if (plugged > 0) {
				result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id)

				if (result !== void 0 && (out = result).length === 0) {
					return flat + out + children
				}
			}

			out = selector.join(',') + '{' + out + '}'

			if (prefix*pattern !== 0) {
				if (prefix === 2 && !vendor(out, 2))
					pattern = 0

				switch (pattern) {
					// ::read-only
					case READONLY: {
						out = out.replace(readonlyptn, ':'+moz+'$1')+out
						break
					}
					// ::placeholder
					case PLACEHOLDER: {
						out = (
							out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
							out.replace(plcholdrptn, '::' + moz + '$1') +
							out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
						)
						break
					}
				}

				pattern = 0
			}
		}

		return flat + out + children
	}

	/**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */
	function select (parent, current, invert) {
		var selectors = current.trim().split(selectorptn)
		var out = selectors

		var length = selectors.length
		var l = parent.length

		switch (l) {
			// 0-1 parent selectors
			case 0:
			case 1: {
				for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
					out[i] = scope(selector, out[i], invert, l).trim()
				}
				break
			}
			// >2 parent selectors, nested
			default: {
				for (var i = 0, j = 0, out = []; i < length; ++i) {
					for (var k = 0; k < l; ++k) {
						out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
					}
				}
			}
		}

		return out
	}

	/**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */
	function scope (parent, current, invert, level) {
		var selector = current
		var code = selector.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (selector = selector.trim()).charCodeAt(0)
		}

		switch (code) {
			// &
			case AND: {
				switch (cascade + level) {
					case 0:
					case 1: {
						if (parent.trim().length === 0) {
							break
						}
					}
					default: {
						return selector.replace(andptn, '$1'+parent.trim())
					}
				}
				break
			}
			// :
			case COLON: {
				switch (selector.charCodeAt(1)) {
					// g in :global
					case 103: {
						if (escape > 0 && cascade > 0) {
							return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
						}
						break
					}
					default: {
						// :hover
						return parent.trim() + selector.replace(andptn, '$1'+parent.trim())
					}
				}
			}
			default: {
				// html &
				if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
					return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
				}
			}
		}

		return parent + selector
	}

	/**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */
	function property (input, first, second, third) {
		var index = 0
		var out = input + ';'
		var hash = (first*2) + (second*3) + (third*4)
		var cache

		// animation: a, n, i characters
		if (hash === 944) {
			return animation(out)
		} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
			return out
		}

		// vendor prefix
		switch (hash) {
			// text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
			case 1015: {
				// text-shadow/text-align/text-transform, a
				return out.charCodeAt(10) === 97 ? webkit + out + out : out
			}
			// filter/fill f, i, l
			case 951: {
				// filter, t
				return out.charCodeAt(3) === 116 ? webkit + out + out : out
			}
			// color/column, c, o, l
			case 963: {
				// column, n
				return out.charCodeAt(5) === 110 ? webkit + out + out : out
			}
			// box-decoration-break, b, o, x
			case 1009: {
				if (out.charCodeAt(4) !== 100) {
					break
				}
			}
			// mask, m, a, s
			// clip-path, c, l, i
			case 969:
			case 942: {
				return webkit + out + out
			}
			// appearance: a, p, p
			case 978: {
				return webkit + out + moz + out + out
			}
			// hyphens: h, y, p
			// user-select: u, s, e
			case 1019:
			case 983: {
				return webkit + out + moz + out + ms + out + out
			}
			// background/backface-visibility, b, a, c
			case 883: {
				// backface-visibility, -
				return out.charCodeAt(8) === DASH ? webkit + out + out : out
			}
			// flex: f, l, e
			case 932: {
				if (out.charCodeAt(4) === DASH) {
					switch (out.charCodeAt(5)) {
						// flex-grow, g
						case 103: {
							return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
						}
						// flex-shrink, s
						case 115: {
							return webkit + out + ms + out.replace('shrink', 'negative') + out
						}
						// flex-basis, b
						case 98: {
							return webkit + out + ms + out.replace('basis', 'preferred-size') + out
						}
					}
				}

				return webkit + out + ms + out + out
			}
			// order: o, r, d
			case 964: {
				return webkit + out + ms + 'flex' + '-' + out + out
			}
			// justify-items/justify-content, j, u, s
			case 1023: {
				// justify-content, c
				if (out.charCodeAt(8) !== 99) {
					break
				}

				cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
				return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
			}
			// cursor, c, u, r
			case 1005: {
				return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
			}
			// writing-mode, w, r, i
			case 1000: {
				cache = out.substring(13).trim()
				index = cache.indexOf('-') + 1

				switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
					// vertical-lr
					case 226: {
						cache = out.replace(writingptn, 'tb')
						break
					}
					// vertical-rl
					case 232: {
						cache = out.replace(writingptn, 'tb-rl')
						break
					}
					// horizontal-tb
					case 220: {
						cache = out.replace(writingptn, 'lr')
						break
					}
					default: {
						return out
					}
				}

				return webkit + out + ms + cache + out
			}
			// position: sticky
			case 1017: {
				if (out.indexOf('sticky', 9) === -1) {
					return out
				}
			}
			// display(flex/inline-flex/inline-box): d, i, s
			case 975: {
				index = (out = input).length - 10
				cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()

				switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
					// inline-
					case 203: {
						// inline-box
						if (cache.charCodeAt(8) < 111) {
							break
						}
					}
					// inline-box/sticky
					case 115: {
						out = out.replace(cache, webkit+cache)+';'+out
						break
					}
					// inline-flex
					// flex
					case 207:
					case 102: {
						out = (
							out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
							out.replace(cache, webkit+cache)+';'+
							out.replace(cache, ms+cache+'box')+';'+
							out
						)
					}
				}

				return out + ';'
			}
			// align-items, align-center, align-self: a, l, i, -
			case 938: {
				if (out.charCodeAt(5) === DASH) {
					switch (out.charCodeAt(6)) {
						// align-items, i
						case 105: {
							cache = out.replace('-items', '')
							return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
						}
						// align-self, s
						case 115: {
							return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
						}
						// align-content
						default: {
							return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out
						}
					}
				}
				break
			}
			// min/max
			case 973:
			case 989: {
				// min-/max- height/width/block-size/inline-size
				if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
					break
				}
			}
			// height/width: min-content / width: max-content
			case 931:
			case 953: {
				if (dimensionptn.test(input) === true) {
					// stretch
					if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115)
						return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch')
					else
						return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out
				}
				break
			}
			// transform, transition: t, r, a
			case 962: {
				out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out

				// transitions
				if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
					return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
				}

				break
			}
		}

		return out
	}

	/**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */
	function vendor (content, context) {
		var index = content.indexOf(context === 1 ? ':' : '{')
		var key = content.substring(0, context !== 3 ? index : 10)
		var value = content.substring(index + 1, content.length - 1)

		return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
	}

	/**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */
	function supports (match, group) {
		var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))

		return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
	}

	/**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */
	function animation (input) {
		var length = input.length
		var index = input.indexOf(':', 9) + 1
		var declare = input.substring(0, index).trim()
		var out = input.substring(index, length-1).trim()

		switch (input.charCodeAt(9)*keyed) {
			case 0: {
				break
			}
			// animation-*, -
			case DASH: {
				// animation-name, n
				if (input.charCodeAt(10) !== 110) {
					break
				}
			}
			// animation/animation-name
			default: {
				// split in case of multiple animations
				var list = out.split((out = '', animationptn))

				for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
					var value = list[i]
					var items = value.split(propertiesptn)

					while (value = items[index]) {
						var peak = value.charCodeAt(0)

						if (keyed === 1 && (
							// letters
							(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
							// dash but not in sequence i.e --
							(peak === DASH && value.charCodeAt(1) !== DASH)
						)) {
							// not a number/function
							switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
								case 1: {
									switch (value) {
										// not a valid reserved keyword
										case 'infinite': case 'alternate': case 'backwards': case 'running':
										case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
										case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
										case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
										case 'initial': case 'unset': case 'step-start': case 'step-end': {
											break
										}
										default: {
											value += key
										}
									}
								}
							}
						}

						items[index++] = value
					}

					out += (i === 0 ? '' : ',') + items.join(' ')
				}
			}
		}

		out = declare + out + ';'

		if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
			return webkit + out + out

		return out
	}

	/**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */
	function isolate (current) {
		for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
			// split individual elements in a selector i.e h1 h2 === [h1, h2]
			var elements = current[i].split(elementptn)
			var out = ''

			for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
				// empty element
				if ((size = (element = elements[j]).length) === 0 && l > 1) {
					continue
				}

				tail = out.charCodeAt(out.length-1)
				code = element.charCodeAt(0)
				padding = ''

				if (j !== 0) {
					// determine if we need padding
					switch (tail) {
						case STAR:
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case OPENPARENTHESES:  {
							break
						}
						default: {
							padding = ' '
						}
					}
				}

				switch (code) {
					case AND: {
						element = padding + nscopealt
					}
					case TILDE:
					case GREATERTHAN:
					case PLUS:
					case SPACE:
					case CLOSEPARENTHESES:
					case OPENPARENTHESES: {
						break
					}
					case OPENBRACKET: {
						element = padding + element + nscopealt
						break
					}
					case COLON: {
						switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
							// :global
							case 530: {
								if (escape > 0) {
									element = padding + element.substring(8, size - 1)
									break
								}
							}
							// :hover, :nth-child(), ...
							default: {
								if (j < 1 || elements[j-1].length < 1) {
									element = padding + nscopealt + element
								}
							}
						}
						break
					}
					case COMMA: {
						padding = ''
					}
					default: {
						if (size > 1 && element.indexOf(':') > 0) {
							element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
						} else {
							element = padding + element + nscopealt
						}
					}
				}

				out += element
			}

			selector[i] = out.replace(formatptn, '').trim()
		}

		return selector
	}

	/**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */
	function proxy (context, content, selectors, parents, line, column, length, id, depth, at) {
		for (var i = 0, out = content, next; i < plugged; ++i) {
			switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
				case void 0:
				case false:
				case true:
				case null: {
					break
				}
				default: {
					out = next
				}
			}
		}

		switch (out) {
			case void 0:
			case false:
			case true:
			case null:
			case content: {
				break
			}
			default: {
				return out
			}
		}
	}

	/**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */
	function minify (output) {
		return output
			.replace(formatptn, '')
			.replace(beforeptn, '')
			.replace(afterptn, '$1')
			.replace(tailptn, '$1')
			.replace(whiteptn, ' ')
	}

	/**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */
	function use (plugin) {
		switch (plugin) {
			case void 0:
			case null: {
				plugged = plugins.length = 0
				break
			}
			default: {
				switch (plugin.constructor) {
					case Array: {
						for (var i = 0, length = plugin.length; i < length; ++i) {
							use(plugin[i])
						}
						break
					}
					case Function: {
						plugins[plugged++] = plugin
						break
					}
					case Boolean: {
						unkwn = !!plugin|0
					}
				}
			}
 		}

 		return use
	}

	/**
	 * Set
	 *
	 * @param {*} options
	 */
	function set (options) {
		for (var name in options) {
			var value = options[name]
			switch (name) {
				case 'keyframe': keyed = value|0; break
				case 'global': escape = value|0; break
				case 'cascade': cascade = value|0; break
				case 'compress': compress = value|0; break
				case 'semicolon': semicolon = value|0; break
				case 'preserve': preserve = value|0; break
				case 'prefix':
					should = null

					if (!value) {
						prefix = 0
					} else if (typeof value !== 'function') {
						prefix = 1
					} else {
						prefix = 2
						should = value
					}
			}
		}

		return set
	}

	/**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */
	function stylis (selector, input) {
		if (this !== void 0 && this.constructor === stylis) {
			return factory(selector)
		}

		// setup
		var ns = selector
		var code = ns.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (ns = ns.trim()).charCodeAt(0)
		}

		// keyframe/animation namespace
		if (keyed > 0) {
			key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
		}

		// reset, used to assert if a plugin is moneky-patching the return value
		code = 1

		// cascade/isolate
		if (cascade === 1) {
			nscope = ns
		} else {
			nscopealt = ns
		}

		var selectors = [nscope]
		var result

		// execute plugins, pre-process context
		if (plugged > 0) {
			result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0)

			if (result !== void 0 && typeof result === 'string') {
				input = result
			}
		}

		// build
		var output = compile(array, selectors, input, 0, 0)

		// execute plugins, post-process context
		if (plugged > 0) {
			result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0)

			// bypass minification
			if (result !== void 0 && typeof(output = result) !== 'string') {
				code = 0
			}
		}

		// reset
		key = ''
		nscope = ''
		nscopealt = ''
		pattern = 0
		line = 1
		column = 1

		return compress*code === 0 ? output : minify(output)
	}

	stylis['use'] = use
	stylis['set'] = set

	if (options !== void 0) {
		set(options)
	}

	return stylis
}));


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(16);
var invariant = __webpack_require__(15);
var ReactPropTypesSecret = __webpack_require__(60);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(62);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.0
 * react-is.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.forward_ref"):60112,n=b?Symbol.for("react.timeout"):60113;
function q(a){if("object"===typeof a&&null!==a){var p=a.$$typeof;switch(p){case c:switch(a=a.type,a){case l:case e:case g:case f:return a;default:switch(a=a&&a.$$typeof,a){case k:case m:case h:return a;default:return p}}case d:return p}}}exports.typeOf=q;exports.AsyncMode=l;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=m;exports.Fragment=e;exports.Profiler=g;exports.Portal=d;exports.StrictMode=f;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===l||a===g||a===f||a===n||"object"===typeof a&&null!==a&&(a.$$typeof===h||a.$$typeof===k||a.$$typeof===m)};exports.isAsyncMode=function(a){return q(a)===l};exports.isContextConsumer=function(a){return q(a)===k};exports.isContextProvider=function(a){return q(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return q(a)===m};
exports.isFragment=function(a){return q(a)===e};exports.isProfiler=function(a){return q(a)===g};exports.isPortal=function(a){return q(a)===d};exports.isStrictMode=function(a){return q(a)===f};


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Home__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Demo__ = __webpack_require__(148);
var App=function App(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:""+'/',component:__WEBPACK_IMPORTED_MODULE_2__Home__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:""+'/demo',component:__WEBPACK_IMPORTED_MODULE_3__Demo__["a" /* default */]})));};/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(19);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(26);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createBrowserHistory);

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(26);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createHashHistory);

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(18);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createMemoryHistory);

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(19);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(72);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(20);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(27);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(76);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(78);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(31);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(80);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(20);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(82);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(21);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(31);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(21);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(86);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(29);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Header__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Intro__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MakingKAccessible__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__HowItWorks__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Features__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WhoCanBenefitFromElla__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Contact__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Footer__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Webchat__ = __webpack_require__(146);
var _templateObject=_taggedTemplateLiteral(['\n  overflow: hidden;\n'],['\n  overflow: hidden;\n']),_templateObject2=_taggedTemplateLiteral(['\n  display: block;\n  position: relative;\n  top: -7em;\n  visibility: hidden;\n'],['\n  display: block;\n  position: relative;\n  top: -7em;\n  visibility: hidden;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable jsx-a11y/media-has-caption */var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject);var Anchor=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].a(_templateObject2);var Home=function Home(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["a" /* I18n */],{ns:'translations'},function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Anchor,{id:'home'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Header__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Intro__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Anchor,{id:'about'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__MakingKAccessible__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__HowItWorks__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Features__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Anchor,{id:'service'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__WhoCanBenefitFromElla__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Anchor,{id:'contact'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Contact__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Footer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Webchat__["a" /* default */],null));}));};/* harmony default export */ __webpack_exports__["a"] = (Home);

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shallowEqual__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__I18n__ = __webpack_require__(32);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








function getDisplayName(component) {
  return component.displayName || component.name || 'Component';
}

function translate(namespaceArg) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


  return function Wrapper(WrappedComponent) {
    var Translate = function (_Component) {
      _inherits(Translate, _Component);

      function Translate(props, context) {
        _classCallCheck(this, Translate);

        var _this = _possibleConstructorReturn(this, (Translate.__proto__ || Object.getPrototypeOf(Translate)).call(this, props, context));

        _this.i18n = props.i18n || options.i18n || context.i18n || Object(__WEBPACK_IMPORTED_MODULE_4__context__["b" /* getI18n */])();
        _this.namespaces = typeof namespaceArg === 'function' ? namespaceArg(props) : namespaceArg || _this.i18n.options && _this.i18n.options.defaultNS;
        if (typeof _this.namespaces === 'string') _this.namespaces = [_this.namespaces];

        var i18nOptions = _this.i18n && _this.i18n.options && _this.i18n.options.react || {};
        _this.options = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_4__context__["a" /* getDefaults */])(), i18nOptions, options);

        _this.getWrappedInstance = _this.getWrappedInstance.bind(_this);
        return _this;
      }

      _createClass(Translate, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
          if (!this.options.usePureComponent) {
            return true;
          }

          return !Object(__WEBPACK_IMPORTED_MODULE_3__shallowEqual__["a" /* default */])(this.props, nextProps);
        }
      }, {
        key: 'getWrappedInstance',
        value: function getWrappedInstance() {
          if (!this.options.withRef) {
            // eslint-disable-next-line no-console
            console.error('To access the wrapped instance, you need to specify ' + '{ withRef: true } as the second argument of the translate() call.');
          }

          /* eslint react/no-string-refs: 1 */
          return this.wrappedInstance;
        }
      }, {
        key: 'render',
        value: function render() {
          var _this2 = this;

          var extraProps = {};

          if (this.options.withRef) {
            extraProps.ref = function (c) {
              _this2.wrappedInstance = c;
            };
          }

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__I18n__["a" /* default */], _extends({ ns: this.namespaces }, this.options, this.props, { i18n: this.i18n }), function (t, _ref) {
            var ready = _ref.ready,
                context = _objectWithoutProperties(_ref, ['ready']);

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({
              tReady: ready
            }, _this2.props, extraProps, context));
          });
        }
      }]);

      return Translate;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    Translate.WrappedComponent = WrappedComponent;

    Translate.contextTypes = {
      i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
    };

    Translate.displayName = 'Translate(' + getDisplayName(WrappedComponent) + ')';

    Translate.namespaces = namespaceArg;

    return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(Translate, WrappedComponent);
  };
}

translate.setDefaults = __WEBPACK_IMPORTED_MODULE_4__context__["d" /* setDefaults */];

translate.setI18n = __WEBPACK_IMPORTED_MODULE_4__context__["e" /* setI18n */];

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule shallowEqual
 * @typechecks
 * 
 */

/* eslint-disable no-self-compare */

var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  }
  // Step 6.a: NaN == NaN
  return x !== x && y !== y;
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Interpolate = function (_Component) {
  _inherits(Interpolate, _Component);

  function Interpolate(props, context) {
    _classCallCheck(this, Interpolate);

    var _this = _possibleConstructorReturn(this, (Interpolate.__proto__ || Object.getPrototypeOf(Interpolate)).call(this, props, context));

    _this.i18n = props.i18n || context.i18n;
    _this.t = props.t || context.t;
    return _this;
  }

  _createClass(Interpolate, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var parent = this.props.parent || 'span';
      var REGEXP = this.props.regexp || this.i18n.services.interpolator.regexp;
      var _props = this.props,
          className = _props.className,
          style = _props.style;

      // Set to true if you want to use raw HTML in translation values
      // See https://github.com/i18next/react-i18next/issues/189

      var useDangerouslySetInnerHTML = this.props.useDangerouslySetInnerHTML || false;
      var dangerouslySetInnerHTMLPartElement = this.props.dangerouslySetInnerHTMLPartElement || 'span';

      var tOpts = _extends({}, this.props.options, { interpolation: { prefix: '#$?', suffix: '?$#' } });
      var format = this.t(this.props.i18nKey, tOpts);

      if (!format || typeof format !== 'string') return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('noscript', null);

      var children = [];

      var handleFormat = function handleFormat(key, props) {
        if (key.indexOf(_this2.i18n.options.interpolation.formatSeparator) < 0) {
          if (props[key] === undefined) _this2.i18n.services.logger.warn('interpolator: missed to pass in variable ' + key + ' for interpolating ' + format);
          return props[key];
        }

        var p = key.split(_this2.i18n.options.interpolation.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this2.i18n.options.interpolation.formatSeparator).trim();

        if (props[k] === undefined) _this2.i18n.services.logger.warn('interpolator: missed to pass in variable ' + k + ' for interpolating ' + format);
        return _this2.i18n.options.interpolation.format(props[k], f, _this2.i18n.language);
      };

      format.split(REGEXP).reduce(function (memo, match, index) {
        var child = void 0;

        if (index % 2 === 0) {
          if (match.length === 0) return memo;
          if (useDangerouslySetInnerHTML) {
            child = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(dangerouslySetInnerHTMLPartElement, { dangerouslySetInnerHTML: { __html: match } });
          } else {
            child = match;
          }
        } else {
          child = handleFormat(match, _this2.props);
        }

        memo.push(child);
        return memo;
      }, children);

      var additionalProps = {};
      if (this.i18n.options.react && this.i18n.options.react.exposeNamespace) {
        var ns = typeof this.t.ns === 'string' ? this.t.ns : this.t.ns[0];
        if (this.props.i18nKey && this.i18n.options.nsSeparator && this.props.i18nKey.indexOf(this.i18n.options.nsSeparator) > -1) {
          var parts = this.props.i18nKey.split(this.i18n.options.nsSeparator);
          ns = parts[0];
        }
        if (this.t.ns) additionalProps['data-i18next-options'] = JSON.stringify({ ns: ns });
      }

      if (className) additionalProps.className = className;
      if (style) additionalProps.style = style;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement.apply(this, [parent, additionalProps].concat(children));
    }
  }]);

  return Interpolate;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Interpolate.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

Interpolate.defaultProps = {
  className: ''
};

Interpolate.contextTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* unused harmony default export */ var _unused_webpack_default_export = (Interpolate);

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html_parse_stringify2__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html_parse_stringify2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_html_parse_stringify2__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





function hasChildren(node) {
  return node && (node.children || node.props && node.props.children);
}

function getChildren(node) {
  return node && node.children ? node.children : node.props && node.props.children;
}

function nodesToString(mem, children, index) {
  if (!children) return '';
  if (Object.prototype.toString.call(children) !== '[object Array]') children = [children];

  children.forEach(function (child, i) {
    // const isElement = React.isValidElement(child);
    // const elementKey = `${index !== 0 ? index + '-' : ''}${i}:${typeof child.type === 'function' ? child.type.name : child.type || 'var'}`;
    var elementKey = '' + i;

    if (typeof child === 'string') {
      mem = '' + mem + child;
    } else if (hasChildren(child)) {
      mem = mem + '<' + elementKey + '>' + nodesToString('', getChildren(child), i + 1) + '</' + elementKey + '>';
    } else if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      mem = mem + '<' + elementKey + '></' + elementKey + '>';
    } else if ((typeof child === 'undefined' ? 'undefined' : _typeof(child)) === 'object') {
      var clone = _extends({}, child);
      var format = clone.format;
      delete clone.format;

      var keys = Object.keys(clone);
      if (format && keys.length === 1) {
        mem = mem + '<' + elementKey + '>{{' + keys[0] + ', ' + format + '}}</' + elementKey + '>';
      } else if (keys.length === 1) {
        mem = mem + '<' + elementKey + '>{{' + keys[0] + '}}</' + elementKey + '>';
      } else if (console && console.warn) {
        // not a valid interpolation object (can only contain one value plus format)
        console.warn('react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.', child);
      }
    } else if (console && console.warn) {
      console.warn('react-i18next: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.', child);
    }
  });

  return mem;
}

function renderNodes(children, targetString, i18n) {
  if (targetString === "") return [];
  if (!children) return [targetString];

  // parse ast from string with additional wrapper tag
  // -> avoids issues in parser removing prepending text nodes
  var ast = __WEBPACK_IMPORTED_MODULE_2_html_parse_stringify2___default.a.parse('<0>' + targetString + '</0>');

  function mapAST(reactNodes, astNodes) {
    if (Object.prototype.toString.call(reactNodes) !== '[object Array]') reactNodes = [reactNodes];
    if (Object.prototype.toString.call(astNodes) !== '[object Array]') astNodes = [astNodes];

    return astNodes.reduce(function (mem, node, i) {
      if (node.type === 'tag') {
        var child = reactNodes[parseInt(node.name, 10)] || {};
        var isElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child);

        if (typeof child === 'string') {
          mem.push(child);
        } else if (hasChildren(child)) {
          var inner = mapAST(getChildren(child), node.children);
          if (child.dummy) child.children = inner; // needed on preact!
          mem.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, _extends({}, child.props, { key: i }), inner));
        } else if ((typeof child === 'undefined' ? 'undefined' : _typeof(child)) === 'object' && !isElement) {
          var interpolated = i18n.services.interpolator.interpolate(node.children[0].content, child, i18n.language);
          mem.push(interpolated);
        } else {
          mem.push(child);
        }
      } else if (node.type === 'text') {
        mem.push(node.content);
      }
      return mem;
    }, []);
  }

  // call mapAST with having react nodes nested into additional node like
  // we did for the string ast from translation
  // return the children of that extra node to get expected result
  var result = mapAST([{ dummy: true, children: children }], ast);
  return getChildren(result[0]);
}

var Trans = function (_React$Component) {
  _inherits(Trans, _React$Component);

  function Trans() {
    _classCallCheck(this, Trans);

    return _possibleConstructorReturn(this, (Trans.__proto__ || Object.getPrototypeOf(Trans)).apply(this, arguments));
  }

  _createClass(Trans, [{
    key: 'render',
    value: function render() {
      var contextAndProps = _extends({ i18n: this.context.i18n, t: this.context.t }, this.props);

      var children = contextAndProps.children,
          count = contextAndProps.count,
          parent = contextAndProps.parent,
          i18nKey = contextAndProps.i18nKey,
          tOptions = contextAndProps.tOptions,
          values = contextAndProps.values,
          defaults = contextAndProps.defaults,
          components = contextAndProps.components,
          namespace = contextAndProps.ns,
          i18n = contextAndProps.i18n,
          tFromContextAndProps = contextAndProps.t,
          additionalProps = _objectWithoutProperties(contextAndProps, ['children', 'count', 'parent', 'i18nKey', 'tOptions', 'values', 'defaults', 'components', 'ns', 'i18n', 't']);

      var t = tFromContextAndProps || i18n.t.bind(i18n);

      var reactI18nextOptions = i18n.options && i18n.options.react || {};
      var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;

      var defaultValue = defaults || nodesToString('', children, 0);
      var hashTransKey = reactI18nextOptions.hashTransKey;
      var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
      var interpolationOverride = values ? {} : { interpolation: { prefix: '#$?', suffix: '?$#' } };
      var translation = key ? t(key, _extends({}, tOptions, values, interpolationOverride, { defaultValue: defaultValue, count: count, ns: namespace })) : defaultValue;

      if (reactI18nextOptions.exposeNamespace) {
        var ns = typeof t.ns === 'string' ? t.ns : t.ns[0];
        if (i18nKey && i18n.options && i18n.options.nsSeparator && i18nKey.indexOf(i18n.options.nsSeparator) > -1) {
          var parts = i18nKey.split(i18n.options.nsSeparator);
          ns = parts[0];
        }
        if (t.ns) additionalProps['data-i18next-options'] = JSON.stringify({ ns: ns });
      }

      if (!useAsParent) return renderNodes(components || children, translation, i18n);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(useAsParent, additionalProps, renderNodes(components || children, translation, i18n));
    }
  }]);

  return Trans;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Trans);


Trans.propTypes = {
  count: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  parent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  i18nKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

// Trans.defaultProps = {
//   parent: 'div'
// };

Trans.contextTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
    parse: __webpack_require__(94),
    stringify: __webpack_require__(97)
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

/*jshint -W030 */
var tagRE = /(?:<!--[\S\s]*?-->|<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>)/g;
var parseTag = __webpack_require__(95);
// re-used obj for quick lookups of components
var empty = Object.create ? Object.create(null) : {};
// common logic for pushing a child node onto a list
function pushTextNode(list, html, level, start, ignoreWhitespace) {
    // calculate correct end of the content slice in case there's
    // no tag after the text node.
    var end = html.indexOf('<', start);
    var content = html.slice(start, end === -1 ? undefined : end);
    // if a node is nothing but whitespace, collapse it as the spec states:
    // https://www.w3.org/TR/html4/struct/text.html#h-9.1
    if (/^\s*$/.test(content)) {
        content = ' ';
    }
    // don't add whitespace-only text nodes if they would be trailing text nodes
    // or if they would be leading whitespace-only text nodes:
    //  * end > -1 indicates this is not a trailing text node
    //  * leading node is when level is -1 and list has length 0
    if ((!ignoreWhitespace && end > -1 && level + list.length >= 0) || content !== ' ') {
        list.push({
            type: 'text',
            content: content
        });
    }
}

module.exports = function parse(html, options) {
    options || (options = {});
    options.components || (options.components = empty);
    var result = [];
    var current;
    var level = -1;
    var arr = [];
    var byTag = {};
    var inComponent = false;

    html.replace(tagRE, function (tag, index) {
        if (inComponent) {
            if (tag !== ('</' + current.name + '>')) {
                return;
            } else {
                inComponent = false;
            }
        }

        var isOpen = tag.charAt(1) !== '/';
        var isComment = tag.indexOf('<!--') === 0;
        var start = index + tag.length;
        var nextChar = html.charAt(start);
        var parent;

        if (isOpen && !isComment) {
            level++;

            current = parseTag(tag);
            if (current.type === 'tag' && options.components[current.name]) {
                current.type = 'component';
                inComponent = true;
            }

            if (!current.voidElement && !inComponent && nextChar && nextChar !== '<') {
                pushTextNode(current.children, html, level, start, options.ignoreWhitespace);
            }

            byTag[current.tagName] = current;

            // if we're at root, push new base node
            if (level === 0) {
                result.push(current);
            }

            parent = arr[level - 1];

            if (parent) {
                parent.children.push(current);
            }

            arr[level] = current;
        }

        if (isComment || !isOpen || current.voidElement) {
            if (!isComment) {
                level--;
            }
            if (!inComponent && nextChar !== '<' && nextChar) {
                // trailing text node
                // if we're at the root, push a base text node. otherwise add as
                // a child to the current node.
                parent = level === -1 ? result : arr[level].children;
                pushTextNode(parent, html, level, start, options.ignoreWhitespace);
            }
        }
    });

    // If the "html" passed isn't actually html, add it as a text node.
    if (!result.length && html.length) {
        pushTextNode(result, html, 0, 0, options.ignoreWhitespace);
    }

    return result;
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var attrRE = /([\w-]+)|=|(['"])([.\s\S]*?)\2/g;
var voidElements = __webpack_require__(96);

module.exports = function (tag) {
    var i = 0;
    var key;
    var expectingValueAfterEquals = true;
    var res = {
        type: 'tag',
        name: '',
        voidElement: false,
        attrs: {},
        children: []
    };

    tag.replace(attrRE, function (match) {
        if (match === '=') {
            expectingValueAfterEquals = true;
            i++;
            return;
        }

        if (!expectingValueAfterEquals) {
            if (key) {
                res.attrs[key] = key; // boolean attribute
            }
            key=match;
        } else {
            if (i === 0) {
                if (voidElements[match] || tag.charAt(tag.length - 2) === '/') {
                    res.voidElement = true;
                }
                res.name = match;
            } else {
                res.attrs[key] = match.replace(/^['"]|['"]$/g, '');
                key=undefined;
            }
        }
        i++;
        expectingValueAfterEquals = false;
    });

    return res;
};


/***/ }),
/* 96 */
/***/ (function(module, exports) {

/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */

module.exports = {
  "area": true,
  "base": true,
  "br": true,
  "col": true,
  "embed": true,
  "hr": true,
  "img": true,
  "input": true,
  "keygen": true,
  "link": true,
  "menuitem": true,
  "meta": true,
  "param": true,
  "source": true,
  "track": true,
  "wbr": true
};


/***/ }),
/* 97 */
/***/ (function(module, exports) {

function attrString(attrs) {
    var buff = [];
    for (var key in attrs) {
        buff.push(key + '="' + attrs[key] + '"');
    }
    if (!buff.length) {
        return '';
    }
    return ' ' + buff.join(' ');
}

function stringify(buff, doc) {
    switch (doc.type) {
    case 'text':
        return buff + doc.content;
    case 'tag':
        buff += '<' + doc.name + (doc.attrs ? attrString(doc.attrs) : '') + (doc.voidElement ? '/>' : '>');
        if (doc.voidElement) {
            return buff;
        }
        return buff + doc.children.reduce(stringify, '') + '</' + doc.name + '>';
    }
}

module.exports = function (doc) {
    return doc.reduce(function (token, rootEl) {
        return token + stringify('', rootEl);
    }, '');
};


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var I18nextProvider = function (_Component) {
  _inherits(I18nextProvider, _Component);

  function I18nextProvider(props, context) {
    _classCallCheck(this, I18nextProvider);

    var _this = _possibleConstructorReturn(this, (I18nextProvider.__proto__ || Object.getPrototypeOf(I18nextProvider)).call(this, props, context));

    _this.i18n = props.i18n;
    if (props.initialI18nStore) {
      _this.i18n.services.resourceStore.data = props.initialI18nStore;
      _this.i18n.options.isInitialSSR = true; // if set will be deleted on first render in translate hoc
    }
    if (props.initialLanguage) {
      _this.i18n.changeLanguage(props.initialLanguage);
    }
    return _this;
  }

  _createClass(I18nextProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { i18n: this.i18n };
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.i18n !== nextProps.i18n) {
        throw new Error('[react-i18next][I18nextProvider]does not support changing the i18n object.');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(children);
    }
  }]);

  return I18nextProvider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

I18nextProvider.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
};

I18nextProvider.childContextTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

/* unused harmony default export */ var _unused_webpack_default_export = (I18nextProvider);

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// shim object entries
if (!Object.entries) Object.entries = function (obj) {
  var ownProps = Object.keys(obj),
      i = ownProps.length,
      resArray = new Array(i); // preallocate the Array
  while (i--) {
    resArray[i] = [ownProps[i], obj[ownProps[i]]];
  }return resArray;
};

// Borrowed from https://github.com/Rezonans/redux-async-connect/blob/master/modules/ReduxAsyncConnect.js#L16
function eachComponents(components, iterator) {
  for (var i = 0, l = components.length; i < l; i++) {
    // eslint-disable-line id-length
    if (_typeof(components[i]) === 'object') {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = Object.entries(components[i])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _slicedToArray(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          iterator(value, i, key);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    } else {
      iterator(components[i], i);
    }
  }
}

function filterAndFlattenComponents(components) {
  var flattened = [];
  eachComponents(components, function (Component) {
    if (Component && Component.namespaces) {

      Component.namespaces.forEach(function (namespace) {
        if (flattened.indexOf(namespace) === -1) {
          flattened.push(namespace);
        }
      });
    }
  });
  return flattened;
}

function loadNamespaces(_ref) {
  var components = _ref.components,
      i18n = _ref.i18n;

  var allNamespaces = filterAndFlattenComponents(components);

  return new Promise(function (resolve) {
    i18n.loadNamespaces(allNamespaces, resolve);
  });
}

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_anchor_link_smooth_scroll__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_anchor_link_smooth_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_anchor_link_smooth_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_logos__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_close_svg__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__img_close_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_menu_black_svg__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_menu_black_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__img_menu_black_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__img_menu_white_svg__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__img_menu_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__img_menu_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LanguagePicker__ = __webpack_require__(109);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  text-transform: uppercase;\n  text-decoration: none;\n  color: #fff;\n  font-size: 22px;\n  font-weight: bold;\n'],['\n  text-transform: uppercase;\n  text-decoration: none;\n  color: #fff;\n  font-size: 22px;\n  font-weight: bold;\n']),_templateObject2=_taggedTemplateLiteral(['\n  font-size: 20px;\n  margin: 0 1.5em;\n  text-decoration: none;\n  color: #fff;\n  font-weight: bold;\n  border-bottom: ',';\n'],['\n  font-size: 20px;\n  margin: 0 1.5em;\n  text-decoration: none;\n  color: #fff;\n  font-weight: bold;\n  border-bottom: ',';\n']),_templateObject3=_taggedTemplateLiteral(['\n  height: 7em;\n  padding: 2em;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 3;\n  box-sizing: border-box;\n  transition: background 0.5s ease-in-out, height 0.5s ease-in-out;\n\n  ',';\n'],['\n  height: 7em;\n  padding: 2em;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 3;\n  box-sizing: border-box;\n  transition: background 0.5s ease-in-out, height 0.5s ease-in-out;\n\n  ',';\n']),_templateObject4=_taggedTemplateLiteral(['\n      background: #fff;\n      box-shadow: rgba(0, 0, 0, 0.0588235) 0px 2px 1px 0px;\n      height: 5em;\n\n      & ',' {\n        color: #000;\n      }\n\n      & ',' {\n        color: #000;\n      }\n    '],['\n      background: #fff;\n      box-shadow: rgba(0, 0, 0, 0.0588235) 0px 2px 1px 0px;\n      height: 5em;\n\n      & ',' {\n        color: #000;\n      }\n\n      & ',' {\n        color: #000;\n      }\n    ']),_templateObject5=_taggedTemplateLiteral(['\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.75s ease-in-out;\n\n  & ',' {\n    display: none;\n  }\n\n  @media (max-width: 800px) {\n    transform: ',';\n    padding: 3em 0;\n    position: absolute;\n    height: 100vh;\n    flex-direction: column;\n    width: 100vw;\n    top: 0;\n    right: 0;\n    background: #fff;\n\n    & ',' {\n      color: #000;\n    }\n\n    & ',' {\n      display: block;\n    }\n  }\n'],['\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.75s ease-in-out;\n\n  & ',' {\n    display: none;\n  }\n\n  @media (max-width: 800px) {\n    transform: ',';\n    padding: 3em 0;\n    position: absolute;\n    height: 100vh;\n    flex-direction: column;\n    width: 100vw;\n    top: 0;\n    right: 0;\n    background: #fff;\n\n    & ',' {\n      color: #000;\n    }\n\n    & ',' {\n      display: block;\n    }\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  flex: 1;\n'],['\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  flex: 1;\n']),_templateObject7=_taggedTemplateLiteral(['\n  height: 2.5em;\n'],['\n  height: 2.5em;\n']),_templateObject8=_taggedTemplateLiteral(['\n  flex: 1;\n'],['\n  flex: 1;\n']),_templateObject9=_taggedTemplateLiteral(['\n  float: right;\n  height: 2em;\n\n  @media (min-width: 800px) {\n    display: none;\n  }\n'],['\n  float: right;\n  height: 2em;\n\n  @media (min-width: 800px) {\n    display: none;\n  }\n']),_templateObject10=_taggedTemplateLiteral(['\n  position: absolute;\n  right: 2em;\n\n  ',';\n\n  ',';\n'],['\n  position: absolute;\n  right: 2em;\n\n  ',';\n\n  ',';\n']),_templateObject11=_taggedTemplateLiteral(['\n      position: static;\n      right: auto;\n    '],['\n      position: static;\n      right: auto;\n    ']),_templateObject12=_taggedTemplateLiteral(['\n      flex-grow: 1;\n    '],['\n      flex-grow: 1;\n    ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable jsx-a11y/anchor-is-valid *//* eslint-disable jsx-a11y/href-no-hash */var HeaderLogoText=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].span(_templateObject);var NavLink=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_3_react_anchor_link_smooth_scroll___default.a)(_templateObject2,function(_ref){var selected=_ref.selected;return selected?'solid 2px #eb8018;':0;});var Header=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].header(_templateObject3,function(props){return props.inverted&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* css */])(_templateObject4,HeaderLogoText,NavLink);});var HeaderMenu=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].nav(_templateObject5,__WEBPACK_IMPORTED_MODULE_8__styles__["e" /* Link */],function(props){return props.show?'translateX(0)':'translateX(100vw)';},NavLink,__WEBPACK_IMPORTED_MODULE_8__styles__["e" /* Link */]);var LogoLink=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_3_react_anchor_link_smooth_scroll___default.a)(_templateObject6);var HeaderLogo=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].img(_templateObject7);var HeaderSide=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].div(_templateObject8);var MenuButton=__WEBPACK_IMPORTED_MODULE_8__styles__["e" /* Link */].extend(_templateObject9);var ChangeLanguage=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].div(_templateObject10,function(props){return props.showMenu&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* css */])(_templateObject11);},function(props){return props.showMenu&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* css */])(_templateObject12);});var HeaderContainer=function(_Component){_inherits(HeaderContainer,_Component);function HeaderContainer(props){_classCallCheck(this,HeaderContainer);var _this=_possibleConstructorReturn(this,(HeaderContainer.__proto__||Object.getPrototypeOf(HeaderContainer)).call(this,props));_this.state={active:'home',userScroll:true,inverted:false,showMenu:false};_this.setActive=_this.setActive.bind(_this);_this.toggleMenu=_this.toggleMenu.bind(_this);_this.container=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(HeaderContainer,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var about=document.getElementById('about');var service=document.getElementById('service');var contact=document.getElementById('contact');document.addEventListener('scroll',function(){if(_this2.state.userScroll){if(window.scrollY<about.offsetTop-300){_this2.setState({active:'home'});}else if(window.scrollY<service.offsetTop-300){_this2.setState({active:'about'});}else if(window.scrollY<contact.offsetTop-600){_this2.setState({active:'service'});}else{_this2.setState({active:'contact'});}}if(_this2.container.current!==null&&window.scrollY>_this2.container.current.clientHeight/2){_this2.setState({inverted:true});}else{_this2.setState({inverted:false});}});}},{key:'setActive',value:function setActive(page){var _this3=this;this.setState({active:page,userScroll:false});this.toggleMenu();setTimeout(function(){return _this3.setState({userScroll:true});},3000);}},{key:'toggleMenu',value:function toggleMenu(){if(window.innerWidth<800){this.setState({showMenu:!this.state.showMenu});}}},{key:'render',value:function render(){var _this4=this;var _state=this.state,active=_state.active,inverted=_state.inverted,showMenu=_state.showMenu;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Header,{innerRef:this.container,inverted:inverted},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderSide,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LogoLink,{onClick:function onClick(){return _this4.setActive('home');},href:'#home'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderLogo,{src:inverted?__WEBPACK_IMPORTED_MODULE_4__img_logos__["a" /* default */].ellaColor:__WEBPACK_IMPORTED_MODULE_4__img_logos__["a" /* default */].ellaMonoWhite,alt:'Ella logo'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderLogoText,null,'Ella'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderMenu,{show:showMenu},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles__["e" /* Link */],{style:{flexGrow:'1'},onClick:this.toggleMenu},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:{height:'3em'},src:__WEBPACK_IMPORTED_MODULE_5__img_close_svg___default.a,alt:'closeIcon'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavLink,{selected:active==='home',onClick:function onClick(){return _this4.setActive('home');},href:'#home'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* Trans */],{i18nKey:'header.navlinks.home'},'Home')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavLink,{selected:active==='about',onClick:function onClick(){return _this4.setActive('about');},href:'#about'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* Trans */],{i18nKey:'header.navlinks.about'},'About')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavLink,{onClick:function onClick(){return _this4.setActive('service');},selected:active==='service',href:'#service'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* Trans */],{i18nKey:'header.navlinks.service'},'Service')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavLink,{selected:active==='contact',onClick:function onClick(){return _this4.setActive('contact');},href:'#contact'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* Trans */],{i18nKey:'header.navlinks.contact'},'Contact')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{flexGrow:'1',height:'3em'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChangeLanguage,{showMenu:showMenu},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__LanguagePicker__["a" /* default */],{inverted:showMenu?true:inverted,showMenu:showMenu}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderSide,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuButton,{onClick:this.toggleMenu},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:inverted?__WEBPACK_IMPORTED_MODULE_6__img_menu_black_svg___default.a:__WEBPACK_IMPORTED_MODULE_7__img_menu_white_svg___default.a,style:{height:'100%'},alt:'menu icon'}))));}}]);return HeaderContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (HeaderContainer);

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["anchor-link"] = factory(require("react"));
	else
		root["anchor-link"] = factory(root["react"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _anchorLink = __webpack_require__(1);

var _anchorLink2 = _interopRequireDefault(_anchorLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _anchorLink2.default;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AnchorLink = function (_Component) {
  _inherits(AnchorLink, _Component);

  function AnchorLink(props) {
    _classCallCheck(this, AnchorLink);

    var _this = _possibleConstructorReturn(this, (AnchorLink.__proto__ || Object.getPrototypeOf(AnchorLink)).call(this, props));

    _this.smoothScroll = _this.smoothScroll.bind(_this);
    return _this;
  }

  _createClass(AnchorLink, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      __webpack_require__(3).polyfill();
    }
  }, {
    key: 'smoothScroll',
    value: function smoothScroll(e) {
      var _this2 = this;

      e.preventDefault();
      var offset = function offset() {
        return 0;
      };
      if (typeof this.props.offset !== 'undefined') {
        if (!!(this.props.offset && this.props.offset.constructor && this.props.offset.apply)) {
          offset = this.props.offset;
        } else {
          offset = function offset() {
            return parseInt(_this2.props.offset);
          };
        }
      }
      var id = e.currentTarget.getAttribute('href').slice(1);
      window.scroll({
        top: document.getElementById(id).offsetTop - offset(),
        behavior: 'smooth'
      });
      if (this.props.onClick) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'a',
        _extends({}, this.props, { onClick: this.smoothScroll }),
        this.props.children
      );
    }
  }]);

  return AnchorLink;
}(_react.Component);

exports.default = AnchorLink;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/* smoothscroll v0.4.0 - 2017 - Dustan Kasten, Jeremias Menichelli - MIT License */
(function () {
  'use strict';

  /*
   * aliases
   * w: window global object
   * d: document
   */
  var w = window;
  var d = document;

  /**
   * indicates if a the current browser is made by Microsoft
   * @method isMicrosoftBrowser
   * @param {String} userAgent
   * @returns {Boolean}
   */
  function isMicrosoftBrowser(userAgent) {
    var userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/'];

    return new RegExp(userAgentPatterns.join('|')).test(userAgent);
  }

   // polyfill
  function polyfill() {
    // return if scroll behavior is supported and polyfill is not forced
    if ('scrollBehavior' in d.documentElement.style
      && w.__forceSmoothScrollPolyfill__ !== true) {
      return;
    }

    // globals
    var Element = w.HTMLElement || w.Element;
    var SCROLL_TIME = 468;

    /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */
    var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;

    // object gathering original scroll methods
    var original = {
      scroll: w.scroll || w.scrollTo,
      scrollBy: w.scrollBy,
      elementScroll: Element.prototype.scroll || scrollElement,
      scrollIntoView: Element.prototype.scrollIntoView
    };

    // define timing method
    var now = w.performance && w.performance.now
      ? w.performance.now.bind(w.performance)
      : Date.now;

    /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function scrollElement(x, y) {
      this.scrollLeft = x;
      this.scrollTop = y;
    }

    /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */
    function ease(k) {
      return 0.5 * (1 - Math.cos(Math.PI * k));
    }

    /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */
    function shouldBailOut(firstArg) {
      if (firstArg === null
        || typeof firstArg !== 'object'
        || firstArg.behavior === undefined
        || firstArg.behavior === 'auto'
        || firstArg.behavior === 'instant') {
        // first argument is not an object/null
        // or behavior is auto, instant or undefined
        return true;
      }

      if (typeof firstArg === 'object' && firstArg.behavior === 'smooth') {
        // first argument is an object and behavior is smooth
        return false;
      }

      // throw error when behavior is not supported
      throw new TypeError(
        'behavior member of ScrollOptions '
        + firstArg.behavior
        + ' is not a valid value for enumeration ScrollBehavior.'
      );
    }

    /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function hasScrollableSpace(el, axis) {
      if (axis === 'Y') {
        return (el.clientHeight + ROUNDING_TOLERANCE) < el.scrollHeight;
      }

      if (axis === 'X') {
        return (el.clientWidth + ROUNDING_TOLERANCE) < el.scrollWidth;
      }
    }

    /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function canOverflow(el, axis) {
      var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];

      return overflowValue === 'auto' || overflowValue === 'scroll';
    }

    /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function isScrollable(el) {
      var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
      var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');

      return isScrollableY || isScrollableX;
    }

    /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */
    function findScrollableParent(el) {
      var isBody;

      do {
        el = el.parentNode;

        isBody = el === d.body;
      } while (isBody === false && isScrollable(el) === false);

      isBody = null;

      return el;
    }

    /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */
    function step(context) {
      var time = now();
      var value;
      var currentX;
      var currentY;
      var elapsed = (time - context.startTime) / SCROLL_TIME;

      // avoid elapsed times higher than one
      elapsed = elapsed > 1 ? 1 : elapsed;

      // apply easing to elapsed time
      value = ease(elapsed);

      currentX = context.startX + (context.x - context.startX) * value;
      currentY = context.startY + (context.y - context.startY) * value;

      context.method.call(context.scrollable, currentX, currentY);

      // scroll more if we have not reached our destination
      if (currentX !== context.x || currentY !== context.y) {
        w.requestAnimationFrame(step.bind(w, context));
      }
    }

    /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function smoothScroll(el, x, y) {
      var scrollable;
      var startX;
      var startY;
      var method;
      var startTime = now();

      // define scroll context
      if (el === d.body) {
        scrollable = w;
        startX = w.scrollX || w.pageXOffset;
        startY = w.scrollY || w.pageYOffset;
        method = original.scroll;
      } else {
        scrollable = el;
        startX = el.scrollLeft;
        startY = el.scrollTop;
        method = scrollElement;
      }

      // scroll looping over a frame
      step({
        scrollable: scrollable,
        method: method,
        startTime: startTime,
        startX: startX,
        startY: startY,
        x: x,
        y: y
      });
    }

    // ORIGINAL METHODS OVERRIDES
    // w.scroll and w.scrollTo
    w.scroll = w.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scroll.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object'
              ? arguments[0]
              : (w.scrollX || w.pageXOffset),
          // use top prop, second argument if present or fallback to scrollY
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined
              ? arguments[1]
              : (w.scrollY || w.pageYOffset)
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        arguments[0].left !== undefined
          ? ~~arguments[0].left
          : (w.scrollX || w.pageXOffset),
        arguments[0].top !== undefined
          ? ~~arguments[0].top
          : (w.scrollY || w.pageYOffset)
      );
    };

    // w.scrollBy
    w.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0])) {
        original.scrollBy.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object'
              ? arguments[0]
              : 0,
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined
             ? arguments[1]
             : 0
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        ~~arguments[0].left + (w.scrollX || w.pageXOffset),
        ~~arguments[0].top + (w.scrollY || w.pageYOffset)
      );
    };

    // Element.prototype.scroll and Element.prototype.scrollTo
    Element.prototype.scroll = Element.prototype.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        // if one number is passed, throw error to match Firefox implementation
        if (typeof arguments[0] === 'number' && arguments[1] === undefined) {
          throw new SyntaxError('Value couldn\'t be converted');
        }

        original.elementScroll.call(
          this,
          // use left prop, first number argument or fallback to scrollLeft
          arguments[0].left !== undefined
            ? ~~arguments[0].left
            : typeof arguments[0] !== 'object'
              ? ~~arguments[0]
              : this.scrollLeft,
          // use top prop, second argument or fallback to scrollTop
          arguments[0].top !== undefined
            ? ~~arguments[0].top
            : arguments[1] !== undefined
              ? ~~arguments[1]
              : this.scrollTop
        );

        return;
      }

      var left = arguments[0].left;
      var top = arguments[0].top;

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        this,
        this,
        typeof left === 'undefined' ? this.scrollLeft : ~~left,
        typeof top === 'undefined' ? this.scrollTop : ~~top
      );
    };

    // Element.prototype.scrollBy
    Element.prototype.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.elementScroll.call(
          this,
          arguments[0].left !== undefined
            ? ~~arguments[0].left + this.scrollLeft
            : ~~arguments[0] + this.scrollLeft,
          arguments[0].top !== undefined
            ? ~~arguments[0].top + this.scrollTop
            : ~~arguments[1] + this.scrollTop
        );

        return;
      }

      this.scroll({
        left: ~~arguments[0].left + this.scrollLeft,
        top: ~~arguments[0].top + this.scrollTop,
        behavior: arguments[0].behavior
      });
    };

    // Element.prototype.scrollIntoView
    Element.prototype.scrollIntoView = function() {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scrollIntoView.call(
          this,
          arguments[0] === undefined
            ? true
            : arguments[0]
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      var scrollableParent = findScrollableParent(this);
      var parentRects = scrollableParent.getBoundingClientRect();
      var clientRects = this.getBoundingClientRect();

      if (scrollableParent !== d.body) {
        // reveal element inside parent
        smoothScroll.call(
          this,
          scrollableParent,
          scrollableParent.scrollLeft + clientRects.left - parentRects.left,
          scrollableParent.scrollTop + clientRects.top - parentRects.top
        );

        // reveal parent in viewport unless is fixed
        if (w.getComputedStyle(scrollableParent).position !== 'fixed') {
          w.scrollBy({
            left: parentRects.left,
            top: parentRects.top,
            behavior: 'smooth'
          });
        }
      } else {
        // reveal element in viewport
        w.scrollBy({
          left: clientRects.left,
          top: clientRects.top,
          behavior: 'smooth'
        });
      }
    };
  }

  if (true) {
    // commonjs
    module.exports = { polyfill: polyfill };
  } else {
    // global
    polyfill();
  }

}());


/***/ })
/******/ ]);
});

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ella-color.4750be01.svg";

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ella-mono-black.a82413e0.svg";

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ella-mono-white.497cb338.svg";

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/facebook.f3c92504.svg";

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/twitter.7c65ec17.svg";

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/menu-black.94935d9d.svg";

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/menu-white.811ea06e.svg";

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  position: absolute;\n  opacity: ',';\n  transition: all 0.5s ease-in-out;\n  padding: 0.5em 0.5em;\n  background: #0a6b94;\n  border-radius: 5px;\n  margin-top: 15px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  pointer-events: ',';\n  margin-left: -0.75em;\n  box-sizing: border-box;\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);\n\n  &:after {\n    bottom: 100%;\n    left: 50%;\n    border: solid transparent;\n    content: \' \';\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n    border-bottom-color: #0a6b94;\n    border-width: 0.5em;\n    margin-left: -0.5em;\n    transition: all 0.5s ease-in-out;\n  }\n\n  & ',' {\n    margin: 0.5em 0.5em;\n  }\n\n  ',';\n\n  ',';\n'],['\n  position: absolute;\n  opacity: ',';\n  transition: all 0.5s ease-in-out;\n  padding: 0.5em 0.5em;\n  background: #0a6b94;\n  border-radius: 5px;\n  margin-top: 15px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  pointer-events: ',';\n  margin-left: -0.75em;\n  box-sizing: border-box;\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);\n\n  &:after {\n    bottom: 100%;\n    left: 50%;\n    border: solid transparent;\n    content: \' \';\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n    border-bottom-color: #0a6b94;\n    border-width: 0.5em;\n    margin-left: -0.5em;\n    transition: all 0.5s ease-in-out;\n  }\n\n  & ',' {\n    margin: 0.5em 0.5em;\n  }\n\n  ',';\n\n  ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n      background: #eb8018;\n\n      &:after {\n        border-bottom-color: #eb8018;\n      }\n    '],['\n      background: #eb8018;\n\n      &:after {\n        border-bottom-color: #eb8018;\n      }\n    ']),_templateObject3=_taggedTemplateLiteral(['\n      margin-top: -16.5em;\n\n      &:after {\n        top: 100%;\n      }\n\n      &:after {\n        border-bottom: 0;\n        border-top-color: #eb8018;\n      }\n    '],['\n      margin-top: -16.5em;\n\n      &:after {\n        top: 100%;\n      }\n\n      &:after {\n        border-bottom: 0;\n        border-top-color: #eb8018;\n      }\n    ']),_templateObject4=_taggedTemplateLiteral(['\n  ',';\n'],['\n  ',';\n']),_templateObject5=_taggedTemplateLiteral(['\n      color: #000;\n      border-color: #eb8018;\n    '],['\n      color: #000;\n      border-color: #eb8018;\n    ']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Popup=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].div(_templateObject,function(props){return props.show?1:0;},function(props){return props.show?'auto':'none';},__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* Button */],function(props){return props.inverted&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* css */])(_templateObject2);},function(props){return props.showMenu&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* css */])(_templateObject3);});var LanguageButton=__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* Button */].extend(_templateObject4,function(props){return props.inverted&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* css */])(_templateObject5);});var languages=['en-us','nl'];var LanguagePicker=function(_Component){_inherits(LanguagePicker,_Component);function LanguagePicker(props){_classCallCheck(this,LanguagePicker);var _this=_possibleConstructorReturn(this,(LanguagePicker.__proto__||Object.getPrototypeOf(LanguagePicker)).call(this,props));_this.state={showPopup:false};_this.popup=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.selectLanguage=_this.selectLanguage.bind(_this);_this.handleClickOutside=_this.handleClickOutside.bind(_this);_this.setPopup=_this.setPopup.bind(_this);return _this;}_createClass(LanguagePicker,[{key:'componentDidMount',value:function componentDidMount(){document.addEventListener('mousedown',this.handleClickOutside);}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('mousedown',this.handleClickOutside);}},{key:'setPopup',value:function setPopup(ref){this.popup=ref;}},{key:'handleClickOutside',value:function handleClickOutside(event){if(this.popup&&!this.popup.contains(event.target)){this.setState({showPopup:false});}}},{key:'selectLanguage',value:function selectLanguage(i18n,language){i18n.changeLanguage(language);this.setState({showPopup:false});}},{key:'renderLanguages',value:function renderLanguages(i18n){var _this2=this;return languages.map(function(language){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* Button */],{key:language,border:true,onClick:function onClick(){return _this2.selectLanguage(i18n,language);}},language.indexOf('-')>-1?language.substring(0,language.indexOf('-')):language);});}},{key:'render',value:function render(){var _this3=this;var showPopup=this.state.showPopup;var _props=this.props,inverted=_props.inverted,showMenu=_props.showMenu;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["a" /* I18n */],null,function(t,_ref){var i18n=_ref.i18n;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:_this3.setPopup},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LanguageButton,{inverted:inverted,border:true,onClick:function onClick(){return _this3.setState({showPopup:!showPopup});}},i18n.languages[0].indexOf('-')>-1?i18n.languages[0].substring(0,i18n.languages[0].indexOf('-')):i18n.languages[0]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Popup,{inverted:inverted,show:showPopup,showMenu:showMenu},_this3.renderLanguages(i18n)));});}}]);return LanguagePicker;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LanguagePicker);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_phone_svg__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_phone_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__img_phone_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_bars_svg__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_bars_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__img_bars_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vid_luis_mov__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vid_luis_mov___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__vid_luis_mov__);
var _templateObject=_taggedTemplateLiteral(['\n  padding-top: 7em;\n  background: -moz-radial-gradient(\n    50% 50%,\n    circle farthest-corner,\n    rgba(110, 187, 220, 1) 0%,\n    rgba(13, 142, 197, 1) 100%\n  );\n  background: -webkit-radial-gradient(\n      50% 50%,\n      circle farthest-corner,\n      rgba(110, 187, 220, 1) 0%,\n      rgba(13, 142, 197, 1) 100%\n    ),\n    url(',');\n  background: url(','),\n    -webkit-gradient(radial, 50% 50%, 0, 50% 50%, 562.99, color-stop(0, rgba(110, 187, 220, 1)), color-stop(1, rgba(13, 142, 197, 1)));\n  background: -o-radial-gradient(\n    50% 50%,\n    circle farthest-corner,\n    rgba(110, 187, 220, 1) 0%,\n    rgba(13, 142, 197, 1) 100%\n  );\n  background-repeat: repeat-y;\n  background-size: 100% 30% auto auto;\n  background-position: left center center center;\n  background: -ms-radial-gradient(\n    50% 50%,\n    circle farthest-corner,\n    rgba(110, 187, 220, 1) 0%,\n    rgba(13, 142, 197, 1) 100%\n  );\n  background: radial-gradient(\n    50% 50%,\n    circle farthest-corner,\n    rgba(110, 187, 220, 1) 0%,\n    rgba(13, 142, 197, 1) 100%\n  );\n  filter: progid:DXImageTransform.Microsoft.Alpha(Stlye=2);\n'],['\n  padding-top: 7em;\n  background: -moz-radial-gradient(\n    50% 50%,\n    circle farthest-corner,\n    rgba(110, 187, 220, 1) 0%,\n    rgba(13, 142, 197, 1) 100%\n  );\n  background: -webkit-radial-gradient(\n      50% 50%,\n      circle farthest-corner,\n      rgba(110, 187, 220, 1) 0%,\n      rgba(13, 142, 197, 1) 100%\n    ),\n    url(',');\n  background: url(','),\n    -webkit-gradient(radial, 50% 50%, 0, 50% 50%, 562.99, color-stop(0, rgba(110, 187, 220, 1)), color-stop(1, rgba(13, 142, 197, 1)));\n  background: -o-radial-gradient(\n    50% 50%,\n    circle farthest-corner,\n    rgba(110, 187, 220, 1) 0%,\n    rgba(13, 142, 197, 1) 100%\n  );\n  background-repeat: repeat-y;\n  background-size: 100% 30% auto auto;\n  background-position: left center center center;\n  background: -ms-radial-gradient(\n    50% 50%,\n    circle farthest-corner,\n    rgba(110, 187, 220, 1) 0%,\n    rgba(13, 142, 197, 1) 100%\n  );\n  background: radial-gradient(\n    50% 50%,\n    circle farthest-corner,\n    rgba(110, 187, 220, 1) 0%,\n    rgba(13, 142, 197, 1) 100%\n  );\n  filter: progid:DXImageTransform.Microsoft.Alpha(Stlye=2);\n']),_templateObject2=_taggedTemplateLiteral(['\n  height: 100%;\n  width: ',';\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n'],['\n  height: 100%;\n  width: ',';\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n']),_templateObject3=_taggedTemplateLiteral(['\n  background: url(',');\n  height: 30em;\n  width: 15em;\n  background-position: center;\n  background-repeat: no-repeat;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n'],['\n  background: url(',');\n  height: 30em;\n  width: 15em;\n  background-position: center;\n  background-repeat: no-repeat;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n']),_templateObject4=_taggedTemplateLiteral(['\n  height: 61.1%;\n  width: 69.5%;\n  margin-right: 4%;\n  margin-bottom: 3.7%;\n'],['\n  height: 61.1%;\n  width: 69.5%;\n  margin-right: 4%;\n  margin-bottom: 3.7%;\n']),_templateObject5=_taggedTemplateLiteral(['\n  max-width: 60em;\n  margin: 0 auto;\n  padding: 2em;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-between;\n  height: 100%;\n  width: 100%;\n  align-items: center;\n\n  @media (max-width: 600px) {\n    flex-direction: column;\n\n    & ',':nth-of-type(1) {\n      margin-bottom: 2em;\n    }\n  }\n'],['\n  max-width: 60em;\n  margin: 0 auto;\n  padding: 2em;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-between;\n  height: 100%;\n  width: 100%;\n  align-items: center;\n\n  @media (max-width: 600px) {\n    flex-direction: column;\n\n    & ',':nth-of-type(1) {\n      margin-bottom: 2em;\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_3_styled_components__["b" /* default */].div(_templateObject,__WEBPACK_IMPORTED_MODULE_6__img_bars_svg___default.a,__WEBPACK_IMPORTED_MODULE_6__img_bars_svg___default.a);var Item=__WEBPACK_IMPORTED_MODULE_3_styled_components__["b" /* default */].div(_templateObject2,function(props){return props.width+'%';});var BackgroundPhone=Item.extend(_templateObject3,__WEBPACK_IMPORTED_MODULE_5__img_phone_svg___default.a);var Video=__WEBPACK_IMPORTED_MODULE_3_styled_components__["b" /* default */].video(_templateObject4);var InnerContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["b" /* default */].div(_templateObject5,Item);var Intro=function Intro(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InnerContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{width:60},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["h" /* Title */],{color:'#fff',dropshadow:true,noUnderline:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* Trans */],{i18nKey:'intro.title'},'A new way to store and access knowledge')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["f" /* Paragraph */],{color:'#fff',dropshadow:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* Trans */],{i18nKey:'intro.text'},'Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda dolor atque eveniet et, iure odio ratione distinctio quidem tempora. Ipsum perspiciatis veritatis nihil rem animi, quidem officiis deserunt vero ipsa.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:""+'/demo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* Button */],{border:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* Trans */],{i18nKey:'intro.try'},'Try demo bot')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BackgroundPhone,{width:30},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Video,{src:__WEBPACK_IMPORTED_MODULE_7__vid_luis_mov___default.a,autoPlay:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["i" /* Triangle */],{left:true,color:'#71c0db'}));};/* harmony default export */ __webpack_exports__["a"] = (Intro);

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/phone.dc59e61b.svg";

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bars.e762e735.svg";

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/luis.ca0629ee.mov";

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Graphics_BeforeEllaGraphic__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Graphics_AfterEllaGraphic__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  z-index: 2;\n'],['\n  z-index: 2;\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: 100%;\n  display: flex;\n  justify-content: space-evenly;\n  height: 20em;\n  margin-top: 1.25em;\n\n  @media (max-width: 550px) {\n    height: 15em;\n  }\n\n  @media (max-width: 420px) {\n    flex-direction: column;\n    height: auto;\n    align-items: center;\n\n    & svg:nth-of-type(1) {\n      margin-bottom: 2em;\n    }\n  }\n'],['\n  width: 100%;\n  display: flex;\n  justify-content: space-evenly;\n  height: 20em;\n  margin-top: 1.25em;\n\n  @media (max-width: 550px) {\n    height: 15em;\n  }\n\n  @media (max-width: 420px) {\n    flex-direction: column;\n    height: auto;\n    align-items: center;\n\n    & svg:nth-of-type(1) {\n      margin-bottom: 2em;\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var TitleForward=__WEBPACK_IMPORTED_MODULE_5__styles__["h" /* Title */].extend(_templateObject);var ImageContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].div(_templateObject2);function MakingKAccessible(_ref){var id=_ref.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["b" /* Container */],{small:true,id:id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["d" /* Intro */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TitleForward,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* Trans */],{i18nKey:'makingKAccessible.title'},'Making knowledge accessible')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["f" /* Paragraph */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* Trans */],{i18nKey:'makingKAccessible.text'},'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Qui ea maxime, quisquam officia architecto accusamus! Dolores, iusto vero! Natus accusantium quam commodi maxime incidunt perferendis perspiciatis consequuntur qui at odio?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ImageContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Graphics_BeforeEllaGraphic__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Graphics_AfterEllaGraphic__["a" /* default */],null))));}/* harmony default export */ __webpack_exports__["a"] = (MakingKAccessible);

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n  width: 50%;\n\n  & {\n    .cls-1 {\n      fill: #fde2d1;\n    }\n\n    .cls-2 {\n      fill: #3d1c09;\n    }\n\n    .cls-3 {\n      fill: #f2f2f2;\n    }\n\n    .cls-4 {\n      fill: #0d8ec5;\n    }\n\n    .cls-5 {\n      fill: #2e1507;\n    }\n\n    .cls-6 {\n      fill: #b3b3b3;\n    }\n\n    .cls-7 {\n      fill: #a8a8a8;\n    }\n\n    .cls-8 {\n      fill: #e6e6e6;\n    }\n\n    .cls-9 {\n      fill: #cecece;\n    }\n\n    .cls-10,\n    .cls-20,\n    .cls-21 {\n      stroke-miterlimit: 10;\n    }\n\n    .cls-10,\n    .cls-20,\n    .cls-21 {\n      fill: none;\n    }\n\n    .cls-20,\n    .cls-21 {\n      stroke: #fff;\n    }\n\n    .cls-20 {\n      stroke-width: 2px;\n    }\n\n    .cls-21 {\n      stroke-width: 1.5px;\n    }\n\n    .cls-10 {\n      stroke: #ccc;\n    }\n  }\n'],['\n  width: 50%;\n\n  & {\n    .cls-1 {\n      fill: #fde2d1;\n    }\n\n    .cls-2 {\n      fill: #3d1c09;\n    }\n\n    .cls-3 {\n      fill: #f2f2f2;\n    }\n\n    .cls-4 {\n      fill: #0d8ec5;\n    }\n\n    .cls-5 {\n      fill: #2e1507;\n    }\n\n    .cls-6 {\n      fill: #b3b3b3;\n    }\n\n    .cls-7 {\n      fill: #a8a8a8;\n    }\n\n    .cls-8 {\n      fill: #e6e6e6;\n    }\n\n    .cls-9 {\n      fill: #cecece;\n    }\n\n    .cls-10,\n    .cls-20,\n    .cls-21 {\n      stroke-miterlimit: 10;\n    }\n\n    .cls-10,\n    .cls-20,\n    .cls-21 {\n      fill: none;\n    }\n\n    .cls-20,\n    .cls-21 {\n      stroke: #fff;\n    }\n\n    .cls-20 {\n      stroke-width: 2px;\n    }\n\n    .cls-21 {\n      stroke-width: 1.5px;\n    }\n\n    .cls-10 {\n      stroke: #ccc;\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n'],['\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(-360deg);\n  }\n'],['\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(-360deg);\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  0% {\n    transform: translateY(8px);\n  }\n  50% {\n    transform: translateY(4px);\n  }\n  100% {\n    transform: translateY(8px);\n  }\n'],['\n  0% {\n    transform: translateY(8px);\n  }\n  50% {\n    transform: translateY(4px);\n  }\n  100% {\n    transform: translateY(8px);\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  0% {\n    transform: translateX(0);\n  }\n  25% {\n    transform: translateX(20px);\n  }\n  75% {\n    transform: translateX(20px);\n  }\n  100% {\n    transform: translateX(0);\n  }\n'],['\n  0% {\n    transform: translateX(0);\n  }\n  25% {\n    transform: translateX(20px);\n  }\n  75% {\n    transform: translateX(20px);\n  }\n  100% {\n    transform: translateX(0);\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  transform-origin: center center;\n  transform-box: fill-box;\n'],['\n  transform-origin: center center;\n  transform-box: fill-box;\n']),_templateObject7=_taggedTemplateLiteral(['\n  animation: ',' 4s linear infinite;\n'],['\n  animation: ',' 4s linear infinite;\n']),_templateObject8=_taggedTemplateLiteral(['\n  animation: ',' 1.5s ease-in-out infinite;\n'],['\n  animation: ',' 1.5s ease-in-out infinite;\n']),_templateObject9=_taggedTemplateLiteral(['\n  animation: ',' 2s ease-in-out infinite;\n'],['\n  animation: ',' 2s ease-in-out infinite;\n']),_templateObject10=_taggedTemplateLiteral(['\n  animation: ',' 10s ease-out infinite;\n'],['\n  animation: ',' 10s ease-out infinite;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Svg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].svg(_templateObject);var spin=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* keyframes */])(_templateObject2);var spinReverse=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* keyframes */])(_templateObject3);var hang=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* keyframes */])(_templateObject4);var forwardBack=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* keyframes */])(_templateObject5);var Gear=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].path(_templateObject6);var GearForward=Gear.extend(_templateObject7,spin);var GearBack=Gear.extend(_templateObject7,spinReverse);var Pdf=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].g(_templateObject8,hang);var Doc=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].g(_templateObject9,hang);var PlayerCircle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].circle(_templateObject10,forwardBack);var BeforeEllaGraphic=function BeforeEllaGraphic(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Svg,{xmlns:'http://www.w3.org/2000/svg',viewBox:'0 0 199.2 344.28'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'Before Ella'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Layer_2','data-name':'Layer 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Layer_1-2','data-name':'Layer 1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Person'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-1',d:'M82.75,188c-5,13-3,27.47,4,39.42,4.61,7.8,11.23,15.53,19.33,15.53s15-8,19.77-15.87a45.44,45.44,0,0,0,5.41-32.49c-2.72-13.26-9.26-29.07-24.93-26.5C93.16,170.23,86.26,178.8,82.75,188Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-2',d:'M80.84,211.8s-1.12-12.93,1.71-20a6.74,6.74,0,0,1,6.29-4.1H97.7a16.69,16.69,0,0,0,5.63-1l16.71-6a81.62,81.62,0,0,0,7.44,11.52c4.36,5.54,4.77,18,4.77,18s1-16.8,3.39-19.68l-3.39-9.84V176l-4.77-1.68-2.4-4.08-6.48-7.2-.72,2.4s-14.88-10.32-30.47,1S80.84,211.8,80.84,211.8Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-1',d:'M129.67,219l1.61-16.36s4.47-3.07,3.75,4.84S129.67,219,129.67,219Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-1',d:'M82.82,219l-2.15-16.36s-4.47-3.07-3.75,4.84A16.15,16.15,0,0,0,82.82,219Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-3',d:'M100,206.7c-3.48-4.56-9.72,0-9.72,0s5.64,5.24,9.92.28Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-4',d:'M93.23,205.18a2.09,2.09,0,0,0,2.21,2,3,3,0,0,0,2.77-2A6.1,6.1,0,0,0,93.23,205.18Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-3',d:'M122,207.39c-3.48-4.56-9.72,0-9.72,0s5.64,5.24,9.92.28Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-4',d:'M115.21,205.87a2.09,2.09,0,0,0,2.21,2,3,3,0,0,0,2.77-2A6.1,6.1,0,0,0,115.21,205.87Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{className:'cls-5',points:'112.8 202.22 111.84 205 125.67 205.36 127.87 207.22 126.03 202.86 112.8 202.22'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-5',d:'M85.64,206.66l2-2,13.76-3a23.92,23.92,0,0,0-1.52-2.56c-.12,0-13,2.95-13,2.95Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{className:'cls-6',x:'36.24',y:'213.03',width:'140',height:'87.33',rx:'14.76',ry:'14.76'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-7',d:'M176.24,285.61a14.76,14.76,0,0,1-14.76,14.76H51a14.76,14.76,0,0,1-14.76-14.76v-6.78c0,8.15,6.61,17.46,14.76,17.46H161.48c8.15,0,14.76-9.31,14.76-17.46Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-8',d:'M84.45,315.94h43.33l-5.66-50.33a10.89,10.89,0,0,0-10.82-9.67H100.94a10.89,10.89,0,0,0-10.82,9.67Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-9',d:'M100.94,255.94a10.89,10.89,0,0,0-10.82,9.67l-5.66,50.33h2.36l5.66-50.33a10.89,10.89,0,0,1,10.82-9.67Z'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'text-big'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'123.05 51.23 123.05 76.84 131.86 76.84 127.28 86.17 140.17 76.84 171.1 76.84 171.1 51.23 123.05 51.23'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{className:'cls-20',x1:'128.6',y1:'57.53',x2:'165.55',y2:'57.53'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{className:'cls-20',x1:'128.6',y1:'63.12',x2:'165.55',y2:'63.12'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{className:'cls-20',x1:'128.6',y1:'68.7',x2:'165.55',y2:'68.7'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'text-small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'187.32 26.16 187.32 44.63 180.96 44.63 184.27 51.36 174.97 44.63 152.66 44.63 152.66 26.16 187.32 26.16'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{className:'cls-21',x1:'183.32',y1:'30.7',x2:'156.66',y2:'30.7'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{className:'cls-21',x1:'183.32',y1:'34.73',x2:'156.66',y2:'34.73'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{className:'cls-21',x1:'183.32',y1:'38.76',x2:'156.66',y2:'38.76'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'graph'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'3.34',y:'177.41',width:'11.5',height:'27.5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'19.28',y:'166.56',width:'11.5',height:'38.34'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'35.22',y:'154.5',width:'11.5',height:'50.41'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GearForward,{id:'gear-big',d:'M199.18,154.12c-.41,1.18-.9,2.34-1.2,3.55a2.1,2.1,0,0,1-2.66,1.77l-.89-.12c-4.09-.61-6.68,2.51-5.39,6.47.89,2.75.85,2.84-1.69,4.22l-.48.25c-3.26,1.77-3.26,1.77-5.51-1.15a4.82,4.82,0,0,0-7.75.75,5.74,5.74,0,0,1-.93,1.74,6.16,6.16,0,0,1-2.05,1c-.24.08-.57-.12-.86-.21-5.1-1.54-4.85-.85-4.24-6a3.2,3.2,0,0,0-.79-2,5.18,5.18,0,0,0-1.94-1.59,6.93,6.93,0,0,0-2.77-.48,6.6,6.6,0,0,0-2,.67,1.86,1.86,0,0,1-2.68-1c-.13-.27-.28-.53-.42-.8-2.35-4.28-2.34-3.86,1.28-6.63,1.92-1.47,1.44-5.89-.72-7-3.81-1.91-3.82-1.6-2.47-5.84,1-3,.93-3,4-2.59a4.68,4.68,0,0,0,5.31-6.31c-1-2.94-.95-3,1.81-4.46l1.13-.58c2.36-1.24,2.52-1.21,4.15.92,1.9,2.48,3.22,3,6.19,1.91a3.94,3.94,0,0,0,1.76-1.87c1.77-3.33,1.73-3.35,5.39-2.24l.17.06c3.15,1,3.17,1,2.7,4.31a4.66,4.66,0,0,0,6.08,5.11c3.31-1.09,3.31-1.09,4.94,2,.25.48.47,1,.75,1.44a2,2,0,0,1-.62,3.09c-.3.2-.58.44-.86.66a5.42,5.42,0,0,0-1.52,6.5c.35.66,1.25,1,1.93,1.5.92.64,1.87,1.25,2.81,1.88Zm-33.38-4.43a9.83,9.83,0,1,0,9.4-10.35A9.88,9.88,0,0,0,165.8,149.69Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GearForward,{id:'gear-small',d:'M116.5,136.91c.24-1.07.4-2,2-2,1.18,0,1.87-1.6,1.15-2.74s-.25-1.6.5-2.26a1.45,1.45,0,0,1,2.2,0,1.87,1.87,0,0,0,3.09-1c.27-.86.54-1.4,1.59-1.23s1.82.24,1.85,1.63c0,1.16,1.62,2.19,2.46,1.59,1.91-1.36,2.5.08,3.4,1.36-.39.56-1,1.09-1.14,1.72-.19,1.09,0,2.28,1.41,2.5s1.22,1.07,1.21,2-.46,1.31-1.43,1.42a2,2,0,0,0-1.49,3.13c.53,1,.16,1.41-.51,1.95s-1.21,1-2.16.26c-1.38-1.14-2.77-.73-3.25,1a1.32,1.32,0,0,1-1.92,1,2.4,2.4,0,0,1-1.45-1.35c-.47-1.67-1.5-2.21-3.16-1.57a1.79,1.79,0,0,1-1.61-.26c-.44-.49-.92-1.45-.72-1.93,1.16-2.82,1.14-3-1.91-4.09Zm9.65-3.47a4,4,0,1,0,4.24,3.77A4,4,0,0,0,126.16,133.43Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GearBack,{id:'gear-mid',d:'M146.74,110.89c1.42-.39,2.14.31,2.45,1.86a2.64,2.64,0,0,0,4.34,1.61c1.33-1.2,2.19-.83,3.38.19s1.39,1.83.46,3.17a2.71,2.71,0,0,0,2.2,4.25c1.36.1,2,.61,1.94,2s.54,2.58-1.55,3c-2.54.46-3.31,2.8-1.66,4.8,1.23,1.5.08,2.22-.67,3.19s-1.5,1.29-2.71.47c-2.14-1.46-4.36-.36-4.54,2.24-.12,1.72-1.21,1.65-2.37,1.74s-2.19.13-2.5-1.53c-.47-2.57-2.73-3.39-4.72-1.73-1.47,1.21-2.22.15-3.22-.63a1.77,1.77,0,0,1-.44-2.76c1.41-2.16.38-4.21-2.25-4.5-1.35-.15-1.71-.88-1.67-2.06s-.6-2.37,1.28-2.82c2.88-.7,3.51-2.61,1.67-4.93-1-1.3-.12-2,.58-2.75s1.26-1.73,2.66-.88c2.59,1.56,4.33.71,4.81-2.32C144.44,110.87,145.49,111,146.74,110.89Zm-5.21,14.63a5.84,5.84,0,1,0,5.36-6.32A5.92,5.92,0,0,0,141.53,125.52Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'player'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M62.81,113.92H61.12l-.61-.07A14.49,14.49,0,0,1,47.75,102c-.1-.55-.15-1.11-.23-1.67s0-1.13,0-1.69c0-.36.08-.72.13-1.08A14.48,14.48,0,0,1,63.41,85.12a13.78,13.78,0,0,1,8,3.49,14.14,14.14,0,0,1,4.94,10.24,13.74,13.74,0,0,1-2,8,14.23,14.23,0,0,1-9.91,6.84C63.91,113.8,63.36,113.84,62.81,113.92ZM74.15,99.48A12.18,12.18,0,1,0,62,111.66,12.2,12.2,0,0,0,74.15,99.48Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M57.9,99.48q0-2.57,0-5.13c0-.1,0-.21,0-.31A.7.7,0,0,1,59,93.4c.8.42,1.57.89,2.35,1.34l6.71,3.92a2.2,2.2,0,0,1,.51.4.59.59,0,0,1,0,.84,2,2,0,0,1-.46.37l-8.83,5.16c-.87.5-1.37.21-1.37-.79Q57.9,102.06,57.9,99.48Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PlayerCircle,{cx:'48.84',cy:'122.14',r:'3.51'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'40.37',y:'120.3',width:'43.2',height:'3.68',rx:'1.84',ry:'1.84'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Doc,{id:'doc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M22.85,40.43V34.74H4.39A4.39,4.39,0,0,0,0,39.14V74.6A4.39,4.39,0,0,0,4.39,79H34.62A4.39,4.39,0,0,0,39,74.6V50.91H33.33A10.51,10.51,0,0,1,22.85,40.43ZM34.72,70.84a4.08,4.08,0,0,1-4.08,4.08H8.37a4.08,4.08,0,0,1-4.08-4.08V53.67H34.72Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M34.85,34.74H25v4.92a9.09,9.09,0,0,0,9.06,9.06H39V38.91A4.16,4.16,0,0,0,34.85,34.74Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-3',d:'M4.29,70.84a4.08,4.08,0,0,0,4.08,4.08H30.64a4.08,4.08,0,0,0,4.08-4.08V53.67H4.29Z'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-3',d:'M4.57,44.69a12,12,0,0,1,1.83-.12,3.84,3.84,0,0,1,2.45.64,2.64,2.64,0,0,1,1,2.25,3,3,0,0,1-1,2.42,4.29,4.29,0,0,1-2.76.77,11.69,11.69,0,0,1-1.53-.09Zm1.36,4.88a2.51,2.51,0,0,0,.47,0,1.85,1.85,0,0,0,2-2.09,1.71,1.71,0,0,0-1.88-1.9,2.8,2.8,0,0,0-.61.05Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-3',d:'M16.21,47.53a2.85,2.85,0,0,1-2.93,3.15,2.79,2.79,0,0,1-2.81-3,2.89,2.89,0,0,1,2.91-3.13A2.78,2.78,0,0,1,16.21,47.53Zm-4.32.08c0,1.17.55,2,1.45,2s1.44-.87,1.44-2-.51-2-1.45-2S11.89,46.45,11.89,47.61Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-3',d:'M21.48,50.41a3.85,3.85,0,0,1-1.53.26,2.84,2.84,0,0,1-3.13-3,3,3,0,0,1,3.26-3.17,3.52,3.52,0,0,1,1.47.27l-.27,1.07a2.92,2.92,0,0,0-1.13-.22,2,2,0,0,0,0,3.93,3.37,3.37,0,0,0,1.13-.2Z'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{className:'cls-10',x1:'8.15',y1:'56.87',x2:'31',y2:'56.87'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{className:'cls-10',x1:'8.15',y1:'61.24',x2:'31',y2:'61.24'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Pdf,{id:'pdf'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M72,6.51V0H50.91a5,5,0,0,0-5,5V45.64a5,5,0,0,0,5,5H85.52a5,5,0,0,0,5-5V18.51H84A12,12,0,0,1,72,6.51ZM85.63,41.33A4.67,4.67,0,0,1,81,46H55.47a4.67,4.67,0,0,1-4.67-4.67V21.67H85.63Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M85.78,0H74.54V5.63A10.41,10.41,0,0,0,84.92,16h5.63V4.77A4.77,4.77,0,0,0,85.78,0Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-3',d:'M50.8,41.33A4.67,4.67,0,0,0,55.47,46H81a4.67,4.67,0,0,0,4.67-4.67V21.67H50.8Z'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{className:'cls-10',x1:'55.21',y1:'25.33',x2:'81.38',y2:'25.33'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{className:'cls-10',x1:'55.21',y1:'30.33',x2:'81.38',y2:'30.33'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{className:'cls-10',x1:'55.21',y1:'35.33',x2:'81.38',y2:'35.33'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-3',d:'M50.8,11.14A13.7,13.7,0,0,1,53.06,11a3.56,3.56,0,0,1,2.27.59,2.17,2.17,0,0,1,.79,1.72,2.37,2.37,0,0,1-.68,1.76,3.44,3.44,0,0,1-2.41.78,4.24,4.24,0,0,1-.57,0v2.65H50.8Zm1.66,3.37a2.56,2.56,0,0,0,.56,0c.89,0,1.44-.45,1.44-1.21s-.47-1.09-1.31-1.09a2.88,2.88,0,0,0-.69.07Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-3',d:'M57.19,11.14A14.92,14.92,0,0,1,59.46,11a4.77,4.77,0,0,1,3,.79,3.28,3.28,0,0,1,1.25,2.8,3.76,3.76,0,0,1-1.23,3,5.33,5.33,0,0,1-3.42,1,14.51,14.51,0,0,1-1.9-.11Zm1.68,6.05a3.12,3.12,0,0,0,.58,0A2.3,2.3,0,0,0,62,14.63a2.13,2.13,0,0,0-2.33-2.36,3.48,3.48,0,0,0-.76.07Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-3',d:'M64.85,11h4.53v1.38H66.53v1.69H69.2v1.36H66.53v3H64.85Z'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ellipse',{id:'base',className:'cls-3',cx:'106.24',cy:'338.61',rx:'92.96',ry:'5.66'})))));};/* harmony default export */ __webpack_exports__["a"] = (BeforeEllaGraphic);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n  width: 50%;\n\n  & {\n    .cls-1 {\n      fill: #f2f2f2;\n    }\n\n    .cls-2 {\n      fill: #fde2d1;\n    }\n\n    .cls-3 {\n      fill: #3d1c09;\n    }\n\n    .cls-4 {\n      fill: #2e1507;\n    }\n\n    .cls-5 {\n      fill: #0d8ec5;\n    }\n\n    .cls-6 {\n      fill: #f39322;\n    }\n\n    .cls-7 {\n      fill: #dd8024;\n    }\n\n    .cls-8 {\n      fill: #e6e6e6;\n    }\n\n    .cls-9 {\n      fill: #cecece;\n    }\n\n    .cls-14,\n    .cls-15 {\n      stroke: #363f44;\n    }\n\n    .cls-14,\n    .cls-15,\n    .cls-17 {\n      stroke-miterlimit: 10;\n    }\n\n    .cls-16 {\n      fill: #fff;\n    }\n\n    .cls-20 {\n      fill: #f1921c;\n    }\n\n    .cls-21 {\n      fill: #e52a2c;\n    }\n\n    .cls-10,\n    .cls-15 {\n      fill: #258ec6;\n    }\n\n    .cls-11 {\n      fill: #bb2e2d;\n    }\n\n    .cls-12 {\n      fill: #19739f;\n    }\n\n    .cls-13 {\n      fill: #e76421;\n    }\n\n    .cls-14,\n    .cls-17 {\n      fill: none;\n    }\n\n    .cls-17 {\n      stroke: #f5a94e;\n    }\n\n    .cls-18 {\n      fill: #fcf615;\n    }\n\n    .cls-19 {\n      fill: #363f44;\n    }\n  }\n'],['\n  width: 50%;\n\n  & {\n    .cls-1 {\n      fill: #f2f2f2;\n    }\n\n    .cls-2 {\n      fill: #fde2d1;\n    }\n\n    .cls-3 {\n      fill: #3d1c09;\n    }\n\n    .cls-4 {\n      fill: #2e1507;\n    }\n\n    .cls-5 {\n      fill: #0d8ec5;\n    }\n\n    .cls-6 {\n      fill: #f39322;\n    }\n\n    .cls-7 {\n      fill: #dd8024;\n    }\n\n    .cls-8 {\n      fill: #e6e6e6;\n    }\n\n    .cls-9 {\n      fill: #cecece;\n    }\n\n    .cls-14,\n    .cls-15 {\n      stroke: #363f44;\n    }\n\n    .cls-14,\n    .cls-15,\n    .cls-17 {\n      stroke-miterlimit: 10;\n    }\n\n    .cls-16 {\n      fill: #fff;\n    }\n\n    .cls-20 {\n      fill: #f1921c;\n    }\n\n    .cls-21 {\n      fill: #e52a2c;\n    }\n\n    .cls-10,\n    .cls-15 {\n      fill: #258ec6;\n    }\n\n    .cls-11 {\n      fill: #bb2e2d;\n    }\n\n    .cls-12 {\n      fill: #19739f;\n    }\n\n    .cls-13 {\n      fill: #e76421;\n    }\n\n    .cls-14,\n    .cls-17 {\n      fill: none;\n    }\n\n    .cls-17 {\n      stroke: #f5a94e;\n    }\n\n    .cls-18 {\n      fill: #fcf615;\n    }\n\n    .cls-19 {\n      fill: #363f44;\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  0% {opacity:1}\n  3% {opacity:0}\n  6% {opacity:0}\n  7% {opacity:1}\n  10% {opacity:0}\n  16% {opacity:1}\n  25% {opacity:1}\n  99% {opacity:1}\n  100% {opacity:0}\n'],['\n  0% {opacity:1}\n  3% {opacity:0}\n  6% {opacity:0}\n  7% {opacity:1}\n  10% {opacity:0}\n  16% {opacity:1}\n  25% {opacity:1}\n  99% {opacity:1}\n  100% {opacity:0}\n']),_templateObject3=_taggedTemplateLiteral(['\n  fill: #f7df1e;\n  animation: ',' 2s infinite;\n'],['\n  fill: #f7df1e;\n  animation: ',' 2s infinite;\n']),_templateObject4=_taggedTemplateLiteral(['\n  animation: ',' 2s infinite;\n'],['\n  animation: ',' 2s infinite;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Svg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].svg(_templateObject);var Flicker=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* keyframes */])(_templateObject2);var LightBulb=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].path(_templateObject3,Flicker);var Stripes=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].g(_templateObject4,Flicker);var AfterEllaGraphic=function AfterEllaGraphic(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Svg,{xmlns:'http://www.w3.org/2000/svg',viewBox:'0 0 214.09 344.34'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'After Ella'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Layer_2','data-name':'Layer 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Layer_1-2','data-name':'Layer 1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'person'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-2',d:'M81.72,188.69c-5,13-3,27.47,4,39.42,4.61,7.8,11.23,15.53,19.33,15.53s15-8,19.77-15.87a45.44,45.44,0,0,0,5.41-32.49c-2.72-13.26-9.26-29.07-24.93-26.5C92.12,170.93,85.22,179.51,81.72,188.69Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-3',d:'M79.8,212.51s-1.12-12.93,1.71-20a6.74,6.74,0,0,1,6.29-4.1h8.86a16.69,16.69,0,0,0,5.63-1l16.71-6A81.62,81.62,0,0,0,126.44,193c4.36,5.54,4.77,18,4.77,18s1-16.8,3.39-19.68l-3.39-9.84v-4.8L126.44,175l-2.4-4.08-6.48-7.2-.72,2.4s-14.88-10.32-30.47,1S79.8,212.51,79.8,212.51Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-2',d:'M128.64,219.7l1.61-16.36s4.47-3.07,3.75,4.84S128.64,219.7,128.64,219.7Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-2',d:'M81.78,219.7l-2.15-16.36s-4.47-3.07-3.75,4.84A16.15,16.15,0,0,0,81.78,219.7Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{className:'cls-4',points:'100.24 201.17 100.24 198.65 86.85 198.65 84.67 202.43 87.5 201 100.24 201.17'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-1',d:'M90.63,206.78s2.14-2.37,4.87-2.23a4.65,4.65,0,0,1,3.92,2.23,6,6,0,0,1-4.39,2A6.58,6.58,0,0,1,90.63,206.78Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{className:'cls-4',points:'110.18 201.17 110.18 198.65 123.57 198.65 125.75 202.43 122.92 201 110.18 201.17'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-1',d:'M119.79,206.78s-2.14-2.37-4.87-2.23a4.65,4.65,0,0,0-3.92,2.23,6,6,0,0,0,4.39,2A6.58,6.58,0,0,0,119.79,206.78Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{className:'cls-5',cx:'95.02',cy:'206.68',r:'2.17'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{className:'cls-5',cx:'115.4',cy:'206.68',r:'2.17'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{className:'cls-6',x:'35.08',y:'213.46',width:'140',height:'87.33',rx:'14.76',ry:'14.76'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-7',d:'M175.08,286a14.76,14.76,0,0,1-14.76,14.76H49.84A14.76,14.76,0,0,1,35.08,286v-6.78c0,8.15,6.61,17.46,14.76,17.46H160.32c8.15,0,14.76-9.31,14.76-17.46Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-8',d:'M83.29,316.37h43.33L121,266a10.89,10.89,0,0,0-10.82-9.67H99.78A10.89,10.89,0,0,0,89,266Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-9',d:'M99.78,256.37A10.89,10.89,0,0,0,89,266l-5.66,50.33h2.36L91.32,266a10.89,10.89,0,0,1,10.82-9.67Z'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Ella-icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-20',d:'M115.54,111.91l-3.68,1.54-6.28,2.6c-.84.35-1.72.62-2.53,1.06a5.65,5.65,0,0,1-1.72.81L91,122.16c-.35.15-.74.18-1.09.33-.39-.52-.23-1.15-.28-1.72-.09-1-.2-2-.26-3s-.19-2-.3-3a.72.72,0,0,1,.43-.85c2.81-1.49,5.59-3,8.38-4.55.42-.23.85-.43,1.28-.65a15.09,15.09,0,0,1,2.41.38l12.52,2.3,1.17.24A.33.33,0,0,1,115.54,111.91Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-21',d:'M97.12,104c-.18-.77-.37-1.54-.54-2.31Q96,99,95.48,96.35c-.15-.74-.29-1.49-.45-2.28.69.09,1.34-.13,2-.1,1.78.07,3.56-.09,5.34-.13,1.1,0,2.21,0,3.31-.09s2.28,0,3.41-.11,2,0,3-.1c1.17-.13,2.35,0,3.52-.11.88-.09,1.74,0,2.64-.09-.06.25-.26.25-.4.32l-12,6a.74.74,0,0,0-.11.09c-.1.21-.31.26-.5.36l-7.4,3.7C97.62,104,97.4,104.13,97.12,104Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-10',d:'M115.54,111.91l-.2-.13a32.46,32.46,0,0,1-3.91-1.54l-7.81-3.3a1,1,0,0,1-.56-.35l-2.31-1c0-.28.25-.26.41-.31,2.64-.84,5.29-1.65,7.94-2.45a5.18,5.18,0,0,1,1.45-.39l2.38,4.25q1.35,2.42,2.68,4.86C115.66,111.62,115.95,111.84,115.54,111.91Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-21',d:'M107.52,118.15l3.27.68c2.05.43,4.1.84,6.15,1.28s4.29.95,6.43,1.41a11.71,11.71,0,0,1,2.2.56H125c-4.36.14-8.73,0-13.09.13-3.53.1-7.06,0-10.59.1-.95,0-1.89.09-2.84.07.1-.3.36-.22.56-.21a2.6,2.6,0,0,0,1.29-.32c2.3-1.13,4.55-2.37,6.86-3.49A1,1,0,0,0,107.52,118.15Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-11',d:'M107.52,118.15c.12.21-.08.23-.18.28L100,122.17a1.57,1.57,0,0,1-.65.13c-.29,0-.59-.1-.86.08l-6.85,0a7.9,7.9,0,0,0-1.69.09c1-.52,2.12-.9,3.18-1.34l8.6-3.54c.44-.18.9-.34,1.35-.51C104.52,117.53,106,117.84,107.52,118.15Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-12',d:'M110.55,102.4a16.75,16.75,0,0,1-2.68.91c-1.67.55-3.35,1-5,1.55a18.67,18.67,0,0,0-2.09.69c-1.21-.51-2.46-.95-3.62-1.57a.87.87,0,0,0,.53-.17l7.86-3.92.24-.09c.9.47,1.8.93,2.69,1.42C109.15,101.59,109.85,102,110.55,102.4Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-13',d:'M103.06,106.58l4.87,2,5.75,2.45,1.66.72-3.25-.57-7.16-1.3-5.53-1a.27.27,0,0,1-.22-.12l3-1.65A4.6,4.6,0,0,0,103.06,106.58Z'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{className:'cls-14',x1:'107.33',y1:'84.02',x2:'107.33',y2:'60.11'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{className:'cls-14',x1:'107.33',y1:'154.71',x2:'107.33',y2:'130.8'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{className:'cls-14',x1:'130.71',y1:'107.41',x2:'154.63',y2:'107.41'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{className:'cls-14',x1:'60.03',y1:'107.41',x2:'83.94',y2:'107.41'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Chat'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Question'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{className:'cls-14',points:'89.55 19.08 89.55 31.87 93.95 31.87 91.66 36.53 98.1 31.87 113.55 31.87 113.55 19.08 89.55 19.08'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-10',d:'M99,29.9a24.5,24.5,0,0,1-2.8-1,1.61,1.61,0,0,0-.49-.11,3.31,3.31,0,0,1-3.1-3.6,3.44,3.44,0,0,1,3.46-3.73A3.31,3.31,0,0,1,99.43,25a3.32,3.32,0,0,1-1.68,3.17v0c.55.16,1.16.28,1.72.4Zm-1.26-4.79c0-1.29-.61-2.37-1.71-2.37s-1.73,1.07-1.73,2.4.64,2.38,1.72,2.38S97.73,26.5,97.73,25.11Z'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Answer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{className:'cls-15',points:'125.57 14.15 125.57 26.74 121.24 26.74 123.49 31.32 117.16 26.74 101.95 26.74 101.95 14.15 125.57 14.15'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-16',d:'M112.55,22.39,112,24.47h-1.89l2.47-8.08h2.4l2.5,8.08h-2l-.62-2.07Zm2-1.37-.5-1.71c-.14-.48-.29-1.08-.41-1.56h0c-.12.48-.24,1.09-.37,1.56L112.81,21Z'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ellipse',{className:'cls-1',cx:'105.2',cy:'338.68',rx:'92.96',ry:'5.66'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('image',{id:'KF-icon',width:'400',height:'661',transform:'translate(179.2 88.32) scale(0.06)',xlinkHref:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZIAAAKXCAYAAACop8zUAAAACXBIWXMAAL/GAAC/xgGoSx2hAAAgAElEQVR4Xu3cza1svXad4RuAYnAAbikeJ+B0DIfgYJyKAHUdwCeUDzbOX+16q9YaJOck38bTEcbdxUVqjokjW/rXP//88y9Jkq7CQNp/+1//9x/KSJL6wEDaY5G4TCRpHxhI+1okLhNJ2gMG0lwkkrQXDKT9ukhcJpLUHwbSXCSStBcMpP25SFwmktQbBtJcJJK0FwykPVskLhNJ6gsDaS4SSdoLBtK+WyQuE0la5z/+/b//80C5ZzCQ9mqRuEwkab47S+QBA2kuEkmq42uJbLVIXCaSNEdiiTxgII2WiItEksb7dYlsuUhcJpI0TnKJPGAgjRaIi0SSxvhzgWy/SFwmkpQzaok8YCCNlofLRJKyvlsiLhJJEhq9RB4wkEaLw2UiSRkzlsgDBtJoabhIJOm+V0vkyEXiMpGk981cIg8YSKOF4SKRpGtogRy/SFwmkvQ9Wh6jlsgDBtJoWRD6+5J0GloeLhIXiSR9ixbH6CXygIE0WhTvoN+QpBPQ4nCRuEgk6Vu0NGYtkQcMpNGSeBf9jiTtipbGzCXygIE0WhDvot+RpN3QwnCRXEC/JUm7oGWxaok8YCCNlsMn6LckaQe0LFwkN9HvSVJntChWL5EHDKTRYriCflOSOqJFQejvp2AgjZbCFfSbktQNLQlCfz8JA2m0FK6i35WkLmhJvIN+IwkDabQQrqLflaTqaDm8i34nDQNptBDuoN+WpKpoObyLfmcEDKTRMriDfluSKqLl8An6rREwkEbL4C76fUmqhBbDJ+i3RsFAGi2CBDqDJFVAi+FT9HujYCCNlkACnUGSVqOl8Cn6vZEwkEZLIIXOIUmr0FK4gn5zJAyk0QJIoXNI0my0DK6i3x0NA2m0AJLoLJI0Cy2DO+i3R8NAGpV/Ep1FkmagRXAH/fYMGEij8k+j80jSSLQI7qDfngUDaVT8I9CZJGkEWgR30e/PgoE0Kv0R6EySlEZL4C76/ZkwkEalPwqdS5JSaAkk0BlmwkAaFf4odC5JuovKP4XOMRsG0qjwR6KzSdJVVP5JdJbZMJBGZT8SnU2SrqDiT6KzrICBNCr70eh8kvQJKv40Os8KGEijop+BzihJ76DST6PzrIKBNCr5GeiMkkSo9NPoPCthII1KfhY6pyR9h0p/BDrTShhIo4Kfhc4pSX+ish+FzrUaBtKo4Geis0rSFyr7kehsq2Egjcp9JjqrJD1Q0Y9EZ6sAA2lU7rPReSWdjYp+NDpfBRhIo2Kfjc4r6VxU8qPR+arAQBoV+wp0ZknnoZKfgc5YBQbSqNRXoXNLOgcV/Ax0xkowkEaFvgqdW9L+qNxnoXNWg4E0KvSV6OyS9kXlPhOdtRoMpFGZr0Rnl7QnKvaZ6KwVYSCNynw1Or+kvVCxz0bnrQgDaVTkq9H5Je2DSn02Om9VGEijIq+AvkFSf1TqK9CZq8JAGpV4FfQdkvqiQl+BzlwZBtKowKug75DUD5X5SnT2yjCQRgVeCX2LpD6oyFeis1eHgTQq70roWyT1QEW+Ep29AwykUXlXQ98jqTYq8tXo/B1gII2Kuxr6Hkl1UYmvRufvAgNpVNwV0TdJqodKvAL6hi4wkEalXRV9l6Q6qMAroG/oBANpVNhV0XdJWo/KuxL6lk4wkEaFXRl9m6R1qLgroW/pBgNpVNaV0bdJWoOKuxr6nm4wkEZlXR19n6S5qLSroe/pCANpVNTV0fdJmodKuxr6nq4wkEZF3QF9o6TxqLQrom/qCgNpVNId0DdKGofKuir6rs4wkEYl3QV9p6Q8KuvK6Ns6w0AaFXQn9K2ScqioK6Nv6w4DaVTOndC3Ssqgoq6Ovq87DKRROXdD3yvpHirp6uj7doCBNCrmbuh7JV1HJd0BfeMOMJBGxdwRfbOkz1FBd0DfuAsMpFEpd0TfLOl9VM5d0HfuBANpVMpd0XdLYlTOndC37gQDaVTIndG3S/oeFXMn9K27wUAalXFn9O2SnqNi7oa+dzcYSKMy7o6+X9LvqJS7oe/dEQbSqIi7o++X9BOVckf0zTvCQBoV8Q7oDiS5RHaCgTQq4R3QHUgnozLujL59VxhIoxLeBd2DdCIq4s7o23eGgTQq4J3QXUgnoSLujL59dxhIo/LdCd2FdAoq4u7o+3eHgTQq393QfUi7oxLujr7/BBhIo+LdDd2HtDMq4R3QHZwAA2lUvDuiO5F2RAW8A7qDU2AgjUp3R3Qn0k6ofHdCd3EKDKRR6e6K7kXaARXvTuguToKBNCrcXdG9SN1R8e6G7uMkGEijwt0Z3Y3UFZXubug+ToOBNCrb3dH9SN1Q6e6G7uNEGEijot0d3Y/UCZXujuhOToSBNCraE9AdSR1Q4e6I7uRUGEijkj0B3ZFUGZXtzuhuToWBNCrZU9A9SRVR0e6M7uZkGEijgj0F3ZNUDRXt7uh+ToaBNCrYk9BdSVVQye6O7ud0GEijcj0N3Ze0GpXsCeiOToeBNCrW09B9SStRwZ6A7kgukhLozqQVqGBPQHekHzCQRqV6IrozaSYq15PQXekHDKRRqZ6K7k2agYr1JHRX+gkDaVSop6J7k0ajYj0N3Zd+wkAaFerJ6O6kUahUT0P3pd9hII3K9HR0f1IaleqJ6M70OwykUZGeju5PSqJCPRHdmf6GgTQqUrlMNAcV6qno3vQ3DKRRicpForGoSE9Gd6fnMJBGJaof6B6lK6hIT0Z3p+9hII0KVD/QPUqfoiI9Hd2fvoeBNCpQ/UR3Kb2LSvR0dH96DQNpVJ76ie5SegeVqFwkd2EgjcpTv6P7lF6hApVLJAEDaVSc+hvdqfQMFah+oHsUw0Aalab+Rncq/YqKUz/RXeo9GEij0tRzdK/SAxWnfkf3qfdgII0KU8/RvUpUmvod3afeh4E0Kkx9j+5W56LS1O/oPvUZDKRRWep7dLc6E5Wm/kZ3qs9gII3KUq/R/eosVJj6G92pPoeBNCpKMbpjnYEKU8/RvepzGEijkhSjO9beqCj1PbpbXYOBNCpJvYfuWXuiotRrdL+6BgNpVJB6D92z9kMlqdfofnUdBtKoIPU+umvtg0pSjO5Y12EgjcpR76O71h6oIMXojnUPBtKoHPUZum/1RgUpRnes+zCQRsWoz9GdqycqSL2H7ln3YSCNSlGfoztXL1SMeh/dtTIwkEalqGvo3tUDFaM+Q/etDAykUSHqGrp31UelqM/QfSsHA2lUiLqO7l51USnqc3TnysFAGpWhrqO7V01UiPoc3bmyMJBGZah76P5VCxWirqF7VxYG0qgIdQ/dv+qgMtQ1dO/Kw0AaFaHuozfQWlSEuo7uXmNgII1KUBn0DlqDilD30P1rDAykUQEqg95B81EJ6h66f42DgTQqQOXQW2geKkHdR2+gcTCQRuWnHHoLzUEFqPvoDTQWBtKo/JRF76GxqACVQe+gsTCQRsWnLHoPjUPlpwx6B42HgTQqPuXRmyiLik9Z9B4aDwNpVHoag95FGVR6yqL30BwYSKPC0xj0LrqPSk9Z9B6aBwNpVHgah95G11HpKY/eRPNgII3KTuPQ2+gaKjzl0ZtoLgykUdlpLHoffYYKT2PQu2guDKRR0Wkseh+9h4pO49DbaD4MpFHRaTx6I71GRaex6H00HwbSqOQ0B72TnqOS01j0PloDA2lUcJqD3kl/o5LTePRGWgMDaVRwmofeSj9RwWk8eiOtg4E0KjfNQ2+lH6jgNB69kdbCQBqVm+ai9zodFZzmoHfSWhhIo2LTXPRep6Ji0zz0VloPA2lUbJqP3uw0VGyai95L62EgjUpN89GbnYRKTXPRe6kGDKRRqWkNercTUKlpPnoz1YCBNCo0rUNvtzMqNM1Hb6Y6MJBGZaZ16O12RYWmNejdVAcG0qjMtBa9326ozLQGvZtqwUAaFZnWovfbBRWZ1qG3Uz0YSKMi03r0ht1RkWktej/Vg4E0KjGtR2/YGZWY1qL3U00YSKMSUw30jh1RiWk9ekPVhIE0KjDVQW/ZCRWY1qM3VF0YSKPyUh30ll1QgakGekfVhYE0Ki/VQu9ZHZWXaqB3VG0YSKPiUi30nlVRcakWek/VhoE0Ki7VQ29aDZWWaqH3VH0YSKPSUj30ppVQaakWek/1gIE0Ki3VRO9aAZWW6qE3VQ8YSKPCUl30titRYakeelP1gYE0KivVRW+7ChWWaqJ3VR8YSKOyUm30vrNRWakmelf1goE0KirVRu87CxWVaqP3VS8YSKOiUn30xqNRSak2el/1g4E0KinVR288EpWU6qM3Vj8YSKOSUg/0ziNQQak+emP1hIE0Kij1QO+cRgWl+uiN1RcG0qig1Ae9dQoVlHqgd1ZfGEijclIv9N53UTmpB3pn9YaBNCom9ULvfRUVk3qh91ZvGEijYlI/9OafolJSL/Te6g8DaVRK6ofe/BNUSuqH3lz9YSCNSkk90bu/gwpJ/dCbaw8YSKNCUk/07oQKST3Ru2sPGEijQlJf9PbfoTJST/Tu2gcG0qiM1Bu9/5+ojNQTvbv2goE0KiL1Ru//hYpIvdH7ay8YSKMiUn/03wNUQuqN3l/7wUAalZD6e/X+VELqjzpA+8FAGpWQ9vDs7amA1B/Nv/aEgTQqIO3hz3enAtIeaP61JwykUQFpH19vTuWjPdDsa18YSKPy0V6ofLQPmn3tCwNpVDzaA5WO9kJzr71hII0KSP1R6WgvNPPaHwbSqITUG5WO9kMzr/1hII2KSH1R4Wg/NO86AwbSqIzUExWO9kTzrjNgII0KSf1Q2WhPNOs6BwbSqJTUC5WN9kWzrnNgII2KST1QyWhvNOc6CwbSqKBUH5WM9kdzrrNgII1KSrVRwWh/NOM6DwbSqKhUFxWM9kfzrTNhII3KSjVRwegMNN86EwbSqLBUD5WLzkCzrXNhII1KS7VQuegcNNs6FwbSqLhUA5WKzkJzrbNhII0KTOtRqeg8NNc6GwbSqMS0FhWKzkMzLWEgjYpM61Ch6Ew00xIG0qjMtAaVic5E8yw9YCCNCk3zUZnoTDTL0hcMpFGpaS4qE52LZln6goE0KjbNQSWis9EcS7/CQBoVnMajEpFojqVfYSCNSk5jUYFINMPSnzCQRkWncahApAeaYelPGEijstMYVB7SA82v9AwG0qjwlEflIX2h+ZWewUAalZ5yqDSkX9HsSt/BQBqVnzKoNKRf0dxKr2AgjQpQ91FpSH+iuZVewUAalaDuocKQ/kQzKxEMpFER6joqDOkZmlmJYCCNylDXUFlIz9C8Su/AQBoVoj5HZSF9h+ZVegcG0qgU9T4qCekVmlXpXRhIo3LUe6gkJEKzKr0LA2lUkGJUEBKhOZU+gYE0Kkm9RgUhEZpR6VMYSKOi1PeoIKR30IxKn8JAGpWlnqNykN5B8yldgYE0Kkz9jcpBehfNp3QFBtKoNPUTlYL0CZpN6SoMpFF56gcqBelTNJvSVRhIowKVS0R5NJfSHRhIoxI9HRWCdAXNpXQHBtKoSE9GZSBdQTMp3YWBNCrTU1EZSFfQPEoJGEijQj0RlYF0Fc2jlICBNCrVk1AJSHfQLEopGEijcj0FlYB0F82ilIKBNCrYE1ABSHfRHEpJGEijkt0dFYCUQHMoJWEgjYp2ZzT8UgLNoJSGgTQq213R8EspNINSGgbSqHB3RIMvpdD8SSNgII1Kdyc09FISzZ40CgbSqHx3QUMvpdHsSaNgII0KeAc08FIazZ00EgbSqIS7o4GXRqC5k0bCQBoVcWc07NIINHPSaBhIozLuioZdGoVmThoNA2lUyB3RoEuj0LxJM2AgjUq5ExpyaTSaN2kGDKRROXdBAy6NRrMmzYKBNCroDmjApdFozqSZMJBGJV0dDbg0A82ZNBMG0qioK6PhlmagGZNmw0AalXVVNNzSLDRj0mwYSKPCrogGW5qF5ktaAQNpVNqV0FBLs9F8SStgII3KuwoaaGk2mi1pFQykUYFXQAMtrUCzJa2CgTQq8dVomKUVaK6klTCQRkW+Eg2ztALNlLQaBtKozFehYZZWoZmSVsNAGhX6CjTI0io0T1IFGEijUp+JhlhajeZJqgADaVTus9AAS6vRLElVYCCNCn4GGmCpApolqQoMpFHJj0bDK1VAcyRVgoE0KvqRaHilKmiOpEowkEZlPwoNrlQFzZBUDQbSqPBHoMGVqqD5kSrCQBqVfhINrVQNzY9UEQbSqPxTaGClamh2pKowkEYLIIEGVqqIZkeqCgNptATuomGVKqK5kSrDQBotgjtoWKWqaG6kyjCQRsvgKhpUqSqaGak6DKTRQriCBlWqjGZGqg4DabQUPkEDKlVH8yJ1gIE0Wg7vogGVqqNZkbrAQBotiHfQgEod0KxIXWAgjZYEoeGUOqA5kTrBQBotCpeITkBzInWCgTRaFi4R7Y5mROoGA2m0MFwi2h3NiNQNBtJoabhAtDOaD6kjDKTR8nCJaGc0H1JHGEijBeIS0a5oNqSuMJDmEtGJaC6kzjCQ5hLRiWgupM4wkOYS0WloJqTuMJDmEtFpaCak7jCQ5gLRSWgepB1gIM0lopPQPEg7wECaS0SnoFmQdoGBtP/3v//1z3/+j3+TtuYi0UkwkPZYJC4TnYBmQdoFBtIe/6Otr2XiUtHuaB6kHWAg7bFI/vU//8//9+dCcaloNzQP0g4wkPb1/2vr1TJxsWgnNBNSdxhI+/V/j+TdZeJSUWc0E1J3GEh7tkg+WSYuFXVEcyF1hoG0P//Po9xZJi4VdUFzIXWGgbRXi+TOMnGxqDqaDakrDKQ9+z/aOGKZuFRUDc2G1BUG0p4tkmfLJL1QXCqqgOZD6ggDaZ8skhHLxKWi1WhGpG4wkPbdIlmxTFwsWoFmROoGA2lXFsmsZeJS0Sw0J1InGEh7tUgqLROXikaiOZE6wUAaLZKKy8SlohFoVqQuMJBGS4QWyepl8isqCukVmhWpCwyk0RJ5d5lUWigPVBrSMzQvUgcYSKMF8skiqbZMvlB5SF9oXqQOMJBGC2SXZfKFikSimZGqw0AaLY8dl8mvqFR0JpobqTIMpNHiuLpIOi2TL1QuOgfNjVQZBtJocZy2TL5Q0Wh/NDtSVRhIo6Vxd5F0XiZfqHC0J5odqSoMpNHSSC2THRbKFyog7YPmR6oIA2m0MFwmr1ERqTeaH6kiDKTRskgvkh2XyRcqJfVEMyRVg4E0WhaElsZpy+QLlZP6oBmSqsFAGi0KQgvj5GXyKyor1UZzJFWCgTRaFO+gheEy+R2Vlup5vBvNklQFBtJoSbyLFobL5DkqMNVBsyRVgYE0WhDvomXxDird3VGRaT2aJ6kCDKTRgvgELYp3UNmehEpN89E8SRVgII2WwydoSbyLCvZEVHCah2ZKWg0DabQcPkVL4l1UrCejotNYNFPSahhIo8VwBS2Jd1GhyqWyCs2VtBIG0mgpXEEL4hNUpPodFaAyaK6klTCQRkvhKloQn6IC1d+oDHUPzZa0CgbSaCFcRYvhCipOfY9KUZ973CvNl7QCBtJoIdxBi+EKKkwxKki9j+ZLWgEDabQM7qLFcAUVpT5DZanXaMak2TCQRovgLloKV1E56hoqTf2NZkyaDQNptAgSaClcRaWoe6hA9RPNmTQTBtJoCSTQQriDylAZVKSnozmTZsJAGi2BFFoId1ERKouK9UQ0a9IsGEijBZBEy+AuKj+NQQV7Cpo1aRYMpFH5J9EiSKDS01hUtrujeZNmwEAalX8aLYIEKjvNQaW7o8d308xJo2EgjYo/jZZACpWc5qMS3gXNnDQaBtKo+EegJZBCxaZ1qIy7o7mTRsJAGpX+KLQEUqjQtB6Vckc0d9JIGEijwh+FFkAalZlqoILuhGZPGgUDaVT4I1H5p1GJqR4q68po9qRRMJBGZT8SFf8IVFyqi4q7Ipo/aQQMpFHZj0bFPwIVluqjAq+C5k8aAQNpVPQzUPGPQEWlPqjMV6MZlNIwkEYlPwOV/ihUUOqJin22x5loDqUkDKRRyc9CpT8KlZJ6o5KfheZQSsJAGhX8TFT6I1EhqT8q+9FoFqUUDKRRuc9EZT8aFZH2QaU/As2ilIKBNCr32ajsR6MC0p5oCaTQPEoJGEijYp+Nin4GKh3tjZbBHTSPUgIG0qjYV6Cin4HKRmegxXAFzaR0FwbSqNRXoaKfgUpGZ6EF8S6aSekuDKRRoa9CJT8LlYvORQvDZaJVMJBGhb4SlfxMVCo6Gy2OPz3+MzSb0lUYSKMyX4nKfTYqE+mBloj/KtFoGEijMl+Nyn02KhHpVy4TrYCBNCryCqjcZ6PykJ5xkWgWDKRRiVdAxb4ClYZE/H8r0SgYSKMSr4KKfQUqCukdNKPSpzCQRgVeBZX6KlQS0jtoTqVPYCCNCrwSKvWVqCikV2hOpU9gII3Kuxoq9JWoLKRXaFald2EgjYq7Girz1agspO/QrErvwkAaFXdFVOarUWFI36F5ld6BgTQq7YqoyCugwpC+QzMrEQykUWlXRUVeARWG9AzNrEQwkEaFXRkVeQVUGtIzNLfSKxhIo7KujEq8EioO6Vc0t9IrGEijsq6OCrwSKg/pVzS70ncwkEZFXR2VdzVUHtIXml3pOxhIo6LugMq7GioQ6QvNr/QMBtKopLug8q6GCkR6oPmVnsFAGhV0F1TcFVGJSA80w9KfMJBGBd0JFXdFVCLSA82x9CsMpFE5d0KlXRkVic5Gcyz9CgNpVM7dUGFXRmWis9EsS18wkEbF3BEVdmVUJjoXzbL0BQNpVModUVlXR4Wic9E8Sw8YSKNS7orKujoqFJ2J5ll6wEAaFXJXVNQdUKnoTDTTEgbSqJA7o6LugEpF56GZljCQRmXcHRV1F1QuOgvNtc6GgTQq4u6ooDuhctFZaLZ1LgykURHvgAq6EyoXnYNmW+fCQBqV8A6onLuhgtE5aL51JgykUQnvgsq5GyoYnYHmW2fCQBoV8E6onLuhktEZaMZ1HgykUfnuhIq5IyoZ7Y9mXOfBQBqV726omLuistHeaM51FgykUfHuhgq5Myob7YvmXGfBQBoV746okDujwtG+aNZ1DgykUenuigq5Myoc7YvmXWfAQBoV7q6ojLujwtGeaN51BgykUeHujMq4Oyod7YlmXvvDQBqV7c6oiHdApaP90MxrfxhIo7LdHRXxLqh8tBeae+0NA2lUtCegEt4FlY/2QXOvvWEgjUr2BFTAu3h8KxWQ9kGzr31hII1K9hRUwjv4enMqIO2BZl/7wkAaFewpqIS7e3zjr+9OJaQ90PxrTxhIo4I9CZVxZ8/enkpIe6AO0H4wkEblehoq5I4e3/Xd+1MJqT/qAO0HA2lUrKehUu6I/nvggcpIvdH7ay8YSKNiPREVcyf0/r+iMlJf9PbaCwbSqFRPROXcxeNb6P3/RIWkvujttQ8MpFGpnopKugN6++9QIaknenftAwNpVKgno6Ku7HF+evtXqJTUE7279oCBNCrTk1FZV0bv/g4qJfVDb649YCCNyvR0VNgVPc5N7/4JKif1Qu+t/jCQRkV6OirtiujNr6ByUi/03uoNA2lUpOq1TOi976ByUh/01uoNA2lUovqBCryCxznpve+iglIf9NbqCwNpVKD6gUq8AnrrFCoo9UDvrL4wkEYFqp+oyFd6nI/eOolKSj3QO6snDKRReeonKvOV6J1HoJJSffTG6gkDaVSe+h0V+gqPc9E7j0RlpdrofdUPBtKoOPU3KvbZ6I1noLJSXfS26gcDaVSa+hsV+0yP89Abz0KFpbrobdULBtKoNPUcFfws9L6zUWGpLnpb9YGBNCpMPUcFPwO97SpUWKqJ3lV9YCCNClPfo6If6fH79LYrUWmpJnpX9YCBNCpLvUaFPwq9awVUWqqH3lQ9YCCNilKvUeGP8PhdetdKqLxUC72n6sNAGhWlGBV/Gr1pRVReqoPeUvVhII1KUoyKP+nxe/SmVVGBqQ56S9WGgTQqSb2HFkAKvWd1VGCqgd5RtWEgjQpS76MlcBe9ZRdUYqqB3lF1YSCNylHvo0Vwx+Pv01t2QiWmGugdVRMG0qgc9RlaCFfRO3ZEJab16A1VEwbSqBj1OVoKn3r8TXrHzqjMtBa9n+rBQBqVoj5Hi+FT9IY7oDLTOvR2qgcDaVSKuoaWw7sef4vecBdUaFqH3k61YCCNClHX0IJ4F73fbqjQtAa9m2rBQBoVoq6jJUHo7XZFpaY16N1UBwbSqAx1Dy2L7zz+s/R2O6NS03z0ZqoDA2lUhLqHFob/GvkeFZvmozdTDRhIoyLUfbQ0/NfIa1RumoveS+thII1KUPfR4vBfI4zKTfPQW2k9DKRRCSqDlof/GmFUcJqH3kprYSCNClA5tET81wijgtMc9E5aCwNpVH7KcYlkUMlpDnonrYOBNCo/ZblIMqjkNB69kdbBQBoVn7JcIjlUdBqP3khrYCCNik95fy6Rx3+N3knfo7LTOPQ2WgMDaVR6GsN/jWRR4WkcehvNh4E0KjyN4b9G8qjwNA69jebCQBoVnsai99FnqPA0Br2L5sJAGhWdxqG30TVUehqD3kXzYCCNyk7j0NvoOio95dGbaB4MpFHZaQx6F91Hxac8ehPNgYE0Kjzl0Zsoi8pPOfQWmgMDaVR6yqM3UR4VoHLoLTQeBtKo9JRF76FxqACVQe+g8TCQRsWnLHoPjUUlqAx6B42FgTQqPuXQW2gOKkFl0DtoHAykUfkph95C81AJ6j56A42DgTQqP2XQO2g+KkLdR2+gMTCQRgWo++gNtBaVoa6ju9cYGEijEtR99AZajwpR19HdKw8DaVSCuofuX3VQIeoaunflYSCNilD30P2rFipFXUP3riwMpFER6jq6e9VEpajP0Z0rCwNpVIa6ju5edVEx6nN058rBQBqVoa6he1d9VIz6HN25MjCQRoWoz9GdqxcqR72P7loZGEijUtTn6M7VDxWk3kd3rfswkEalqM/QfasvKki9h+5Z92EgjVlOFrIAAAjeSURBVIpRn6H7Vm9UknoP3bPuwUAaFaPeR3etPVBJitEd6x4MpFE56n1019oHFaUY3bGuw0AalaPeQ/es/VBR6jW6X12HgTQqSL2H7ln7osLU9+hudQ0G0qggxeiOtT8qTH2P7lafw0AalaReo/vVOagw9Rzdqz6HgTQqSr1G96uzUGnqObpXfQYDaVSU+h7drc5Epam/0Z3qMxhIo7LU9+hudS4qTv2N7lTvw0AalaWeo3uVqDj1O7pPvQ8DaVSYeo7uVfpCBaqf6C71HgykUWHqb3Sn0p+oQPUD3aPeg4E0Kk39ju5T+g6VqH6gexTDQBoVp35H9ym9QiWqH+ge9RoG0qg49RPdpfQOKlE9ronvUd/DQBqVp36iu5TeRUWqxzXxPeo5DKRReeoHukfpU1Skp6P70/cwkEYFqh/oHqWrqFBPRnen5zCQRgUql4jGo0I9Fd2bnsNAGpXo6ej+pBQq1VPRvelvGEijIj0d3Z+URKV6Iroz/Q0DaVSkJ6O7k0agYj0R3Zl+h4E0KtOT0d1Jo1CxnojuTD9hII3K9FR0b9IMVK4nobvSTxhIo0I9Fd2bNAsV7EnorvQDBtKoUE9EdybNRgV7Cron/YCBNCrVE9GdSStQyZ6C7kkukuXovqSVqGRPQHckF8lSdFdSBVS0J6A7Oh0G0qhcT0J3JVVBRbs7up/TYSCNyvUUdE9SRVS4O6O7ORkG0qhgT0H3JFVFhbszuptTYSCNCvYEdEdSdVS4u6J7ORUG0qhkT0B3JHVApbsrupcTYSCNSnZ3dD9SJ1S6O6I7OREG0qhod0Z3I3VExbsjupPTYCCNynZndDdSV1S8u6H7OA0G0qhsd0X3Iu2ACngndBcnwUAaFe6u6F6kXVAB74Lu4SQYSKPC3RHdibQbKuFd0D2cAgNpVLo7ojuRdkQlvAO6g1NgII1Kdzd0H9LOqIh3QHdwAgykUfHuhO5COgEV8Q7oDnaHgTQq353QXUinoCLujr5/dxhIo/LdBd2DdCIq5M7o23eGgTQq4F3QPUinokLuir57ZxhIowLeAd2BdDoq5a7ou3eFgTQq4R3QHUjac5nQN+8KA2lUwt3R90v6iYq5I/rmHWEgjYq4O/p+Sb+jYu6GvndHGEijIu6Mvl3Sc1TO3dD37gYDaVTGXdF3S2JU0J3Qt+4EA2lUyF3Rd0t6DxV0F/SdO8FAGhVyR/TNkj5DJd0FfecuMJBGpdwRfbOkz1FJd0DfuAsMpFEpd0PfK+k6KuoO6Bt3gIE0KuZu6Hsl3UNFXR193w4wkEbF3Al9q6QMKuvq6Pu6w0AalXMX9J2S8qiwq6Lv6g4DaVTQXdB3ShqDSrsq+q7OMJBGBd0BfaOksai0q6Lv6goDaVTSHdA3ShqPSrsi+qauMJBGJV0dfZ+keai4K6Jv6ggDaVTU1dH3SZqLirsa+p6OMJBGRV0ZfZukNai8q6Hv6QYDaVTWVdF3SVqPCrwK+o5uMJBGhV0VfZekGqjEq6Dv6AQDaVTYFdE3SaqFSrwC+oZOMJBGpV0RfZOkeqjIK6Bv6AIDaVTa1dD3SKqLirwC+oYOMJBGxV0NfY+k2qjIV6Pzd4CBNCruSuhbJPVAZb4anb86DKRReVdC3yKpFyr0Vejc1WEgjcq7CvoOST1Rqa9C564MA2lU4BXQN0jqjUp9BTpzZRhIoxKvgL5BUn9U7CvQmavCQBqV+Gp0fkn7oGKfjc5bFQbSqMhXo/NL2guV+2x03oowkEZFvhKdXdKeqNxno/NWg4E0KvOV6OyS9kYFPwudsxoMpFGZr0LnlnQGKvlZ6JyVYCCNCn0FOrOks1DJz0BnrAQDaVTqK9CZJZ2Hin4GOmMVGEijUp+NzivpXFT0o9H5qsBAGhX7bHReSWejsh+NzlcBBtKo2Geis0rSA5X9SHS2CjCQRuU+E51Vkn5FpT8KnWs1DKRRuc9C55SkZ6j0R6FzrYSBNCr4GeiMkvQKlf4IdKaVMJBGJT8DnVGSCBX/CHSmVTCQRiU/Gp1Pkt5FxZ9G51kFA2lU9KPR+STpE1T+aXSeFTCQRkU/Ep1Nkq6g8k+is6yAgTQq+5HobJJ0By2BFDrHbBhIo7Ifhc4lSQm0BBLoDLNhII0KfxQ6lySl0CJIoDPMhIE0KvwR6EySlEaLIIHOMAsG0qj00+g8kjQKLYK76PdnwUAaFX8anUeSRqJlcBf9/gwYSKPiT6KzSNIstBCuot+dAQNpVP5JdBZJmomWwlX0u6NhII3KP4XOIUkr0FK4gn5zNAyk0QJIoXNI0iq0GK6g3xwJA2m0ABLoDJK0Gi2GT9HvjYSBNFoCd9HvS1IVtBw+Rb83CgbSaBHcRb8vSZXQcvgU/d4IGEijRXAH/bYkVUUL4l30OyNgII2WwR3025JUGS2Jd9HvpGEgjZbBVfS7ktQBLYl30G+kYSCNFsJV9LuS1AUtinfQbyRhII0WwhX0m5LUDS0KQn8/CQNptBQ+Rb8nSV3RsiD091MwkEaL4VP0e5LUGS0LF8lN9FuStAtaGiuXCQbSaDl8gn5LknZCS2PVMsFAGi2Hd9HvSNKOaGm4SD5AvyNJu6LFMXuZYCCNFsQ76DckaXe0OFwkLhJJQrQ8Zi0TDKTRkiD09yXpJLQ8XCQuEUl6Cy2RkcsEA2m0LFwkknQNLZHjFwn9XUnSmmWCgTRaGC4SSbqHFkl6mWAgjRaGS0SS7nORuEgk6bZZywQDabQ0XCKSlHP8IqG/JUl6z8hlgoE0Wh4uEkka47hFQn9HkvS5EcsEA2m0QFwkkjTWEYuE/oYk6Z7kMsFAGi0RF4kkzZFaJhhIc4lIUh3bLRL6z0qSxrizTDCQ5iKRpL1gIM0lIkl7wUCai0SS9oKBNJeIJO0FA2kuEknaCwbSXCKStBcMpLlEJGkvGEhzkUjSXjCQ5hKRpL1gIM1FIkl7wUCaS0SS9oIBSZJewYAkSa9gQJKkVzAgSdIrGJAk6RUMSJL0CgYkSXoFA5IkvYIBSZJewYAkSa9gQJKkVzAgSdIr/wU8p+D/DNWZpwAAAABJRU5ErkJggg=='}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{className:'cls-17',cx:'188.75',cy:'107.15',r:'24.84'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'_Group_','data-name':'<Group>'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LightBulb,{id:'lightbulb',className:'cls-18',d:'M24.29,109c.15.25.31.49.45.75.43.74.91.6,1.43.1a10.67,10.67,0,0,1,1-.72,11.83,11.83,0,0,0-.4,1.28c-.25,1.57-.51,3.15-.68,4.74,0,.24.39.54.59.81.2-.27.57-.54.58-.82a17.91,17.91,0,0,1,1.32-6.33c.32-.8,0-1.25-.86-1.09a14.61,14.61,0,0,0-2,.68,19.77,19.77,0,0,0-2.46-.69c-.79-.12-1.09.3-.76,1A16.56,16.56,0,0,1,23.75,115c0,.41,0,.92.59.9s.64-.52.61-1a19.79,19.79,0,0,0-.18-2.31c-.2-1.15-.48-2.3-.73-3.44Zm-2.13,7.82a9.08,9.08,0,0,0-2.63-5.53,9.09,9.09,0,0,1,.39-13.38A8.91,8.91,0,0,1,31.74,111.2a7.39,7.39,0,0,0-2.35,4.3.86.86,0,0,1-.79.85c-2.3.53-4.57,1.11-6.85,1.66l-.09-.35C21.83,117.37,22.2,117.06,22.16,116.8Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-19',d:'M28.24,126.17c-.83.47-1.72.83-2.62,1.23a20.86,20.86,0,0,1-2.38-1c-.25-.13-.3-.61-.43-.94.33,0,.75-.19,1-.05a3.24,3.24,0,0,0,3.82-.16c.19-.14.59,0,.89,0C28.43,125.6,28.44,126.07,28.24,126.17Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-19',d:'M24.74,109.73c-.14-.26-.3-.5-.45-.75l-.25.22c.25,1.14.53,2.29.73,3.44A19.79,19.79,0,0,1,25,115c0,.45,0,1-.61,1s-.57-.49-.59-.9a16.56,16.56,0,0,0-1.32-6.32c-.33-.71,0-1.13.76-1a19.77,19.77,0,0,1,2.46.69,14.61,14.61,0,0,1,2-.68c.86-.16,1.18.29.86,1.09a17.91,17.91,0,0,0-1.32,6.33c0,.28-.38.55-.58.82-.2-.27-.61-.57-.59-.81.17-1.59.43-3.17.68-4.74a11.83,11.83,0,0,1,.4-1.28,10.67,10.67,0,0,0-1,.72C25.65,110.33,25.17,110.47,24.74,109.73Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-19',d:'M21.39,121q4.09-1.07,8.22-2c.24,0,.57.24.85.38-.19.25-.35.66-.59.72-2.7.72-5.41,1.38-8.12,2.06-.06,0-.12,0-.37.06-.12-.12-.48-.32-.49-.54A.88.88,0,0,1,21.39,121Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-19',d:'M21.35,124c2.72-.74,5.44-1.44,8.18-2.09.26-.07.62.25.94.39-.2.26-.36.68-.61.74-2.68.72-5.38,1.38-8.08,2.06l-.4,0c-.1-.09-.46-.26-.49-.48A.82.82,0,0,1,21.35,124Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-19',d:'M32.18,98.77a8.77,8.77,0,0,0-12.26-.88,9.09,9.09,0,0,0-.39,13.38,9.08,9.08,0,0,1,2.63,5.53c0,.26-.33.57-.5.86-.23-.23-.62-.45-.66-.72a9.1,9.1,0,0,0-2.45-5,9.69,9.69,0,0,1-3-6.69c0-4.87,2.67-8.86,6.66-10.14a10,10,0,0,1,11.47,3.48,10.24,10.24,0,0,1,.4,11.62,14.29,14.29,0,0,1-1.65,2,6.68,6.68,0,0,0-2,4,1.09,1.09,0,0,1-.95,1.08c-2.54.62-5.06,1.29-7.61,1.88-.34.08-1-.1-1.1-.31-.22-.62.36-.75.84-.87l.07,0c2.28-.55,4.55-1.13,6.85-1.66a.86.86,0,0,0,.79-.85,7.39,7.39,0,0,1,2.35-4.3A8.77,8.77,0,0,0,32.18,98.77Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Stripes,{id:'Stripes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-19',d:'M42.44,102.72c.27,0,.51.36.76.56-.25.21-.48.58-.73.59-1.42.06-2.84,0-4.26,0-.22,0-.43-.36-.64-.55.2-.21.39-.57.62-.59a20.34,20.34,0,0,1,2.21,0h0A15.41,15.41,0,0,1,42.44,102.72Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-19',d:'M39.78,114.86c.24.22.26.68.37,1-.39,0-.89.07-1.16-.14-1.15-.88-2.24-1.83-3.32-2.8a1.31,1.31,0,0,1-.32-.83c0-.21.18-.43.27-.65l.27.19a4.43,4.43,0,0,1,.59.36C37.59,113,38.72,113.88,39.78,114.86Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-19',d:'M37.69,93.9c-.92.81-1.83,1.62-2.8,2.35-.24.19-.71.06-1.08.08.11-.33.11-.75.33-1C35,94.5,36,93.69,37,92.9a1.12,1.12,0,0,1,.78-.19c.16,0,.29.3.48.51A4.94,4.94,0,0,1,37.69,93.9Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-19',d:'M25.07,90.39a18.09,18.09,0,0,1,0-2c0-.25.33-.46.51-.69.22.2.61.4.62.62.06,1.32.06,2.66,0,4,0,.22-.44.43-.68.64-.16-.25-.43-.48-.46-.74C25,91.64,25.07,91,25.07,90.39Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-19',d:'M16.2,96.4c-1-.81-2-1.65-3-2.54-.16-.16,0-.62-.05-.94.29,0,.67-.09.85,0,1,.79,1.94,1.64,2.89,2.49a1.84,1.84,0,0,1,.32.51A.62.62,0,0,1,16.2,96.4Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-19',d:'M11,114.92c1.17-1,2.37-2.07,3.58-3.07a.64.64,0,0,1,.63,0,.81.81,0,0,1,.2.68,1.64,1.64,0,0,1-.52.69c-.91.8-1.84,1.58-2.78,2.36-.19.16-.43.28-.7.47-.21-.18-.46-.3-.52-.48A.71.71,0,0,1,11,114.92Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{className:'cls-19',d:'M12.87,103.86a18.89,18.89,0,0,1-2.13,0h0a15.83,15.83,0,0,1-2,0c-.23,0-.43-.35-.64-.54.2-.21.39-.59.6-.6,1.39,0,2.78,0,4.17,0,.2,0,.39.36.59.55C13.3,103.48,13.1,103.84,12.87,103.86Z'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{className:'cls-17',cx:'25.34',cy:'107.15',r:'24.84'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{className:'cls-17',cx:'107.56',cy:'25.34',r:'24.84'}))));};/* harmony default export */ __webpack_exports__["a"] = (AfterEllaGraphic);

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_howItWorks__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vid_promo_mp4__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vid_promo_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__vid_promo_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  max-width: 70em;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n'],['\n  max-width: 70em;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n']),_templateObject2=_taggedTemplateLiteral(['\n  display: flex;\n  height: 25em;\n  width: 100%;\n  justify-content: center;\n  margin: 2em 0;\n\n  @media (max-width: 800px) {\n    flex-direction: column;\n    height: auto;\n    align-items: center;\n  }\n'],['\n  display: flex;\n  height: 25em;\n  width: 100%;\n  justify-content: center;\n  margin: 2em 0;\n\n  @media (max-width: 800px) {\n    flex-direction: column;\n    height: auto;\n    align-items: center;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  width: 33%;\n  background: url(',');\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: center;\n\n  @media (max-width: 800px) {\n    width: 20em;\n    height: 25em;\n    margin: -5em 0;\n    transform: rotate(90deg);\n  }\n'],['\n  width: 33%;\n  background: url(',');\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: center;\n\n  @media (max-width: 800px) {\n    width: 20em;\n    height: 25em;\n    margin: -5em 0;\n    transform: rotate(90deg);\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  width: 66%;\n  background: url(',');\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n\n  &:after {\n    padding-top: 70%;\n    display: block;\n    content: \'\';\n  }\n\n  @media (max-width: 800px) {\n    width: 100%;\n    height: 20em;\n  }\n'],['\n  width: 66%;\n  background: url(',');\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n\n  &:after {\n    padding-top: 70%;\n    display: block;\n    content: \'\';\n  }\n\n  @media (max-width: 800px) {\n    width: 100%;\n    height: 20em;\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  padding: 4.7% 8.6% 4.6% 8.3%;\n  box-sizing: border-box;\n  background-clip: content-box;\n'],['\n  width: 100%;\n  height: 100%;\n  padding: 4.7% 8.6% 4.6% 8.3%;\n  box-sizing: border-box;\n  background-clip: content-box;\n']),_templateObject6=_taggedTemplateLiteral(['\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  margin-top: 3em;\n\n  @media (max-width: 800px) {\n    flex-direction: column;\n    justify-content: center;\n  }\n'],['\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  margin-top: 3em;\n\n  @media (max-width: 800px) {\n    flex-direction: column;\n    justify-content: center;\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  margin: 1em 3em;\n  text-align: center;\n  min-width: 5em;\n  width: 30%;\n\n  & img {\n    max-width: 20em;\n    margin: 3em 0;\n  }\n\n  @media (max-width: 800px) {\n    width: auto;\n  }\n'],['\n  margin: 1em 3em;\n  text-align: center;\n  min-width: 5em;\n  width: 30%;\n\n  & img {\n    max-width: 20em;\n    margin: 3em 0;\n  }\n\n  @media (max-width: 800px) {\n    width: auto;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var InnerContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].div(_templateObject);var VideoContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].div(_templateObject2);var ChatGraphics=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].div(_templateObject3,function(props){return props.background;});var VideoBackground=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].div(_templateObject4,__WEBPACK_IMPORTED_MODULE_3__img_howItWorks__["a" /* default */].ipad);var Video=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].video(_templateObject5);var ImageContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].div(_templateObject6);var Segment=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].div(_templateObject7);var HowItWorks=function HowItWorks(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["b" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["i" /* Triangle */],{color:'#0d8ec5',rightTop:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["i" /* Triangle */],{color:'#71c0db',leftBottom:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InnerContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["d" /* Intro */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["h" /* Title */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* Trans */],{i18nKey:'howItWorks.title'},'How it works')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["f" /* Paragraph */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* Trans */],{i18nKey:'howItWorks.text'},'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quibusdam officia magni vitae maiores inventore explicabo dolore dolorum, optio impedit eum totam corporis tempore provident, neque adipisci quisquam animi esse repellat!'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(VideoContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatGraphics,{background:__WEBPACK_IMPORTED_MODULE_3__img_howItWorks__["a" /* default */].chatsLeft}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(VideoBackground,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Video,{src:__WEBPACK_IMPORTED_MODULE_4__vid_promo_mp4___default.a,controls:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatGraphics,{background:__WEBPACK_IMPORTED_MODULE_3__img_howItWorks__["a" /* default */].chatsRight})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ImageContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Segment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__img_howItWorks__["a" /* default */].search,alt:'search'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["g" /* SubTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* Trans */],{i18nKey:'howItWorks.searchTitle'},'Search')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* Trans */],{i18nKey:'howItWorks.searchText'},'Lorem ipsum dolor sit amet consectetur adipisicing elit. Expedita sequi nemo assumenda maiores totam a voluptatum labore recusandae dolore, cumque alias corporis, nostrum iure inventore numquam, eos quas odio officia!'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Segment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__img_howItWorks__["a" /* default */].kf,alt:'kf'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["g" /* SubTitle */],null,'KnowledgeFlow'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* Trans */],{i18nKey:'howItWorks.kfText'},'Lorem ipsum dolor sit amet consectetur adipisicing elit. Expedita sequi nemo assumenda maiores totam a voluptatum labore recusandae dolore, cumque alias corporis, nostrum iure inventore numquam, eos quas odio officia!'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Segment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__img_howItWorks__["a" /* default */].answer,alt:'answer'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["g" /* SubTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* Trans */],{i18nKey:'howItWorks.answerTitle'},'Answer')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* Trans */],{i18nKey:'howItWorks.answerText'},'Lorem ipsum dolor sit amet consectetur adipisicing elit. Expedita sequi nemo assumenda maiores totam a voluptatum labore recusandae dolore, cumque alias corporis, nostrum iure inventore numquam, eos quas odio officia!'))))));};/* harmony default export */ __webpack_exports__["a"] = (HowItWorks);

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__search_svg__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__search_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__search_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__kf_svg__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__kf_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__kf_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__answer_svg__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__answer_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__answer_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chats_left_svg__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chats_left_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__chats_left_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chats_right_svg__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chats_right_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__chats_right_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ipad_svg__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ipad_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ipad_svg__);
/* harmony default export */ __webpack_exports__["a"] = ({search:__WEBPACK_IMPORTED_MODULE_0__search_svg___default.a,kf:__WEBPACK_IMPORTED_MODULE_1__kf_svg___default.a,answer:__WEBPACK_IMPORTED_MODULE_2__answer_svg___default.a,chatsLeft:__WEBPACK_IMPORTED_MODULE_3__chats_left_svg___default.a,chatsRight:__WEBPACK_IMPORTED_MODULE_4__chats_right_svg___default.a,ipad:__WEBPACK_IMPORTED_MODULE_5__ipad_svg___default.a});

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/search.62c44f4f.svg";

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/kf.b437660f.svg";

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/answer.bfdea715.svg";

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/chats-left.9f7f7288.svg";

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/chats-right.c02a8da6.svg";

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ipad.e376554b.svg";

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/promo.6e83685a.mp4";

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_features__ = __webpack_require__(127);
var _templateObject=_taggedTemplateLiteral(['\n  list-style: none;\n  display: flex;\n  width: 80%;\n  padding-left: 0;\n  justify-content: space-evenly;\n\n  li {\n    margin: 0 2em;\n    text-align: center;\n    max-width: 10em;\n    min-width: 3em;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    img {\n      width: 80%;\n    }\n  }\n\n  @media (max-width: 600px) {\n    flex-wrap: wrap;\n\n    & li {\n      width: 50%;\n      margin: 0;\n    }\n  }\n'],['\n  list-style: none;\n  display: flex;\n  width: 80%;\n  padding-left: 0;\n  justify-content: space-evenly;\n\n  li {\n    margin: 0 2em;\n    text-align: center;\n    max-width: 10em;\n    min-width: 3em;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    img {\n      width: 80%;\n    }\n  }\n\n  @media (max-width: 600px) {\n    flex-wrap: wrap;\n\n    & li {\n      width: 50%;\n      margin: 0;\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var InnerContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].ul(_templateObject);var Features=function Features(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* Container */],{style:{background:'url('+__WEBPACK_IMPORTED_MODULE_4__img_features__["a" /* default */].barsExtended+'), #0d8ec5'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["h" /* Title */],{style:{color:'#fff'},noUnderline:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* Trans */],{i18nKey:'features.title'},'Features')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InnerContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__img_features__["a" /* default */].code,alt:'Code icon'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{style:{color:'#fff'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* Trans */],{i18nKey:'features.customizable'},'Customizable'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__img_features__["a" /* default */].screenMini,alt:'Screen icon'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{style:{color:'#fff'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* Trans */],{i18nKey:'features.anyDevice'},'Any device'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__img_features__["a" /* default */].analytics,alt:'Analytics icon'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{style:{color:'#fff'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* Trans */],{i18nKey:'features.analytics'},'Analytics'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__img_features__["a" /* default */].twentyFourSeven,alt:'24/7 icon'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{style:{color:'#fff'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* Trans */],{i18nKey:'features.available247'},'Available 24/7'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__img_features__["a" /* default */].mic,alt:'Mic icon'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{style:{color:'#fff'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* Trans */],{i18nKey:'features.voice'},'Voice')))));};/* harmony default export */ __webpack_exports__["a"] = (Features);

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__code_svg__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__code_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__code_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__screen_mini_svg__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__screen_mini_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__screen_mini_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__analytics_svg__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__analytics_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__analytics_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__24_7_svg__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__24_7_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__24_7_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mic_svg__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mic_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__mic_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bars_extended_svg__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bars_extended_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__bars_extended_svg__);
/* harmony default export */ __webpack_exports__["a"] = ({code:__WEBPACK_IMPORTED_MODULE_0__code_svg___default.a,screenMini:__WEBPACK_IMPORTED_MODULE_1__screen_mini_svg___default.a,analytics:__WEBPACK_IMPORTED_MODULE_2__analytics_svg___default.a,twentyFourSeven:__WEBPACK_IMPORTED_MODULE_3__24_7_svg___default.a,mic:__WEBPACK_IMPORTED_MODULE_4__mic_svg___default.a,barsExtended:__WEBPACK_IMPORTED_MODULE_5__bars_extended_svg___default.a});

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/code.c2179a70.svg";

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/screen-mini.b59f671c.svg";

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/analytics.bea86d32.svg";

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/24-7.547df329.svg";

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mic.8ef6d34a.svg";

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bars-extended.2daff766.svg";

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_whoCanBFromElla__ = __webpack_require__(135);
var _templateObject=_taggedTemplateLiteral(['\n  display: flex;\n  justify-content: space-between;\n  margin: 2em auto;\n  max-width: 70em;\n\n  @media (max-width: 900px) {\n    flex-wrap: wrap;\n  }\n'],['\n  display: flex;\n  justify-content: space-between;\n  margin: 2em auto;\n  max-width: 70em;\n\n  @media (max-width: 900px) {\n    flex-wrap: wrap;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: 15%;\n  padding: 2em;\n  background: ',';\n  border-radius: 12px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  @media (max-width: 900px) {\n    width: 40%;\n    margin: 1em 0;\n  }\n\n  @media (max-width: 750px) {\n    width: 100%;\n    margin: 1em 0;\n  }\n\n  ',';\n'],['\n  width: 15%;\n  padding: 2em;\n  background: ',';\n  border-radius: 12px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  @media (max-width: 900px) {\n    width: 40%;\n    margin: 1em 0;\n  }\n\n  @media (max-width: 750px) {\n    width: 100%;\n    margin: 1em 0;\n  }\n\n  ',';\n']),_templateObject3=_taggedTemplateLiteral(['\n      opacity: 0.3;\n    '],['\n      opacity: 0.3;\n    ']),_templateObject4=_taggedTemplateLiteral(['\n  height: 9em;\n'],['\n  height: 9em;\n']),_templateObject5=_taggedTemplateLiteral(['\n  flex-grow: 1;\n'],['\n  flex-grow: 1;\n']),_templateObject6=_taggedTemplateLiteral(['\n  background: #0d8ec5;\n'],['\n  background: #0d8ec5;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Content=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].div(_templateObject);var Segment=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].div(_templateObject2,function(props){return props.backgroundColor;},function(props){return!props.available&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* css */])(_templateObject3);});var Graphic=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].img(_templateObject4);var SegmentParagraph=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].p(_templateObject5);var DemoButton=__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* Button */].extend(_templateObject6);var WhoCanBenefitFromElla=function WhoCanBenefitFromElla(_ref){var id=_ref.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* Container */],{id:id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* Intro */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["h" /* Title */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* Trans */],{i18nKey:'whoCanBenefit.title'},'Who can benefit From Ella?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["f" /* Paragraph */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* Trans */],{i18nKey:'whoCanBenefit.text'},'Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi dolorem totam maiores tenetur, vel asperiores possimus exercitationem reiciendis.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Content,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Segment,{backgroundColor:'#e2f1f8',available:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Graphic,{src:__WEBPACK_IMPORTED_MODULE_5__img_whoCanBFromElla__["a" /* default */].personRetail}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["g" /* SubTitle */],{noUnderline:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* Trans */],{i18nKey:'whoCanBenefit.retail.title'},'Retail')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SegmentParagraph,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* Trans */],{i18nKey:'whoCanBenefit.retail.text'},'Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis repellendus odit nesciunt in. Velit mollitia rem impedit, at.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:""+'/demo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DemoButton,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* Trans */],{i18nKey:'whoCanBenefit.retail.demo'},'Demo')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Segment,{backgroundColor:'#fcefe3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Graphic,{src:__WEBPACK_IMPORTED_MODULE_5__img_whoCanBFromElla__["a" /* default */].personProduction}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["g" /* SubTitle */],{noUnderline:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* Trans */],{i18nKey:'whoCanBenefit.production.title'},'Production')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SegmentParagraph,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* Trans */],{i18nKey:'whoCanBenefit.production.text'},'Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis repellendus odit nesciunt in. Velit mollitia rem impedit, at.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* Trans */],{i18nKey:'whoCanBenefit.production.comingSoon'},'Coming soon'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Segment,{backgroundColor:'#f9e5e5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Graphic,{src:__WEBPACK_IMPORTED_MODULE_5__img_whoCanBFromElla__["a" /* default */].personServices}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["g" /* SubTitle */],{noUnderline:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* Trans */],{i18nKey:'whoCanBenefit.services.title'},'Services')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SegmentParagraph,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* Trans */],{i18nKey:'whoCanBenefit.services.text'},'Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis repellendus odit nesciunt in. Velit mollitia rem impedit, at.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* Trans */],{i18nKey:'whoCanBenefit.services.comingSoon'},'Coming soon'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Segment,{backgroundColor:'#e7f2e8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Graphic,{src:__WEBPACK_IMPORTED_MODULE_5__img_whoCanBFromElla__["a" /* default */].personTraining}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["g" /* SubTitle */],{noUnderline:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* Trans */],{i18nKey:'whoCanBenefit.training.title'},'Training')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SegmentParagraph,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* Trans */],{i18nKey:'whoCanBenefit.training.text'},'Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis repellendus odit nesciunt in. Velit mollitia rem impedit, at.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["b" /* Trans */],{i18nKey:'whoCanBenefit.training.comingSoon'},'Coming soon')))));};/* harmony default export */ __webpack_exports__["a"] = (WhoCanBenefitFromElla);

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__person_retail_svg__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__person_retail_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__person_retail_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__person_production_svg__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__person_production_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__person_production_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__person_services_svg__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__person_services_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__person_services_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__person_training_svg__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__person_training_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__person_training_svg__);
/* harmony default export */ __webpack_exports__["a"] = ({personRetail:__WEBPACK_IMPORTED_MODULE_0__person_retail_svg___default.a,personProduction:__WEBPACK_IMPORTED_MODULE_1__person_production_svg___default.a,personServices:__WEBPACK_IMPORTED_MODULE_2__person_services_svg___default.a,personTraining:__WEBPACK_IMPORTED_MODULE_3__person_training_svg___default.a});

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/person-retail.c0c6e595.svg";

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/person-production.e1c10b74.svg";

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/person-services.89cab515.svg";

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/person-training.42356fc2.svg";

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_contact__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  display: flex;\n\n  @media (max-width: 600px) {\n    flex-direction: column;\n    align-items: center;\n  }\n'],['\n  display: flex;\n\n  @media (max-width: 600px) {\n    flex-direction: column;\n    align-items: center;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  margin: 0 1%;\n  width: 60%;\n  display: inline-block;\n\n  & input,\n  textarea {\n    width: 100%;\n  }\n\n  & > * {\n    margin: 0.75em 0;\n  }\n\n  @media (max-width: 600px) {\n    width: 100%;\n    margin-bottom: 2em;\n  }\n'],['\n  margin: 0 1%;\n  width: 60%;\n  display: inline-block;\n\n  & input,\n  textarea {\n    width: 100%;\n  }\n\n  & > * {\n    margin: 0.75em 0;\n  }\n\n  @media (max-width: 600px) {\n    width: 100%;\n    margin-bottom: 2em;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  resize: vertical;\n'],['\n  resize: vertical;\n']),_templateObject4=_taggedTemplateLiteral(['\n  float: right;\n  color: #0a6b94;\n  border: solid 1px #0a6b94;\n  background: #fff;\n  width: 8em;\n'],['\n  float: right;\n  color: #0a6b94;\n  border: solid 1px #0a6b94;\n  background: #fff;\n  width: 8em;\n']),_templateObject5=_taggedTemplateLiteral(['\n  margin: 0 3%;\n  list-style: none;\n  padding: 0;\n  width: 40%;\n  display: inline-block;\n\n  & li {\n    display: flex;\n    align-items: center;\n\n    &:not(:first-child) {\n      margin: 2em 0;\n    }\n  }\n\n  @media (max-width: 600px) {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n\n    & li {\n      margin: 1em 1em !important;\n    }\n  }\n'],['\n  margin: 0 3%;\n  list-style: none;\n  padding: 0;\n  width: 40%;\n  display: inline-block;\n\n  & li {\n    display: flex;\n    align-items: center;\n\n    &:not(:first-child) {\n      margin: 2em 0;\n    }\n  }\n\n  @media (max-width: 600px) {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n\n    & li {\n      margin: 1em 1em !important;\n    }\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  width: 2em;\n  height: 2em;\n  margin-right: 1em;\n'],['\n  width: 2em;\n  height: 2em;\n  margin-right: 1em;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var FormContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject);var Form=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].form(_templateObject2);var Textarea=__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* Input */].withComponent('textarea').extend(_templateObject3);var SubmitButton=__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* Button */].extend(_templateObject4);var List=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].ul(_templateObject5);var ListGraphic=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].img(_templateObject6);function Contact(_ref){var id=_ref.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* Container */],{small:true,id:id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["i" /* Triangle */],{color:'#0d8ec5',leftTop:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["i" /* Triangle */],{color:'#71c0db',rightBottom:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* Intro */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["h" /* Title */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* Trans */],{i18nKey:'contact.title'},'Contact & Support')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["f" /* Paragraph */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* Trans */],{i18nKey:'contact.text'},'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ut eius quia itaque porro, quod voluptatum pariatur.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FormContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Form,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["a" /* I18n */],null,function(t){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* Input */],{type:'text',placeholder:t('contact.name')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* Input */],{type:'text',placeholder:t('contact.company')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* Input */],{type:'text',placeholder:t('contact.email')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Textarea,{name:'text',cols:'30',rows:'10',placeholder:t('contact.message')}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubmitButton,{type:'submit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* Trans */],{i18nKey:'contact.send'},'Send'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(List,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListGraphic,{src:__WEBPACK_IMPORTED_MODULE_3__img_contact__["a" /* default */].location,alt:''}),'Kapelstraat 88, B-2840 Rumst, Belgium'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListGraphic,{src:__WEBPACK_IMPORTED_MODULE_3__img_contact__["a" /* default */].email,alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["e" /* Link */],{style:{color:'#000'},href:'mailto:info@knowledgeflow.eu'},'info@knowledgeflow.eu')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListGraphic,{src:__WEBPACK_IMPORTED_MODULE_3__img_contact__["a" /* default */].phone,alt:''}),'+32 (0)495 52 53 55'))));}/* harmony default export */ __webpack_exports__["a"] = (Contact);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__location_svg__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__location_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__location_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__email_svg__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__email_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__email_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__phone_svg__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__phone_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__phone_svg__);
/* harmony default export */ __webpack_exports__["a"] = ({location:__WEBPACK_IMPORTED_MODULE_0__location_svg___default.a,email:__WEBPACK_IMPORTED_MODULE_1__email_svg___default.a,phone:__WEBPACK_IMPORTED_MODULE_2__phone_svg___default.a});

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/location.7d8aa277.svg";

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/email.fa509e67.svg";

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/phone.dbb9dc4e.svg";

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_logos__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral([''],['']),_templateObject2=_taggedTemplateLiteral(['\n  background-color: #0a6b94;\n  height: 6.25em;\n  display: flex;\n  align-items: center;\n  padding: 0 6em 0 2em;\n  justify-content: space-around;\n  color: #fff;\n\n  & > * {\n    margin: 0 1em;\n  }\n\n  & > * > * {\n    margin: 0 0.5em;\n  }\n\n  @media (max-width: 900px) {\n    flex-direction: column;\n    height: auto;\n    padding-right: 0;\n\n    & > * {\n      margin: 1em 0;\n    }\n  }\n'],['\n  background-color: #0a6b94;\n  height: 6.25em;\n  display: flex;\n  align-items: center;\n  padding: 0 6em 0 2em;\n  justify-content: space-around;\n  color: #fff;\n\n  & > * {\n    margin: 0 1em;\n  }\n\n  & > * > * {\n    margin: 0 0.5em;\n  }\n\n  @media (max-width: 900px) {\n    flex-direction: column;\n    height: auto;\n    padding-right: 0;\n\n    & > * {\n      margin: 1em 0;\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  height: ',';\n'],['\n  height: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Footer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].footer(_templateObject);var FooterContent=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject2);var Logo=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].img(_templateObject3,function(props){return props.small?'2em':'2.5em';});var Copyright=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].span(_templateObject);var FooterComponent=function FooterComponent(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Footer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FooterContent,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Logo,{src:__WEBPACK_IMPORTED_MODULE_3__img_logos__["a" /* default */].ellaColor,alt:'Ella logo'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["e" /* Link */],{href:'#'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* Trans */],{i18nKey:'footer.terms'},'Terms of use')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["e" /* Link */],{href:'#'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* Trans */],{i18nKey:'footer.privacy'},'Privacy')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["e" /* Link */],{href:'#'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["b" /* Trans */],{i18nKey:'footer.support'},'Support'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["e" /* Link */],{href:'#'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Logo,{small:true,src:__WEBPACK_IMPORTED_MODULE_3__img_logos__["a" /* default */].facebook,alt:'Facebook logo'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["e" /* Link */],{href:'#'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Logo,{small:true,src:__WEBPACK_IMPORTED_MODULE_3__img_logos__["a" /* default */].twitter,alt:'Twitter logo'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Copyright,null,'\xA9 Copyright 2018 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles__["e" /* Link */],{href:'#'},'Knowledgeflow'))));};/* harmony default export */ __webpack_exports__["a"] = (FooterComponent);

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_woman_svg__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_woman_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__img_woman_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_close_svg__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__img_close_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  position: fixed;\n  bottom: 1.25em;\n  right: 1.25em;\n  z-index: 99;\n'],['\n  position: fixed;\n  bottom: 1.25em;\n  right: 1.25em;\n  z-index: 99;\n']),_templateObject2=_taggedTemplateLiteral(['\n  0% {\n    opacity: 0;\n    height: 50vh;\n  }\n  100% {\n    opacity: 1;\n    height: 50vh;\n  }\n'],['\n  0% {\n    opacity: 0;\n    height: 50vh;\n  }\n  100% {\n    opacity: 1;\n    height: 50vh;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  0% {\n    opacity: 1;\n    height: 50vh;\n  }\n  99% {\n    opacity: 0;\n    height: 50vh;\n  }\n  100% {\n    height: 0;\n    opacity: 0;\n  }\n'],['\n  0% {\n    opacity: 1;\n    height: 50vh;\n  }\n  99% {\n    opacity: 0;\n    height: 50vh;\n  }\n  100% {\n    height: 0;\n    opacity: 0;\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  display: block;\n  height: 0;\n  opacity: 0;\n  border: solid 1px #0078d7;\n  border-radius: 5px;\n  max-width: 18.75em;\n  max-height: 37.5em;\n  background: #fff;\n  margin-bottom: 4.25em;\n\n  ',';\n\n  ',';\n'],['\n  display: block;\n  height: 0;\n  opacity: 0;\n  border: solid 1px #0078d7;\n  border-radius: 5px;\n  max-width: 18.75em;\n  max-height: 37.5em;\n  background: #fff;\n  margin-bottom: 4.25em;\n\n  ',';\n\n  ',';\n']),_templateObject5=_taggedTemplateLiteral(['\n      width: 50vw;\n      height: 50vh;\n      opacity: 1;\n      animation: ',' 0.5s ease-in-out;\n    '],['\n      width: 50vw;\n      height: 50vh;\n      opacity: 1;\n      animation: ',' 0.5s ease-in-out;\n    ']),_templateObject6=_taggedTemplateLiteral(['\n      animation: ',' 0.5s ease-in-out;\n    '],['\n      animation: ',' 0.5s ease-in-out;\n    ']),_templateObject7=_taggedTemplateLiteral(['\n  cursor: pointer;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n'],['\n  cursor: pointer;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n']),_templateObject8=_taggedTemplateLiteral(['\n  float: right;\n  height: 5em;\n  width: 5em;\n  border-radius: 50%;\n  border: 1px solid #eb8018;\n  background: ',';\n  background-position: center;\n  background-size: cover;\n'],['\n  float: right;\n  height: 5em;\n  width: 5em;\n  border-radius: 50%;\n  border: 1px solid #eb8018;\n  background: ',';\n  background-position: center;\n  background-size: cover;\n']),_templateObject9=_taggedTemplateLiteral(['\n  height: 1.25em;\n  width: 1.25em;\n  top: -0.3em;\n  left: -0.3em;\n  border-radius: 50%;\n  background: #eb8018;\n  text-align: center;\n  line-height: 1.25em;\n  color: #fff;\n  position: absolute;\n'],['\n  height: 1.25em;\n  width: 1.25em;\n  top: -0.3em;\n  left: -0.3em;\n  border-radius: 50%;\n  background: #eb8018;\n  text-align: center;\n  line-height: 1.25em;\n  color: #fff;\n  position: absolute;\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject);var FadeIn=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* keyframes */])(_templateObject2);var FadeOut=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* keyframes */])(_templateObject3);var Iframe=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].iframe(_templateObject4,function(_ref){var active=_ref.active;return active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* css */])(_templateObject5,FadeIn);},function(_ref2){var active=_ref2.active,allowFadeout=_ref2.allowFadeout;return!active&&allowFadeout&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* css */])(_templateObject6,FadeOut);});var ButtonContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject7);var OpenCloseButton=__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* Button */].extend(_templateObject8,function(_ref3){var open=_ref3.open;return'#fff url('+(open?__WEBPACK_IMPORTED_MODULE_3__img_close_svg___default.a:__WEBPACK_IMPORTED_MODULE_2__img_woman_svg___default.a)+')';});var Badge=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject9);var WebchatContainer=function(_Component){_inherits(WebchatContainer,_Component);function WebchatContainer(props,context){_classCallCheck(this,WebchatContainer);var _this=_possibleConstructorReturn(this,(WebchatContainer.__proto__||Object.getPrototypeOf(WebchatContainer)).call(this,props,context));_this.state={showChat:false,allowFadeout:false};_this.toggleChat=_this.toggleChat.bind(_this);return _this;}_createClass(WebchatContainer,[{key:'toggleChat',value:function toggleChat(){var _state=this.state,showChat=_state.showChat,allowFadeout=_state.allowFadeout;if(!showChat&&!allowFadeout){this.setState({allowFadeout:true});}this.setState({showChat:!showChat});}},{key:'render',value:function render(){var _state2=this.state,showChat=_state2.showChat,allowFadeout=_state2.allowFadeout;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Iframe,{active:showChat,allowFadeout:allowFadeout,title:'webchat',src:'https://webchat.botframework.com/embed/project-siba-faqbotservice?s=mO_IJV-qtHA.cwA.55M.1fgxugry7WA18aX_h7X4Pv1FDJj-TL3j4Y9LVA8350Y'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonContainer,{onClick:this.toggleChat},!showChat&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Badge,null,'1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OpenCloseButton,{open:showChat})));}}]);return WebchatContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (WebchatContainer);

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/woman.359a04b3.svg";

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProductList__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Ella__ = __webpack_require__(152);
var _templateObject=_taggedTemplateLiteral(['\n  display: flex;\n'],['\n  display: flex;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject);var Demo=function Demo(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ProductList__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Ella__["a" /* default */],null));};/* harmony default export */ __webpack_exports__["a"] = (Demo);

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_collapsible__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_collapsible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_collapsible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__all_products_json__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__all_products_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__all_products_json__);
var _templateObject=_taggedTemplateLiteral(['\n  display: flex;\n  width: 65vw;\n  flex-wrap: wrap;\n  overflow: auto;\n  max-height: 100vh;\n'],['\n  display: flex;\n  width: 65vw;\n  flex-wrap: wrap;\n  overflow: auto;\n  max-height: 100vh;\n']),_templateObject2=_taggedTemplateLiteral(['\n  padding: 3em;\n  width: calc(50% - 2em);\n  margin: 1em;\n  box-sizing: border-box;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n  transition: 0.3s;\n  border-radius: 5px;\n\n  &:hover {\n    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);\n  }\n'],['\n  padding: 3em;\n  width: calc(50% - 2em);\n  margin: 1em;\n  box-sizing: border-box;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n  transition: 0.3s;\n  border-radius: 5px;\n\n  &:hover {\n    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  font-size: 25px;\n'],['\n  font-size: 25px;\n']),_templateObject4=_taggedTemplateLiteral(['\n  color: ',';\n  cursor: pointer;\n  display: inline-block;\n  border: 1px solid ',';\n  padding: 0.5em;\n  border-radius: 5px;\n  margin: 0.5em 0;\n'],['\n  color: ',';\n  cursor: pointer;\n  display: inline-block;\n  border: 1px solid ',';\n  padding: 0.5em;\n  border-radius: 5px;\n  margin: 0.5em 0;\n']),_templateObject5=_taggedTemplateLiteral(['\n  list-style: none;\n  padding-left: 0;\n'],['\n  list-style: none;\n  padding-left: 0;\n']),_templateObject6=_taggedTemplateLiteral(['\n  float: right;\n'],['\n  float: right;\n']),_templateObject7=_taggedTemplateLiteral(['\n  width: 100%;\n'],['\n  width: 100%;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ProductList=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject);var Product=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject2);var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].h2(_templateObject3);var BlockTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].h3(_templateObject4,function(props){return props.color;},function(props){return props.color;});var BlockList=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].ul(_templateObject5);var ListValue=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject6);var Image=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].img(_templateObject7);var renderProducts=function renderProducts(){var templateBlocks=__WEBPACK_IMPORTED_MODULE_3__all_products_json___default.a.included.filter(function(bit){return bit.type==='knowledge-template-blocks';});var productBits=__WEBPACK_IMPORTED_MODULE_3__all_products_json___default.a.included.filter(function(bit){return bit.type==='knowledge-bits';});return __WEBPACK_IMPORTED_MODULE_3__all_products_json___default.a.data.map(function(product){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Product,{key:product.resourceId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,null,product.name.en),templateBlocks.map(function(block){var knowledgeBitIDsForProductBlock=product.content.filter(function(bit){return bit.knowledgeTemplateBlockId===block.resourceId;});if(knowledgeBitIDsForProductBlock.length===0){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_collapsible___default.a,{key:block.resourceId,trigger:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BlockTitle,{color:block.color},block.name.en)},knowledgeBitIDsForProductBlock.map(function(bit){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BlockList,{key:bit.knowledgeBitId},productBits.filter(function(ExBit){return ExBit.resourceId===bit.knowledgeBitId;}).map(function(ExBit){if(!ExBit.content){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Not found');}if(ExBit.content.url){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:ExBit.resourceId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Image,{src:ExBit.content.secure_url,alt:''}));}if(ExBit.content.label){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:ExBit.resourceId},ExBit.content.label&&ExBit.content.label.en,':\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListValue,null,ExBit.content.name.en,'\xA0',ExBit.content.unit&&ExBit.content.unit.en));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:ExBit.resourceId},ExBit.content.name.en);}));}));}));});};var ProductListComponent=function ProductListComponent(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductList,null,renderProducts());};/* harmony default export */ __webpack_exports__["a"] = (ProductListComponent);

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Collapsible = function (_Component) {
  _inherits(Collapsible, _Component);

  function Collapsible(props) {
    _classCallCheck(this, Collapsible);

    // Bind class methods
    var _this = _possibleConstructorReturn(this, (Collapsible.__proto__ || Object.getPrototypeOf(Collapsible)).call(this, props));

    _this.handleTriggerClick = _this.handleTriggerClick.bind(_this);
    _this.handleTransitionEnd = _this.handleTransitionEnd.bind(_this);
    _this.continueOpenCollapsible = _this.continueOpenCollapsible.bind(_this);

    // Defaults the dropdown to be closed
    if (props.open) {
      _this.state = {
        isClosed: false,
        shouldSwitchAutoOnNextCycle: false,
        height: 'auto',
        transition: 'none',
        hasBeenOpened: true,
        overflow: props.overflowWhenOpen,
        inTransition: false
      };
    } else {
      _this.state = {
        isClosed: true,
        shouldSwitchAutoOnNextCycle: false,
        height: 0,
        transition: 'height ' + props.transitionTime + 'ms ' + props.easing,
        hasBeenOpened: false,
        overflow: 'hidden',
        inTransition: false
      };
    }
    return _this;
  }

  _createClass(Collapsible, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      if (this.state.shouldOpenOnNextCycle) {
        this.continueOpenCollapsible();
      }

      if (prevState.height === 'auto' && this.state.shouldSwitchAutoOnNextCycle === true) {
        window.setTimeout(function () {
          // Set small timeout to ensure a true re-render
          _this2.setState({
            height: 0,
            overflow: 'hidden',
            isClosed: true,
            shouldSwitchAutoOnNextCycle: false
          });
        }, 50);
      }

      // If there has been a change in the open prop (controlled by accordion)
      if (prevProps.open !== this.props.open) {
        if (this.props.open === true) {
          this.openCollapsible();
          this.props.onOpening();
        } else {
          this.closeCollapsible();
          this.props.onClosing();
        }
      }
    }
  }, {
    key: 'closeCollapsible',
    value: function closeCollapsible() {
      this.setState({
        shouldSwitchAutoOnNextCycle: true,
        height: this.refs.inner.offsetHeight,
        transition: 'height ' + (this.props.transitionCloseTime ? this.props.transitionCloseTime : this.props.transitionTime) + 'ms ' + this.props.easing,
        inTransition: true
      });
    }
  }, {
    key: 'openCollapsible',
    value: function openCollapsible() {
      this.setState({
        inTransition: true,
        shouldOpenOnNextCycle: true
      });
    }
  }, {
    key: 'continueOpenCollapsible',
    value: function continueOpenCollapsible() {
      this.setState({
        height: this.refs.inner.offsetHeight,
        transition: 'height ' + this.props.transitionTime + 'ms ' + this.props.easing,
        isClosed: false,
        hasBeenOpened: true,
        inTransition: true,
        shouldOpenOnNextCycle: false
      });
    }
  }, {
    key: 'handleTriggerClick',
    value: function handleTriggerClick(event) {
      event.preventDefault();

      if (this.props.triggerDisabled) {
        return;
      }

      if (this.props.handleTriggerClick) {
        this.props.handleTriggerClick(this.props.accordionPosition);
      } else {
        if (this.state.isClosed === true) {
          this.openCollapsible();
          this.props.onOpening();
        } else {
          this.closeCollapsible();
          this.props.onClosing();
        }
      }
    }
  }, {
    key: 'renderNonClickableTriggerElement',
    value: function renderNonClickableTriggerElement() {
      if (this.props.triggerSibling && typeof this.props.triggerSibling === 'string') {
        return _react2.default.createElement(
          'span',
          { className: this.props.classParentString + '__trigger-sibling' },
          this.props.triggerSibling
        );
      } else if (this.props.triggerSibling) {
        return _react2.default.createElement(this.props.triggerSibling, null);
      }

      return null;
    }
  }, {
    key: 'handleTransitionEnd',
    value: function handleTransitionEnd() {
      // Switch to height auto to make the container responsive
      if (!this.state.isClosed) {
        this.setState({ height: 'auto', overflow: this.props.overflowWhenOpen, inTransition: false });
        this.props.onOpen();
      } else {
        this.setState({ inTransition: false });
        this.props.onClose();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var dropdownStyle = {
        height: this.state.height,
        WebkitTransition: this.state.transition,
        msTransition: this.state.transition,
        transition: this.state.transition,
        overflow: this.state.overflow
      };

      var openClass = this.state.isClosed ? 'is-closed' : 'is-open';
      var disabledClass = this.props.triggerDisabled ? 'is-disabled' : '';

      //If user wants different text when tray is open
      var trigger = this.state.isClosed === false && this.props.triggerWhenOpen !== undefined ? this.props.triggerWhenOpen : this.props.trigger;

      // If user wants a trigger wrapping element different than 'span'
      var TriggerElement = this.props.triggerTagName;

      // Don't render children until the first opening of the Collapsible if lazy rendering is enabled
      var children = this.props.lazyRender && !this.state.hasBeenOpened && this.state.isClosed && !this.state.inTransition ? null : this.props.children;

      // Construct CSS classes strings
      var triggerClassString = this.props.classParentString + '__trigger ' + openClass + ' ' + disabledClass + ' ' + (this.state.isClosed ? this.props.triggerClassName : this.props.triggerOpenedClassName);
      var parentClassString = this.props.classParentString + ' ' + (this.state.isClosed ? this.props.className : this.props.openedClassName);
      var outerClassString = this.props.classParentString + '__contentOuter ' + this.props.contentOuterClassName;
      var innerClassString = this.props.classParentString + '__contentInner ' + this.props.contentInnerClassName;

      return _react2.default.createElement(
        'div',
        { className: parentClassString.trim() },
        _react2.default.createElement(
          TriggerElement,
          {
            className: triggerClassString.trim(),
            onClick: this.handleTriggerClick,
            style: this.props.triggerStyle && this.props.triggerStyle,
            onKeyPress: function onKeyPress(event) {
              var key = event.key;

              if (key === ' ' || key === 'Enter') {
                _this3.handleTriggerClick(event);
              }
            },
            tabIndex: this.props.tabIndex && this.props.tabIndex
          },
          trigger
        ),
        this.renderNonClickableTriggerElement(),
        _react2.default.createElement(
          'div',
          {
            className: outerClassString.trim(),
            ref: 'outer',
            style: dropdownStyle,
            onTransitionEnd: this.handleTransitionEnd
          },
          _react2.default.createElement(
            'div',
            {
              className: innerClassString.trim(),
              ref: 'inner'
            },
            children
          )
        )
      );
    }
  }]);

  return Collapsible;
}(_react.Component);

Collapsible.propTypes = {
  transitionTime: _propTypes2.default.number,
  transitionCloseTime: _propTypes2.default.number,
  triggerTagName: _propTypes2.default.string,
  easing: _propTypes2.default.string,
  open: _propTypes2.default.bool,
  classParentString: _propTypes2.default.string,
  openedClassName: _propTypes2.default.string,
  triggerStyle: _propTypes2.default.object,
  triggerClassName: _propTypes2.default.string,
  triggerOpenedClassName: _propTypes2.default.string,
  contentOuterClassName: _propTypes2.default.string,
  contentInnerClassName: _propTypes2.default.string,
  accordionPosition: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  handleTriggerClick: _propTypes2.default.func,
  onOpen: _propTypes2.default.func,
  onClose: _propTypes2.default.func,
  onOpening: _propTypes2.default.func,
  onClosing: _propTypes2.default.func,
  trigger: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  triggerWhenOpen: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  triggerDisabled: _propTypes2.default.bool,
  lazyRender: _propTypes2.default.bool,
  overflowWhenOpen: _propTypes2.default.oneOf(['hidden', 'visible', 'auto', 'scroll', 'inherit', 'initial', 'unset']),
  triggerSibling: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
  tabIndex: _propTypes2.default.number
};

Collapsible.defaultProps = {
  transitionTime: 400,
  transitionCloseTime: null,
  triggerTagName: 'span',
  easing: 'linear',
  open: false,
  classParentString: 'Collapsible',
  triggerDisabled: false,
  lazyRender: false,
  overflowWhenOpen: 'hidden',
  openedClassName: '',
  triggerStyle: null,
  triggerClassName: '',
  triggerOpenedClassName: '',
  contentOuterClassName: '',
  contentInnerClassName: '',
  className: '',
  triggerSibling: null,
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  onOpening: function onOpening() {},
  onClosing: function onClosing() {},
  tabIndex: null
};

exports.default = Collapsible;



/***/ }),
/* 151 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"total":21,"offset":0,"limit":25},"data":[{"name":{"en":"Gardena Powermax 42E"},"published":true,"knowledgeTemplateId":"5ac74e444473ec6212182859","content":[{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acb25de75345d32878e285d","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb247f665a1508542d6a93","knowledgeBitId":"5acb261b665a156f362d6b85","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb247f665a1508542d6a93","knowledgeBitId":"5acb262475345d0f1d8e28a8","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb247f665a1508542d6a93","knowledgeBitId":"5acb2627665a154f6c2d6b95","weight":2,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acb882275345d41d78e2ea6","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acb88e5665a15f0cc2d71c8","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acb8a1175345d7a4a8e2edd","weight":2,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acb8a8a665a150b0b2d71ed","weight":3,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acb8ae875345d7d908e2ef4","weight":4,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acb9006665a1517f72d7207","weight":5,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","knowledgeBitId":"5acb90d175345d59248e2f66","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acb92be665a1550922d72a2","weight":6,"relatedItems":[]}],"blocks":["5ac74e594473ec1377182869","5acb247f665a1508542d6a93","5acb26bc75345d482b8e2915","5acb906a665a154bae2d723a","5acc9cb7142c384a102eb92f","5acca273e1febae5e41fa5d1","5acca2fa142c38ffe62ebbda"],"type":"knowledge-sheets","resourceId":"5acb286975345d307a8e2a1e"},{"name":{"en":"Hawaï de luxe"},"published":true,"knowledgeTemplateId":"5ac74e444473ec6212182859","content":[{"knowledgeTemplateBlockId":"5acb247f665a1508542d6a93","knowledgeBitId":"5acb937275345d5cab8e2fb9","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","knowledgeBitId":"5acb9380665a1512d72d72cd","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acb93d875345d6d9b8e2fca","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acb9422665a1569102d72e2","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acb944a75345db7948e2fe7","weight":2,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acb9463665a1580a62d72fc","weight":3,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acb947575345d62d48e2ffc","weight":4,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acca5cb142c3839b82ebc8f","weight":5,"relatedItems":[]}],"blocks":["5ac74e594473ec1377182869","5acb247f665a1508542d6a93","5acb26bc75345d482b8e2915","5acb906a665a154bae2d723a","5acc9cb7142c384a102eb92f","5acca273e1febae5e41fa5d1","5acca2fa142c38ffe62ebbda"],"type":"knowledge-sheets","resourceId":"5acb9355665a1519a62d72bb"},{"name":{"en":"Roundup Extra"},"published":true,"knowledgeTemplateId":"5ac74e444473ec6212182859","content":[{"knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","knowledgeBitId":"5acca079142c3812232ebb3a","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acca0e8e1feba340b1fa56d","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acca114142c381f0f2ebb53","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acca180e1feba3a591fa5ab","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","knowledgeBitId":"5acca3e5142c3873932ebc25","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","knowledgeBitId":"5acca418e1feba68f21fa660","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","knowledgeBitId":"5acca43e142c38f8af2ebc4d","weight":2,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","knowledgeBitId":"5acca481e1feba1d971fa686","weight":3,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","knowledgeBitId":"5acca4ba142c38cbe12ebc5d","weight":4,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acca52ee1febac6a51fa6af","weight":2,"relatedItems":[]}],"blocks":["5ac74e594473ec1377182869","5acb247f665a1508542d6a93","5acb26bc75345d482b8e2915","5acb906a665a154bae2d723a","5acc9cb7142c384a102eb92f","5acca273e1febae5e41fa5d1","5acca2fa142c38ffe62ebbda"],"type":"knowledge-sheets","resourceId":"5acca062142c3805ef2ebb2e"},{"name":{"en":"C-Cube Stone Grey 240/30"},"published":true,"knowledgeTemplateId":"5ac74e444473ec6212182859","content":[{"knowledgeTemplateBlockId":"5acb247f665a1508542d6a93","knowledgeBitId":"5accb873ee2ecd28f366672e","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5accb8c7ee2ecda6fb666765","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5accb88b2e1f2fc4e87431a9","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5accb8edee2ecd0bc166677b","weight":2,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5accb8f92e1f2f6cbf7431f1","weight":3,"relatedItems":[]},{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5accb944ee2ecd4cb56667d8","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5accb94f2e1f2f62ca74324b","weight":2,"relatedItems":[]},{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5accb959ee2ecd47eb6667ef","weight":3,"relatedItems":[]},{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5accb98c2e1f2f72c374326a","weight":4,"relatedItems":[]},{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5accb99cee2ecd4ae266680a","weight":5,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","knowledgeBitId":"5accb9bf2e1f2f4c47743279","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","knowledgeBitId":"5accb9c5ee2ecd5c85666817","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5accb9ef2e1f2f47f0743297","weight":0,"relatedItems":[]}],"blocks":["5ac74e594473ec1377182869","5acb247f665a1508542d6a93","5acb26bc75345d482b8e2915","5acb906a665a154bae2d723a","5acc9cb7142c384a102eb92f","5acca273e1febae5e41fa5d1","5acca2fa142c38ffe62ebbda"],"type":"knowledge-sheets","resourceId":"5accb8632e1f2f7a3674318c"},{"name":{"en":"Pedigree Markies Original"},"published":true,"knowledgeTemplateId":"5ac74e444473ec6212182859","content":[{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5accba54ee2ecd1655666877","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5accbac02e1f2fbb8f743304","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5accbadaee2ecd74116668b3","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5accbb072e1f2f5c43743329","weight":3,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5accbb29ee2ecd1c376668da","weight":2,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","knowledgeBitId":"5accbb3c2e1f2f2e41743340","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","knowledgeBitId":"5accbb69ee2ecd0e136668e9","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","knowledgeBitId":"5accbb7c2e1f2fca7c743350","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5accbbbdee2ecd6a2e666909","weight":4,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5accbbf82e1f2f00cf743382","weight":5,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5accbc72ee2ecdeddf666940","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5accbcbf2e1f2f59ad7433d6","weight":6,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5accbce7ee2ecd40c3666988","weight":7,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5accbd332e1f2f37967433fa","weight":8,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","knowledgeBitId":"5accbd7dee2ecd0a586669cd","weight":2,"relatedItems":[]}],"blocks":["5ac74e594473ec1377182869","5acb247f665a1508542d6a93","5acb26bc75345d482b8e2915","5acb906a665a154bae2d723a","5acc9cb7142c384a102eb92f","5acca273e1febae5e41fa5d1","5acca2fa142c38ffe62ebbda"],"type":"knowledge-sheets","resourceId":"5accba40ee2ecdf4d1666869"},{"name":{"en":"AVEVE Crumble"},"published":true,"knowledgeTemplateId":"5ac74e444473ec6212182859","content":[{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5accbe912e1f2f49a9743446","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5accbeb3ee2ecde7a56669ec","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5accbecb2e1f2fbc9e743458","weight":2,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5accbc72ee2ecdeddf666940","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5accbf232e1f2f32d874347d","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","knowledgeBitId":"5accbf43ee2ecd41f0666a21","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","knowledgeBitId":"5accbf5f2e1f2f795974348f","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","knowledgeBitId":"5accbf75ee2ecd7443666a2f","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5accc0e82e1f2f6d8d7434a2","weight":3,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5accc123ee2ecd2423666a47","weight":4,"relatedItems":[]}],"blocks":["5ac74e594473ec1377182869","5acb247f665a1508542d6a93","5acb26bc75345d482b8e2915","5acb906a665a154bae2d723a","5acc9cb7142c384a102eb92f","5acca273e1febae5e41fa5d1","5acca2fa142c38ffe62ebbda"],"type":"knowledge-sheets","resourceId":"5accbe7e2e1f2f19b974343a"},{"name":{"en":"Birchmeier Granomax 5"},"published":true,"knowledgeTemplateId":"5ac74e444473ec6212182859","content":[{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdb765ee2ecd0ec3666de7","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdb8582e1f2f2d0e743855","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","knowledgeBitId":"5acdb877ee2ecd075f666df9","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","knowledgeBitId":"5acdb8882e1f2fc65e743864","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","knowledgeBitId":"5acdb8a5ee2ecda80d666e09","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","knowledgeBitId":"5acdb8ac2e1f2f49d9743874","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdb92aee2ecd4e7e666e67","weight":1,"relatedItems":[]}],"blocks":["5ac74e594473ec1377182869","5acb247f665a1508542d6a93","5acb26bc75345d482b8e2915","5acb906a665a154bae2d723a","5acc9cb7142c384a102eb92f","5acca273e1febae5e41fa5d1","5acca2fa142c38ffe62ebbda"],"type":"knowledge-sheets","resourceId":"5acdb652ee2ecd7db4666d01"},{"name":{"en":"Barbecook Vuurkorf classic squadra"},"published":true,"knowledgeTemplateId":"5ac74e444473ec6212182859","content":[{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdb99f2e1f2f545e7438de","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdb9c7ee2ecd488d666e8d","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdb9da2e1f2f01e57438f4","weight":2,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb247f665a1508542d6a93","knowledgeBitId":"5acb937275345d5cab8e2fb9","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdba422e1f2f4129743907","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","knowledgeBitId":"5acdbaafee2ecdafe0666eab","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdbda02e1f2fff2c743999","weight":1,"relatedItems":[]}],"blocks":["5ac74e594473ec1377182869","5acb247f665a1508542d6a93","5acb26bc75345d482b8e2915","5acb906a665a154bae2d723a","5acc9cb7142c384a102eb92f","5acca273e1febae5e41fa5d1","5acca2fa142c38ffe62ebbda"],"type":"knowledge-sheets","resourceId":"5acdb9832e1f2f15f17438d1"},{"name":{"en":"Blackfox Leaf Scraper Scoop"},"published":true,"knowledgeTemplateId":"5ac74e444473ec6212182859","content":[{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdbe71ee2ecd7051666f4a","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","knowledgeBitId":"5acdbed52e1f2f7f2d7439b4","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdbf5cee2ecd39eb666fad","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdbf712e1f2f22ca743a13","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb247f665a1508542d6a93","knowledgeBitId":"5acb937275345d5cab8e2fb9","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","knowledgeBitId":"5acdc1f22e1f2fbe15743a23","weight":0,"relatedItems":[]}],"blocks":["5ac74e594473ec1377182869","5acb247f665a1508542d6a93","5acb26bc75345d482b8e2915","5acb906a665a154bae2d723a","5acc9cb7142c384a102eb92f","5acca273e1febae5e41fa5d1","5acca2fa142c38ffe62ebbda"],"type":"knowledge-sheets","resourceId":"5acdbe60ee2ecd5c30666f3d"},{"name":{"en":"AVEVE Kweek"},"published":true,"knowledgeTemplateId":"5ac74e444473ec6212182859","content":[{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdc2cfee2ecd6bd3666fd7","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdc2ee2e1f2f51c2743a4c","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdc30fee2ecd7039666ffd","weight":2,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdc3292e1f2f287e743a6f","weight":3,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","knowledgeBitId":"5acdc342ee2ecdc379667015","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","knowledgeBitId":"5acdc3572e1f2f58cb743a7f","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdc36eee2ecd1a1d667028","weight":5,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdc3862e1f2fe81d743a98","weight":6,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","knowledgeBitId":"5acdc3c8ee2ecd744b66704b","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","knowledgeBitId":"5acdc3cd2e1f2f54e8743ab4","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdc40bee2ecdafd5667076","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5accbc72ee2ecdeddf666940","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdc44eee2ecd7f806670b7","weight":4,"relatedItems":[]}],"blocks":["5ac74e594473ec1377182869","5acb247f665a1508542d6a93","5acb26bc75345d482b8e2915","5acb906a665a154bae2d723a","5acc9cb7142c384a102eb92f","5acca273e1febae5e41fa5d1","5acca2fa142c38ffe62ebbda"],"type":"knowledge-sheets","resourceId":"5acdc2b62e1f2ffdf8743a30"},{"name":{"en":"Hondendiner"},"published":true,"knowledgeTemplateId":"5ac74e444473ec6212182859","content":[{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdc6802e1f2f3e8b743b34","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdc68cee2ecd57786670e8","weight":2,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdc69c2e1f2fd6b2743b4c","weight":3,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdc6adee2ecd21bc667101","weight":4,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","knowledgeBitId":"5acdc6c92e1f2f1ba4743b5f","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","knowledgeBitId":"5acdc6d9ee2ecd9833667110","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5accbc72ee2ecdeddf666940","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdc6fdee2ecdc645667129","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdc7162e1f2f1659743b88","weight":5,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdc733ee2ecd91f1667144","weight":6,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdc74b2e1f2f46ff743ba6","weight":7,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","knowledgeBitId":"5acdc762ee2ecd2911667158","weight":2,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","knowledgeBitId":"5acdc77e2e1f2fbd61743bb5","weight":0,"relatedItems":[]}],"blocks":["5ac74e594473ec1377182869","5acb247f665a1508542d6a93","5acb26bc75345d482b8e2915","5acb906a665a154bae2d723a","5acc9cb7142c384a102eb92f","5acca273e1febae5e41fa5d1","5acca2fa142c38ffe62ebbda"],"type":"knowledge-sheets","resourceId":"5acdc66bee2ecd085d6670d3"},{"name":{"en":"KB Home Defense Mier lokdoos F"},"published":true,"knowledgeTemplateId":"5ac74e444473ec6212182859","content":[{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdc8d8ee2ecd00d2667182","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdc8ea2e1f2f3614743bde","weight":2,"relatedItems":[]},{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdc93bee2ecd3acc6671aa","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","knowledgeBitId":"5acdc9522e1f2ff9c0743c07","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","knowledgeBitId":"5acdc96aee2ecde1036671bd","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdc9862e1f2f4907743c1c","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","knowledgeBitId":"5acdca26ee2ecd2a536671d0","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdca4c2e1f2fbed9743c2f","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdca5eee2ecd0cb96671e8","weight":2,"relatedItems":[]}],"blocks":["5ac74e594473ec1377182869","5acb247f665a1508542d6a93","5acb26bc75345d482b8e2915","5acb906a665a154bae2d723a","5acc9cb7142c384a102eb92f","5acca273e1febae5e41fa5d1","5acca2fa142c38ffe62ebbda"],"type":"knowledge-sheets","resourceId":"5acdc8c22e1f2f6972743bce"},{"name":{"en":"DCM Fertilizer Potatoes"},"published":true,"knowledgeTemplateId":"5ac74e444473ec6212182859","content":[{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdcb122e1f2f61df743cc2","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdcb28ee2ecd75c4667278","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdcb3f2e1f2fce44743cd8","weight":2,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdcb58ee2ecda92d667291","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdcb6a2e1f2f8138743cee","weight":2,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdcb7cee2ecd0a386672a8","weight":3,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","knowledgeBitId":"5acdcb8a2e1f2f4036743d05","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","knowledgeBitId":"5acdcba0ee2ecd06f96672b9","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdcbd42e1f2f96ec743d35","weight":0,"relatedItems":[]}],"blocks":["5ac74e594473ec1377182869","5acb247f665a1508542d6a93","5acb26bc75345d482b8e2915","5acb906a665a154bae2d723a","5acc9cb7142c384a102eb92f","5acca273e1febae5e41fa5d1","5acca2fa142c38ffe62ebbda"],"type":"knowledge-sheets","resourceId":"5acdcafeee2ecdabf8667262"},{"name":{"en":"Orchid potting soil"},"published":true,"knowledgeTemplateId":"5ac74e444473ec6212182859","content":[{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdd0efee2ecd59c26672fd","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdd1002e1f2f26d7743d59","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdd11aee2ecd431f66730e","weight":2,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","knowledgeBitId":"5acdd1342e1f2f0dd9743d6a","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdd13fee2ecd2dd5667323","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","knowledgeBitId":"5acdd1702e1f2f40fb743d88","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdd1b0ee2ecd406c667344","weight":2,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdd1c42e1f2f345b743da3","weight":3,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdd1f3ee2ecd8332667368","weight":0,"relatedItems":[]}],"blocks":["5ac74e594473ec1377182869","5acb247f665a1508542d6a93","5acb26bc75345d482b8e2915","5acb906a665a154bae2d723a","5acc9cb7142c384a102eb92f","5acca273e1febae5e41fa5d1","5acca2fa142c38ffe62ebbda"],"type":"knowledge-sheets","resourceId":"5acdd0ce2e1f2f7e56743d47"},{"name":{"en":"AVEVE Zonnebloem Distino Mix"},"published":true,"knowledgeTemplateId":"5ac74e444473ec6212182859","content":[{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdd24f2e1f2f6881743dd0","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdd262ee2ecd77a766738d","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","knowledgeBitId":"5acdd2812e1f2ffb9e743de2","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdd2b1ee2ecd73bd6673a7","weight":2,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdd2e22e1f2f44ab743e08","weight":3,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdd2f6ee2ecd520c6673c8","weight":4,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","knowledgeBitId":"5acdd30d2e1f2f6460743e1c","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdd318ee2ecd75c26673df","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca2fa142c38ffe62ebbda","knowledgeBitId":"5acdd5c12e1f2f06b9743fc2","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca2fa142c38ffe62ebbda","knowledgeBitId":"5acdd5e92e1f2f8df274400f","weight":1,"relatedItems":[]}],"blocks":["5ac74e594473ec1377182869","5acb247f665a1508542d6a93","5acb26bc75345d482b8e2915","5acb906a665a154bae2d723a","5acc9cb7142c384a102eb92f","5acca273e1febae5e41fa5d1","5acca2fa142c38ffe62ebbda"],"type":"knowledge-sheets","resourceId":"5acdd248ee2ecd4151667378"},{"name":{"en":"Marigold Fiesta Gitana Mix"},"published":true,"knowledgeTemplateId":"5ac74e444473ec6212182859","content":[{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdd36d2e1f2f832b743e4b","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdd318ee2ecd75c26673df","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdd38f2e1f2fcc34743e63","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","knowledgeBitId":"5acdd3a2ee2ecdd61a667418","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdd3ba2e1f2f2ffd743e7b","weight":2,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdd3e9ee2ecddd9a667454","weight":3,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdd3f52e1f2f25e1743eb5","weight":4,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","knowledgeBitId":"5acdd40cee2ecd6e17667466","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca2fa142c38ffe62ebbda","knowledgeBitId":"5acdd4242e1f2f07a6743edc","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca2fa142c38ffe62ebbda","knowledgeBitId":"5acdd5e92e1f2f8df274400f","weight":1,"relatedItems":[]}],"blocks":["5ac74e594473ec1377182869","5acb247f665a1508542d6a93","5acb26bc75345d482b8e2915","5acb906a665a154bae2d723a","5acc9cb7142c384a102eb92f","5acca273e1febae5e41fa5d1","5acca2fa142c38ffe62ebbda"],"type":"knowledge-sheets","resourceId":"5acdd35d2e1f2f90a5743e3d"},{"name":{"en":"AVEVE Gilia Tricolor Bird’s eyes"},"published":true,"knowledgeTemplateId":"5ac74e444473ec6212182859","content":[{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdd4cbee2ecd2a436674b7","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdd4dd2e1f2fcb4f743f12","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdd318ee2ecd75c26673df","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","knowledgeBitId":"5acdd5062e1f2f60c1743f30","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdd521ee2ecd30ec6674ff","weight":2,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdd53c2e1f2f29fd743f64","weight":3,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdd572ee2ecd72aa667521","weight":4,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","knowledgeBitId":"5acdd5862e1f2fa549743f7f","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca2fa142c38ffe62ebbda","knowledgeBitId":"5acdd4242e1f2f07a6743edc","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca2fa142c38ffe62ebbda","knowledgeBitId":"5acdd5c12e1f2f06b9743fc2","weight":1,"relatedItems":[]}],"blocks":["5ac74e594473ec1377182869","5acb247f665a1508542d6a93","5acb26bc75345d482b8e2915","5acb906a665a154bae2d723a","5acc9cb7142c384a102eb92f","5acca273e1febae5e41fa5d1","5acca2fa142c38ffe62ebbda"],"type":"knowledge-sheets","resourceId":"5acdd4bdee2ecd49cf6674a9"},{"name":{"en":"Gardena Comfort wandslangenbox 15 roll-up automatic"},"published":true,"knowledgeTemplateId":"5ac74e444473ec6212182859","content":[{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdd67f2e1f2febcc744053","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdd68dee2ecdf4df6675fb","weight":2,"relatedItems":[]},{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdd6982e1f2f0019744062","weight":3,"relatedItems":[]},{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdd6a6ee2ecdc42b66760a","weight":4,"relatedItems":[]},{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdd6bf2e1f2f59ad744074","weight":5,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","knowledgeBitId":"5acdd6e8ee2ecd4e2e66761e","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","knowledgeBitId":"5acdd7022e1f2f266b744083","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdd735ee2ecdf9bb66762e","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdd7c12e1f2f7a0574409b","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdd7caee2ecd1f50667648","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","knowledgeBitId":"5acdd7fc2e1f2f84127440ae","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acc9cb7142c384a102eb92f","knowledgeBitId":"5acdd95eee2ecd2b9b6676a5","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca2fa142c38ffe62ebbda","knowledgeBitId":"5acddae32e1f2f5057744197","weight":0,"relatedItems":[]}],"blocks":["5ac74e594473ec1377182869","5acb247f665a1508542d6a93","5acb26bc75345d482b8e2915","5acb906a665a154bae2d723a","5acc9cb7142c384a102eb92f","5acca273e1febae5e41fa5d1","5acca2fa142c38ffe62ebbda"],"type":"knowledge-sheets","resourceId":"5acdd6582e1f2f8efd744043"},{"name":{"en":"Gardena Premium hose piece 15 - 19 mm"},"published":true,"knowledgeTemplateId":"5ac74e444473ec6212182859","content":[{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdd8e8ee2ecd5ed666766c","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdd8f52e1f2f874c7440ce","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdd907ee2ecd56fe66767b","weight":2,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdd91a2e1f2f6a8b7440df","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdd7c12e1f2f7a0574409b","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","knowledgeBitId":"5acdd93f2e1f2fba8e7440f0","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdd9a92e1f2f4753744115","weight":3,"relatedItems":[]}],"blocks":["5ac74e594473ec1377182869","5acb247f665a1508542d6a93","5acb26bc75345d482b8e2915","5acb906a665a154bae2d723a","5acc9cb7142c384a102eb92f","5acca273e1febae5e41fa5d1","5acca2fa142c38ffe62ebbda"],"type":"knowledge-sheets","resourceId":"5acdd895ee2ecd03d866765e"},{"name":{"en":"Gardena Classic hose car 50 Complete 8013-20"},"published":true,"knowledgeTemplateId":"5ac74e444473ec6212182859","content":[{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdd9e4ee2ecd34616676cb","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdd9f02e1f2f5588744137","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdd9fbee2ecd4f316676da","weight":2,"relatedItems":[]},{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acdda0a2e1f2fd630744147","weight":3,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdd7c12e1f2f7a0574409b","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdda852e1f2f7e7374415b","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acc9cb7142c384a102eb92f","knowledgeBitId":"5acdd95eee2ecd2b9b6676a5","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","knowledgeBitId":"5acddabd2e1f2f2bd2744169","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca2fa142c38ffe62ebbda","knowledgeBitId":"5acddad5ee2ecda2d7667719","weight":0,"relatedItems":[]}],"blocks":["5ac74e594473ec1377182869","5acb247f665a1508542d6a93","5acb26bc75345d482b8e2915","5acb906a665a154bae2d723a","5acc9cb7142c384a102eb92f","5acca273e1febae5e41fa5d1","5acca2fa142c38ffe62ebbda"],"type":"knowledge-sheets","resourceId":"5acdd9d22e1f2fae34744123"},{"name":{"en":"Ecorub Rubber drift 5 m"},"published":true,"knowledgeTemplateId":"5ac74e444473ec6212182859","content":[{"knowledgeTemplateBlockId":"5ac74e594473ec1377182869","knowledgeBitId":"5acddbb0ee2ecd43b566774c","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb247f665a1508542d6a93","knowledgeBitId":"5acb937275345d5cab8e2fb9","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acddd97ee2ecd0f95667773","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdddaa2e1f2f0efc7441e3","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdddd3ee2ecd596366778a","weight":2,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acddde72e1f2f17647441fb","weight":3,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","knowledgeBitId":"5acdddf9ee2ecd24f46677a1","weight":4,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","knowledgeBitId":"5acddf51ee2ecd77dc6677ae","weight":0,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","knowledgeBitId":"5acddf582e1f2f4c82744219","weight":1,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","knowledgeBitId":"5acddf60ee2ecd41e16677ba","weight":2,"relatedItems":[]},{"knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","knowledgeBitId":"5acde0002e1f2f09cb74422b","weight":0,"relatedItems":[]}],"blocks":["5ac74e594473ec1377182869","5acb247f665a1508542d6a93","5acb26bc75345d482b8e2915","5acb906a665a154bae2d723a","5acc9cb7142c384a102eb92f","5acca273e1febae5e41fa5d1","5acca2fa142c38ffe62ebbda"],"type":"knowledge-sheets","resourceId":"5acddb57ee2ecd3f8666773e"}],"included":[{"name":{"en":"Description"},"description":{"en":""},"knowledgeTemplateId":"5ac74e444473ec6212182859","knowledgeSetId":"5ac5c0e27336def598b7c395","active":true,"kBitGroupRoles":[{"roleId":"59f74757c93d9d0012bd1211","userGroupId":"5ac5c0b3482a01ea5fd9a302"},{"roleId":"59f74757ac159c001284a128","userGroupId":"5ac5c0b3482a01ea5fd9a302"},{"roleId":"59f74758ac159c001284a12a","userGroupId":"5ac5c0b3482a01ea5fd9a302"},{"roleId":"59f74759c93d9d0012bd1213","userGroupId":"5ac5c0b3482a01ea5fd9a302"}],"weight":0,"bitTypeSettings":{"59f74759c93d9d0012bd1216":{"MIN_LENGTH":5,"MAX_LENGTH":500,"ALLOW_ALFA_CHARS":true,"ALLOW_NUM_CHARS":true,"ALLOW_SPECIAL_CHARS":true,"SHOW_SUGGESTIONS":false,"ST_ENABLE_LABEL":false,"ST_LABEL_ENTRY_TYPE":"ST_ENTRY_TYPE_FREE","ST_ENABLE_UNIT":false,"ST_UNIT_ENTRY_TYPE":"ST_ENTRY_TYPE_FREE","ST_ENABLE_DESCRIPTION":false}},"canRelateTo":[],"color":"#2190C6","createdAt":"2018-04-06T10:39:21.117Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:16:38.746Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-template-blocks","resourceId":"5ac74e594473ec1377182869"},{"name":{"en":"Colors"},"description":{"en":""},"knowledgeTemplateId":"5ac74e444473ec6212182859","knowledgeSetId":"5ac5c0e27336def598b7c395","active":true,"kBitGroupRoles":[{"userGroupId":"5ac5c0b3482a01ea5fd9a302","roleId":"59f74757c93d9d0012bd1211"},{"userGroupId":"5ac5c0b3482a01ea5fd9a302","roleId":"59f74757ac159c001284a128"},{"userGroupId":"5ac5c0b3482a01ea5fd9a302","roleId":"59f74758ac159c001284a12a"},{"userGroupId":"5ac5c0b3482a01ea5fd9a302","roleId":"59f74759c93d9d0012bd1213"}],"weight":1,"bitTypeSettings":{"59f74759c93d9d0012bd1216":{"MIN_LENGTH":0,"MAX_LENGTH":0,"ALLOW_ALFA_CHARS":true,"ALLOW_NUM_CHARS":true,"ALLOW_SPECIAL_CHARS":true,"SHOW_SUGGESTIONS":false,"ST_ENABLE_LABEL":false,"ST_LABEL_ENTRY_TYPE":"ST_ENTRY_TYPE_FREE","ST_ENABLE_UNIT":false,"ST_UNIT_ENTRY_TYPE":"ST_ENTRY_TYPE_FREE","ST_ENABLE_DESCRIPTION":false}},"canRelateTo":[],"color":"#fcb900","createdAt":"2018-04-09T08:29:51.843Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T11:18:14.632Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-template-blocks","resourceId":"5acb247f665a1508542d6a93"},{"name":{"en":"Properties"},"description":{"en":""},"knowledgeTemplateId":"5ac74e444473ec6212182859","knowledgeSetId":"5ac5c0e27336def598b7c395","active":true,"kBitGroupRoles":[{"userGroupId":"5ac5c0b3482a01ea5fd9a302","roleId":"59f74757c93d9d0012bd1211"},{"userGroupId":"5ac5c0b3482a01ea5fd9a302","roleId":"59f74757ac159c001284a128"},{"userGroupId":"5ac5c0b3482a01ea5fd9a302","roleId":"59f74758ac159c001284a12a"},{"userGroupId":"5ac5c0b3482a01ea5fd9a302","roleId":"59f74759c93d9d0012bd1213"}],"weight":2,"bitTypeSettings":{"59f74759c93d9d0012bd1216":{"MIN_LENGTH":0,"MAX_LENGTH":0,"ALLOW_ALFA_CHARS":true,"ALLOW_NUM_CHARS":true,"ALLOW_SPECIAL_CHARS":true,"SHOW_SUGGESTIONS":false,"ST_ENABLE_LABEL":true,"ST_LABEL_ENTRY_TYPE":"ST_ENTRY_TYPE_FREE","ST_ENABLE_UNIT":true,"ST_UNIT_ENTRY_TYPE":"ST_ENTRY_TYPE_FREE","ST_ENABLE_DESCRIPTION":false}},"canRelateTo":[],"color":"#00d084","createdAt":"2018-04-09T08:39:24.650Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T11:18:22.091Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-template-blocks","resourceId":"5acb26bc75345d482b8e2915"},{"name":{"en":"Images"},"description":{"en":""},"knowledgeTemplateId":"5ac74e444473ec6212182859","knowledgeSetId":"5ac5c0e27336def598b7c395","active":true,"kBitGroupRoles":[{"userGroupId":"5ac5c0b3482a01ea5fd9a302","roleId":"59f74757c93d9d0012bd1211"},{"userGroupId":"5ac5c0b3482a01ea5fd9a302","roleId":"59f74757ac159c001284a128"},{"userGroupId":"5ac5c0b3482a01ea5fd9a302","roleId":"59f74758ac159c001284a12a"},{"userGroupId":"5ac5c0b3482a01ea5fd9a302","roleId":"59f74759c93d9d0012bd1213"}],"weight":3,"bitTypeSettings":{"59f7475aac159c001284a12c":{"SHOW_SUGGESTIONS":false}},"canRelateTo":[],"color":"#8ed1fc","createdAt":"2018-04-09T16:10:18.867Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-09T16:12:29.764Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-template-blocks","resourceId":"5acb906a665a154bae2d723a"},{"name":{"en":"Cross-selling"},"description":{"en":""},"knowledgeTemplateId":"5ac74e444473ec6212182859","knowledgeSetId":"5ac5c0e27336def598b7c395","active":true,"kBitGroupRoles":[{"userGroupId":"5ac5c0b3482a01ea5fd9a302","roleId":"59f74757c93d9d0012bd1211"},{"userGroupId":"5ac5c0b3482a01ea5fd9a302","roleId":"59f74757ac159c001284a128"},{"userGroupId":"5ac5c0b3482a01ea5fd9a302","roleId":"59f74758ac159c001284a12a"},{"userGroupId":"5ac5c0b3482a01ea5fd9a302","roleId":"59f74759c93d9d0012bd1213"}],"weight":4,"bitTypeSettings":{"59f74759c93d9d0012bd1216":{"MIN_LENGTH":0,"MAX_LENGTH":0,"ALLOW_ALFA_CHARS":true,"ALLOW_NUM_CHARS":true,"ALLOW_SPECIAL_CHARS":true,"SHOW_SUGGESTIONS":false,"ST_ENABLE_LABEL":false,"ST_LABEL_ENTRY_TYPE":"ST_ENTRY_TYPE_FREE","ST_ENABLE_UNIT":false,"ST_UNIT_ENTRY_TYPE":"ST_ENTRY_TYPE_FREE","ST_ENABLE_DESCRIPTION":false}},"canRelateTo":[{"resourceType":"knowledge-templates","resourceId":"5ac74e444473ec6212182859"}],"color":"#9900ef","createdAt":"2018-04-10T11:15:03.838Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T11:17:47.783Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-template-blocks","resourceId":"5acc9cb7142c384a102eb92f"},{"name":{"en":"Usage"},"description":{"en":""},"knowledgeTemplateId":"5ac74e444473ec6212182859","knowledgeSetId":"5ac5c0e27336def598b7c395","active":true,"kBitGroupRoles":[{"userGroupId":"5ac5c0b3482a01ea5fd9a302","roleId":"59f74757c93d9d0012bd1211"},{"userGroupId":"5ac5c0b3482a01ea5fd9a302","roleId":"59f74757ac159c001284a128"},{"userGroupId":"5ac5c0b3482a01ea5fd9a302","roleId":"59f74758ac159c001284a12a"},{"userGroupId":"5ac5c0b3482a01ea5fd9a302","roleId":"59f74759c93d9d0012bd1213"}],"weight":5,"bitTypeSettings":{"59f74759c93d9d0012bd1216":{"MIN_LENGTH":5,"MAX_LENGTH":1000,"ALLOW_ALFA_CHARS":true,"ALLOW_NUM_CHARS":true,"ALLOW_SPECIAL_CHARS":true,"SHOW_SUGGESTIONS":false,"ST_ENABLE_LABEL":false,"ST_LABEL_ENTRY_TYPE":"ST_ENTRY_TYPE_FREE","ST_ENABLE_UNIT":false,"ST_UNIT_ENTRY_TYPE":"ST_ENTRY_TYPE_FREE","ST_ENABLE_DESCRIPTION":false}},"canRelateTo":[],"color":"#7bdcb5","createdAt":"2018-04-10T11:39:31.808Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:34:42.360Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-template-blocks","resourceId":"5acca273e1febae5e41fa5d1"},{"name":{"en":"Alternatives"},"description":{"en":""},"knowledgeTemplateId":"5ac74e444473ec6212182859","knowledgeSetId":"5ac5c0e27336def598b7c395","active":true,"kBitGroupRoles":[{"userGroupId":"5ac5c0b3482a01ea5fd9a302","roleId":"59f74757c93d9d0012bd1211"},{"userGroupId":"5ac5c0b3482a01ea5fd9a302","roleId":"59f74757ac159c001284a128"},{"userGroupId":"5ac5c0b3482a01ea5fd9a302","roleId":"59f74758ac159c001284a12a"},{"userGroupId":"5ac5c0b3482a01ea5fd9a302","roleId":"59f74759c93d9d0012bd1213"}],"weight":6,"bitTypeSettings":{"59f74759c93d9d0012bd1216":{"MIN_LENGTH":0,"MAX_LENGTH":0,"ALLOW_ALFA_CHARS":true,"ALLOW_NUM_CHARS":true,"ALLOW_SPECIAL_CHARS":true,"SHOW_SUGGESTIONS":false,"ST_ENABLE_LABEL":false,"ST_LABEL_ENTRY_TYPE":"ST_ENTRY_TYPE_FREE","ST_ENABLE_UNIT":false,"ST_UNIT_ENTRY_TYPE":"ST_ENTRY_TYPE_FREE","ST_ENABLE_DESCRIPTION":false}},"canRelateTo":[{"resourceType":"knowledge-templates","resourceId":"5ac74e444473ec6212182859"}],"color":"#2190C6","createdAt":"2018-04-10T11:41:46.462Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T11:42:03.370Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-template-blocks","resourceId":"5acca2fa142c38ffe62ebbda"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"The Gardena PowerMax ™ 42nd electric lawn mower is a powerful and easy-to-use electric lawn mower with Powerplus: the engine has a great ability, powerful transmission and a large drawing power for excellent, accurate and constant cutting results and optimal grass collection by the 50 L grass collector."},"contentToString":{"en":"The Gardena PowerMax ™ 42nd electric lawn mower is a powerful and easy-to-use electric lawn mower with Powerplus: the engine has a great ability, powerful transmission and a large drawing power for excellent, accurate and constant cutting results and optimal grass collection by the 50 L grass collector."}},"createdAt":"2018-04-09T08:35:42.527Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-09T08:35:42.527Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acb25de75345d32878e285d"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb247f665a1508542d6a93","content":{"name":{"en":"blue"},"contentToString":{"en":"blue"}},"createdAt":"2018-04-09T08:36:43.195Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-09T08:36:43.195Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acb261b665a156f362d6b85"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb247f665a1508542d6a93","content":{"name":{"en":"yellow"},"contentToString":{"en":"yellow"}},"createdAt":"2018-04-09T08:36:52.279Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-09T08:36:52.279Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acb262475345d0f1d8e28a8"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb247f665a1508542d6a93","content":{"name":{"en":"red"},"contentToString":{"en":"red"}},"createdAt":"2018-04-09T08:36:55.782Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-09T08:36:55.782Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acb2627665a154f6c2d6b95"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"1700"},"label":{"en":"Power"},"unit":{"en":"W"},"contentToString":{"en":"Power 1700 W"}},"createdAt":"2018-04-09T15:34:58.468Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-09T15:35:38.814Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acb882275345d41d78e2ea6"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"15"},"label":{"en":"Cable length"},"unit":{"en":"m"},"contentToString":{"en":"Cable length 15 m"}},"createdAt":"2018-04-09T15:38:13.932Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-09T15:38:13.932Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acb88e5665a15f0cc2d71c8"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"13.9"},"label":{"en":"Weight"},"unit":{"en":"kg"},"contentToString":{"en":"Weight 13.9 kg"}},"createdAt":"2018-04-09T15:43:13.024Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-09T15:43:13.024Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acb8a1175345d7a4a8e2edd"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"42"},"label":{"en":"Cut width"},"unit":{"en":"cm"},"contentToString":{"en":"Cut width 42 cm"}},"createdAt":"2018-04-09T15:45:14.573Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-09T15:45:14.573Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acb8a8a665a150b0b2d71ed"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"50"},"label":{"en":"Collector volume"},"unit":{"en":"l"},"contentToString":{"en":"Collector volume 50 l"}},"createdAt":"2018-04-09T15:46:48.052Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-09T15:46:48.052Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acb8ae875345d7d908e2ef4"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"1"},"label":{"en":"Warranty"},"unit":{"en":"year"},"contentToString":{"en":"Warranty 1 year"}},"createdAt":"2018-04-09T16:08:38.365Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-09T16:08:38.365Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acb9006665a1517f72d7207"},{"active":true,"kBitTypeId":"59f7475aac159c001284a12c","knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","content":{"public_id":"g2clmdesnaakql2pqauu","width":550,"height":499,"format":"jpg","resource_type":"image","tags":[],"bytes":37229,"etag":"fecfd76eddf01e63ee64d7404f33f325","url":"http://res.cloudinary.com/knowledgeflow/image/authenticated/s--UvGG01hI--/v1523290320/g2clmdesnaakql2pqauu.jpg","secure_url":"https://res.cloudinary.com/knowledgeflow/image/authenticated/s--UvGG01hI--/v1523290320/g2clmdesnaakql2pqauu.jpg","signature":"a32f1e31d7a46df2164dfbf7d68d24bcb0cc03e2","description":{"en":"","nl":"","ro":""}},"createdAt":"2018-04-09T16:12:01.204Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-09T16:12:01.204Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acb90d175345d59248e2f66"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"210,99"},"label":{"en":"Price"},"unit":{"en":"€"},"contentToString":{"en":"Price 210,99 €"}},"createdAt":"2018-04-09T16:20:14.437Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-09T16:20:14.437Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acb92be665a1550922d72a2"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb247f665a1508542d6a93","content":{"name":{"en":"black"},"contentToString":{"en":"black"}},"createdAt":"2018-04-09T16:23:14.528Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-09T16:23:14.528Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acb937275345d5cab8e2fb9"},{"active":true,"kBitTypeId":"59f7475aac159c001284a12c","knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","content":{"public_id":"aqwbowymaodqxu6lz71n","width":585,"height":585,"format":"jpg","resource_type":"image","tags":[],"bytes":46905,"etag":"97c1ffa775205f0be2a3a1096f412fcc","url":"http://res.cloudinary.com/knowledgeflow/image/authenticated/s--9MAzWp1n--/v1523291008/aqwbowymaodqxu6lz71n.jpg","secure_url":"https://res.cloudinary.com/knowledgeflow/image/authenticated/s--9MAzWp1n--/v1523291008/aqwbowymaodqxu6lz71n.jpg","signature":"de60a7df79f001c7f88e034283c9f37e0b1590a7","description":{"en":"","nl":"","ro":""}},"createdAt":"2018-04-09T16:23:28.533Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-09T16:23:28.533Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acb9380665a1512d72d72cd"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"Steel"},"label":{"en":"Material"},"contentToString":{"en":"Material Steel"}},"createdAt":"2018-04-09T16:24:56.708Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-09T16:24:56.708Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acb93d875345d6d9b8e2fca"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"60 x 43"},"label":{"en":"Grilling surface"},"unit":{"en":"cm"},"contentToString":{"en":"Grilling surface 60 x 43 cm"}},"createdAt":"2018-04-09T16:26:10.219Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-09T16:26:10.219Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acb9422665a1569102d72e2"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"2"},"label":{"en":"Warranty"},"unit":{"en":"years"},"contentToString":{"en":"Warranty 2 years"}},"createdAt":"2018-04-09T16:26:50.700Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-09T16:26:50.700Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acb944a75345db7948e2fe7"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"8"},"label":{"en":"Amount of people"},"contentToString":{"en":"Amount of people 8"}},"createdAt":"2018-04-09T16:27:15.670Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-09T16:27:15.670Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acb9463665a1580a62d72fc"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"2"},"label":{"en":"Wheels"},"contentToString":{"en":"Wheels 2"}},"createdAt":"2018-04-09T16:27:33.748Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-09T16:27:33.748Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acb947575345d62d48e2ffc"},{"active":true,"kBitTypeId":"59f7475aac159c001284a12c","knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","content":{"public_id":"cdnqhsoix3jjuwb0jhbt","width":585,"height":585,"format":"jpg","resource_type":"image","tags":[],"bytes":43021,"etag":"075d1587a82f1698cc7848ef535ac633","url":"http://res.cloudinary.com/knowledgeflow/image/authenticated/s--F29ogfxO--/v1523359864/cdnqhsoix3jjuwb0jhbt.jpg","secure_url":"https://res.cloudinary.com/knowledgeflow/image/authenticated/s--F29ogfxO--/v1523359864/cdnqhsoix3jjuwb0jhbt.jpg","signature":"1f990108485bb0e8b04b959447231f201d0554e3","description":{"en":"","nl":"","ro":""}},"createdAt":"2018-04-10T11:31:05.184Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T11:31:05.184Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acca079142c3812232ebb3a"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"500"},"label":{"en":"Volume"},"unit":{"en":"ml"},"contentToString":{"en":"Volume 500 ml"}},"createdAt":"2018-04-10T11:32:56.662Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T11:32:56.662Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acca0e8e1feba340b1fa56d"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"38,95"},"label":{"en":"Price"},"unit":{"en":"€"},"contentToString":{"en":"Price 38,95 €"}},"createdAt":"2018-04-10T11:33:40.732Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T11:33:40.732Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acca114142c381f0f2ebb53"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"Total weed control with systemic action. Concentrated formula, for the control of more difficult weeds (buttercup, cultivated grass ...) and for larger surfaces. Destroys all weeds in the root. Sow and plant already possible after one week."},"contentToString":{"en":"Total weed control with systemic action. Concentrated formula, for the control of more difficult weeds (buttercup, cultivated grass ...) and for larger surfaces. Destroys all weeds in the root. Sow and plant already possible after one week."}},"createdAt":"2018-04-10T11:35:28.040Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T11:35:28.040Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acca180e1feba3a591fa5ab"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","content":{"name":{"en":"Application with sprayer: fill the appliance halfway with water, add the prescribed dose, top up with water and mix. Apply evenly and drip."},"contentToString":{"en":"Application with sprayer: fill the appliance halfway with water, add the prescribed dose, top up with water and mix. Apply evenly and drip."}},"createdAt":"2018-04-10T11:45:41.560Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T11:45:41.560Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acca3e5142c3873932ebc25"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","content":{"name":{"en":"Application with brush (20 ml in 100 ml water): Against the regrowth of shoots."},"contentToString":{"en":"Application with brush (20 ml in 100 ml water): Against the regrowth of shoots."}},"createdAt":"2018-04-10T11:46:32.272Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T11:46:32.272Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acca418e1feba68f21fa660"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","content":{"name":{"en":"Roundup Extra should be applied to green weeds, in growth or already developed. Treat on a day with mild weather (12-25 ° C) without rain, nor wind. Rain can reduce the effect within 4 to 6 hours after application. Preferably spray on a dry vegetation."},"contentToString":{"en":"Roundup Extra should be applied to green weeds, in growth or already developed. Treat on a day with mild weather (12-25 ° C) without rain, nor wind. Rain can reduce the effect within 4 to 6 hours after application. Preferably spray on a dry vegetation."}},"createdAt":"2018-04-10T11:47:10.028Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T11:47:10.028Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acca43e142c38f8af2ebc4d"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","content":{"name":{"en":"Maintenance treatment: 10-20 ml Roundup Extra - 2.5 L water - 50m²"},"contentToString":{"en":"Maintenance treatment: 10-20 ml Roundup Extra - 2.5 L water - 50m²"}},"createdAt":"2018-04-10T11:48:17.751Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T11:48:17.751Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acca481e1feba1d971fa686"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","content":{"name":{"en":"Stubborn weed: 30-50 ml Roundup Extra - 2.5 L water - 50 m²"},"contentToString":{"en":"Stubborn weed: 30-50 ml Roundup Extra - 2.5 L water - 50 m²"}},"createdAt":"2018-04-10T11:49:14.086Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T11:49:14.086Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acca4ba142c38cbe12ebc5d"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"77,90"},"label":{"en":"Price / l"},"unit":{"en":"€"},"contentToString":{"en":"Price / l 77,90 €"}},"createdAt":"2018-04-10T11:51:10.882Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T11:51:10.882Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acca52ee1febac6a51fa6af"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"89,95"},"label":{"en":"Price"},"unit":{"en":"€"},"contentToString":{"en":"Price 89,95 €"}},"createdAt":"2018-04-10T11:53:47.924Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T11:53:47.924Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acca5cb142c3839b82ebc8f"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb247f665a1508542d6a93","content":{"name":{"en":"grey"},"contentToString":{"en":"grey"}},"createdAt":"2018-04-10T13:13:23.996Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:13:23.996Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accb873ee2ecd28f366672e"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"28"},"label":{"en":"Height"},"unit":{"en":"cm"},"contentToString":{"en":"Height 28 cm"}},"createdAt":"2018-04-10T13:13:47.573Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:13:47.573Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accb88b2e1f2fc4e87431a9"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"29,5 x 29,5 x 28"},"label":{"en":"Dimensions"},"unit":{"en":"cm"},"contentToString":{"en":"Dimensions 29,5 x 29,5 x 28 cm"}},"createdAt":"2018-04-10T13:14:47.196Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:14:47.196Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accb8c7ee2ecda6fb666765"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"29,5"},"label":{"en":"Width"},"unit":{"en":"cm"},"contentToString":{"en":"Width 29,5 cm"}},"createdAt":"2018-04-10T13:15:25.851Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:15:25.851Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accb8edee2ecd0bc166677b"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"29,5"},"label":{"en":"Length"},"unit":{"en":"cm"},"contentToString":{"en":"Length 29,5 cm"}},"createdAt":"2018-04-10T13:15:37.191Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:15:37.191Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accb8f92e1f2f6cbf7431f1"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"Manufactured in Germany"},"contentToString":{"en":"Manufactured in Germany"}},"createdAt":"2018-04-10T13:16:52.372Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:16:52.372Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accb944ee2ecd4cb56667d8"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"For inside and outside use"},"contentToString":{"en":"For inside and outside use"}},"createdAt":"2018-04-10T13:17:03.260Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:17:03.260Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accb94f2e1f2f62ca74324b"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"Eco-friendly"},"contentToString":{"en":"Eco-friendly"}},"createdAt":"2018-04-10T13:17:13.278Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:17:13.278Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accb959ee2ecd47eb6667ef"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"UV and frost-proof"},"contentToString":{"en":"UV and frost-proof"}},"createdAt":"2018-04-10T13:18:04.145Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:18:04.145Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accb98c2e1f2f72c374326a"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"German Design Award Winner 2017"},"contentToString":{"en":"German Design Award Winner 2017"}},"createdAt":"2018-04-10T13:18:20.478Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:18:20.478Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accb99cee2ecd4ae266680a"},{"active":true,"kBitTypeId":"59f7475aac159c001284a12c","knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","content":{"public_id":"vnaovz4vrivqdg0zekwh","width":585,"height":585,"format":"jpg","resource_type":"image","tags":[],"bytes":104757,"etag":"c1916d381e4b5adc74f5b01c610236bb","url":"http://res.cloudinary.com/knowledgeflow/image/authenticated/s----8I2Fux--/v1523366335/vnaovz4vrivqdg0zekwh.jpg","secure_url":"https://res.cloudinary.com/knowledgeflow/image/authenticated/s----8I2Fux--/v1523366335/vnaovz4vrivqdg0zekwh.jpg","signature":"e368fd934396ed298dde848b2010cb5f52e7796d","description":{"en":"","nl":"","ro":""}},"createdAt":"2018-04-10T13:18:55.839Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:18:55.839Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accb9bf2e1f2f4c47743279"},{"active":true,"kBitTypeId":"59f7475aac159c001284a12c","knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","content":{"public_id":"meafoq7m5xzps0ayojte","width":585,"height":585,"format":"jpg","resource_type":"image","tags":[],"bytes":117542,"etag":"772ed26f87568e4c6e44396583d5d1ff","url":"http://res.cloudinary.com/knowledgeflow/image/authenticated/s--V6xuLeYY--/v1523366341/meafoq7m5xzps0ayojte.jpg","secure_url":"https://res.cloudinary.com/knowledgeflow/image/authenticated/s--V6xuLeYY--/v1523366341/meafoq7m5xzps0ayojte.jpg","signature":"a122e86fd2434d121a1c3cc60c776dd6f47e02ef","description":{"en":"","nl":"","ro":""}},"createdAt":"2018-04-10T13:19:01.888Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:19:01.888Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accb9c5ee2ecd5c85666817"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"Flower pot"},"contentToString":{"en":"Flower pot"}},"createdAt":"2018-04-10T13:19:43.986Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:19:43.986Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accb9ef2e1f2f47f0743297"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"Marquis are delicious crunchy biscuits filled with meat. They are perfect for rolling and throwing and catching, so that your dog's play time is even more fun."},"contentToString":{"en":"Marquis are delicious crunchy biscuits filled with meat. They are perfect for rolling and throwing and catching, so that your dog's play time is even more fun."}},"createdAt":"2018-04-10T13:21:24.747Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:22:56.445Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accba54ee2ecd1655666877"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"Natural source of calcium"},"contentToString":{"en":"Natural source of calcium"}},"createdAt":"2018-04-10T13:23:12.402Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:23:18.838Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accbac02e1f2fbb8f743304"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"500"},"label":{"en":"Weight"},"unit":{"en":"g"},"contentToString":{"en":"Weight 500 g"}},"createdAt":"2018-04-10T13:23:38.387Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:23:38.387Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accbadaee2ecd74116668b3"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"3,70"},"label":{"en":"Price / kg"},"unit":{"en":"€"},"contentToString":{"en":"Price / kg 3,70 €"}},"createdAt":"2018-04-10T13:24:23.977Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:24:23.977Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accbb072e1f2f5c43743329"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"1,85"},"label":{"en":"Price"},"unit":{"en":"€"},"contentToString":{"en":"Price 1,85 €"}},"createdAt":"2018-04-10T13:24:57.218Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:24:57.218Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accbb29ee2ecd1c376668da"},{"active":true,"kBitTypeId":"59f7475aac159c001284a12c","knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","content":{"public_id":"ldbp4o9i954uwhqmcpsn","width":585,"height":585,"format":"jpg","resource_type":"image","tags":[],"bytes":67547,"etag":"ab904409f9f2d537654b516837378fc5","url":"http://res.cloudinary.com/knowledgeflow/image/authenticated/s--9h9BYLmO--/v1523366715/ldbp4o9i954uwhqmcpsn.jpg","secure_url":"https://res.cloudinary.com/knowledgeflow/image/authenticated/s--9h9BYLmO--/v1523366715/ldbp4o9i954uwhqmcpsn.jpg","signature":"8827f4003d29d7870270ac7f2af82bf948e89939","description":{"en":"","nl":"","ro":""}},"createdAt":"2018-04-10T13:25:16.411Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:25:16.411Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accbb3c2e1f2f2e41743340"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","content":{"name":{"en":"Medium-sized dogs (10-25 kg): Give up to 8 biscuits per week. Large dogs (25+ kg): Give up to 16 biscuits per week."},"contentToString":{"en":"Medium-sized dogs (10-25 kg): Give up to 8 biscuits per week. Large dogs (25+ kg): Give up to 16 biscuits per week."}},"createdAt":"2018-04-10T13:26:01.900Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:26:01.900Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accbb69ee2ecd0e136668e9"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","content":{"name":{"en":"Make sure that there is always enough fresh drinking water available."},"contentToString":{"en":"Make sure that there is always enough fresh drinking water available."}},"createdAt":"2018-04-10T13:26:20.171Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:26:20.171Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accbb7c2e1f2fca7c743350"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"Chewing snack"},"label":{"en":"Food-type"},"unit":{"en":""},"contentToString":{"en":"Food-type Chewing snack "}},"createdAt":"2018-04-10T13:27:25.446Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:28:31.283Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accbbbdee2ecd6a2e666909"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"Training snack"},"label":{"en":"Specific food-type"},"unit":{"en":""},"contentToString":{"en":"Specific food-type Training snack "}},"createdAt":"2018-04-10T13:28:24.106Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:28:24.106Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accbbf82e1f2f00cf743382"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"Food"},"label":{"en":"Type"},"unit":{"en":""},"contentToString":{"en":"Type Food "}},"createdAt":"2018-04-10T13:30:26.149Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:30:26.149Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accbc72ee2ecdeddf666940"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"Cereals, meat and animal by-products (including 4% meat), sugars, oils and fats, minerals, vegetable by-products"},"label":{"en":"Composition"},"unit":{"en":""},"contentToString":{"en":"Composition Cereals, meat and animal by-products (including 4% meat), sugars, oils and fats, minerals, vegetable by-products "}},"createdAt":"2018-04-10T13:31:43.846Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:31:43.846Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accbcbf2e1f2f59ad7433d6"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"Protein: 14.3%, fat content: 10.7%, inorganic substances: 8.2%, crude fiber: 1.3%, calcium: 1.7%, omega 3 fatty acids: 1010 mg / kg, energy value: 365 kcal / 100g"},"label":{"en":"Analytical components"},"unit":{"en":""},"contentToString":{"en":"Analytical components Protein: 14.3%, fat content: 10.7%, inorganic substances: 8.2%, crude fiber: 1.3%, calcium: 1.7%, omega 3 fatty acids: 1010 mg / kg, energy value: 365 kcal / 100g "}},"createdAt":"2018-04-10T13:32:23.332Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:33:00.929Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accbce7ee2ecd40c3666988"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"Vitamin A: 4767 IU, Vitamin E: 47.7 mg, Mono-hydrated iron sulfate: 43.5 mg"},"label":{"en":"Additives"},"unit":{"en":""},"contentToString":{"en":"Additives Vitamin A: 4767 IU, Vitamin E: 47.7 mg, Mono-hydrated iron sulfate: 43.5 mg "}},"createdAt":"2018-04-10T13:33:39.883Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:33:39.883Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accbd332e1f2f37967433fa"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","content":{"name":{"en":"Keep cool and dry."},"contentToString":{"en":"Keep cool and dry."}},"createdAt":"2018-04-10T13:34:53.770Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:34:53.770Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accbd7dee2ecd0a586669cd"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"For a delicious dessert with fresh fruit, for example pieces of apple or red fruits. Only add water and fruit of your choice and bake the whole in the oven."},"contentToString":{"en":"For a delicious dessert with fresh fruit, for example pieces of apple or red fruits. Only add water and fruit of your choice and bake the whole in the oven."}},"createdAt":"2018-04-10T13:39:29.261Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:39:29.261Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accbe912e1f2f49a9743446"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"With blond cassava sugar"},"contentToString":{"en":"With blond cassava sugar"}},"createdAt":"2018-04-10T13:40:03.089Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:40:03.089Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accbeb3ee2ecde7a56669ec"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"400"},"label":{"en":"Weight"},"unit":{"en":"g"},"contentToString":{"en":"Weight 400 g"}},"createdAt":"2018-04-10T13:40:27.548Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:40:27.548Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accbecb2e1f2fbc9e743458"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"Bakery Mix"},"label":{"en":"Food-type"},"unit":{"en":""},"contentToString":{"en":"Food-type Bakery Mix "}},"createdAt":"2018-04-10T13:41:55.323Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:41:55.323Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accbf232e1f2f32d874347d"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","content":{"name":{"en":"Preheat the oven to 180 ° C. Peel the apples and cut the flesh into pieces. Stew them briefly in butter. Divide the pieces over a refractory dish and add some raisins if necessary. Put 200 g of mix in a bowl and add 15 ml of water. Mix with a fork until the water is completely absorbed. Then knead by hand for 1 minute into a dry dough that you can easily tumble. Add a little water if the dough is too dry or a little flour if the dough is too moist and knead new. Form clumps and crumble them over the apple pieces. Bake the crumble at 180 ° C for 20 to 30 minutes."},"contentToString":{"en":"Preheat the oven to 180 ° C. Peel the apples and cut the flesh into pieces. Stew them briefly in butter. Divide the pieces over a refractory dish and add some raisins if necessary. Put 200 g of mix in a bowl and add 15 ml of water. Mix with a fork until the water is completely absorbed. Then knead by hand for 1 minute into a dry dough that you can easily tumble. Add a little water if the dough is too dry or a little flour if the dough is too moist and knead new. Form clumps and crumble them over the apple pieces. Bake the crumble at 180 ° C for 20 to 30 minutes."}},"createdAt":"2018-04-10T13:42:27.006Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:42:27.006Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accbf43ee2ecd41f0666a21"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","content":{"name":{"en":"Preferably keep cool and dry. Close the packaging well after use!"},"contentToString":{"en":"Preferably keep cool and dry. Close the packaging well after use!"}},"createdAt":"2018-04-10T13:42:55.253Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:42:55.253Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accbf5f2e1f2f795974348f"},{"active":true,"kBitTypeId":"59f7475aac159c001284a12c","knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","content":{"public_id":"ox44a9yjjxog87v3vtin","width":585,"height":585,"format":"jpg","resource_type":"image","tags":[],"bytes":39368,"etag":"70a3c42eecb6f83e5b63f67b3ed71ef5","url":"http://res.cloudinary.com/knowledgeflow/image/authenticated/s--8VJNIMEJ--/v1523367796/ox44a9yjjxog87v3vtin.jpg","secure_url":"https://res.cloudinary.com/knowledgeflow/image/authenticated/s--8VJNIMEJ--/v1523367796/ox44a9yjjxog87v3vtin.jpg","signature":"3e3c1d9b9b146ce86b6fee6d71dc9168bfdc48cf","description":{"en":"","nl":"","ro":""}},"createdAt":"2018-04-10T13:43:17.392Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:43:17.392Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accbf75ee2ecd7443666a2f"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"Candy cassade, wheat flour, vegetable fat (palm), protein powder, salt, flavor."},"label":{"en":"Composition"},"unit":{"en":""},"contentToString":{"en":"Composition Candy cassade, wheat flour, vegetable fat (palm), protein powder, salt, flavor. "}},"createdAt":"2018-04-10T13:49:28.770Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:49:28.770Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accc0e82e1f2f6d8d7434a2"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"May contain traces of milk, soy, sesame seeds, lupins and nuts."},"label":{"en":"Allergens"},"unit":{"en":""},"contentToString":{"en":"Allergens May contain traces of milk, soy, sesame seeds, lupins and nuts. "}},"createdAt":"2018-04-10T13:50:27.128Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-10T13:50:27.128Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5accc123ee2ecd2423666a47"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"The solution for easily and evenly spreading fertilizer, grass seed, ... In addition, you can also use it in the winter to evenly distribute road salt. The granomax has a capacity of 5 kg. You carry the bag on the back and the granules are distributed evenly with the adjustable distribution cap."},"contentToString":{"en":"The solution for easily and evenly spreading fertilizer, grass seed, ... In addition, you can also use it in the winter to evenly distribute road salt. The granomax has a capacity of 5 kg. You carry the bag on the back and the granules are distributed evenly with the adjustable distribution cap."}},"createdAt":"2018-04-11T07:21:09.013Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T07:21:09.013Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdb765ee2ecd0ec3666de7"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"51,2 x 15 x 7,8"},"label":{"en":"Dimensions"},"unit":{"en":"cm"},"contentToString":{"en":"Dimensions 51,2 x 15 x 7,8 cm"}},"createdAt":"2018-04-11T07:25:12.076Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T07:25:12.076Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdb8582e1f2f2d0e743855"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","content":{"name":{"en":"The pellets are spread evenly with the adjustable distribution head."},"contentToString":{"en":"The pellets are spread evenly with the adjustable distribution head."}},"createdAt":"2018-04-11T07:25:43.790Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T07:25:43.790Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdb877ee2ecd075f666df9"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","content":{"name":{"en":"You carry the bag on your back."},"contentToString":{"en":"You carry the bag on your back."}},"createdAt":"2018-04-11T07:26:00.610Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T07:26:00.610Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdb8882e1f2fc65e743864"},{"active":true,"kBitTypeId":"59f7475aac159c001284a12c","knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","content":{"public_id":"aaghix8cp0zjekzbuoar","width":585,"height":585,"format":"jpg","resource_type":"image","tags":[],"bytes":33026,"etag":"7e3b1bd47941a25773a81710795ae65c","url":"http://res.cloudinary.com/knowledgeflow/image/authenticated/s--PdAJ1YiE--/v1523431589/aaghix8cp0zjekzbuoar.jpg","secure_url":"https://res.cloudinary.com/knowledgeflow/image/authenticated/s--PdAJ1YiE--/v1523431589/aaghix8cp0zjekzbuoar.jpg","signature":"6bce39673047fb86e6331db4ac24a459be07bc08","description":{"en":"","nl":"","ro":""}},"createdAt":"2018-04-11T07:26:29.270Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T07:26:29.270Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdb8a5ee2ecda80d666e09"},{"active":true,"kBitTypeId":"59f7475aac159c001284a12c","knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","content":{"public_id":"nuv35kj4am4lmtvjcwqf","width":585,"height":585,"format":"jpg","resource_type":"image","tags":[],"bytes":22436,"etag":"9254948acb5938ae912de0ede2a35429","url":"http://res.cloudinary.com/knowledgeflow/image/authenticated/s--qpLC7XY0--/v1523431595/nuv35kj4am4lmtvjcwqf.jpg","secure_url":"https://res.cloudinary.com/knowledgeflow/image/authenticated/s--qpLC7XY0--/v1523431595/nuv35kj4am4lmtvjcwqf.jpg","signature":"2d23da007824dd6d3b146ff8383c0761c779b176","description":{"en":"","nl":"","ro":""}},"createdAt":"2018-04-11T07:26:36.352Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T07:26:36.352Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdb8ac2e1f2f49d9743874"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"29,75"},"label":{"en":"Price"},"unit":{"en":"€"},"contentToString":{"en":"Price 29,75 €"}},"createdAt":"2018-04-11T07:28:42.958Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T07:28:42.958Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdb92aee2ecd4e7e666e67"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"Gather around the fire all year round"},"contentToString":{"en":"Gather around the fire all year round"}},"createdAt":"2018-04-11T07:30:39.794Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T07:30:52.667Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdb99f2e1f2f545e7438de"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"Also ideal as the conclusion of a tasty barbecue"},"contentToString":{"en":"Also ideal as the conclusion of a tasty barbecue"}},"createdAt":"2018-04-11T07:31:19.388Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T07:31:19.388Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdb9c7ee2ecd488d666e8d"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"Fire basket made of lacquered steel with heat-resistant paint"},"contentToString":{"en":"Fire basket made of lacquered steel with heat-resistant paint"}},"createdAt":"2018-04-11T07:31:38.860Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T07:31:38.860Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdb9da2e1f2f01e57438f4"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"62 x 62 x 48,5"},"label":{"en":"Dimensions"},"unit":{"en":"cm"},"contentToString":{"en":"Dimensions 62 x 62 x 48,5 cm"}},"createdAt":"2018-04-11T07:33:22.027Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T07:33:22.027Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdba422e1f2f4129743907"},{"active":true,"kBitTypeId":"59f7475aac159c001284a12c","knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","content":{"public_id":"oaxgrgoiil8snrdrvkgz","width":585,"height":585,"format":"jpg","resource_type":"image","tags":[],"bytes":43985,"etag":"bf85bc5a90fa6ae50d6f6a9e669fef25","url":"http://res.cloudinary.com/knowledgeflow/image/authenticated/s--RsqnRpxT--/v1523432111/oaxgrgoiil8snrdrvkgz.jpg","secure_url":"https://res.cloudinary.com/knowledgeflow/image/authenticated/s--RsqnRpxT--/v1523432111/oaxgrgoiil8snrdrvkgz.jpg","signature":"8f0f260c639e992bc607166ab5d2aa0707babd33","description":{"en":"","nl":"","ro":""}},"createdAt":"2018-04-11T07:35:11.969Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T07:35:11.969Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdbaafee2ecdafe0666eab"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"69,99"},"label":{"en":"Price"},"unit":{"en":"€"},"contentToString":{"en":"Price 69,99 €"}},"createdAt":"2018-04-11T07:47:44.618Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T07:47:44.618Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdbda02e1f2fff2c743999"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"To collect leaves easily."},"contentToString":{"en":"To collect leaves easily."}},"createdAt":"2018-04-11T07:51:13.038Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T07:51:13.038Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdbe71ee2ecd7051666f4a"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","content":{"name":{"en":"Easy to use with 2 handles."},"contentToString":{"en":"Easy to use with 2 handles."}},"createdAt":"2018-04-11T07:52:53.946Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T07:52:53.946Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdbed52e1f2f7f2d7439b4"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"50 x 35 x 11"},"label":{"en":"Dimensions"},"unit":{"en":"cm"},"contentToString":{"en":"Dimensions 50 x 35 x 11 cm"}},"createdAt":"2018-04-11T07:55:08.299Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T07:55:08.299Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdbf5cee2ecd39eb666fad"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"16,80"},"label":{"en":"Price"},"unit":{"en":"€"},"contentToString":{"en":"Price 16,80 €"}},"createdAt":"2018-04-11T07:55:29.728Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T07:55:29.728Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdbf712e1f2f22ca743a13"},{"active":true,"kBitTypeId":"59f7475aac159c001284a12c","knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","content":{"public_id":"qgunteamvgglpwdtunbj","width":585,"height":585,"format":"jpg","resource_type":"image","tags":[],"bytes":33740,"etag":"e29dc1061961333090d654257dd1b223","url":"http://res.cloudinary.com/knowledgeflow/image/authenticated/s---3AZOwNV--/v1523433969/qgunteamvgglpwdtunbj.jpg","secure_url":"https://res.cloudinary.com/knowledgeflow/image/authenticated/s---3AZOwNV--/v1523433969/qgunteamvgglpwdtunbj.jpg","signature":"b9f0b337e95b7892c7dab57ca4a592b8131c2334","description":{"en":"","nl":"","ro":""}},"createdAt":"2018-04-11T08:06:10.191Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:06:10.191Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc1f22e1f2fbe15743a23"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"This visually attractive, pure mixture with a high protein content was developed specifically for the needs of (travel) pigeons during the breeding period."},"contentToString":{"en":"This visually attractive, pure mixture with a high protein content was developed specifically for the needs of (travel) pigeons during the breeding period."}},"createdAt":"2018-04-11T08:09:51.984Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:10:16.192Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc2cfee2ecd6bd3666fd7"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"The mixture contains French Cribs with a high germ content (+ 85%) and orange maize."},"contentToString":{"en":"The mixture contains French Cribs with a high germ content (+ 85%) and orange maize."}},"createdAt":"2018-04-11T08:10:22.773Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:10:22.773Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc2ee2e1f2f51c2743a4c"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"12,45"},"label":{"en":"Price"},"unit":{"en":"€"},"contentToString":{"en":"Price 12,45 €"}},"createdAt":"2018-04-11T08:10:55.885Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:10:55.885Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc30fee2ecd7039666ffd"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"0,62"},"label":{"en":"Price / kg"},"unit":{"en":"€"},"contentToString":{"en":"Price / kg 0,62 €"}},"createdAt":"2018-04-11T08:11:21.142Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:11:21.142Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc3292e1f2f287e743a6f"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","content":{"name":{"en":"This extremely pure mixture contains a high protein content specifically for the needs of (travel) pigeons during the breeding period."},"contentToString":{"en":"This extremely pure mixture contains a high protein content specifically for the needs of (travel) pigeons during the breeding period."}},"createdAt":"2018-04-11T08:11:46.741Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:11:46.741Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc342ee2ecdc379667015"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","content":{"name":{"en":"This mixture is aimed at the needs of (travel) pigeons in the breeding period."},"contentToString":{"en":"This mixture is aimed at the needs of (travel) pigeons in the breeding period."}},"createdAt":"2018-04-11T08:12:07.430Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:12:07.430Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc3572e1f2f58cb743a7f"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"Corn Cribs 20%, Peas yellow 13.5%, Dunpeas 11.5%, Dari 10%, Peas green 9%, Wheat 8%, Milo 6%, Cardy 6%, Maple peas 5%, Corn orange 5%, Vitsen 3%, Sunflower seeds striped 3%"},"label":{"en":"Composition"},"unit":{"en":""},"contentToString":{"en":"Composition Corn Cribs 20%, Peas yellow 13.5%, Dunpeas 11.5%, Dari 10%, Peas green 9%, Wheat 8%, Milo 6%, Cardy 6%, Maple peas 5%, Corn orange 5%, Vitsen 3%, Sunflower seeds striped 3% "}},"createdAt":"2018-04-11T08:12:30.940Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:13:08.334Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc36eee2ecd1a1d667028"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"Crude protein: 15.88%, Crude fat: 4.55%, Carbohydrates: 58.0%, Crude ash: 2.29%, Crude fiber: 6.32%"},"label":{"en":"Analytical components"},"unit":{"en":""},"contentToString":{"en":"Analytical components Crude protein: 15.88%, Crude fat: 4.55%, Carbohydrates: 58.0%, Crude ash: 2.29%, Crude fiber: 6.32% "}},"createdAt":"2018-04-11T08:12:54.245Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:13:36.002Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc3862e1f2fe81d743a98"},{"active":true,"kBitTypeId":"59f7475aac159c001284a12c","knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","content":{"public_id":"zafuejl9ajutuusciiea","width":585,"height":585,"format":"jpg","resource_type":"image","tags":[],"bytes":37909,"etag":"d05a14126948518689000a95f3c7f912","url":"http://res.cloudinary.com/knowledgeflow/image/authenticated/s--Up6pdUOX--/v1523434439/zafuejl9ajutuusciiea.jpg","secure_url":"https://res.cloudinary.com/knowledgeflow/image/authenticated/s--Up6pdUOX--/v1523434439/zafuejl9ajutuusciiea.jpg","signature":"563f0475a8275b39dfdd821d0bdad529cfef0680","description":{"en":"","nl":"","ro":""}},"createdAt":"2018-04-11T08:14:00.005Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:14:00.005Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc3c8ee2ecd744b66704b"},{"active":true,"kBitTypeId":"59f7475aac159c001284a12c","knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","content":{"public_id":"hximyiqmi70k03xj45jz","width":585,"height":585,"format":"jpg","resource_type":"image","tags":[],"bytes":166988,"etag":"19aef9b6fd31ade6ebb89f8b2795a9ad","url":"http://res.cloudinary.com/knowledgeflow/image/authenticated/s--uPzoiTU_--/v1523434445/hximyiqmi70k03xj45jz.jpg","secure_url":"https://res.cloudinary.com/knowledgeflow/image/authenticated/s--uPzoiTU_--/v1523434445/hximyiqmi70k03xj45jz.jpg","signature":"5c427639e29800fb40f1502a61529d56cd6b77fb","description":{"en":"","nl":"","ro":""}},"createdAt":"2018-04-11T08:14:05.773Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:14:05.773Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc3cd2e1f2f54e8743ab4"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"Mix"},"label":{"en":"Food-type"},"unit":{"en":""},"contentToString":{"en":"Food-type Mix "}},"createdAt":"2018-04-11T08:15:07.293Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:15:07.293Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc40bee2ecdafd5667076"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"20"},"label":{"en":"Weight"},"unit":{"en":"kg"},"contentToString":{"en":"Weight 20 kg"}},"createdAt":"2018-04-11T08:16:14.918Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:16:14.918Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc44eee2ecd7f806670b7"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"This complete meal for dogs contains a balanced mix of proteins, fats, vitamins and mineral salts. This complete pet food for dogs meets the nutritional needs of your dog and helps him to obtain a shiny coat, good eyes and excellent vitality."},"contentToString":{"en":"This complete meal for dogs contains a balanced mix of proteins, fats, vitamins and mineral salts. This complete pet food for dogs meets the nutritional needs of your dog and helps him to obtain a shiny coat, good eyes and excellent vitality."}},"createdAt":"2018-04-11T08:25:36.352Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:25:36.352Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc6802e1f2f3e8b743b34"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"18"},"label":{"en":"Weight"},"unit":{"en":"kg"},"contentToString":{"en":"Weight 18 kg"}},"createdAt":"2018-04-11T08:25:48.589Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:25:48.589Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc68cee2ecd57786670e8"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"24,95"},"label":{"en":"Price"},"unit":{"en":"€"},"contentToString":{"en":"Price 24,95 €"}},"createdAt":"2018-04-11T08:26:04.413Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:26:04.413Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc69c2e1f2fd6b2743b4c"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"1,39"},"label":{"en":"Price / kg"},"unit":{"en":"€"},"contentToString":{"en":"Price / kg 1,39 €"}},"createdAt":"2018-04-11T08:26:21.643Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:26:21.643Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc6adee2ecd21bc667101"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","content":{"name":{"en":"Adjust the amount according to the age and activity of your dog. You can serve AVEVE Diner dry. If you wish to serve AVEVE Dinner as a hot meal, add warm broth or water. Mix and wait for about 10 minutes. The meal is ready to serve."},"contentToString":{"en":"Adjust the amount according to the age and activity of your dog. You can serve AVEVE Diner dry. If you wish to serve AVEVE Dinner as a hot meal, add warm broth or water. Mix and wait for about 10 minutes. The meal is ready to serve."}},"createdAt":"2018-04-11T08:26:49.865Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:26:49.865Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc6c92e1f2f1ba4743b5f"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","content":{"name":{"en":"Always provide fresh drinking water!"},"contentToString":{"en":"Always provide fresh drinking water!"}},"createdAt":"2018-04-11T08:27:05.457Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:27:05.457Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc6d9ee2ecd9833667110"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"Extruded chunks"},"label":{"en":"Food-type"},"unit":{"en":""},"contentToString":{"en":"Food-type Extruded chunks "}},"createdAt":"2018-04-11T08:27:41.213Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:27:41.213Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc6fdee2ecdc645667129"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"Vegetable by-products, Meat and animal by-products (min. 4% Meat), Cereals, Oils and Fats, Vegetables, Minerals."},"label":{"en":"Composition"},"unit":{"en":""},"contentToString":{"en":"Composition Vegetable by-products, Meat and animal by-products (min. 4% Meat), Cereals, Oils and Fats, Vegetables, Minerals. "}},"createdAt":"2018-04-11T08:28:06.645Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:28:06.645Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc7162e1f2f1659743b88"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"Crude Protein: 21.0%, Crude Fat: 9.5%, Crude Fiber: 4.0%, Crude Axis: 6.5%"},"label":{"en":"Analytical components"},"unit":{"en":""},"contentToString":{"en":"Analytical components Crude Protein: 21.0%, Crude Fat: 9.5%, Crude Fiber: 4.0%, Crude Axis: 6.5% "}},"createdAt":"2018-04-11T08:28:35.333Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:28:35.333Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc733ee2ecd91f1667144"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"Vitamin (E672): 10,000IE / kg, Vitamin D3 (E671): 1,000IE / kg, Vitamin E: 100mg / kg, Copper (E4): 14mg / kg, Iron (E1): 100mg / kg, Zinc (E6) : 140mg / kg, Manganese (E5): 40mg / kg, Selenium (E8): 0.15mg / kg, Iodine (E2): 1,5mg / kg"},"label":{"en":"Additives"},"unit":{"en":""},"contentToString":{"en":"Additives Vitamin (E672): 10,000IE / kg, Vitamin D3 (E671): 1,000IE / kg, Vitamin E: 100mg / kg, Copper (E4): 14mg / kg, Iron (E1): 100mg / kg, Zinc (E6) : 140mg / kg, Manganese (E5): 40mg / kg, Selenium (E8): 0.15mg / kg, Iodine (E2): 1,5mg / kg "}},"createdAt":"2018-04-11T08:28:59.973Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:28:59.973Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc74b2e1f2f46ff743ba6"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","content":{"name":{"en":"Shelf life and lot number: see packaging. Keep cool, dry and dark. Always close the package properly."},"contentToString":{"en":"Shelf life and lot number: see packaging. Keep cool, dry and dark. Always close the package properly."}},"createdAt":"2018-04-11T08:29:22.680Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:29:22.680Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc762ee2ecd2911667158"},{"active":true,"kBitTypeId":"59f7475aac159c001284a12c","knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","content":{"public_id":"hdlxlsalgmvuzibfbvnq","width":585,"height":585,"format":"jpg","resource_type":"image","tags":[],"bytes":58675,"etag":"e4f79832b830da733c25df6951595d14","url":"http://res.cloudinary.com/knowledgeflow/image/authenticated/s--oMwXD-WY--/v1523435390/hdlxlsalgmvuzibfbvnq.jpg","secure_url":"https://res.cloudinary.com/knowledgeflow/image/authenticated/s--oMwXD-WY--/v1523435390/hdlxlsalgmvuzibfbvnq.jpg","signature":"dd177e97b69156276e869d4dcc432d7ba526c1b4","description":{"en":"","nl":"","ro":""}},"createdAt":"2018-04-11T08:29:50.644Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:29:50.644Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc77e2e1f2fbd61743bb5"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"Ant bait box to control ants in and around the home."},"contentToString":{"en":"Ant bait box to control ants in and around the home."}},"createdAt":"2018-04-11T08:35:36.973Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:36:58.225Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc8d8ee2ecd00d2667182"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"3 + 1 free"},"contentToString":{"en":"3 + 1 free"}},"createdAt":"2018-04-11T08:35:54.604Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:36:02.431Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc8ea2e1f2f3614743bde"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"The formula based on fipronil guarantees a powerful effect."},"contentToString":{"en":"The formula based on fipronil guarantees a powerful effect."}},"createdAt":"2018-04-11T08:37:15.416Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:37:15.416Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc93bee2ecd3acc6671aa"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","content":{"name":{"en":"Push in the claws and release them. Place the box with the holes upwards at places where ants pass by. The ants collect the product and place it in the nest, which is completely destroyed in a few days (larvae and adults). In case of a strong presence of ants, place several boxes."},"contentToString":{"en":"Push in the claws and release them. Place the box with the holes upwards at places where ants pass by. The ants collect the product and place it in the nest, which is completely destroyed in a few days (larvae and adults). In case of a strong presence of ants, place several boxes."}},"createdAt":"2018-04-11T08:37:38.973Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:37:38.973Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc9522e1f2ff9c0743c07"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","content":{"name":{"en":"1 box per nest. In case of strong presence of ants, place several boxes."},"contentToString":{"en":"1 box per nest. In case of strong presence of ants, place several boxes."}},"createdAt":"2018-04-11T08:38:02.499Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:38:02.499Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc96aee2ecde1036671bd"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"Contains 0.05% fipronil"},"label":{"en":"Composition"},"unit":{"en":""},"contentToString":{"en":"Composition Contains 0.05% fipronil "}},"createdAt":"2018-04-11T08:38:30.436Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:38:30.436Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdc9862e1f2f4907743c1c"},{"active":true,"kBitTypeId":"59f7475aac159c001284a12c","knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","content":{"public_id":"v0pydqxuwkxnknh81iqc","width":585,"height":585,"format":"jpg","resource_type":"image","tags":[],"bytes":113745,"etag":"857ca7d64c43d14c0c276c5550044f52","url":"http://res.cloudinary.com/knowledgeflow/image/authenticated/s--WN2E6Mep--/v1523436069/v0pydqxuwkxnknh81iqc.jpg","secure_url":"https://res.cloudinary.com/knowledgeflow/image/authenticated/s--WN2E6Mep--/v1523436069/v0pydqxuwkxnknh81iqc.jpg","signature":"9888d5b23a7fdb775a69f3a1654a2ffdbcc819c1","description":{"en":"","nl":"","ro":""}},"createdAt":"2018-04-11T08:41:10.328Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:41:10.328Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdca26ee2ecd2a536671d0"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"12,35"},"label":{"en":"Price"},"unit":{"en":"€"},"contentToString":{"en":"Price 12,35 €"}},"createdAt":"2018-04-11T08:41:48.524Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:41:48.524Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdca4c2e1f2fbed9743c2f"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"30,87"},"label":{"en":"Price / kg"},"unit":{"en":"€"},"contentToString":{"en":"Price / kg 30,87 €"}},"createdAt":"2018-04-11T08:42:06.617Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:42:06.617Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdca5eee2ecd0cb96671e8"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"Specially formulated food for the cultivation of potatoes, based on natural raw materials"},"contentToString":{"en":"Specially formulated food for the cultivation of potatoes, based on natural raw materials"}},"createdAt":"2018-04-11T08:45:06.420Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:45:06.420Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdcb122e1f2f61df743cc2"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"Rich in potassium for large, firm and tasty potatoes that have a long shelf life"},"contentToString":{"en":"Rich in potassium for large, firm and tasty potatoes that have a long shelf life"}},"createdAt":"2018-04-11T08:45:28.998Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:45:28.998Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdcb28ee2ecd75c4667278"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"Applicable in an organic garden"},"contentToString":{"en":"Applicable in an organic garden"}},"createdAt":"2018-04-11T08:45:51.805Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:45:51.805Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdcb3f2e1f2fce44743cd8"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"10"},"label":{"en":"Weight"},"unit":{"en":"kg"},"contentToString":{"en":"Weight 10 kg"}},"createdAt":"2018-04-11T08:46:16.857Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:46:16.857Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdcb58ee2ecda92d667291"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"17,95"},"label":{"en":"Price"},"unit":{"en":"€"},"contentToString":{"en":"Price 17,95 €"}},"createdAt":"2018-04-11T08:46:34.349Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:46:34.349Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdcb6a2e1f2f8138743cee"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"1,80"},"label":{"en":"Price / kg"},"unit":{"en":"€"},"contentToString":{"en":"Price / kg 1,80 €"}},"createdAt":"2018-04-11T08:46:52.588Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:46:52.588Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdcb7cee2ecd0a386672a8"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","content":{"name":{"en":"Dosage: 0,8 - 1,2 kg / 10 m²"},"contentToString":{"en":"Dosage: 0,8 - 1,2 kg / 10 m²"}},"createdAt":"2018-04-11T08:47:06.900Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:47:06.900Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdcb8a2e1f2f4036743d05"},{"active":true,"kBitTypeId":"59f7475aac159c001284a12c","knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","content":{"public_id":"tvaaflc34lbccycbdd4o","width":585,"height":585,"format":"jpg","resource_type":"image","tags":[],"bytes":61895,"etag":"d401d678b3a6023b144853b7e0a63ac1","url":"http://res.cloudinary.com/knowledgeflow/image/authenticated/s--fPfVEeSl--/v1523436448/tvaaflc34lbccycbdd4o.jpg","secure_url":"https://res.cloudinary.com/knowledgeflow/image/authenticated/s--fPfVEeSl--/v1523436448/tvaaflc34lbccycbdd4o.jpg","signature":"4b1bf9a2cd44a231536147a5c2f1aeb3f969baa2","description":{"en":"","nl":"","ro":""}},"createdAt":"2018-04-11T08:47:28.544Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:47:28.544Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdcba0ee2ecd06f96672b9"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"Fertilizer"},"label":{"en":"Type"},"unit":{"en":""},"contentToString":{"en":"Type Fertilizer "}},"createdAt":"2018-04-11T08:48:20.295Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T08:48:20.295Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdcbd42e1f2f96ec743d35"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"Specific potting soil for the planting and repotting of all types of orchids: Phalaenopsis, Miltonia, Odontglossum, Cymbidium and Cattleya. The fertilizer in the potting soil ensures a good start-up thanks to a complete and balanced package of nutritional elements that is adapted to the needs of the plants."},"contentToString":{"en":"Specific potting soil for the planting and repotting of all types of orchids: Phalaenopsis, Miltonia, Odontglossum, Cymbidium and Cattleya. The fertilizer in the potting soil ensures a good start-up thanks to a complete and balanced package of nutritional elements that is adapted to the needs of the plants."}},"createdAt":"2018-04-11T09:10:07.447Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:10:07.447Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd0efee2ecd59c26672fd"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"Good plant development and flowering"},"contentToString":{"en":"Good plant development and flowering"}},"createdAt":"2018-04-11T09:10:24.767Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:10:24.767Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd1002e1f2f26d7743d59"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"Pieces of bark (Pinus) prevent the soil from silting up and also provide a sustainable support to the roots"},"contentToString":{"en":"Pieces of bark (Pinus) prevent the soil from silting up and also provide a sustainable support to the roots"}},"createdAt":"2018-04-11T09:10:50.491Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:10:50.491Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd11aee2ecd431f66730e"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","content":{"name":{"en":"Give your plant water for repotting. Carefully remove them from the pot and remove the soil without damaging the roots. The dried out leaves, dead roots and dry flower stalks must be removed."},"contentToString":{"en":"Give your plant water for repotting. Carefully remove them from the pot and remove the soil without damaging the roots. The dried out leaves, dead roots and dry flower stalks must be removed."}},"createdAt":"2018-04-11T09:11:16.347Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:11:16.347Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd1342e1f2f0dd9743d6a"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"5"},"label":{"en":"Volume"},"unit":{"en":"l"},"contentToString":{"en":"Volume 5 l"}},"createdAt":"2018-04-11T09:11:27.074Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:11:36.566Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd13fee2ecd2dd5667323"},{"active":true,"kBitTypeId":"59f7475aac159c001284a12c","knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","content":{"public_id":"t257fqfd04s0ipewsdq3","width":585,"height":585,"format":"jpg","resource_type":"image","tags":[],"bytes":49573,"etag":"b604a8317ee79b5e23399531724354a0","url":"http://res.cloudinary.com/knowledgeflow/image/authenticated/s--gRrexcwe--/v1523437935/t257fqfd04s0ipewsdq3.jpg","secure_url":"https://res.cloudinary.com/knowledgeflow/image/authenticated/s--gRrexcwe--/v1523437935/t257fqfd04s0ipewsdq3.jpg","signature":"96592729eed8d83434c0fbeae97b0d4ebdb3e255","description":{"en":"","nl":"","ro":""}},"createdAt":"2018-04-11T09:12:16.192Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:12:16.192Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd1702e1f2f40fb743d88"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"4,70"},"label":{"en":"Price"},"unit":{"en":"€"},"contentToString":{"en":"Price 4,70 €"}},"createdAt":"2018-04-11T09:13:20.200Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:13:20.200Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd1b0ee2ecd406c667344"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"0,94"},"label":{"en":"Price / l"},"unit":{"en":"€"},"contentToString":{"en":"Price / l 0,94 €"}},"createdAt":"2018-04-11T09:13:40.351Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:13:40.351Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd1c42e1f2f345b743da3"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"Potting soil"},"label":{"en":"Type"},"unit":{"en":""},"contentToString":{"en":"Type Potting soil "}},"createdAt":"2018-04-11T09:14:27.470Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:14:27.470Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd1f3ee2ecd8332667368"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"The mix of yellow, orange, red shades makes these sunflowers particularly suitable as cut flowers. For applications in the border, a perk and in large pots."},"contentToString":{"en":"The mix of yellow, orange, red shades makes these sunflowers particularly suitable as cut flowers. For applications in the border, a perk and in large pots."}},"createdAt":"2018-04-11T09:15:59.750Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:15:59.750Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd24f2e1f2f6881743dd0"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"2,15"},"label":{"en":"Price"},"unit":{"en":"€"},"contentToString":{"en":"Price 2,15 €"}},"createdAt":"2018-04-11T09:16:18.614Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:16:18.614Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd262ee2ecd77a766738d"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","content":{"name":{"en":"Sow indoors in a nursery container or in pots, 1-2 cm deep. Cover the jars with plastic or glass to keep the sowing soil moist until the emergence of the seed. After four weeks, plant the young plants at the destination. In the ground: thinly sow, lightly press the seeds and cover with a layer of fine earth of about 1-2 cm. Watering and after emergence, if necessary, thinning to 25 cm apart."},"contentToString":{"en":"Sow indoors in a nursery container or in pots, 1-2 cm deep. Cover the jars with plastic or glass to keep the sowing soil moist until the emergence of the seed. After four weeks, plant the young plants at the destination. In the ground: thinly sow, lightly press the seeds and cover with a layer of fine earth of about 1-2 cm. Watering and after emergence, if necessary, thinning to 25 cm apart."}},"createdAt":"2018-04-11T09:16:49.202Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:16:49.202Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd2812e1f2ffb9e743de2"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"60"},"label":{"en":"Adult height"},"unit":{"en":"cm"},"contentToString":{"en":"Adult height 60 cm"}},"createdAt":"2018-04-11T09:17:37.340Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:22:13.134Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd2b1ee2ecd73bd6673a7"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"15 - 25"},"label":{"en":"Germ temperature"},"unit":{"en":"°C"},"contentToString":{"en":"Germ temperature 15 - 25 °C"}},"createdAt":"2018-04-11T09:18:26.110Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:18:26.110Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd2e22e1f2f44ab743e08"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"40"},"label":{"en":"Seeds / g"},"unit":{"en":""},"contentToString":{"en":"Seeds / g 40 "}},"createdAt":"2018-04-11T09:18:46.095Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:18:46.095Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd2f6ee2ecd520c6673c8"},{"active":true,"kBitTypeId":"59f7475aac159c001284a12c","knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","content":{"public_id":"xyheijdjf6n3taoyitlg","width":585,"height":585,"format":"jpg","resource_type":"image","tags":[],"bytes":71224,"etag":"ba4219103e30b48b9de115e02e2185f3","url":"http://res.cloudinary.com/knowledgeflow/image/authenticated/s--pkNwQfLs--/v1523438349/xyheijdjf6n3taoyitlg.jpg","secure_url":"https://res.cloudinary.com/knowledgeflow/image/authenticated/s--pkNwQfLs--/v1523438349/xyheijdjf6n3taoyitlg.jpg","signature":"57862b2ee813462d068df0424e46439d144620a2","description":{"en":"","nl":"","ro":""}},"createdAt":"2018-04-11T09:19:09.586Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:19:09.586Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd30d2e1f2f6460743e1c"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"Seed mix"},"label":{"en":"Type"},"unit":{"en":""},"contentToString":{"en":"Type Seed mix "}},"createdAt":"2018-04-11T09:19:20.515Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:19:20.515Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd318ee2ecd75c26673df"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"Marigolds (Calendula) are very easy to grow on all grounds and bloom long and luxuriant. The mixture is composed of yellow and orange hues and gives an abundance of cut flowers."},"contentToString":{"en":"Marigolds (Calendula) are very easy to grow on all grounds and bloom long and luxuriant. The mixture is composed of yellow and orange hues and gives an abundance of cut flowers."}},"createdAt":"2018-04-11T09:20:45.281Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:20:45.281Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd36d2e1f2f832b743e4b"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"1,35"},"label":{"en":"Price"},"unit":{"en":"€"},"contentToString":{"en":"Price 1,35 €"}},"createdAt":"2018-04-11T09:21:19.173Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:21:19.173Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd38f2e1f2fcc34743e63"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","content":{"name":{"en":"Sow in well-worked, finely raked and weed-free soil. Thinly sow and lightly press the seeds and cover with a layer of fine soil of about 1 cm. Watering and after emergence, if necessary, thinning to 15 cm apart. In the past, sow indoors and grow the young plants in pots."},"contentToString":{"en":"Sow in well-worked, finely raked and weed-free soil. Thinly sow and lightly press the seeds and cover with a layer of fine soil of about 1 cm. Watering and after emergence, if necessary, thinning to 15 cm apart. In the past, sow indoors and grow the young plants in pots."}},"createdAt":"2018-04-11T09:21:38.817Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:21:38.817Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd3a2ee2ecdd61a667418"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"30"},"label":{"en":"Adult height"},"unit":{"en":"cm"},"contentToString":{"en":"Adult height 30 cm"}},"createdAt":"2018-04-11T09:22:02.865Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:22:02.865Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd3ba2e1f2f2ffd743e7b"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"10 - 20"},"label":{"en":"Germ temperature"},"unit":{"en":"°C"},"contentToString":{"en":"Germ temperature 10 - 20 °C"}},"createdAt":"2018-04-11T09:22:49.654Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:22:49.654Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd3e9ee2ecddd9a667454"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"140"},"label":{"en":"Seeds / g"},"unit":{"en":""},"contentToString":{"en":"Seeds / g 140 "}},"createdAt":"2018-04-11T09:23:01.298Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:23:01.298Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd3f52e1f2f25e1743eb5"},{"active":true,"kBitTypeId":"59f7475aac159c001284a12c","knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","content":{"public_id":"ggmrzap3wlumr0usaljt","width":585,"height":585,"format":"jpg","resource_type":"image","tags":[],"bytes":61261,"etag":"6989b0f9ee829da280d47e5bd531b58b","url":"http://res.cloudinary.com/knowledgeflow/image/authenticated/s--mOlscBF2--/v1523438603/ggmrzap3wlumr0usaljt.jpg","secure_url":"https://res.cloudinary.com/knowledgeflow/image/authenticated/s--mOlscBF2--/v1523438603/ggmrzap3wlumr0usaljt.jpg","signature":"3f68513c81db1bf65548db85a3f381cd85d94573","description":{"en":"","nl":"","ro":""}},"createdAt":"2018-04-11T09:23:24.254Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:23:24.254Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd40cee2ecd6e17667466"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca2fa142c38ffe62ebbda","content":{"name":{"en":"AVEVE Sunflower Distino Mix"},"contentToString":{"en":"AVEVE Sunflower Distino Mix"}},"createdAt":"2018-04-11T09:23:48.931Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:23:48.931Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd4242e1f2f07a6743edc"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"A nice plant with small light blue bell-shaped flowers with a dark heart. Fragrant flowers that attract bees and butterflies. Bushy growth."},"contentToString":{"en":"A nice plant with small light blue bell-shaped flowers with a dark heart. Fragrant flowers that attract bees and butterflies. Bushy growth."}},"createdAt":"2018-04-11T09:26:35.493Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:26:35.493Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd4cbee2ecd2a436674b7"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"1,55"},"label":{"en":"Price"},"unit":{"en":"€"},"contentToString":{"en":"Price 1,55 €"}},"createdAt":"2018-04-11T09:26:53.110Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:26:53.110Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd4dd2e1f2fcb4f743f12"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","content":{"name":{"en":"Sow in well-worked, finely raked and weed-free soil. Thinly sow and lightly press the seeds and cover with a layer of fine soil of about 1 cm. Watering and after emergence, if necessary, thinning to 15 cm apart. Also well suited for pots."},"contentToString":{"en":"Sow in well-worked, finely raked and weed-free soil. Thinly sow and lightly press the seeds and cover with a layer of fine soil of about 1 cm. Watering and after emergence, if necessary, thinning to 15 cm apart. Also well suited for pots."}},"createdAt":"2018-04-11T09:27:34.830Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:27:34.830Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd5062e1f2f60c1743f30"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"50"},"label":{"en":"Adult height"},"unit":{"en":"cm"},"contentToString":{"en":"Adult height 50 cm"}},"createdAt":"2018-04-11T09:28:01.428Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:28:01.428Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd521ee2ecd30ec6674ff"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"18 - 20"},"label":{"en":"Germ temperature"},"unit":{"en":"°C"},"contentToString":{"en":"Germ temperature 18 - 20 °C"}},"createdAt":"2018-04-11T09:28:28.205Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:28:28.205Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd53c2e1f2f29fd743f64"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"220"},"label":{"en":"Seeds / g"},"unit":{"en":""},"contentToString":{"en":"Seeds / g 220 "}},"createdAt":"2018-04-11T09:29:22.117Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:29:22.117Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd572ee2ecd72aa667521"},{"active":true,"kBitTypeId":"59f7475aac159c001284a12c","knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","content":{"public_id":"dzyp5lub9n089ogqffdz","width":585,"height":585,"format":"jpg","resource_type":"image","tags":[],"bytes":68232,"etag":"572f94e44f35ce3d0aad08eb50086b2c","url":"http://res.cloudinary.com/knowledgeflow/image/authenticated/s--HGUK6nR9--/v1523438982/dzyp5lub9n089ogqffdz.jpg","secure_url":"https://res.cloudinary.com/knowledgeflow/image/authenticated/s--HGUK6nR9--/v1523438982/dzyp5lub9n089ogqffdz.jpg","signature":"40dde7b7c6f4b51b94316a59b09346257bd6f8eb","description":{"en":"","nl":"","ro":""}},"createdAt":"2018-04-11T09:29:42.990Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:29:42.990Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd5862e1f2fa549743f7f"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca2fa142c38ffe62ebbda","content":{"name":{"en":"AVEVE Marigold Fiesta Gitana Mix"},"contentToString":{"en":"AVEVE Marigold Fiesta Gitana Mix"}},"createdAt":"2018-04-11T09:30:41.092Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:30:41.092Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd5c12e1f2f06b9743fc2"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca2fa142c38ffe62ebbda","content":{"name":{"en":"AVEVE Gilia Tricolor Bird’s eyes"},"contentToString":{"en":"AVEVE Gilia Tricolor Bird’s eyes"}},"createdAt":"2018-04-11T09:31:21.280Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:31:21.280Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd5e92e1f2f8df274400f"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"Includes wall hose holder"},"contentToString":{"en":"Includes wall hose holder"}},"createdAt":"2018-04-11T09:33:51.090Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:33:51.090Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd67f2e1f2febcc744053"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"Hose guide"},"contentToString":{"en":"Hose guide"}},"createdAt":"2018-04-11T09:34:05.859Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:34:05.859Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd68dee2ecdf4df6675fb"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"Rotatable"},"contentToString":{"en":"Rotatable"}},"createdAt":"2018-04-11T09:34:16.125Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:34:16.125Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd6982e1f2f0019744062"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"Integrated carrying handle"},"contentToString":{"en":"Integrated carrying handle"}},"createdAt":"2018-04-11T09:34:30.012Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:34:30.012Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd6a6ee2ecdc42b66760a"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"Theft protection"},"contentToString":{"en":"Theft protection"}},"createdAt":"2018-04-11T09:34:55.918Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:34:55.918Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd6bf2e1f2f59ad744074"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","content":{"name":{"en":"The hose is automatically rolled up. The practical hose box is attached to the wall and can be swiveled 180 °. The hose can be pulled out with little effort and stopped at short intervals of up to 50 cm. The quality hose of 13 mm (½ '') provides a high water flow and optimum operation of the nozzle. With a short pull on the hose, the lock is released and the hose is automatically retracted by the roll-up without having to do anything else. Your hands remain clean."},"contentToString":{"en":"The hose is automatically rolled up. The practical hose box is attached to the wall and can be swiveled 180 °. The hose can be pulled out with little effort and stopped at short intervals of up to 50 cm. The quality hose of 13 mm (½ '') provides a high water flow and optimum operation of the nozzle. With a short pull on the hose, the lock is released and the hose is automatically retracted by the roll-up without having to do anything else. Your hands remain clean."}},"createdAt":"2018-04-11T09:35:36.343Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:35:36.343Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd6e8ee2ecd4e2e66761e"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","content":{"name":{"en":"After use, the connecting hose can easily be attached to the drip stop to prevent water running out."},"contentToString":{"en":"After use, the connecting hose can easily be attached to the drip stop to prevent water running out."}},"createdAt":"2018-04-11T09:36:02.826Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:36:02.826Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd7022e1f2f266b744083"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"The wall hose box is fully equipped with a 15-meter long quality hose, a 2-meter long connecting hose, a continuously adjustable garden sprayer (item no. 8114) and the required Original Gardena System components: three hose pieces (item 900, 901, 902) ), a standard hose coupling (item no 915) and a water stop (article number 913)."},"contentToString":{"en":"The wall hose box is fully equipped with a 15-meter long quality hose, a 2-meter long connecting hose, a continuously adjustable garden sprayer (item no. 8114) and the required Original Gardena System components: three hose pieces (item 900, 901, 902) ), a standard hose coupling (item no 915) and a water stop (article number 913)."}},"createdAt":"2018-04-11T09:36:53.018Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:36:53.018Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd735ee2ecdf9bb66762e"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"Irrigation"},"label":{"en":"Type"},"unit":{"en":""},"contentToString":{"en":"Type Irrigation "}},"createdAt":"2018-04-11T09:39:13.627Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:39:13.627Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd7c12e1f2f7a0574409b"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"104,99"},"label":{"en":"Price"},"unit":{"en":"€"},"contentToString":{"en":"Price 104,99 €"}},"createdAt":"2018-04-11T09:39:22.166Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:39:22.166Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd7caee2ecd1f50667648"},{"active":true,"kBitTypeId":"59f7475aac159c001284a12c","knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","content":{"public_id":"trd7wfk5u2icpijznkcm","width":585,"height":585,"format":"jpg","resource_type":"image","tags":[],"bytes":50145,"etag":"f7c5b19f4e183509b48947d40095143d","url":"http://res.cloudinary.com/knowledgeflow/image/authenticated/s--FZYFrDEz--/v1523439611/trd7wfk5u2icpijznkcm.jpg","secure_url":"https://res.cloudinary.com/knowledgeflow/image/authenticated/s--FZYFrDEz--/v1523439611/trd7wfk5u2icpijznkcm.jpg","signature":"3c56ee57a2faedf1a619088f4a74510fcf2aee9e","description":{"en":"","nl":"","ro":""}},"createdAt":"2018-04-11T09:40:12.299Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:40:12.299Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd7fc2e1f2f84127440ae"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"Modern and attractive design"},"contentToString":{"en":"Modern and attractive design"}},"createdAt":"2018-04-11T09:44:08.175Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:44:08.175Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd8e8ee2ecd5ed666766c"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"With ridges of soft plastic"},"contentToString":{"en":"With ridges of soft plastic"}},"createdAt":"2018-04-11T09:44:21.903Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:44:21.903Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd8f52e1f2f874c7440ce"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"Particularly strong hose connection due to strong clamping nut made of high-quality metal"},"contentToString":{"en":"Particularly strong hose connection due to strong clamping nut made of high-quality metal"}},"createdAt":"2018-04-11T09:44:39.816Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:44:39.816Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd907ee2ecd56fe66767b"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"7,99"},"label":{"en":"Price"},"unit":{"en":"€"},"contentToString":{"en":"Price 7,99 €"}},"createdAt":"2018-04-11T09:44:58.250Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:44:58.250Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd91a2e1f2f6a8b7440df"},{"active":true,"kBitTypeId":"59f7475aac159c001284a12c","knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","content":{"public_id":"evvvlkvw2ronjbzxauud","width":585,"height":585,"format":"jpg","resource_type":"image","tags":[],"bytes":47287,"etag":"a455fb0fd96e77b394c6a49336009a2a","url":"http://res.cloudinary.com/knowledgeflow/image/authenticated/s--bCND3aYD--/v1523439935/evvvlkvw2ronjbzxauud.jpg","secure_url":"https://res.cloudinary.com/knowledgeflow/image/authenticated/s--bCND3aYD--/v1523439935/evvvlkvw2ronjbzxauud.jpg","signature":"af41a7a8d9306f33c474e5947611d8eac902d84c","description":{"en":"","nl":"","ro":""}},"createdAt":"2018-04-11T09:45:35.433Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:45:35.433Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd93f2e1f2fba8e7440f0"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acc9cb7142c384a102eb92f","content":{"name":{"en":"Gardena Premium hose piece 15 - 19 mm"},"contentToString":{"en":"Gardena Premium hose piece 15 - 19 mm"}},"createdAt":"2018-04-11T09:46:06.931Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:46:06.931Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd95eee2ecd2b9b6676a5"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"The hose piece is suitable for 19 mm (3/4 \") and 16 mm (5/8\") hoses."},"contentToString":{"en":"The hose piece is suitable for 19 mm (3/4 \") and 16 mm (5/8\") hoses."}},"createdAt":"2018-04-11T09:47:21.244Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:47:21.244Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd9a92e1f2f4753744115"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"Easy in transport. The swivel bar ensures that the handle does not rotate when you unroll the hose. A curved connection ensures that the hose does not bend and that the hose rolls up carefree."},"contentToString":{"en":"Easy in transport. The swivel bar ensures that the handle does not rotate when you unroll the hose. A curved connection ensures that the hose does not bend and that the hose rolls up carefree."}},"createdAt":"2018-04-11T09:48:20.359Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:48:20.359Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd9e4ee2ecd34616676cb"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"Stability"},"contentToString":{"en":"Stability"}},"createdAt":"2018-04-11T09:48:32.306Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:48:32.306Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd9f02e1f2f5588744137"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"Rotatable bearing spindle"},"contentToString":{"en":"Rotatable bearing spindle"}},"createdAt":"2018-04-11T09:48:43.439Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:48:43.439Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdd9fbee2ecd4f316676da"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"Smooth running wheels with profile"},"contentToString":{"en":"Smooth running wheels with profile"}},"createdAt":"2018-04-11T09:48:58.036Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:48:58.036Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdda0a2e1f2fd630744147"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"42,99"},"label":{"en":"Price"},"unit":{"en":"€"},"contentToString":{"en":"Price 42,99 €"}},"createdAt":"2018-04-11T09:51:01.570Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:51:01.570Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdda852e1f2f7e7374415b"},{"active":true,"kBitTypeId":"59f7475aac159c001284a12c","knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","content":{"public_id":"mvvnjnwez12rglesxbze","width":585,"height":585,"format":"jpg","resource_type":"image","tags":[],"bytes":39015,"etag":"29fdb2454d76abd94bb796e6aaa03a26","url":"http://res.cloudinary.com/knowledgeflow/image/authenticated/s--R4XcY5od--/v1523440317/mvvnjnwez12rglesxbze.jpg","secure_url":"https://res.cloudinary.com/knowledgeflow/image/authenticated/s--R4XcY5od--/v1523440317/mvvnjnwez12rglesxbze.jpg","signature":"6e814997857bf6996544edaddd81fcf5e5d98901","description":{"en":"","nl":"","ro":""}},"createdAt":"2018-04-11T09:51:57.814Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:51:57.814Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acddabd2e1f2f2bd2744169"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca2fa142c38ffe62ebbda","content":{"name":{"en":"Gardena Comfort wall hose box 15 roll-up automatic"},"contentToString":{"en":"Gardena Comfort wall hose box 15 roll-up automatic"}},"createdAt":"2018-04-11T09:52:21.216Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:52:21.216Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acddad5ee2ecda2d7667719"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca2fa142c38ffe62ebbda","content":{"name":{"en":"Gardena Classic hose car 50 Complete 8013-20"},"contentToString":{"en":"Gardena Classic hose car 50 Complete 8013-20"}},"createdAt":"2018-04-11T09:52:35.386Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T09:52:35.386Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acddae32e1f2f5057744197"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5ac74e594473ec1377182869","content":{"name":{"en":"Ecorub border rubber length 5 m."},"contentToString":{"en":"Ecorub border rubber length 5 m."}},"createdAt":"2018-04-11T09:56:00.313Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-05-04T11:55:55.650Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acddbb0ee2ecd43b566774c"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"Fence"},"label":{"en":"Type"},"unit":{"en":""},"contentToString":{"en":"Type Fence "}},"createdAt":"2018-04-11T10:04:07.276Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T10:04:07.276Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acddd97ee2ecd0f95667773"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"16,95"},"label":{"en":"Price"},"unit":{"en":"€"},"contentToString":{"en":"Price 16,95 €"}},"createdAt":"2018-04-11T10:04:26.673Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T10:04:26.673Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdddaa2e1f2f0efc7441e3"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"3,5"},"label":{"en":"Height"},"unit":{"en":"mm"},"contentToString":{"en":"Height 3,5 mm"}},"createdAt":"2018-04-11T10:05:07.104Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T10:05:07.104Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdddd3ee2ecd596366778a"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"13"},"label":{"en":"Width"},"unit":{"en":"cm"},"contentToString":{"en":"Width 13 cm"}},"createdAt":"2018-04-11T10:05:27.874Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T10:05:27.874Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acddde72e1f2f17647441fb"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acb26bc75345d482b8e2915","content":{"name":{"en":"5"},"label":{"en":"Length"},"unit":{"en":"m"},"contentToString":{"en":"Length 5 m"}},"createdAt":"2018-04-11T10:05:45.151Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T10:05:45.151Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acdddf9ee2ecd24f46677a1"},{"active":true,"kBitTypeId":"59f7475aac159c001284a12c","knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","content":{"public_id":"z7yp8ycoo6mv5yvlefup","width":585,"height":585,"format":"jpg","resource_type":"image","tags":[],"bytes":163989,"etag":"3aee26bcb39dfbb889d0f3343456acfa","url":"http://res.cloudinary.com/knowledgeflow/image/authenticated/s--d_AA0oM9--/v1523441488/z7yp8ycoo6mv5yvlefup.jpg","secure_url":"https://res.cloudinary.com/knowledgeflow/image/authenticated/s--d_AA0oM9--/v1523441488/z7yp8ycoo6mv5yvlefup.jpg","signature":"c82215554d90cd527feb9edbef5aa63eea32254d","description":{"en":"","nl":"","ro":""}},"createdAt":"2018-04-11T10:11:29.202Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T10:11:29.202Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acddf51ee2ecd77dc6677ae"},{"active":true,"kBitTypeId":"59f7475aac159c001284a12c","knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","content":{"public_id":"vhpjs4iafprtecuotxsj","width":585,"height":585,"format":"jpg","resource_type":"image","tags":[],"bytes":140694,"etag":"da88e278d1c055df0d2a10e2d3c1b5c6","url":"http://res.cloudinary.com/knowledgeflow/image/authenticated/s--zE2lE_4I--/v1523441495/vhpjs4iafprtecuotxsj.jpg","secure_url":"https://res.cloudinary.com/knowledgeflow/image/authenticated/s--zE2lE_4I--/v1523441495/vhpjs4iafprtecuotxsj.jpg","signature":"7b2d9c77c9fb691e6395c2f7ea00fbe75187f82d","description":{"en":"","nl":"","ro":""}},"createdAt":"2018-04-11T10:11:36.367Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T10:11:36.367Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acddf582e1f2f4c82744219"},{"active":true,"kBitTypeId":"59f7475aac159c001284a12c","knowledgeTemplateBlockId":"5acb906a665a154bae2d723a","content":{"public_id":"mhijbywzldhle3lzqkxv","width":585,"height":585,"format":"jpg","resource_type":"image","tags":[],"bytes":142539,"etag":"bf55924d98c51560a4c2dc4751d88f4d","url":"http://res.cloudinary.com/knowledgeflow/image/authenticated/s--YQPY9OdW--/v1523441503/mhijbywzldhle3lzqkxv.jpg","secure_url":"https://res.cloudinary.com/knowledgeflow/image/authenticated/s--YQPY9OdW--/v1523441503/mhijbywzldhle3lzqkxv.jpg","signature":"8a1b11fd0de1d616228f257821f3e09b7f6786da","description":{"en":"","nl":"","ro":""}},"createdAt":"2018-04-11T10:11:44.074Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T10:11:44.074Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acddf60ee2ecd41e16677ba"},{"active":true,"kBitTypeId":"59f74759c93d9d0012bd1216","knowledgeTemplateBlockId":"5acca273e1febae5e41fa5d1","content":{"name":{"en":"Put into the ground, no support pickets needed."},"contentToString":{"en":"Put into the ground, no support pickets needed."}},"createdAt":"2018-04-11T10:14:24.843Z","createdBy":"5ac5c097482a01b279d9a2f9","updatedAt":"2018-04-11T10:14:24.843Z","updatedBy":"5ac5c097482a01b279d9a2f9","type":"knowledge-bits","resourceId":"5acde0002e1f2f09cb74422b"}]}

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n  width: 35vw;\n  height: 100vh;\n  padding: 0.25em;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'],['\n  width: 35vw;\n  height: 100vh;\n  padding: 0.25em;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: 99%;\n  height: 99%;\n  box-sizing: border-box;\n  border: solid 1px #0078d7;\n  border-radius: 5px;\n'],['\n  width: 99%;\n  height: 99%;\n  box-sizing: border-box;\n  border: solid 1px #0078d7;\n  border-radius: 5px;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject);var Iframe=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].iframe(_templateObject2);var Ella=function Ella(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Iframe,{src:'https://webchat.botframework.com/embed/project-siba-chatbot?s=nO3ucarABhU.cwA.c4Q.CG8IfORCPfSBiimstIH7G22tjxHY1hZ7AUNSWwHKCT8'}));};/* harmony default export */ __webpack_exports__["a"] = (Ella);

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_i18next__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18next_xhr_backend__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18next_xhr_backend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_i18next_xhr_backend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18next_browser_languagedetector__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18next_browser_languagedetector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_i18next_browser_languagedetector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_i18next__ = __webpack_require__(3);
__WEBPACK_IMPORTED_MODULE_0_i18next__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_i18next_xhr_backend___default.a).use(__WEBPACK_IMPORTED_MODULE_2_i18next_browser_languagedetector___default.a).use(__WEBPACK_IMPORTED_MODULE_3_react_i18next__["c" /* reactI18nextModule */]).init({fallbackLng:'en',// have a common namespace used around the full app
ns:['translations'],defaultNS:'translations',whitelist:['en','nl'],debug:"production"!=='production',interpolation:{escapeValue:false// not needed for react!!
},react:{wait:true}});/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_i18next__["a" /* default */]);

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export changeLanguage */
/* unused harmony export cloneInstance */
/* unused harmony export createInstance */
/* unused harmony export dir */
/* unused harmony export exists */
/* unused harmony export getFixedT */
/* unused harmony export init */
/* unused harmony export loadLanguages */
/* unused harmony export loadNamespaces */
/* unused harmony export loadResources */
/* unused harmony export off */
/* unused harmony export on */
/* unused harmony export setDefaultNamespace */
/* unused harmony export t */
/* unused harmony export use */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18next_js__ = __webpack_require__(156);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);

var changeLanguage = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].changeLanguage.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var cloneInstance = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].cloneInstance.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var createInstance = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].createInstance.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var dir = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].dir.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var exists = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].exists.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var getFixedT = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].getFixedT.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var init = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].init.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var loadLanguages = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].loadLanguages.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var loadNamespaces = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].loadNamespaces.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var loadResources = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].loadResources.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var off = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].off.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var on = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].on.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var setDefaultNamespace = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].setDefaultNamespace.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var t = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].t.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var use = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].use.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResourceStore_js__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Translator_js__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LanguageUtils_js__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PluralResolver_js__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Interpolator_js__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BackendConnector_js__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__defaults_js__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__postProcessor_js__ = __webpack_require__(35);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }












function noop() {}

var I18n = function (_EventEmitter) {
  _inherits(I18n, _EventEmitter);

  function I18n() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    _classCallCheck(this, I18n);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.options = Object(__WEBPACK_IMPORTED_MODULE_8__defaults_js__["b" /* transformOptions */])(options);
    _this.services = {};
    _this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */];
    _this.modules = { external: [] };

    if (callback && !_this.isInitialized && !options.isClone) {
      var _ret;

      // https://github.com/i18next/i18next/issues/879
      if (!_this.options.initImmediate) return _ret = _this.init(options, callback), _possibleConstructorReturn(_this, _ret);
      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }
    return _this;
  }

  I18n.prototype.init = function init() {
    var _this2 = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    this.options = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_8__defaults_js__["a" /* get */])(), this.options, Object(__WEBPACK_IMPORTED_MODULE_8__defaults_js__["b" /* transformOptions */])(options));

    this.format = this.options.interpolation.format;
    if (!callback) callback = noop;

    function createClassOnDemand(ClassOrObject) {
      if (!ClassOrObject) return null;
      if (typeof ClassOrObject === 'function') return new ClassOrObject();
      return ClassOrObject;
    }

    // init services
    if (!this.options.isClone) {
      if (this.modules.logger) {
        __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].init(createClassOnDemand(this.modules.logger), this.options);
      } else {
        __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].init(null, this.options);
      }

      var lu = new __WEBPACK_IMPORTED_MODULE_4__LanguageUtils_js__["a" /* default */](this.options);
      this.store = new __WEBPACK_IMPORTED_MODULE_2__ResourceStore_js__["a" /* default */](this.options.resources, this.options);

      var s = this.services;
      s.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */];
      s.resourceStore = this.store;
      s.languageUtils = lu;
      s.pluralResolver = new __WEBPACK_IMPORTED_MODULE_5__PluralResolver_js__["a" /* default */](lu, { prepend: this.options.pluralSeparator, compatibilityJSON: this.options.compatibilityJSON, simplifyPluralSuffix: this.options.simplifyPluralSuffix });
      s.interpolator = new __WEBPACK_IMPORTED_MODULE_6__Interpolator_js__["a" /* default */](this.options);

      s.backendConnector = new __WEBPACK_IMPORTED_MODULE_7__BackendConnector_js__["a" /* default */](createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
      // pipe events from backendConnector
      s.backendConnector.on('*', function (event) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      if (this.modules.languageDetector) {
        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
        s.languageDetector.init(s, this.options.detection, this.options);
      }

      if (this.modules.i18nFormat) {
        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
        if (s.i18nFormat.init) s.i18nFormat.init(this);
      }

      this.translator = new __WEBPACK_IMPORTED_MODULE_3__Translator_js__["a" /* default */](this.services, this.options);
      // pipe events from translator
      this.translator.on('*', function (event) {
        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      this.modules.external.forEach(function (m) {
        if (m.init) m.init(_this2);
      });
    }

    // append api
    var storeApi = ['getResource', 'addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle', 'hasResourceBundle', 'getResourceBundle'];
    storeApi.forEach(function (fcName) {
      _this2[fcName] = function () {
        var _store;

        return (_store = _this2.store)[fcName].apply(_store, arguments);
      };
    });

    var load = function load() {
      _this2.changeLanguage(_this2.options.lng, function (err, t) {
        _this2.isInitialized = true;
        _this2.logger.log('initialized', _this2.options);
        _this2.emit('initialized', _this2.options);

        callback(err, t);
      });
    };

    if (this.options.resources || !this.options.initImmediate) {
      load();
    } else {
      setTimeout(load, 0);
    }

    return this;
  };

  /* eslint consistent-return: 0 */


  I18n.prototype.loadResources = function loadResources() {
    var _this3 = this;

    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;

    if (!this.options.resources) {
      if (this.language && this.language.toLowerCase() === 'cimode') return callback(); // avoid loading resources for cimode

      var toLoad = [];

      var append = function append(lng) {
        if (!lng) return;
        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
        lngs.forEach(function (l) {
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };

      if (!this.language) {
        // at least load fallbacks in this case
        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        fallbacks.forEach(function (l) {
          return append(l);
        });
      } else {
        append(this.language);
      }

      if (this.options.preload) {
        this.options.preload.forEach(function (l) {
          return append(l);
        });
      }

      this.services.backendConnector.load(toLoad, this.options.ns, callback);
    } else {
      callback(null);
    }
  };

  I18n.prototype.reloadResources = function reloadResources(lngs, ns) {
    if (!lngs) lngs = this.languages;
    if (!ns) ns = this.options.ns;
    this.services.backendConnector.reload(lngs, ns);
  };

  I18n.prototype.use = function use(module) {
    if (module.type === 'backend') {
      this.modules.backend = module;
    }

    if (module.type === 'logger' || module.log && module.warn && module.error) {
      this.modules.logger = module;
    }

    if (module.type === 'languageDetector') {
      this.modules.languageDetector = module;
    }

    if (module.type === 'i18nFormat') {
      this.modules.i18nFormat = module;
    }

    if (module.type === 'postProcessor') {
      __WEBPACK_IMPORTED_MODULE_9__postProcessor_js__["a" /* default */].addPostProcessor(module);
    }

    if (module.type === '3rdParty') {
      this.modules.external.push(module);
    }

    return this;
  };

  I18n.prototype.changeLanguage = function changeLanguage(lng, callback) {
    var _this4 = this;

    var done = function done(err, l) {
      _this4.translator.changeLanguage(l);

      if (l) {
        _this4.emit('languageChanged', l);
        _this4.logger.log('languageChanged', l);
      }

      if (callback) callback(err, function () {
        return _this4.t.apply(_this4, arguments);
      });
    };

    var setLng = function setLng(l) {
      if (l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
        if (!_this4.translator.language) _this4.translator.changeLanguage(l);

        if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
      }

      _this4.loadResources(function (err) {
        done(err, l);
      });
    };

    if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
      setLng(this.services.languageDetector.detect());
    } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
      this.services.languageDetector.detect(setLng);
    } else {
      setLng(lng);
    }
  };

  I18n.prototype.getFixedT = function getFixedT(lng, ns) {
    var _this5 = this;

    var fixedT = function fixedT(key, opts) {
      for (var _len3 = arguments.length, rest = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        rest[_key3 - 2] = arguments[_key3];
      }

      var options = _extends({}, opts);
      if ((typeof opts === 'undefined' ? 'undefined' : _typeof(opts)) !== 'object') {
        options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
      }

      options.lng = options.lng || fixedT.lng;
      options.lngs = options.lngs || fixedT.lngs;
      options.ns = options.ns || fixedT.ns;
      return _this5.t(key, options);
    };
    if (typeof lng === 'string') {
      fixedT.lng = lng;
    } else {
      fixedT.lngs = lng;
    }
    fixedT.ns = ns;
    return fixedT;
  };

  I18n.prototype.t = function t() {
    var _translator;

    return this.translator && (_translator = this.translator).translate.apply(_translator, arguments);
  };

  I18n.prototype.exists = function exists() {
    var _translator2;

    return this.translator && (_translator2 = this.translator).exists.apply(_translator2, arguments);
  };

  I18n.prototype.setDefaultNamespace = function setDefaultNamespace(ns) {
    this.options.defaultNS = ns;
  };

  I18n.prototype.loadNamespaces = function loadNamespaces(ns, callback) {
    var _this6 = this;

    if (!this.options.ns) return callback && callback();
    if (typeof ns === 'string') ns = [ns];

    ns.forEach(function (n) {
      if (_this6.options.ns.indexOf(n) < 0) _this6.options.ns.push(n);
    });

    this.loadResources(callback);
  };

  I18n.prototype.loadLanguages = function loadLanguages(lngs, callback) {
    if (typeof lngs === 'string') lngs = [lngs];
    var preloaded = this.options.preload || [];

    var newLngs = lngs.filter(function (lng) {
      return preloaded.indexOf(lng) < 0;
    });
    // Exit early if all given languages are already preloaded
    if (!newLngs.length) return callback();

    this.options.preload = preloaded.concat(newLngs);
    this.loadResources(callback);
  };

  I18n.prototype.dir = function dir(lng) {
    if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
    if (!lng) return 'rtl';

    var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];

    return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
  };

  /* eslint class-methods-use-this: 0 */


  I18n.prototype.createInstance = function createInstance() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    return new I18n(options, callback);
  };

  I18n.prototype.cloneInstance = function cloneInstance() {
    var _this7 = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

    var mergedOptions = _extends({}, this.options, options, { isClone: true });
    var clone = new I18n(mergedOptions);
    var membersToCopy = ['store', 'services', 'language'];
    membersToCopy.forEach(function (m) {
      clone[m] = _this7[m];
    });
    clone.translator = new __WEBPACK_IMPORTED_MODULE_3__Translator_js__["a" /* default */](clone.services, clone.options);
    clone.translator.on('*', function (event) {
      for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      clone.emit.apply(clone, [event].concat(args));
    });
    clone.init(mergedOptions, callback);
    clone.translator.options = clone.options; // sync options

    return clone;
  };

  return I18n;
}(__WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new I18n());

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EventEmitter_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_js__ = __webpack_require__(13);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }




var ResourceStore = function (_EventEmitter) {
  _inherits(ResourceStore, _EventEmitter);

  function ResourceStore(data) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { ns: ['translation'], defaultNS: 'translation' };

    _classCallCheck(this, ResourceStore);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.data = data || {};
    _this.options = options;
    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }
    return _this;
  }

  ResourceStore.prototype.addNamespaces = function addNamespaces(ns) {
    if (this.options.ns.indexOf(ns) < 0) {
      this.options.ns.push(ns);
    }
  };

  ResourceStore.prototype.removeNamespaces = function removeNamespaces(ns) {
    var index = this.options.ns.indexOf(ns);
    if (index > -1) {
      this.options.ns.splice(index, 1);
    }
  };

  ResourceStore.prototype.getResource = function getResource(lng, ns, key) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

    var path = [lng, ns];
    if (key && typeof key !== 'string') path = path.concat(key);
    if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
    }

    return __WEBPACK_IMPORTED_MODULE_1__utils_js__["d" /* getPath */](this.data, path);
  };

  ResourceStore.prototype.addResource = function addResource(lng, ns, key, value) {
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : { silent: false };

    var keySeparator = this.options.keySeparator;
    if (keySeparator === undefined) keySeparator = '.';

    var path = [lng, ns];
    if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      value = ns;
      ns = path[1];
    }

    this.addNamespaces(ns);

    __WEBPACK_IMPORTED_MODULE_1__utils_js__["h" /* setPath */](this.data, path, value);

    if (!options.silent) this.emit('added', lng, ns, key, value);
  };

  ResourceStore.prototype.addResources = function addResources(lng, ns, resources) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { silent: false };

    /* eslint no-restricted-syntax: 0 */
    for (var m in resources) {
      if (typeof resources[m] === 'string') this.addResource(lng, ns, m, resources[m], { silent: true });
    }
    if (!options.silent) this.emit('added', lng, ns, resources);
  };

  ResourceStore.prototype.addResourceBundle = function addResourceBundle(lng, ns, resources, deep, overwrite) {
    var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : { silent: false };

    var path = [lng, ns];
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      deep = resources;
      resources = ns;
      ns = path[1];
    }

    this.addNamespaces(ns);

    var pack = __WEBPACK_IMPORTED_MODULE_1__utils_js__["d" /* getPath */](this.data, path) || {};

    if (deep) {
      __WEBPACK_IMPORTED_MODULE_1__utils_js__["b" /* deepExtend */](pack, resources, overwrite);
    } else {
      pack = _extends({}, pack, resources);
    }

    __WEBPACK_IMPORTED_MODULE_1__utils_js__["h" /* setPath */](this.data, path, pack);

    if (!options.silent) this.emit('added', lng, ns, resources);
  };

  ResourceStore.prototype.removeResourceBundle = function removeResourceBundle(lng, ns) {
    if (this.hasResourceBundle(lng, ns)) {
      delete this.data[lng][ns];
    }
    this.removeNamespaces(ns);

    this.emit('removed', lng, ns);
  };

  ResourceStore.prototype.hasResourceBundle = function hasResourceBundle(lng, ns) {
    return this.getResource(lng, ns) !== undefined;
  };

  ResourceStore.prototype.getResourceBundle = function getResourceBundle(lng, ns) {
    if (!ns) ns = this.options.defaultNS;

    // COMPATIBILITY: remove extend in v2.1.0
    if (this.options.compatibilityAPI === 'v1') return _extends({}, this.getResource(lng, ns));

    return this.getResource(lng, ns);
  };

  ResourceStore.prototype.toJSON = function toJSON() {
    return this.data;
  };

  return ResourceStore;
}(__WEBPACK_IMPORTED_MODULE_0__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ResourceStore);

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__postProcessor_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_js__ = __webpack_require__(13);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }






var Translator = function (_EventEmitter) {
  _inherits(Translator, _EventEmitter);

  function Translator(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Translator);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    __WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* copy */](['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat'], services, _this);

    _this.options = options;
    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].create('translator');
    return _this;
  }

  Translator.prototype.changeLanguage = function changeLanguage(lng) {
    if (lng) this.language = lng;
  };

  Translator.prototype.exists = function exists(key) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { interpolation: {} };

    var resolved = this.resolve(key, options);
    return resolved && resolved.res !== undefined;
  };

  Translator.prototype.extractFromKey = function extractFromKey(key, options) {
    var nsSeparator = options.nsSeparator || this.options.nsSeparator;
    if (nsSeparator === undefined) nsSeparator = ':';

    var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

    var namespaces = options.ns || this.options.defaultNS;
    if (nsSeparator && key.indexOf(nsSeparator) > -1) {
      var parts = key.split(nsSeparator);
      if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
      key = parts.join(keySeparator);
    }
    if (typeof namespaces === 'string') namespaces = [namespaces];

    return {
      key: key,
      namespaces: namespaces
    };
  };

  Translator.prototype.translate = function translate(keys, options) {
    var _this2 = this;

    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object' && this.options.overloadTranslationOptionHandler) {
      /* eslint prefer-rest-params: 0 */
      options = this.options.overloadTranslationOptionHandler(arguments);
    }
    if (!options) options = {};

    // non valid keys handling
    if (keys === undefined || keys === null || keys === '') return '';
    if (typeof keys === 'number') keys = String(keys);
    if (typeof keys === 'string') keys = [keys];

    // separators
    var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

    // get namespace(s)

    var _extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
        key = _extractFromKey.key,
        namespaces = _extractFromKey.namespaces;

    var namespace = namespaces[namespaces.length - 1];

    // return key on CIMode
    var lng = options.lng || this.language;
    var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (lng && lng.toLowerCase() === 'cimode') {
      if (appendNamespaceToCIMode) {
        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
        return namespace + nsSeparator + key;
      }

      return key;
    }

    // resolve from store
    var resolved = this.resolve(keys, options);
    var res = resolved && resolved.res;
    var resUsedKey = resolved && resolved.usedKey || key;

    var resType = Object.prototype.toString.apply(res);
    var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
    var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;

    // object
    var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
    if (res && handleAsObject && noObject.indexOf(resType) < 0 && !(joinArrays && resType === '[object Array]')) {
      if (!options.returnObjects && !this.options.returnObjects) {
        this.logger.warn('accessing an object - but returnObjects options is not enabled!');
        return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : 'key \'' + key + ' (' + this.language + ')\' returned an object instead of string.';
      }

      // if we got a separator we loop over children - else we just return object as is
      // as having it set to false means no hierarchy so no lookup for nested values
      if (keySeparator) {
        var copy = resType === '[object Array]' ? [] : {}; // apply child translation on a copy

        /* eslint no-restricted-syntax: 0 */
        for (var m in res) {
          if (Object.prototype.hasOwnProperty.call(res, m)) {
            var deepKey = '' + resUsedKey + keySeparator + m;
            copy[m] = this.translate(deepKey, _extends({}, options, { joinArrays: false, ns: namespaces }));
            if (copy[m] === deepKey) copy[m] = res[m]; // if nothing found use orginal value as fallback
          }
        }
        res = copy;
      }
    } else if (joinArrays && resType === '[object Array]') {
      // array special treatment
      res = res.join(joinArrays);
      if (res) res = this.extendTranslation(res, keys, options);
    } else {
      // string, empty or null
      var usedDefault = false;
      var usedKey = false;

      // fallback value
      if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
        usedDefault = true;
        res = options.defaultValue;
      }
      if (!this.isValidLookup(res)) {
        usedKey = true;
        res = key;
      }

      // save missing
      var updateMissing = options.defaultValue && options.defaultValue !== res && this.options.updateMissing;
      if (usedKey || usedDefault || updateMissing) {
        this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? options.defaultValue : res);

        var lngs = [];
        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
          for (var i = 0; i < fallbackLngs.length; i++) {
            lngs.push(fallbackLngs[i]);
          }
        } else if (this.options.saveMissingTo === 'all') {
          lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
        } else {
          lngs.push(options.lng || this.language);
        }

        var send = function send(l, k) {
          if (_this2.options.missingKeyHandler) {
            _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
          } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
            _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
          }
          _this2.emit('missingKey', l, namespace, k, res);
        };

        if (this.options.saveMissing) {
          if (this.options.saveMissingPlurals && options.count) {
            lngs.forEach(function (l) {
              var plurals = _this2.pluralResolver.getPluralFormsOfKey(l, key);

              plurals.forEach(function (p) {
                return send([l], p);
              });
            });
          } else {
            send(lngs, key);
          }
        }
      }

      // extend
      res = this.extendTranslation(res, keys, options, resolved);

      // append namespace if still key
      if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = namespace + ':' + key;

      // parseMissingKeyHandler
      if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
    }

    // return
    return res;
  };

  Translator.prototype.extendTranslation = function extendTranslation(res, key, options, resolved) {
    var _this3 = this;

    if (this.i18nFormat && this.i18nFormat.parse) {
      res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, { resolved: resolved });
    } else if (!options.skipInterpolation) {
      // i18next.parsing
      if (options.interpolation) this.interpolator.init(_extends({}, options, { interpolation: _extends({}, this.options.interpolation, options.interpolation) }));

      // interpolate
      var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
      if (this.options.interpolation.defaultVariables) data = _extends({}, this.options.interpolation.defaultVariables, data);
      res = this.interpolator.interpolate(res, data, options.lng || this.language);

      // nesting
      if (options.nest !== false) res = this.interpolator.nest(res, function () {
        return _this3.translate.apply(_this3, arguments);
      }, options);

      if (options.interpolation) this.interpolator.reset();
    }

    // post process
    var postProcess = options.postProcess || this.options.postProcess;
    var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

    if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
      res = __WEBPACK_IMPORTED_MODULE_2__postProcessor_js__["a" /* default */].handle(postProcessorNames, res, key, options, this);
    }

    return res;
  };

  Translator.prototype.resolve = function resolve(keys) {
    var _this4 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var found = void 0;
    var usedKey = void 0;
    var usedLng = void 0;
    var usedNS = void 0;

    if (typeof keys === 'string') keys = [keys];

    // forEach possible key
    keys.forEach(function (k) {
      if (_this4.isValidLookup(found)) return;
      var extracted = _this4.extractFromKey(k, options);
      var key = extracted.key;
      usedKey = key;
      var namespaces = extracted.namespaces;
      if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);

      var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
      var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';

      var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language);

      namespaces.forEach(function (ns) {
        if (_this4.isValidLookup(found)) return;
        usedNS = ns;

        codes.forEach(function (code) {
          if (_this4.isValidLookup(found)) return;
          usedLng = code;

          var finalKey = key;
          var finalKeys = [finalKey];

          if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
            _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
          } else {
            var pluralSuffix = void 0;
            if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count);

            // fallback for plural if context not found
            if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);

            // get key for context if needed
            if (needsContextHandling) finalKeys.push(finalKey += '' + _this4.options.contextSeparator + options.context);

            // get key for plural if needed
            if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
          }

          // iterate over finalKeys starting with most specific pluralkey (-> contextkey only) -> singularkey only
          var possibleKey = void 0;
          /* eslint no-cond-assign: 0 */
          while (possibleKey = finalKeys.pop()) {
            if (!_this4.isValidLookup(found)) {
              found = _this4.getResource(code, ns, possibleKey, options);
            }
          }
        });
      });
    });

    return { res: found, usedKey: usedKey, usedLng: usedLng, usedNS: usedNS };
  };

  Translator.prototype.isValidLookup = function isValidLookup(res) {
    return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
  };

  Translator.prototype.getResource = function getResource(code, ns, key) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    return this.resourceStore.getResource(code, ns, key, options);
  };

  return Translator;
}(__WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Translator);

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(8);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    _classCallCheck(this, LanguageUtil);

    this.options = options;

    this.whitelist = this.options.whitelist || false;
    this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].create('languageUtils');
  }

  LanguageUtil.prototype.getScriptPartFromCode = function getScriptPartFromCode(code) {
    if (!code || code.indexOf('-') < 0) return null;

    var p = code.split('-');
    if (p.length === 2) return null;
    p.pop();
    return this.formatLanguageCode(p.join('-'));
  };

  LanguageUtil.prototype.getLanguagePartFromCode = function getLanguagePartFromCode(code) {
    if (!code || code.indexOf('-') < 0) return code;

    var p = code.split('-');
    return this.formatLanguageCode(p[0]);
  };

  LanguageUtil.prototype.formatLanguageCode = function formatLanguageCode(code) {
    // http://www.iana.org/assignments/language-tags/language-tags.xhtml
    if (typeof code === 'string' && code.indexOf('-') > -1) {
      var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
      var p = code.split('-');

      if (this.options.lowerCaseLng) {
        p = p.map(function (part) {
          return part.toLowerCase();
        });
      } else if (p.length === 2) {
        p[0] = p[0].toLowerCase();
        p[1] = p[1].toUpperCase();

        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
      } else if (p.length === 3) {
        p[0] = p[0].toLowerCase();

        // if lenght 2 guess it's a country
        if (p[1].length === 2) p[1] = p[1].toUpperCase();
        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();

        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
      }

      return p.join('-');
    }

    return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
  };

  LanguageUtil.prototype.isWhitelisted = function isWhitelisted(code) {
    if (this.options.load === 'languageOnly' || this.options.nonExplicitWhitelist) {
      code = this.getLanguagePartFromCode(code);
    }
    return !this.whitelist || !this.whitelist.length || this.whitelist.indexOf(code) > -1;
  };

  LanguageUtil.prototype.getFallbackCodes = function getFallbackCodes(fallbacks, code) {
    if (!fallbacks) return [];
    if (typeof fallbacks === 'string') fallbacks = [fallbacks];
    if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;

    if (!code) return fallbacks.default || [];

    // asume we have an object defining fallbacks
    var found = fallbacks[code];
    if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
    if (!found) found = fallbacks[this.formatLanguageCode(code)];
    if (!found) found = fallbacks.default;

    return found || [];
  };

  LanguageUtil.prototype.toResolveHierarchy = function toResolveHierarchy(code, fallbackCode) {
    var _this = this;

    var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);

    var codes = [];
    var addCode = function addCode(c) {
      if (!c) return;
      if (_this.isWhitelisted(c)) {
        codes.push(c);
      } else {
        _this.logger.warn('rejecting non-whitelisted language code: ' + c);
      }
    };

    if (typeof code === 'string' && code.indexOf('-') > -1) {
      if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
      if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
      if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
    } else if (typeof code === 'string') {
      addCode(this.formatLanguageCode(code));
    }

    fallbackCodes.forEach(function (fc) {
      if (codes.indexOf(fc) < 0) addCode(_this.formatLanguageCode(fc));
    });

    return codes;
  };

  return LanguageUtil;
}();

/* harmony default export */ __webpack_exports__["a"] = (LanguageUtil);

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(8);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



// definition http://translate.sourceforge.net/wiki/l10n/pluralforms
/* eslint-disable */
var sets = [{ lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'ti', 'tr', 'uz', 'wa'], nr: [1, 2], fc: 1 }, { lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'he', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'], nr: [1, 2], fc: 2 }, { lngs: ['ay', 'bo', 'cgg', 'fa', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'], nr: [1], fc: 3 }, { lngs: ['be', 'bs', 'dz', 'hr', 'ru', 'sr', 'uk'], nr: [1, 2, 5], fc: 4 }, { lngs: ['ar'], nr: [0, 1, 2, 3, 11, 100], fc: 5 }, { lngs: ['cs', 'sk'], nr: [1, 2, 5], fc: 6 }, { lngs: ['csb', 'pl'], nr: [1, 2, 5], fc: 7 }, { lngs: ['cy'], nr: [1, 2, 3, 8], fc: 8 }, { lngs: ['fr'], nr: [1, 2], fc: 9 }, { lngs: ['ga'], nr: [1, 2, 3, 7, 11], fc: 10 }, { lngs: ['gd'], nr: [1, 2, 3, 20], fc: 11 }, { lngs: ['is'], nr: [1, 2], fc: 12 }, { lngs: ['jv'], nr: [0, 1], fc: 13 }, { lngs: ['kw'], nr: [1, 2, 3, 4], fc: 14 }, { lngs: ['lt'], nr: [1, 2, 10], fc: 15 }, { lngs: ['lv'], nr: [1, 2, 0], fc: 16 }, { lngs: ['mk'], nr: [1, 2], fc: 17 }, { lngs: ['mnk'], nr: [0, 1, 2], fc: 18 }, { lngs: ['mt'], nr: [1, 2, 11, 20], fc: 19 }, { lngs: ['or'], nr: [2, 1], fc: 2 }, { lngs: ['ro'], nr: [1, 2, 20], fc: 20 }, { lngs: ['sl'], nr: [5, 1, 2, 3], fc: 21 }];

var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n === 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  }
};
/* eslint-enable */

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;

    this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].create('pluralResolver');

    this.rules = createRules();
  }

  PluralResolver.prototype.addRule = function addRule(lng, obj) {
    this.rules[lng] = obj;
  };

  PluralResolver.prototype.getRule = function getRule(code) {
    return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
  };

  PluralResolver.prototype.needsPlural = function needsPlural(code) {
    var rule = this.getRule(code);

    return rule && rule.numbers.length > 1;
  };

  PluralResolver.prototype.getPluralFormsOfKey = function getPluralFormsOfKey(code, key) {
    var _this = this;

    var ret = [];

    var rule = this.getRule(code);

    if (!rule) return ret;

    rule.numbers.forEach(function (n) {
      var suffix = _this.getSuffix(code, n);
      ret.push('' + key + suffix);
    });

    return ret;
  };

  PluralResolver.prototype.getSuffix = function getSuffix(code, count) {
    var _this2 = this;

    var rule = this.getRule(code);

    if (rule) {
      // if (rule.numbers.length === 1) return ''; // only singular

      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];

      // special treatment for lngs only having singular and plural
      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }

      var returnSuffix = function returnSuffix() {
        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
      };

      // COMPATIBILITY JSON
      // v1
      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return '_plural_' + suffix.toString();
        return returnSuffix();
      } else if ( /* v2 */this.options.compatibilityJSON === 'v2' || rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      } else if ( /* v3 - gettext index */rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }
      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }

    this.logger.warn('no plural rule found for: ' + code);
    return '';
  };

  return PluralResolver;
}();

/* harmony default export */ __webpack_exports__["a"] = (PluralResolver);

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger_js__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Interpolator);

    this.logger = __WEBPACK_IMPORTED_MODULE_1__logger_js__["a" /* default */].create('interpolator');

    this.init(options, true);
  }

  /* eslint no-param-reassign: 0 */


  Interpolator.prototype.init = function init() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var reset = arguments[1];

    if (reset) {
      this.options = options;
      this.format = options.interpolation && options.interpolation.format || function (value) {
        return value;
      };
      this.escape = options.interpolation && options.interpolation.escape || __WEBPACK_IMPORTED_MODULE_0__utils_js__["c" /* escape */];
    }
    if (!options.interpolation) options.interpolation = { escapeValue: true };

    var iOpts = options.interpolation;

    this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;

    this.prefix = iOpts.prefix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.prefix) : iOpts.prefixEscaped || '{{';
    this.suffix = iOpts.suffix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.suffix) : iOpts.suffixEscaped || '}}';

    this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';

    this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
    this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';

    this.nestingPrefix = iOpts.nestingPrefix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */]('$t(');
    this.nestingSuffix = iOpts.nestingSuffix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](')');

    this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;

    // the regexp
    this.resetRegExp();
  };

  Interpolator.prototype.reset = function reset() {
    if (this.options) this.init(this.options);
  };

  Interpolator.prototype.resetRegExp = function resetRegExp() {
    // the regexp
    var regexpStr = this.prefix + '(.+?)' + this.suffix;
    this.regexp = new RegExp(regexpStr, 'g');

    var regexpUnescapeStr = '' + this.prefix + this.unescapePrefix + '(.+?)' + this.unescapeSuffix + this.suffix;
    this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');

    var nestingRegexpStr = this.nestingPrefix + '(.+?)' + this.nestingSuffix;
    this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
  };

  Interpolator.prototype.interpolate = function interpolate(str, data, lng) {
    var _this = this;

    var match = void 0;
    var value = void 0;
    var replaces = void 0;

    function regexSafe(val) {
      return val.replace(/\$/g, '$$$$');
    }

    var handleFormat = function handleFormat(key) {
      if (key.indexOf(_this.formatSeparator) < 0) return __WEBPACK_IMPORTED_MODULE_0__utils_js__["d" /* getPath */](data, key);

      var p = key.split(_this.formatSeparator);
      var k = p.shift().trim();
      var f = p.join(_this.formatSeparator).trim();

      return _this.format(__WEBPACK_IMPORTED_MODULE_0__utils_js__["d" /* getPath */](data, k), f, lng);
    };

    this.resetRegExp();

    replaces = 0;
    // unescape if has unescapePrefix/Suffix
    /* eslint no-cond-assign: 0 */
    while (match = this.regexpUnescape.exec(str)) {
      value = handleFormat(match[1].trim());
      str = str.replace(match[0], value);
      this.regexpUnescape.lastIndex = 0;
      replaces++;
      if (replaces >= this.maxReplaces) {
        break;
      }
    }

    replaces = 0;
    // regular escape on demand
    while (match = this.regexp.exec(str)) {
      value = handleFormat(match[1].trim());
      if (value === undefined) {
        if (typeof this.options.missingInterpolationHandler === 'function') {
          var temp = this.options.missingInterpolationHandler(str, match);
          value = typeof temp === 'string' ? temp : '';
        } else {
          this.logger.warn('missed to pass in variable ' + match[1] + ' for interpolating ' + str);
          value = '';
        }
      } else if (typeof value !== 'string') {
        value = __WEBPACK_IMPORTED_MODULE_0__utils_js__["e" /* makeString */](value);
      }
      value = this.escapeValue ? regexSafe(this.escape(value)) : regexSafe(value);
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
      replaces++;
      if (replaces >= this.maxReplaces) {
        break;
      }
    }
    return str;
  };

  Interpolator.prototype.nest = function nest(str, fc) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var match = void 0;
    var value = void 0;

    var clonedOptions = _extends({}, options);
    clonedOptions.applyPostProcessor = false; // avoid post processing on nested lookup

    // if value is something like "myKey": "lorem $(anotherKey, { "count": {{aValueInOptions}} })"
    function handleHasOptions(key, inheritedOptions) {
      if (key.indexOf(',') < 0) return key;

      var p = key.split(',');
      key = p.shift();
      var optionsString = p.join(',');
      optionsString = this.interpolate(optionsString, clonedOptions);
      optionsString = optionsString.replace(/'/g, '"');

      try {
        clonedOptions = JSON.parse(optionsString);

        if (inheritedOptions) clonedOptions = _extends({}, inheritedOptions, clonedOptions);
      } catch (e) {
        this.logger.error('failed parsing options string in nesting for key ' + key, e);
      }

      return key;
    }

    // regular escape on demand
    while (match = this.nestingRegexp.exec(str)) {
      value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);

      // is only the nesting key (key1 = '$(key2)') return the value without stringify
      if (value && match[0] === str && typeof value !== 'string') return value;

      // no string to include or empty
      if (typeof value !== 'string') value = __WEBPACK_IMPORTED_MODULE_0__utils_js__["e" /* makeString */](value);
      if (!value) {
        this.logger.warn('missed to resolve ' + match[1] + ' for nesting ' + str);
        value = '';
      }
      // Nested keys should not be escaped by default #854
      // value = this.escapeValue ? regexSafe(utils.escape(value)) : regexSafe(value);
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
    }
    return str;
  };

  return Interpolator;
}();

/* harmony default export */ __webpack_exports__["a"] = (Interpolator);

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventEmitter_js__ = __webpack_require__(12);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }





function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var Connector = function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Connector);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.backend = backend;
    _this.store = store;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = __WEBPACK_IMPORTED_MODULE_1__logger_js__["a" /* default */].create('backendConnector');

    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }
    return _this;
  }

  Connector.prototype.queueLoad = function queueLoad(languages, namespaces, callback) {
    var _this2 = this;

    // find what needs to be loaded
    var toLoad = [];
    var pending = [];
    var toLoadLanguages = [];
    var toLoadNamespaces = [];

    languages.forEach(function (lng) {
      var hasAllNamespaces = true;

      namespaces.forEach(function (ns) {
        var name = lng + '|' + ns;

        if (_this2.store.hasResourceBundle(lng, ns)) {
          _this2.state[name] = 2; // loaded
        } else if (_this2.state[name] < 0) {
          // nothing to do for err
        } else if (_this2.state[name] === 1) {
          if (pending.indexOf(name) < 0) pending.push(name);
        } else {
          _this2.state[name] = 1; // pending

          hasAllNamespaces = false;

          if (pending.indexOf(name) < 0) pending.push(name);
          if (toLoad.indexOf(name) < 0) toLoad.push(name);
          if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
        }
      });

      if (!hasAllNamespaces) toLoadLanguages.push(lng);
    });

    if (toLoad.length || pending.length) {
      this.queue.push({
        pending: pending,
        loaded: {},
        errors: [],
        callback: callback
      });
    }

    return {
      toLoad: toLoad,
      pending: pending,
      toLoadLanguages: toLoadLanguages,
      toLoadNamespaces: toLoadNamespaces
    };
  };

  Connector.prototype.loaded = function loaded(name, err, data) {
    var _this3 = this;

    var _name$split = name.split('|'),
        _name$split2 = _slicedToArray(_name$split, 2),
        lng = _name$split2[0],
        ns = _name$split2[1];

    if (err) this.emit('failedLoading', lng, ns, err);

    if (data) {
      this.store.addResourceBundle(lng, ns, data);
    }

    // set loaded
    this.state[name] = err ? -1 : 2;

    // callback if ready
    this.queue.forEach(function (q) {
      __WEBPACK_IMPORTED_MODULE_0__utils_js__["f" /* pushPath */](q.loaded, [lng], ns);
      remove(q.pending, name);

      if (err) q.errors.push(err);

      if (q.pending.length === 0 && !q.done) {
        _this3.emit('loaded', q.loaded);
        /* eslint no-param-reassign: 0 */
        q.done = true;
        if (q.errors.length) {
          q.callback(q.errors);
        } else {
          q.callback();
        }
      }
    });

    // remove done load requests
    this.queue = this.queue.filter(function (q) {
      return !q.done;
    });
  };

  Connector.prototype.read = function read(lng, ns, fcName) {
    var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    var _this4 = this;

    var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 250;
    var callback = arguments[5];

    if (!lng.length) return callback(null, {}); // noting to load

    return this.backend[fcName](lng, ns, function (err, data) {
      if (err && data /* = retryFlag */ && tried < 5) {
        setTimeout(function () {
          _this4.read.call(_this4, lng, ns, fcName, tried + 1, wait * 2, callback);
        }, wait);
        return;
      }
      callback(err, data);
    });
  };

  /* eslint consistent-return: 0 */


  Connector.prototype.load = function load(languages, namespaces, callback) {
    var _this5 = this;

    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
      return callback && callback();
    }

    if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];

    var toLoad = this.queueLoad(languages, namespaces, callback);
    if (!toLoad.toLoad.length) {
      if (!toLoad.pending.length) callback(); // nothing to load and no pendings...callback now
      return null; // pendings will trigger callback
    }

    toLoad.toLoad.forEach(function (name) {
      _this5.loadOne(name);
    });
  };

  Connector.prototype.reload = function reload(languages, namespaces) {
    var _this6 = this;

    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
    }

    if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];

    languages.forEach(function (l) {
      namespaces.forEach(function (n) {
        _this6.loadOne(l + '|' + n, 're');
      });
    });
  };

  Connector.prototype.loadOne = function loadOne(name) {
    var _this7 = this;

    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    var _name$split3 = name.split('|'),
        _name$split4 = _slicedToArray(_name$split3, 2),
        lng = _name$split4[0],
        ns = _name$split4[1];

    this.read(lng, ns, 'read', null, null, function (err, data) {
      if (err) _this7.logger.warn(prefix + 'loading namespace ' + ns + ' for language ' + lng + ' failed', err);
      if (!err && data) _this7.logger.log(prefix + 'loaded namespace ' + ns + ' for language ' + lng, data);

      _this7.loaded(name, err, data);
    });
  };

  Connector.prototype.saveMissing = function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
    var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

    if (this.backend && this.backend.create) {
      this.backend.create(languages, namespace, key, fallbackValue, null /* unused callback */, _extends({}, options, { isUpdate: isUpdate }));
    }

    // write to store to avoid resending
    if (!languages || !languages[0]) return;
    this.store.addResource(languages[0], namespace, key, fallbackValue);
  };

  return Connector;
}(__WEBPACK_IMPORTED_MODULE_2__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Connector);

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return get; });
/* harmony export (immutable) */ __webpack_exports__["b"] = transformOptions;

function get() {
  return {
    debug: false,
    initImmediate: true,

    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false, // string or array of namespaces

    whitelist: false, // array with whitelisted languages
    nonExplicitWhitelist: false,
    load: 'all', // | currentOnly | languageOnly
    preload: false, // array with preload languages

    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',

    saveMissing: false, // enable to send missing values
    updateMissing: false, // enable to update default values if different from translated value (only useful on initial development, or when keeping code as source of truth)
    saveMissingTo: 'fallback', // 'current' || 'all'
    saveMissingPlurals: true, // will save all forms not only singular key
    missingKeyHandler: false, // function(lng, ns, key, fallbackValue) -> override if prefer on handling
    missingInterpolationHandler: false, // function(str, match)

    postProcess: false, // string or array of postProcessor names
    returnNull: true, // allows null value as valid translation
    returnEmptyString: true, // allows empty string value as valid translation
    returnObjects: false,
    joinArrays: false, // or string to join array
    returnedObjectHandler: function returnedObjectHandler() {}, // function(key, value, options) triggered if key returns object but returnObjects is set to false
    parseMissingKeyHandler: false, // function(key) parsed a key that was not found in t() before returning
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (args[1]) ret.defaultValue = args[1];
      if (args[2]) ret.tDescription = args[2];
      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      // prefixEscaped: '{{',
      // suffixEscaped: '}}',
      // unescapeSuffix: '',
      unescapePrefix: '-',

      nestingPrefix: '$t(',
      nestingSuffix: ')',
      // nestingPrefixEscaped: '$t(',
      // nestingSuffixEscaped: ')',
      // defaultVariables: undefined // object that can have values to interpolate on - extends passed in interpolation data
      maxReplaces: 1000 // max replaces to prevent endless loop
    }
  };
}

/* eslint no-param-reassign: 0 */
function transformOptions(options) {
  // create namespace object if namespace is passed in as string
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  // extend whitelist with cimode
  if (options.whitelist && options.whitelist.indexOf('cimode') < 0) {
    options.whitelist = options.whitelist.concat(['cimode']);
  }

  return options;
}

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(165).default;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(166);

var utils = _interopRequireWildcard(_utils);

var _ajax = __webpack_require__(167);

var _ajax2 = _interopRequireDefault(_ajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getDefaults() {
  return {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
    addPath: '/locales/add/{{lng}}/{{ns}}',
    allowMultiLoading: false,
    parse: JSON.parse,
    crossDomain: false,
    ajax: _ajax2.default
  };
}

var Backend = function () {
  function Backend(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Backend);

    this.init(services, options);

    this.type = 'backend';
  }

  _createClass(Backend, [{
    key: 'init',
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.services = services;
      this.options = utils.defaults(options, this.options || {}, getDefaults());
    }
  }, {
    key: 'readMulti',
    value: function readMulti(languages, namespaces, callback) {
      var loadPath = this.options.loadPath;
      if (typeof this.options.loadPath === 'function') {
        loadPath = this.options.loadPath(languages, namespaces);
      }

      var url = this.services.interpolator.interpolate(loadPath, { lng: languages.join('+'), ns: namespaces.join('+') });

      this.loadUrl(url, callback);
    }
  }, {
    key: 'read',
    value: function read(language, namespace, callback) {
      var loadPath = this.options.loadPath;
      if (typeof this.options.loadPath === 'function') {
        loadPath = this.options.loadPath([language], [namespace]);
      }

      var url = this.services.interpolator.interpolate(loadPath, { lng: language, ns: namespace });

      this.loadUrl(url, callback);
    }
  }, {
    key: 'loadUrl',
    value: function loadUrl(url, callback) {
      var _this = this;

      this.options.ajax(url, this.options, function (data, xhr) {
        if (xhr.status >= 500 && xhr.status < 600) return callback('failed loading ' + url, true /* retry */);
        if (xhr.status >= 400 && xhr.status < 500) return callback('failed loading ' + url, false /* no retry */);

        var ret = void 0,
            err = void 0;
        try {
          ret = _this.options.parse(data, url);
        } catch (e) {
          err = 'failed parsing ' + url + ' to json';
        }
        if (err) return callback(err, false);
        callback(null, ret);
      });
    }
  }, {
    key: 'create',
    value: function create(languages, namespace, key, fallbackValue) {
      var _this2 = this;

      if (typeof languages === 'string') languages = [languages];

      var payload = {};
      payload[key] = fallbackValue || '';

      languages.forEach(function (lng) {
        var url = _this2.services.interpolator.interpolate(_this2.options.addPath, { lng: lng, ns: namespace });

        _this2.options.ajax(url, _this2.options, function (data, xhr) {
          //const statusCode = xhr.status.toString();
          // TODO: if statusCode === 4xx do log
        }, payload);
      });
    }
  }]);

  return Backend;
}();

Backend.type = 'backend';

exports.default = Backend;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaults = defaults;
exports.extend = extend;
var arr = [];
var each = arr.forEach;
var slice = arr.slice;

function defaults(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

function extend(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function addQueryString(url, params) {
  if (params && (typeof params === 'undefined' ? 'undefined' : _typeof(params)) === 'object') {
    var queryString = '',
        e = encodeURIComponent;

    // Must encode data
    for (var paramName in params) {
      queryString += '&' + e(paramName) + '=' + e(params[paramName]);
    }

    if (!queryString) {
      return url;
    }

    url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
  }

  return url;
}

// https://gist.github.com/Xeoncross/7663273
function ajax(url, options, callback, data, cache) {

  if (data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
    if (!cache) {
      data['_t'] = new Date();
    }
    // URL encoded form data must be in querystring format
    data = addQueryString('', data).slice(1);
  }

  if (options.queryStringParams) {
    url = addQueryString(url, options.queryStringParams);
  }

  try {
    var x;
    if (XMLHttpRequest) {
      x = new XMLHttpRequest();
    } else {
      x = new ActiveXObject('MSXML2.XMLHTTP.3.0');
    }
    x.open(data ? 'POST' : 'GET', url, 1);
    if (!options.crossDomain) {
      x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    }
    x.withCredentials = !!options.withCredentials;
    if (data) {
      x.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    }
    if (x.overrideMimeType) {
      x.overrideMimeType("application/json");
    }
    var h = options.customHeaders;
    if (h) {
      for (var i in h) {
        x.setRequestHeader(i, h[i]);
      }
    }
    x.onreadystatechange = function () {
      x.readyState > 3 && callback && callback(x.responseText, x);
    };
    x.send(data);
  } catch (e) {
    console && console.log(e);
  }
}

exports.default = ajax;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(169).default;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(170);

var utils = _interopRequireWildcard(_utils);

var _cookie = __webpack_require__(171);

var _cookie2 = _interopRequireDefault(_cookie);

var _querystring = __webpack_require__(172);

var _querystring2 = _interopRequireDefault(_querystring);

var _localStorage = __webpack_require__(173);

var _localStorage2 = _interopRequireDefault(_localStorage);

var _navigator = __webpack_require__(174);

var _navigator2 = _interopRequireDefault(_navigator);

var _htmlTag = __webpack_require__(175);

var _htmlTag2 = _interopRequireDefault(_htmlTag);

var _path = __webpack_require__(176);

var _path2 = _interopRequireDefault(_path);

var _subdomain = __webpack_require__(177);

var _subdomain2 = _interopRequireDefault(_subdomain);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getDefaults() {
  return {
    order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
    lookupQuerystring: 'lng',
    lookupCookie: 'i18next',
    lookupLocalStorage: 'i18nextLng',

    // cache user language
    caches: ['localStorage'],
    excludeCacheFor: ['cimode']
    //cookieMinutes: 10,
    //cookieDomain: 'myDomain'
  };
}

var Browser = function () {
  function Browser(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Browser);

    this.type = 'languageDetector';
    this.detectors = {};

    this.init(services, options);
  }

  _createClass(Browser, [{
    key: 'init',
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      this.services = services;
      this.options = utils.defaults(options, this.options || {}, getDefaults());
      this.i18nOptions = i18nOptions;

      this.addDetector(_cookie2.default);
      this.addDetector(_querystring2.default);
      this.addDetector(_localStorage2.default);
      this.addDetector(_navigator2.default);
      this.addDetector(_htmlTag2.default);
      this.addDetector(_path2.default);
      this.addDetector(_subdomain2.default);
    }
  }, {
    key: 'addDetector',
    value: function addDetector(detector) {
      this.detectors[detector.name] = detector;
    }
  }, {
    key: 'detect',
    value: function detect(detectionOrder) {
      var _this = this;

      if (!detectionOrder) detectionOrder = this.options.order;

      var detected = [];
      detectionOrder.forEach(function (detectorName) {
        if (_this.detectors[detectorName]) {
          var lookup = _this.detectors[detectorName].lookup(_this.options);
          if (lookup && typeof lookup === 'string') lookup = [lookup];
          if (lookup) detected = detected.concat(lookup);
        }
      });

      var found = void 0;
      detected.forEach(function (lng) {
        if (found) return;
        var cleanedLng = _this.services.languageUtils.formatLanguageCode(lng);
        if (_this.services.languageUtils.isWhitelisted(cleanedLng)) found = cleanedLng;
      });

      if (!found) {
        var fallbacks = this.i18nOptions.fallbackLng;
        if (typeof fallbacks === 'string') fallbacks = [fallbacks];
        if (!fallbacks) fallbacks = [];

        if (Object.prototype.toString.apply(fallbacks) === '[object Array]') {
          found = fallbacks[0];
        } else {
          found = fallbacks[0] || fallbacks.default && fallbacks.default[0];
        }
      };

      return found;
    }
  }, {
    key: 'cacheUserLanguage',
    value: function cacheUserLanguage(lng, caches) {
      var _this2 = this;

      if (!caches) caches = this.options.caches;
      if (!caches) return;
      if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
      caches.forEach(function (cacheName) {
        if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
      });
    }
  }]);

  return Browser;
}();

Browser.type = 'languageDetector';

exports.default = Browser;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaults = defaults;
exports.extend = extend;
var arr = [];
var each = arr.forEach;
var slice = arr.slice;

function defaults(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

function extend(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var cookie = {
  create: function create(name, value, minutes, domain) {
    var expires = void 0;
    if (minutes) {
      var date = new Date();
      date.setTime(date.getTime() + minutes * 60 * 1000);
      expires = '; expires=' + date.toGMTString();
    } else expires = '';
    domain = domain ? 'domain=' + domain + ';' : '';
    document.cookie = name + '=' + value + expires + ';' + domain + 'path=/';
  },

  read: function read(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },

  remove: function remove(name) {
    this.create(name, '', -1);
  }
};

exports.default = {
  name: 'cookie',

  lookup: function lookup(options) {
    var found = void 0;

    if (options.lookupCookie && typeof document !== 'undefined') {
      var c = cookie.read(options.lookupCookie);
      if (c) found = c;
    }

    return found;
  },
  cacheUserLanguage: function cacheUserLanguage(lng, options) {
    if (options.lookupCookie && typeof document !== 'undefined') {
      cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain);
    }
  }
};

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'querystring',

  lookup: function lookup(options) {
    var found = void 0;

    if (typeof window !== 'undefined') {
      var query = window.location.search.substring(1);
      var params = query.split('&');
      for (var i = 0; i < params.length; i++) {
        var pos = params[i].indexOf('=');
        if (pos > 0) {
          var key = params[i].substring(0, pos);
          if (key === options.lookupQuerystring) {
            found = params[i].substring(pos + 1);
          }
        }
      }
    }

    return found;
  }
};

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var hasLocalStorageSupport = void 0;
try {
  hasLocalStorageSupport = window !== 'undefined' && window.localStorage !== null;
  var testKey = 'i18next.translate.boo';
  window.localStorage.setItem(testKey, 'foo');
  window.localStorage.removeItem(testKey);
} catch (e) {
  hasLocalStorageSupport = false;
}

exports.default = {
  name: 'localStorage',

  lookup: function lookup(options) {
    var found = void 0;

    if (options.lookupLocalStorage && hasLocalStorageSupport) {
      var lng = window.localStorage.getItem(options.lookupLocalStorage);
      if (lng) found = lng;
    }

    return found;
  },
  cacheUserLanguage: function cacheUserLanguage(lng, options) {
    if (options.lookupLocalStorage && hasLocalStorageSupport) {
      window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
  }
};

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'navigator',

  lookup: function lookup(options) {
    var found = [];

    if (typeof navigator !== 'undefined') {
      if (navigator.languages) {
        // chrome only; not an array, so can't use .push.apply instead of iterating
        for (var i = 0; i < navigator.languages.length; i++) {
          found.push(navigator.languages[i]);
        }
      }
      if (navigator.userLanguage) {
        found.push(navigator.userLanguage);
      }
      if (navigator.language) {
        found.push(navigator.language);
      }
    }

    return found.length > 0 ? found : undefined;
  }
};

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'htmlTag',

  lookup: function lookup(options) {
    var found = void 0;
    var htmlTag = options.htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);

    if (htmlTag && typeof htmlTag.getAttribute === 'function') {
      found = htmlTag.getAttribute('lang');
    }

    return found;
  }
};

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'path',

  lookup: function lookup(options) {
    var found = void 0;
    if (typeof window !== 'undefined') {
      var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
      if (language instanceof Array) {
        if (typeof options.lookupFromUrlIndex === 'number') {
          found = language[options.lookupFromPathIndex].replace('/', '');
        } else {
          found = language[0].replace('/', '');
        }
      }
    }
    return found;
  }
};

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'subdomain',

  lookup: function lookup(options) {
    var found = void 0;
    if (typeof window !== 'undefined') {
      var language = window.location.pathname.match(/(?:http[s]*\:\/\/)*(.*?)\.(?=[^\/]*\..{2,5})/gi);
      if (language instanceof Array) {
        if (typeof options.lookupFromSubdomainIndex === 'number') {
          found = language[options.lookupFromSubdomainIndex].replace('http://', '').replace('https://', '').replace('.', '');
        } else {
          found = language[0].replace('http://', '').replace('https://', '').replace('.', '');
        }
      }
    }
    return found;
  }
};

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Avenir_ttf__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Avenir_ttf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Avenir_ttf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AvenirRegular_woff__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AvenirRegular_woff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AvenirRegular_woff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AvenirRegular_woff2__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AvenirRegular_woff2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AvenirRegular_woff2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AvenirHeavy_woff2__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AvenirHeavy_woff2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AvenirHeavy_woff2__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__Avenir_ttf___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__AvenirRegular_woff___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__AvenirRegular_woff2___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__AvenirHeavy_woff2___default.a; });


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Avenir.e2f2a8b1.ttf";

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/AvenirRegular.4dc77f0f.woff";

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/AvenirRegular.eecd612f.woff2";

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/AvenirHeavy.289fbfee.woff2";

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.9c983b1e.js